/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Email: { input: any; output: any; }
  ExpediaPropertyRoomOccupancy: { input: any; output: any; }
  ISO8601Date: { input: any; output: any; }
  ISO8601DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Phone: { input: any; output: any; }
  PickupAt: { input: any; output: any; }
};

/** ActiveStorage */
export type ActiveStorage = CreatedAtUpdatedAt & {
  __typename?: 'ActiveStorage';
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  /** Original name of the file */
  filename: Scalars['String']['output'];
  /** ID of the type */
  id: Scalars['ID']['output'];
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
  /** URL of the record */
  url?: Maybe<Scalars['String']['output']>;
};


/** ActiveStorage */
export type ActiveStorageUrlArgs = {
  size?: InputMaybe<ImageSizeEnum>;
};

/** The connection type for ActiveStorage. */
export type ActiveStorageConnection = {
  __typename?: 'ActiveStorageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActiveStorageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ActiveStorage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ActiveStorageEdge = {
  __typename?: 'ActiveStorageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ActiveStorage>;
};

/** Autogenerated input type of AddAndFinalizeBundleProduct */
export type AddAndFinalizeBundleProductInput = {
  /** ID */
  id: Scalars['ID']['input'];
  itineraryInput: ItineraryInput;
  productInput: TypesItineraryInputsBundleProduct;
  paymentInput: CreditCard;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAndFinalizeBundleProduct */
export type AddAndFinalizeBundleProductPayload = {
  __typename?: 'AddAndFinalizeBundleProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated return type of AddLesson */
export type AddLessonPayload = {
  __typename?: 'AddLessonPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated return type of AddLiftTicket */
export type AddLiftTicketPayload = {
  __typename?: 'AddLiftTicketPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated return type of AddProperty */
export type AddPropertyPayload = {
  __typename?: 'AddPropertyPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated return type of AddRental */
export type AddRentalPayload = {
  __typename?: 'AddRentalPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of AddScheduledPayment */
export type AddScheduledPaymentInput = {
  lineItemId: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  processAt: Scalars['Date']['input'];
  collectionSource: ScheduledPaymentCollectionSourceEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddScheduledPayment */
export type AddScheduledPaymentPayload = {
  __typename?: 'AddScheduledPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  scheduledPayment: ScheduledPayment;
};

/** Autogenerated return type of AddTransportation */
export type AddTransportationPayload = {
  __typename?: 'AddTransportationPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated return type of AddUpsell */
export type AddUpsellPayload = {
  __typename?: 'AddUpsellPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Attributes for accepting an address to the itinerary */
export type Address = {
  /** Line 1 of the address */
  line1?: InputMaybe<Scalars['String']['input']>;
  /** Line 2 of the address */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** Line 3 of the address */
  line3?: InputMaybe<Scalars['String']['input']>;
  /** City of the address */
  city?: InputMaybe<Scalars['String']['input']>;
  /** State of the address */
  stateProvinceCode?: InputMaybe<Scalars['String']['input']>;
  /** Postal code of the address */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Country code of the address */
  countryCode?: InputMaybe<CountryCodeEnum>;
};

export enum AgeEnum {
  Adult = 'ADULT',
  Child = 'CHILD',
  Infant = 'INFANT'
}

export enum AgentTypeEnum {
  Fulfilment = 'FULFILMENT',
  Assigned = 'ASSIGNED',
  Customer = 'CUSTOMER',
  PostBooking = 'POST_BOOKING',
  LiftTicket = 'LIFT_TICKET',
  Rental = 'RENTAL',
  Transportation = 'TRANSPORTATION',
  Lesson = 'LESSON',
  F4 = 'F4',
  Requested = 'REQUESTED',
  InProgress = 'IN_PROGRESS',
  FlightInfo = 'FLIGHT_INFO'
}

export type Airport = {
  __typename?: 'Airport';
  /** The IATA code of this airport */
  iataCode: Scalars['String']['output'];
  /** The primary id of this airport */
  id: Scalars['ID']['output'];
  /** Airport latitude */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Airport longitude */
  lng?: Maybe<Scalars['Float']['output']>;
  /** The name of this airport */
  name: Scalars['String']['output'];
};

/**
 * This lists all of the amenities available with a specific rate,
 * including value adds, such as breakfast. See our amenities reference for
 * current known amenity ID and name values.
 *
 */
export type Amenity = {
  __typename?: 'Amenity';
  /** Amenity group name */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Numeric identifier for the amenity. */
  id: Scalars['ID']['output'];
  /** Amenity name */
  name: Scalars['String']['output'];
};

/** Autogenerated input type of AssignAgent */
export type AssignAgentInput = {
  agentId: Scalars['ID']['input'];
  agentType: AgentTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssignAgent */
export type AssignAgentPayload = {
  __typename?: 'AssignAgentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of AssignLineItemAgent */
export type AssignLineItemAgentInput = {
  lineItemId: Scalars['ID']['input'];
  agentId: Scalars['ID']['input'];
  agentType: AgentTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AssignLineItemAgent */
export type AssignLineItemAgentPayload = {
  __typename?: 'AssignLineItemAgentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

export enum AuditActionEnum {
  Create = 'CREATE',
  Update = 'UPDATE',
  Destroy = 'DESTROY'
}

export type Audited = {
  __typename?: 'Audited';
  action: Scalars['String']['output'];
  associatedAuditable?: Maybe<AuditedUnion>;
  auditable: AuditedUnion;
  auditableType: Scalars['String']['output'];
  changes?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  typedChanges: Array<AuditedChange>;
  user?: Maybe<User>;
  /** Audit change version */
  version: Scalars['Int']['output'];
};

export type AuditedChange = {
  __typename?: 'AuditedChange';
  attribute: Scalars['String']['output'];
  from?: Maybe<AuditedChangeRecordUnion>;
  to?: Maybe<AuditedChangeRecordUnion>;
};

export type AuditedChangeRecordBoolean = {
  __typename?: 'AuditedChangeRecordBoolean';
  boolean: Scalars['Boolean']['output'];
};

export type AuditedChangeRecordDate = {
  __typename?: 'AuditedChangeRecordDate';
  date: Scalars['ISO8601Date']['output'];
};

export type AuditedChangeRecordDateTime = {
  __typename?: 'AuditedChangeRecordDateTime';
  dateTime: Scalars['ISO8601DateTime']['output'];
};

export type AuditedChangeRecordFloat = {
  __typename?: 'AuditedChangeRecordFloat';
  float: Scalars['Float']['output'];
};

export type AuditedChangeRecordInteger = {
  __typename?: 'AuditedChangeRecordInteger';
  integer: Scalars['Int']['output'];
};

export type AuditedChangeRecordString = {
  __typename?: 'AuditedChangeRecordString';
  string: Scalars['String']['output'];
};

export type AuditedChangeRecordUnion = AuditedChangeRecordBoolean | AuditedChangeRecordDate | AuditedChangeRecordDateTime | AuditedChangeRecordFloat | AuditedChangeRecordInteger | AuditedChangeRecordString | Itinerary | LessonProduct | LiftTicketProduct | PropertyProduct | RentalProduct | TransportationProduct | UpsellProduct | User | UserCreditCard;

/** The connection type for Audited. */
export type AuditedConnection = {
  __typename?: 'AuditedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditedEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Audited>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditedEdge = {
  __typename?: 'AuditedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Audited>;
};

export type AuditedUnion = Itinerary | ItineraryEmailLog | LineItem | Payment | SupportCase | SupportNote;

/** Author */
export type Author = {
  __typename?: 'Author';
  /** Author avatar URL */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Author bio content */
  bioContent?: Maybe<Scalars['String']['output']>;
  /** The primary id of this author */
  id: Scalars['ID']['output'];
  /** The name of this author */
  name: Scalars['String']['output'];
  /** The slug of this author */
  slug: Scalars['String']['output'];
};


/** Author */
export type AuthorAvatarArgs = {
  style?: InputMaybe<AuthorAvatarStyleEnum>;
};

export enum AuthorAvatarStyleEnum {
  Original = 'ORIGINAL',
  Medium = 'MEDIUM',
  Thumb = 'THUMB'
}

export type AvailableDates = {
  __typename?: 'AvailableDates';
  /** Bundle departing flight end date */
  arriveAt: Scalars['DateTime']['output'];
  /** Bundle's duration in days. This can be used to avoid client side time calc mismatches */
  days: Scalars['Int']['output'];
  /** Bundle returning flight end date */
  endAt: Scalars['DateTime']['output'];
  /** Bundle returning flight start date */
  returnAt: Scalars['DateTime']['output'];
  /** Bundle departing flight start date */
  startAt: Scalars['DateTime']['output'];
};

export type AvailableTravellers = {
  __typename?: 'AvailableTravellers';
  /** Number of adult travellers */
  adults: Scalars['Int']['output'];
  /** Number of child travellers */
  children: Scalars['Int']['output'];
};

export enum BannerSizeEnum {
  Box = 'Box',
  Medium = 'Medium',
  Large = 'Large',
  Tall = 'Tall',
  Original = 'Original'
}

/** An individual bed group */
export type BedGroup = {
  __typename?: 'BedGroup';
  /**
   * The bed configuration for a given room. This array can be empty for the
   * related bed group.
   *
   */
  configuration?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Description of a bed configuration for the room. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for a bed group. */
  id?: Maybe<Scalars['ID']['output']>;
};

export enum BedSizeEnum {
  Twin = 'TWIN',
  King = 'KING',
  Queen = 'QUEEN',
  Double = 'DOUBLE',
  Single = 'SINGLE',
  Full = 'FULL'
}

/** Attributes for property bed type configuration */
export type BedTypeConfigurationInput = {
  /** Size of the bed */
  size: BedSizeEnum;
  /** Number of beds */
  quantity: Scalars['Int']['input'];
};

/** Attributes for property bed types */
export type BedTypeInput = {
  /** Bed group id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Bed group description */
  description: Scalars['String']['input'];
  /** Bedding configuration */
  configuration: Array<BedTypeConfigurationInput>;
};

/** BlogCategory */
export type BlogCategory = {
  __typename?: 'BlogCategory';
  allPosts: BlogPostConnection;
  id: Scalars['ID']['output'];
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** BlogCategory */
export type BlogCategoryAllPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** BlogPost */
export type BlogPost = {
  __typename?: 'BlogPost';
  category?: Maybe<BlogCategory>;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** The connection type for BlogPost. */
export type BlogPostConnection = {
  __typename?: 'BlogPostConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BlogPostEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BlogPost>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BlogPostEdge = {
  __typename?: 'BlogPostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BlogPost>;
};

/** Bundle */
export type Bundle = {
  __typename?: 'Bundle';
  /** A list of possible start/end dates for bundle */
  availableDates: Array<AvailableDates>;
  /** A list of possible traveller combinations */
  availableTravellers: Array<AvailableTravellers>;
  bundleProduct?: Maybe<BundleProduct>;
  /** Hotel's distance to lift */
  distanceToLift?: Maybe<Scalars['String']['output']>;
  /** Bundle's flight content HTML */
  flightContent: Scalars['String']['output'];
  /** Bundle's hotel address */
  hotelAddress: Scalars['String']['output'];
  /** Bundle's hotel content HTML */
  hotelContent: Scalars['String']['output'];
  /** Bundle's hotel content HTML for checkout section */
  hotelContentCheckout: Scalars['String']['output'];
  /** Bundle's hotel logo */
  hotelLogo?: Maybe<PrismicImageType>;
  /** Bundle's hotel name */
  hotelName: Scalars['String']['output'];
  /** Hotel's star rating */
  hotelStarRating?: Maybe<Scalars['Float']['output']>;
  /** Primary ID */
  id: Scalars['ID']['output'];
  /** Bundle's related images */
  images?: Maybe<BundleImageTypeConnection>;
  /** Bundle's inclusion list */
  inclusionsList: Scalars['String']['output'];
  /** Bundle's full name */
  name: Scalars['String']['output'];
  /** Bundle's package content HTML */
  packageContent: Scalars['String']['output'];
  /** Related Resort */
  resort: Resort;
  /** Bundle's included lift pass days, used for rental product query */
  skiDaysIncluded: Scalars['Int']['output'];
  /** Bundle slug */
  slug: Scalars['String']['output'];
  /** Bundle's T&Cs */
  termsAndConditions: Scalars['String']['output'];
  /** Hotel's Tripadvisor Rating */
  tripadvisorRating?: Maybe<Scalars['String']['output']>;
  /** Hotel's Tripadvisor review number */
  tripadvisorRatingCount?: Maybe<Scalars['Int']['output']>;
};


/** Bundle */
export type BundleBundleProductArgs = {
  filter?: InputMaybe<BundleProductFilterInput>;
};


/** Bundle */
export type BundleHotelLogoArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};


/** Bundle */
export type BundleImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type BundleImageType = {
  __typename?: 'BundleImageType';
  /** Image Caption */
  caption?: Maybe<Scalars['String']['output']>;
  /** Prismic Image */
  image?: Maybe<PrismicImageType>;
};


export type BundleImageTypeImageArgs = {
  size?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for BundleImageType. */
export type BundleImageTypeConnection = {
  __typename?: 'BundleImageTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BundleImageTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BundleImageType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BundleImageTypeEdge = {
  __typename?: 'BundleImageTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BundleImageType>;
};

export type BundleProduct = {
  __typename?: 'BundleProduct';
  /** Number of adult travellers */
  adults: Scalars['Int']['output'];
  /** Arrival city */
  arrivalCity: Scalars['String']['output'];
  /** Destination city arrival date */
  arriveAt: Scalars['DateTime']['output'];
  /** Bundle ID */
  bundleId: Scalars['ID']['output'];
  /** Number of child travellers */
  children: Scalars['Int']['output'];
  /** Currency of prices */
  currency: Scalars['String']['output'];
  /** Bundle's duration in days. This can be used to avoid client side time calc mismatches */
  days: Scalars['Int']['output'];
  /** Destination city departure date */
  departAt: Scalars['DateTime']['output'];
  /** Departure city */
  departureCity: Scalars['String']['output'];
  /** Product's deposit due at */
  depositDueAt: Scalars['DateTime']['output'];
  /** Product's deposit price */
  depositPrice: Scalars['Float']['output'];
  /** Bundle end date */
  endAt: Scalars['DateTime']['output'];
  /** Primary ID */
  id: Scalars['ID']['output'];
  /** Nights of stay for hotel. This is calculated using flight arrival and departure dates at destination city */
  numHotelNights: Scalars['Int']['output'];
  /** Product's payable price */
  payablePrice: Scalars['Float']['output'];
  /** Bundle start date */
  startAt: Scalars['DateTime']['output'];
  /** Product's strikethrough price */
  strikethroughPrice: Scalars['Float']['output'];
};

/** Inputs for filtering out bundle products */
export type BundleProductFilterInput = {
  startAt: Scalars['Date']['input'];
  departureCity: Scalars['String']['input'];
  adults: Scalars['String']['input'];
  children: Scalars['String']['input'];
};

/** LineItem */
export type BundleProductLineItemType = {
  __typename?: 'BundleProductLineItemType';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  pretaxPayableAmount: Scalars['Float']['output'];
  product: BundleProduct;
  productSupplier?: Maybe<ProductSupplier>;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type BundleProductLineItemTypeNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Attributes for accepting a traveller data for bundle product */
export type BundleTraveller = {
  /** Age type of the traveller */
  ageType: AgeEnum;
  /** Title of the traveller */
  title?: InputMaybe<Scalars['String']['input']>;
  /** First name of the traveller */
  firstName: Scalars['String']['input'];
  /** Last name of the traveller */
  lastName: Scalars['String']['input'];
  /** Date of birth of the traveller */
  dob: Scalars['String']['input'];
  /** Passport for the traveller */
  passport?: InputMaybe<Passport>;
  /** Rental product type */
  rentalType?: InputMaybe<RentalProductGearTypeEnum>;
};

/** Autogenerated input type of CancelProperty */
export type CancelPropertyInput = {
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelProperty */
export type CancelPropertyPayload = {
  __typename?: 'CancelPropertyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Attributes for property cancellation policies */
export type CancellationPolicyInput = {
  startAt: Scalars['Date']['input'];
  endAt: Scalars['Date']['input'];
  amount: Scalars['Float']['input'];
};

/** Autogenerated input type of ClearRefundableAmount */
export type ClearRefundableAmountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClearRefundableAmount */
export type ClearRefundableAmountPayload = {
  __typename?: 'ClearRefundableAmountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Attributes for accepting lift ticket order contact details */
export type ContactDetailsInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  country: Scalars['String']['input'];
};

/** Content */
export type Content = CreatedAtUpdatedAt & {
  __typename?: 'Content';
  /** Content author */
  author?: Maybe<Author>;
  /** Main content */
  content?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  /** Google Map URL */
  googleMapUrl?: Maybe<Scalars['String']['output']>;
  h1LeadAbove?: Maybe<Scalars['String']['output']>;
  h1LeadBelow?: Maybe<Scalars['String']['output']>;
  /** H1 text */
  h1Main?: Maybe<Scalars['String']['output']>;
  heroImage?: Maybe<ContentHeroImage>;
  /** The primary id of this content */
  id: Scalars['ID']['output'];
  /** Meta description for SEO */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** Photo author */
  photoAuthor?: Maybe<Author>;
  /** Related ranked contents */
  rankedContents?: Maybe<RankedContentConnection>;
  /** The region this content belongs to */
  region?: Maybe<Region>;
  /** Related content */
  relatedContents?: Maybe<Array<RelatedContent>>;
  sideNavText?: Maybe<Scalars['String']['output']>;
  /** The friendly slug of this content */
  slug: Scalars['String']['output'];
  /** Content title */
  title: Scalars['String']['output'];
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};


/** Content */
export type ContentRankedContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<OrderByDirectionEnum>;
};

/** The connection type for Content. */
export type ContentConnection = {
  __typename?: 'ContentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Content>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentEdge = {
  __typename?: 'ContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Content>;
};

export type ContentHeroImage = {
  __typename?: 'ContentHeroImage';
  /** Image ID */
  id: Scalars['String']['output'];
  /** Image style type */
  style?: Maybe<ContentHeroImageStyle>;
};


export type ContentHeroImageStyleArgs = {
  type: ContentHeroImageStyleTypeEnum;
};

export type ContentHeroImageStyle = {
  __typename?: 'ContentHeroImageStyle';
  /** Image height */
  height: Scalars['Int']['output'];
  /** Concatenation of image ID and style type for caching purposes */
  id: Scalars['String']['output'];
  /** Image URL */
  url: Scalars['String']['output'];
  /** Image width */
  width: Scalars['Int']['output'];
};

export enum ContentHeroImageStyleTypeEnum {
  Original = 'ORIGINAL',
  Mini = 'MINI',
  Thumb = 'THUMB',
  Card = 'CARD',
  Medium = 'MEDIUM',
  Large = 'LARGE'
}

/** Continent */
export type Continent = {
  __typename?: 'Continent';
  /** The hemisphere of this continent */
  hemisphere: ContinentHemisphereEnum;
  /** Continent ID */
  id: Scalars['ID']['output'];
  /** The name of this continent */
  name: Scalars['String']['output'];
  /** The slug of this continent */
  slug: Scalars['String']['output'];
};

export enum ContinentHemisphereEnum {
  South = 'SOUTH',
  North = 'NORTH'
}

export type Coordinates = {
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Longitude */
  longitude: Scalars['Float']['output'];
};

/** Country */
export type Country = {
  __typename?: 'Country';
  /** Country ID */
  id: Scalars['ID']['output'];
  /** The ISO a2 code of this country */
  isoA2: Scalars['String']['output'];
  /** The ISO a3 code of this country */
  isoA3: Scalars['String']['output'];
  /** The name of this country */
  name: Scalars['String']['output'];
  /** Subregions belonging to this country */
  regions?: Maybe<RegionConnection>;
  /** Resorts belonging to this country */
  resorts?: Maybe<ResortConnection>;
  /** Subregions belonging to this country */
  subregions?: Maybe<SubregionConnection>;
};


/** Country */
export type CountryRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Country */
export type CountryResortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Country */
export type CountrySubregionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum CountryCodeEnum {
  Af = 'AF',
  Ax = 'AX',
  Al = 'AL',
  Dz = 'DZ',
  As = 'AS',
  Ad = 'AD',
  Ao = 'AO',
  Ai = 'AI',
  Aq = 'AQ',
  Ag = 'AG',
  Ar = 'AR',
  Am = 'AM',
  Aw = 'AW',
  Au = 'AU',
  At = 'AT',
  Az = 'AZ',
  Bs = 'BS',
  Bh = 'BH',
  Bd = 'BD',
  Bb = 'BB',
  By = 'BY',
  Be = 'BE',
  Bz = 'BZ',
  Bj = 'BJ',
  Bm = 'BM',
  Bt = 'BT',
  Bo = 'BO',
  Bq = 'BQ',
  Ba = 'BA',
  Bw = 'BW',
  Bv = 'BV',
  Br = 'BR',
  Io = 'IO',
  Bn = 'BN',
  Bg = 'BG',
  Bf = 'BF',
  Bi = 'BI',
  Kh = 'KH',
  Cm = 'CM',
  Ca = 'CA',
  Cv = 'CV',
  Ky = 'KY',
  Cf = 'CF',
  Td = 'TD',
  Cl = 'CL',
  Cn = 'CN',
  Cx = 'CX',
  Cc = 'CC',
  Co = 'CO',
  Km = 'KM',
  Cg = 'CG',
  Cd = 'CD',
  Ck = 'CK',
  Cr = 'CR',
  Ci = 'CI',
  Hr = 'HR',
  Cu = 'CU',
  Cw = 'CW',
  Cy = 'CY',
  Cz = 'CZ',
  Dk = 'DK',
  Dj = 'DJ',
  Dm = 'DM',
  Do = 'DO',
  Ec = 'EC',
  Eg = 'EG',
  Sv = 'SV',
  Gq = 'GQ',
  Er = 'ER',
  Ee = 'EE',
  Et = 'ET',
  Fk = 'FK',
  Fo = 'FO',
  Fj = 'FJ',
  Fi = 'FI',
  Fr = 'FR',
  Gf = 'GF',
  Pf = 'PF',
  Tf = 'TF',
  Ga = 'GA',
  Gm = 'GM',
  Ge = 'GE',
  De = 'DE',
  Gh = 'GH',
  Gi = 'GI',
  Gr = 'GR',
  Gl = 'GL',
  Gd = 'GD',
  Gp = 'GP',
  Gu = 'GU',
  Gt = 'GT',
  Gg = 'GG',
  Gn = 'GN',
  Gw = 'GW',
  Gy = 'GY',
  Ht = 'HT',
  Hm = 'HM',
  Va = 'VA',
  Hn = 'HN',
  Hk = 'HK',
  Hu = 'HU',
  Is = 'IS',
  In = 'IN',
  Id = 'ID',
  Ir = 'IR',
  Iq = 'IQ',
  Ie = 'IE',
  Im = 'IM',
  Il = 'IL',
  It = 'IT',
  Jm = 'JM',
  Jp = 'JP',
  Je = 'JE',
  Jo = 'JO',
  Kz = 'KZ',
  Ke = 'KE',
  Ki = 'KI',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Kg = 'KG',
  La = 'LA',
  Lv = 'LV',
  Lb = 'LB',
  Ls = 'LS',
  Lr = 'LR',
  Ly = 'LY',
  Li = 'LI',
  Lt = 'LT',
  Lu = 'LU',
  Mo = 'MO',
  Mk = 'MK',
  Mg = 'MG',
  Mw = 'MW',
  My = 'MY',
  Mv = 'MV',
  Ml = 'ML',
  Mt = 'MT',
  Mh = 'MH',
  Mq = 'MQ',
  Mr = 'MR',
  Mu = 'MU',
  Yt = 'YT',
  Mx = 'MX',
  Fm = 'FM',
  Md = 'MD',
  Mc = 'MC',
  Mn = 'MN',
  Me = 'ME',
  Ms = 'MS',
  Ma = 'MA',
  Mz = 'MZ',
  Mm = 'MM',
  Na = 'NA',
  Nr = 'NR',
  Np = 'NP',
  Nl = 'NL',
  Nc = 'NC',
  Nz = 'NZ',
  Ni = 'NI',
  Ne = 'NE',
  Ng = 'NG',
  Nu = 'NU',
  Nf = 'NF',
  Mp = 'MP',
  No = 'NO',
  Om = 'OM',
  Pk = 'PK',
  Pw = 'PW',
  Ps = 'PS',
  Pa = 'PA',
  Pg = 'PG',
  Py = 'PY',
  Pe = 'PE',
  Ph = 'PH',
  Pn = 'PN',
  Pl = 'PL',
  Pt = 'PT',
  Pr = 'PR',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Ru = 'RU',
  Rw = 'RW',
  Bl = 'BL',
  Sh = 'SH',
  Kn = 'KN',
  Lc = 'LC',
  Mf = 'MF',
  Pm = 'PM',
  Vc = 'VC',
  Ws = 'WS',
  Sm = 'SM',
  St = 'ST',
  Sa = 'SA',
  Sn = 'SN',
  Rs = 'RS',
  Sc = 'SC',
  Sl = 'SL',
  Sg = 'SG',
  Sx = 'SX',
  Sk = 'SK',
  Si = 'SI',
  Sb = 'SB',
  So = 'SO',
  Za = 'ZA',
  Gs = 'GS',
  Ss = 'SS',
  Es = 'ES',
  Lk = 'LK',
  Sd = 'SD',
  Sr = 'SR',
  Sj = 'SJ',
  Sz = 'SZ',
  Se = 'SE',
  Ch = 'CH',
  Sy = 'SY',
  Tw = 'TW',
  Tj = 'TJ',
  Tz = 'TZ',
  Th = 'TH',
  Tl = 'TL',
  Tg = 'TG',
  Tk = 'TK',
  To = 'TO',
  Tt = 'TT',
  Tn = 'TN',
  Tr = 'TR',
  Tm = 'TM',
  Tc = 'TC',
  Tv = 'TV',
  Ug = 'UG',
  Ua = 'UA',
  Ae = 'AE',
  Gb = 'GB',
  Us = 'US',
  Um = 'UM',
  Uy = 'UY',
  Uz = 'UZ',
  Vu = 'VU',
  Ve = 'VE',
  Vn = 'VN',
  Vg = 'VG',
  Vi = 'VI',
  Wf = 'WF',
  Eh = 'EH',
  Ye = 'YE',
  Zm = 'ZM',
  Zw = 'ZW'
}

/** Coupon / ProductDiscount */
export type Coupon = CreatedAtUpdatedAt & {
  __typename?: 'Coupon';
  active: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  discountValue?: Maybe<Scalars['Float']['output']>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  itineraries: Array<Itinerary>;
  maxUse?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  numOfPaidUses: Scalars['Int']['output'];
  originItinerary?: Maybe<Itinerary>;
  reason?: Maybe<ProductDiscountReasonEnum>;
  remainingAmount: Scalars['Float']['output'];
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for Coupon. */
export type CouponConnection = {
  __typename?: 'CouponConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CouponEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Coupon>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CouponEdge = {
  __typename?: 'CouponEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Coupon>;
};

/** Autogenerated input type of CreateAttachment */
export type CreateAttachmentInput = {
  /** Signed blob ID generated via `createDirectUpload` mutation */
  signedBlobId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAttachment */
export type CreateAttachmentPayload = {
  __typename?: 'CreateAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of CreateCoupon */
export type CreateCouponInput = {
  /** Name to reference this coupon */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Coupon code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Coupon currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Number of uses allowed */
  maxUse?: InputMaybe<Scalars['Int']['input']>;
  /** Discount value of the coupon */
  value: Scalars['String']['input'];
  /** Date that this coupon expires at */
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  /** Origin itinerary that the coupon is related to */
  originItineraryId?: InputMaybe<Scalars['ID']['input']>;
  reason: ProductDiscountReasonEnum;
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Minimum spend required for the coupon to be applicable */
  minSpend?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateCoupon */
export type CreateCouponPayload = {
  __typename?: 'CreateCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
};

/** Autogenerated input type of CreateDirectUpload */
export type CreateDirectUploadInput = {
  /** Original file name */
  filename: Scalars['String']['input'];
  /** File size (bytes) */
  byteSize: Scalars['Int']['input'];
  /** MD5 file checksum as base64 */
  checksum: Scalars['String']['input'];
  /** File content type */
  contentType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDirectUpload */
export type CreateDirectUploadPayload = {
  __typename?: 'CreateDirectUploadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  directUpload: DirectUpload;
};

/** Autogenerated input type of CreateLiftTicketBlackout */
export type CreateLiftTicketBlackoutInput = {
  /** ID of the resort */
  resortId: Scalars['ID']['input'];
  /** Date in format of yyyy-mm-dd */
  date: Scalars['Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLiftTicketBlackout */
export type CreateLiftTicketBlackoutPayload = {
  __typename?: 'CreateLiftTicketBlackoutPayload';
  /** Whether this date is blacked out */
  blackout?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Date of the blackout */
  date?: Maybe<Scalars['Date']['output']>;
};

/** Autogenerated input type of CreateNote */
export type CreateNoteInput = {
  /** Blob of text to be noted */
  text: Scalars['String']['input'];
  /** ID of the object to be noted */
  notableId: Scalars['ID']['input'];
  /** Type of the object to be noted */
  notableType: NotableTypeEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateNote */
export type CreateNotePayload = {
  __typename?: 'CreateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Note>;
};

/** Autogenerated input type of CreatePropertyProductReview */
export type CreatePropertyProductReviewInput = {
  /** Itinerary ID related to this review */
  itineraryId: Scalars['ID']['input'];
  /** Property ID related to this review */
  propertyProductId: Scalars['ID']['input'];
  /** Short review comment */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Review score */
  score?: InputMaybe<Scalars['Int']['input']>;
  /** How did the customer find us? */
  customerAcquisitionChannel?: InputMaybe<Scalars['String']['input']>;
  /** Other notes about how the customer found us */
  cacOtherNotes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePropertyProductReview */
export type CreatePropertyProductReviewPayload = {
  __typename?: 'CreatePropertyProductReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<FormParamError>>;
  /** Successfully created review */
  propertyProductReview?: Maybe<PropertyProductReview>;
};

/** Autogenerated return type of CreateReview */
export type CreateReviewPayload = {
  __typename?: 'CreateReviewPayload';
  newReviewEdge: ReviewEdge;
  resort: Resort;
  reviewsConnection: ReviewConnection;
};


/** Autogenerated return type of CreateReview */
export type CreateReviewPayloadReviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateUser */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  user: User;
};

export type CreatedAtUpdatedAt = {
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};

/** Attributes for accepting a credit card */
export type CreditCard = {
  /** First name of the credit card owner */
  firstName: Scalars['String']['input'];
  /** Last name of the credit card owner */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Credit card number */
  number: Scalars['String']['input'];
  /** Credit card expiry month */
  month: Scalars['String']['input'];
  /** Credit card expiry year */
  year: Scalars['String']['input'];
  /** Credit card verification number */
  verificationValue: Scalars['String']['input'];
};

export type CreditCardMutations = {
  __typename?: 'CreditCardMutations';
  create?: Maybe<MutationsCreditCardCreatePayload>;
  remove?: Maybe<MutationsCreditCardRemovePayload>;
  setDefaultCard?: Maybe<MutationsCreditCardSetDefaultCardPayload>;
};


export type CreditCardMutationsCreateArgs = {
  input: MutationsCreditCardCreateInput;
};


export type CreditCardMutationsRemoveArgs = {
  input: MutationsCreditCardRemoveInput;
};


export type CreditCardMutationsSetDefaultCardArgs = {
  input: MutationsCreditCardSetDefaultCardInput;
};

export type CuratedPropertyDatum = {
  __typename?: 'CuratedPropertyDatum';
  checkinSpecialInstructions?: Maybe<Scalars['String']['output']>;
  gettingAround?: Maybe<Scalars['String']['output']>;
  groceryShopping?: Maybe<Scalars['String']['output']>;
  highlights?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  petFees?: Maybe<Scalars['String']['output']>;
  shuttleMap?: Maybe<Scalars['String']['output']>;
  shuttleTimetable?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeactivateCoupon */
export type DeactivateCouponInput = {
  /** Coupon code */
  code: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeactivateCoupon */
export type DeactivateCouponPayload = {
  __typename?: 'DeactivateCouponPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  coupon: Coupon;
};

export enum DestinationTypeEnum {
  Resort = 'RESORT',
  Subregion = 'SUBREGION',
  Region = 'REGION',
  Propertyproduct = 'PROPERTYPRODUCT'
}

/** Represents direct upload credentials */
export type DirectUpload = {
  __typename?: 'DirectUpload';
  /** Created blob record ID */
  blobId: Scalars['ID']['output'];
  /** HTTP request headers (JSON-encoded) */
  headers: Scalars['String']['output'];
  /** Generated UUID */
  id: Scalars['ID']['output'];
  /** Created blob record signed ID */
  signedBlobId: Scalars['ID']['output'];
  /** Upload URL */
  url: Scalars['String']['output'];
};

/** Autogenerated input type of DuplicateItinerary */
export type DuplicateItineraryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DuplicateItinerary */
export type DuplicateItineraryPayload = {
  __typename?: 'DuplicateItineraryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of EmailItinerary */
export type EmailItineraryInput = {
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['Email']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EmailItinerary */
export type EmailItineraryPayload = {
  __typename?: 'EmailItineraryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

export enum EmailTypeEnum {
  FirstConfirmation = 'FIRST_CONFIRMATION',
  FinalConfirmation = 'FINAL_CONFIRMATION',
  Cancellation = 'CANCELLATION',
  PartialCancellation = 'PARTIAL_CANCELLATION',
  InsuranceClaim = 'INSURANCE_CLAIM'
}

/** Rating information provided by guests who stayed at this property */
export type ExpediaGuestRating = {
  __typename?: 'ExpediaGuestRating';
  /** The rating for the amenities provided by the property, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  amenities?: Maybe<Scalars['String']['output']>;
  /** The cleanliness rating for the property, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  cleanliness?: Maybe<Scalars['String']['output']>;
  /** The comfort rating of the rooms, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  comfort?: Maybe<Scalars['String']['output']>;
  /** The rating for the property’s condition, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  condition?: Maybe<Scalars['String']['output']>;
  /** A count of all of the guest review ratings which currently exist for this property. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The rating for how convinent the location of the property is, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  location?: Maybe<Scalars['String']['output']>;
  /** The rating for how satisfying the neighborhood of the property is, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** Overall rating for the property averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  overall?: Maybe<Scalars['String']['output']>;
  /** The quality rating of the rooms, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  quality?: Maybe<Scalars['String']['output']>;
  /** Overall rating for the property averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  rating?: Maybe<Scalars['String']['output']>;
  /** The percent of guests who recommend staying at this property. */
  recommendationPercent?: Maybe<Scalars['String']['output']>;
  /** The rating of the staff’s service for the property, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  service?: Maybe<Scalars['String']['output']>;
  /** The rating for how much value the property provided for the cost of the stay, averaged from all guest reviews. Returns a value between 1.0 and 5.0. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Information about the property’s star rating */
export type ExpediaPropertyRating = {
  __typename?: 'ExpediaPropertyRating';
  /** The rating assigned to this property. Returns a value between 0.5 and 5.0. A blank value indicates no rating is available. */
  rating?: Maybe<Scalars['String']['output']>;
  /** Returns a value of either 'Star' or 'Alternate'. Star indicates the rating is provided by the property’s local star rating authority. Alternate indicates that the rating is an Expedia-assigned value; an official rating was not available. */
  type?: Maybe<Scalars['String']['output']>;
};

/** The room information. */
export type ExpediaPropertyRoomAvailability = {
  __typename?: 'ExpediaPropertyRoomAvailability';
  /**
   * Lists all of the amenities available in the room. See our amenities
   * reference for current known amenity ID and name values.
   *
   */
  amenities?: Maybe<Array<Maybe<Amenity>>>;
  /** A map of the room's bed groups. */
  bedGroups?: Maybe<Array<Maybe<BedGroup>>>;
  /** Provides an overview description of a room. */
  descriptions?: Maybe<Scalars['String']['output']>;
  /** Room ID. */
  id: Scalars['ID']['output'];
  /** The room's images. Contains all room images available. */
  images?: Maybe<Array<Maybe<Image>>>;
  /** Name of the room. */
  name: Scalars['String']['output'];
  /** Array of objects containing rate information. */
  rates: Array<PropertyRoomRate>;
};

/** Autogenerated input type of FinalizeDuplicate */
export type FinalizeDuplicateInput = {
  /** Primary Key of credit card to charge */
  creditCardId?: InputMaybe<Scalars['ID']['input']>;
  /** New credit card details */
  creditCardParams?: InputMaybe<CreditCard>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FinalizeDuplicate */
export type FinalizeDuplicatePayload = {
  __typename?: 'FinalizeDuplicatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Finalized Itinerary */
  itinerary: Itinerary;
};

/** Autogenerated input type of FinalizeDuplicateWithoutPayment */
export type FinalizeDuplicateWithoutPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FinalizeDuplicateWithoutPayment */
export type FinalizeDuplicateWithoutPaymentPayload = {
  __typename?: 'FinalizeDuplicateWithoutPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of FinalizeWithoutPayment */
export type FinalizeWithoutPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FinalizeWithoutPayment */
export type FinalizeWithoutPaymentPayload = {
  __typename?: 'FinalizeWithoutPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

export type FloatRangeInput = {
  /** Minimum value */
  min: Scalars['Float']['input'];
  /** Maximum value */
  max: Scalars['Float']['input'];
};

/** Form error object */
export type FormParamError = {
  __typename?: 'FormParamError';
  /** Errors related to this param */
  errors: Array<Scalars['String']['output']>;
  /** Name of the param that caused the error */
  param: Scalars['String']['output'];
};

export enum GenderEnum {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER'
}

/**
 * An individual image. See our image categories reference for current known
 * caption and category values.
 *
 */
export type Image = {
  __typename?: 'Image';
  /** Image caption */
  caption?: Maybe<Scalars['String']['output']>;
  /** The category of the image. */
  category: Scalars['String']['output'];
  /** Whether this image is a hero image or not. */
  heroImage: Scalars['Boolean']['output'];
  /** The primary id of this image */
  id: Scalars['ID']['output'];
  /** The URL of the largest image */
  link: Scalars['String']['output'];
  /** Image URL links */
  links: Scalars['JSON']['output'];
  /** Order index of the image */
  order: Scalars['Int']['output'];
};

/** The connection type for Image. */
export type ImageConnection = {
  __typename?: 'ImageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ImageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Image>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ImageEdge = {
  __typename?: 'ImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Image>;
};

export enum ImageSizeEnum {
  Original = 'Original',
  Mini = 'Mini',
  Thumb = 'Thumb',
  Medium = 'Medium',
  Wide = 'Wide'
}

/** Autogenerated return type of ImportComponents */
export type ImportComponentsPayload = {
  __typename?: 'ImportComponentsPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of ImportEquipmentRentals */
export type ImportEquipmentRentalsPayload = {
  __typename?: 'ImportEquipmentRentalsPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of ImportGroundTransfers */
export type ImportGroundTransfersPayload = {
  __typename?: 'ImportGroundTransfersPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of ImportLiftTickets */
export type ImportLiftTicketsPayload = {
  __typename?: 'ImportLiftTicketsPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of ImportLodging */
export type ImportLodgingPayload = {
  __typename?: 'ImportLodgingPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of ImportRegion */
export type ImportRegionPayload = {
  __typename?: 'ImportRegionPayload';
  message: Scalars['String']['output'];
};

/** Input type for Date comparison queries on SearchKick */
export type InputsComparisonDate = {
  /** Parseable Date string for comparison */
  value: Scalars['Date']['input'];
  /** Comparison required on Date */
  comparison: ScalarComparisonEnum;
};

/** Input type for Float comparison queries on SearchKick */
export type InputsComparisonFloat = {
  /** Parseable Float for comparison */
  value: Scalars['Float']['input'];
  /** Comparison required on Float */
  comparison: ScalarComparisonEnum;
};

/** Input type for Integer comparison queries on SearchKick */
export type InputsComparisonInteger = {
  /** Parseable Integer for comparison */
  value: Scalars['Int']['input'];
  /** Comparison required on Integer */
  comparison: ScalarComparisonEnum;
};

export type IntegerRangeInput = {
  /** Minimum value */
  min: Scalars['Int']['input'];
  /** Maximum value */
  max: Scalars['Int']['input'];
};

/** Itinerary */
export type Itinerary = CreatedAtUpdatedAt & {
  __typename?: 'Itinerary';
  /** The arrival date of the itinerary */
  arriveAt: Scalars['Date']['output'];
  audits?: Maybe<AuditedConnection>;
  /** Bundle line item */
  bundleLineItem?: Maybe<BundleProductLineItemType>;
  /** Price breakdown using LineItems calculator */
  calculatedPriceBreakdown: Scalars['JSON']['output'];
  /** Itinerary cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The date when the itinerary cancellation cutoff is at */
  cancellationCutoffAt?: Maybe<Scalars['DateTime']['output']>;
  /** Itinerary cancellation policies */
  cancellationPolicies?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Duplicated itinerary */
  child?: Maybe<Itinerary>;
  /** Coupon applied to the itinerary */
  coupon?: Maybe<Coupon>;
  /** The code of the coupon */
  couponCode?: Maybe<Scalars['String']['output']>;
  /** Total amount of coupon discount applied to the itinerary */
  couponDiscount: Scalars['Float']['output'];
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  /** The currency of the itinerary */
  currency: Scalars['String']['output'];
  customerAgent?: Maybe<User>;
  /** Itinerary data */
  data?: Maybe<Scalars['JSON']['output']>;
  /** The departure date of the itinerary */
  departAt: Scalars['Date']['output'];
  /** moving_taxes split test - use this instead of tax_amount */
  displayableTaxAmount: Scalars['Float']['output'];
  /** Date of birth of the main contact */
  dob?: Maybe<Scalars['String']['output']>;
  /** A list of duplicated itineraries from the main itinerary */
  duplicated: Array<Itinerary>;
  /** Email of the main contact */
  email?: Maybe<Scalars['Email']['output']>;
  f4Agent?: Maybe<User>;
  /** First name of the main contact */
  firstName?: Maybe<Scalars['String']['output']>;
  flightInfoAgent?: Maybe<User>;
  /** @deprecated No longer used */
  followupEmail1Sent: Scalars['Boolean']['output'];
  followupEmail2DueAt?: Maybe<Scalars['Date']['output']>;
  followupEmail2Sent: Scalars['Boolean']['output'];
  followupEmail3DueAt?: Maybe<Scalars['Date']['output']>;
  followupEmail3Sent: Scalars['Boolean']['output'];
  followupEmail4DueAt?: Maybe<Scalars['Date']['output']>;
  followupEmail4Sent: Scalars['Boolean']['output'];
  fulfilmentAgent?: Maybe<User>;
  fulfilmentAttachments: ActiveStorageConnection;
  fulfilmentState: ItineraryFulfilmentStateEnum;
  /** Has the duplicated itinerary changed in terms of line items */
  hasLineItemsChanged: Scalars['Boolean']['output'];
  /** Session ID of the itinerary */
  id: Scalars['ID']['output'];
  inProgressAgent?: Maybe<User>;
  /** Internal DB ID */
  internalId: Scalars['ID']['output'];
  invoiceReceived: Scalars['Boolean']['output'];
  isAudited: Scalars['Boolean']['output'];
  isCancelled: Scalars['Boolean']['output'];
  isConfirmationNumberReceived: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  /** Indicates whether any coupons has been applied to the itinerary */
  isCouponApplied: Scalars['Boolean']['output'];
  isDraftDuplicate: Scalars['Boolean']['output'];
  isDuplicated: Scalars['Boolean']['output'];
  isFlightsRequired: Scalars['Boolean']['output'];
  isInformationRequired: Scalars['Boolean']['output'];
  isModified: Scalars['Boolean']['output'];
  isOnRequest: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  isProblematic: Scalars['Boolean']['output'];
  isRetailRequired: Scalars['Boolean']['output'];
  isUrgent: Scalars['Boolean']['output'];
  /** Last name of the main contact */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Last scheduled payment for itinerary, used for insurance fulfilment */
  lastScheduledPayment?: Maybe<ScheduledPayment>;
  lessonAgent?: Maybe<User>;
  /** Lesson line items */
  lessonLineItems: LessonProductLineItemTypeConnection;
  liftTicketAgent?: Maybe<User>;
  /** Lift ticket line items */
  liftTicketLineItems: LiftTicketProductLineItemConnection;
  /** Line items that have been added to the itinerary */
  lineItems: Array<LineItem>;
  /** Itinerary lock details */
  lock: TypesItineraryItineraryLockType;
  /** The very first itinerary that the customer has booked */
  main: Itinerary;
  /** Primary Key of the main itinerary */
  mainId: Scalars['ID']['output'];
  manualFollowupEmail4Required: Scalars['Boolean']['output'];
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Traveler details as object */
  normalizedTravelerDetails?: Maybe<Array<TravelerDetail>>;
  /** Itinerary notes */
  notes?: Maybe<NoteConnection>;
  notifications: NotificationConnection;
  /** Old fake ID */
  oldFakeId: Scalars['ID']['output'];
  /** The date when the itinerary is being paid */
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  /** The parent itinerary that this itinerary was duplicated from */
  parent?: Maybe<Itinerary>;
  /** Primary Key of the parent itinerary */
  parentId?: Maybe<Scalars['ID']['output']>;
  /** Itinerary payment schedules */
  paymentSchedules?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Itinerary payments */
  payments?: Maybe<PaymentConnection>;
  /** Phone number of the main contact */
  phone?: Maybe<Scalars['String']['output']>;
  postBookingAgent?: Maybe<User>;
  postBookingCallSuccessful: Scalars['Boolean']['output'];
  postBookingCallUnsuccessful?: Maybe<Scalars['Boolean']['output']>;
  postBookingCalls?: Maybe<PostBookingCallConnection>;
  /** @deprecated Use pre_arrival_call_one instead */
  preArrivalCall: Scalars['Boolean']['output'];
  preArrivalCallOne: Scalars['Boolean']['output'];
  preArrivalCallTwo: Scalars['Boolean']['output'];
  preArrivalCalls?: Maybe<PreArrivalCallConnection>;
  preArrivalCompleted: Scalars['Boolean']['output'];
  productsConfirmed: Scalars['Boolean']['output'];
  productsOrdered: Scalars['Boolean']['output'];
  /** Aggregated total amount of all the products */
  productsTotal?: Maybe<Scalars['JSON']['output']>;
  /** Property line item */
  propertyLineItem: PropertyProductLineItem;
  /** Property payment */
  propertyPayment?: Maybe<Payment>;
  /** Aggregated total amount of the property */
  propertyTotal?: Maybe<Scalars['JSON']['output']>;
  /** Public facing ID */
  publicId: Scalars['ID']['output'];
  refundableAmount?: Maybe<Scalars['Float']['output']>;
  /** Coupons that were created because of this itinerary */
  relatedCoupons: Array<Coupon>;
  remainingBalancePaid: Scalars['Boolean']['output'];
  rentalAgent?: Maybe<User>;
  /** Rental line itemss */
  rentalLineItems: RentalProductLineItemConnection;
  requestedAgent?: Maybe<User>;
  /** Related resort */
  resort?: Maybe<Resort>;
  /** Itinerary scheduled payments */
  scheduledPayments?: Maybe<ScheduledPaymentConnection>;
  /** Session ID of the itinerary - use this instead of :id */
  sessionId: Scalars['ID']['output'];
  /** Ski.com Quote ID */
  skicomQuoteId?: Maybe<Scalars['Int']['output']>;
  /** Current state of the itinerary */
  state: ItineraryStateEnum;
  supplierNotes?: Maybe<Scalars['String']['output']>;
  supplierPaid: Scalars['Boolean']['output'];
  /** Support cases for itinerary */
  supportCases: Array<SupportCase>;
  /** The AB test version of the itinerary */
  testVersion?: Maybe<Scalars['String']['output']>;
  /** Total amount of the itinerary before any discounts being applied */
  totalAmount: Scalars['Float']['output'];
  /** Total amount of card fees */
  totalCardFees: Scalars['JSON']['output'];
  /** Total amount needed to secure the itinerary */
  totalDepositAmount: Scalars['Float']['output'];
  /** Total discount applied to the itinerary */
  totalDiscount: Scalars['Float']['output'];
  /** Total percentage of discount */
  totalDiscountPercentage: Scalars['Int']['output'];
  /** Total amount of the fees (eg: Resort fees that need to be paid on arrival) */
  totalFees: Scalars['Float']['output'];
  /** Total paid amount */
  totalPaidAmount: Scalars['Float']['output'];
  /** Total payable amount of the itinerary */
  totalPayable: Scalars['Float']['output'];
  /** Total amount remaining */
  totalRemaining: Scalars['Float']['output'];
  /** Total amount of the tax being paid */
  totalTaxAmount: Scalars['Float']['output'];
  transportationAgent?: Maybe<User>;
  /** Transportation line items */
  transportationLineItems: TransportationProductLineItemConnection;
  /** Itinerary traveler details */
  travelerDetails?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
  /** Upsell line items */
  upsellLineItems: UpsellProductLineItemConnection;
  /** The user that this itinerary belongs to */
  user?: Maybe<User>;
  /** User credit cards available to the itinerary */
  userCreditCards: UserCreditCardConnection;
  /** @deprecated No longer exists due to audit log updates */
  versions?: Maybe<TypesVersionConnection>;
};


/** Itinerary */
export type ItineraryAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryFulfilmentAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryLessonLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryLiftTicketLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Itinerary */
export type ItineraryPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  includeFailed?: InputMaybe<Scalars['Boolean']['input']>;
  trxnType?: InputMaybe<Array<PaymentTrxnTypeEnum>>;
};


/** Itinerary */
export type ItineraryPostBookingCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryPreArrivalCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryRentalLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryScheduledPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  paymentType?: InputMaybe<Array<ScheduledPaymentPaymentTypeEnum>>;
  snowpakCollect?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Itinerary */
export type ItineraryTransportationLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryUpsellLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryUserCreditCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Itinerary */
export type ItineraryVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ItineraryArrivalDepatureInput = {
  arrival?: InputMaybe<Scalars['Date']['input']>;
  departure?: InputMaybe<Scalars['Date']['input']>;
};

/** The connection type for Itinerary. */
export type ItineraryConnection = {
  __typename?: 'ItineraryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItineraryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Itinerary>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ItineraryEdge = {
  __typename?: 'ItineraryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Itinerary>;
};

export type ItineraryEmailLog = {
  __typename?: 'ItineraryEmailLog';
  address?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itinerary: Itinerary;
  sentBy?: Maybe<User>;
  state: ItineraryEmailLogStateEnum;
  type: ItineraryEmailLogTypeEnum;
};

export enum ItineraryEmailLogStateEnum {
  Pending = 'PENDING',
  Failure = 'FAILURE',
  Queued = 'QUEUED',
  Success = 'SUCCESS',
  Unsubscribed = 'UNSUBSCRIBED'
}

export enum ItineraryEmailLogTypeEnum {
  Confirmation = 'CONFIRMATION',
  Followup_1 = 'FOLLOWUP_1',
  Followup_4 = 'FOLLOWUP_4',
  SavedItinerary = 'SAVED_ITINERARY',
  Review = 'REVIEW',
  Cancellation = 'CANCELLATION',
  PartialCancellation = 'PARTIAL_CANCELLATION',
  PreArrival = 'PRE_ARRIVAL',
  InsuranceClaim = 'INSURANCE_CLAIM',
  FollowupForKillington = 'FOLLOWUP_FOR_KILLINGTON',
  RemainingBalanceReminder = 'REMAINING_BALANCE_REMINDER',
  PaymentCollected = 'PAYMENT_COLLECTED',
  CustomerAcquisitionChannel = 'CUSTOMER_ACQUISITION_CHANNEL'
}

export enum ItineraryFulfilmentEventEnum {
  AuditIssue = 'AuditIssue',
  FulfilmentIssue = 'FulfilmentIssue',
  Audit = 'Audit',
  Order = 'Order',
  Confirm = 'Confirm',
  Notify = 'Notify',
  Cancel = 'Cancel',
  RequestChange = 'RequestChange',
  ProceedChange = 'ProceedChange',
  RequestCancel = 'RequestCancel',
  ProceedCancel = 'ProceedCancel'
}

export enum ItineraryFulfilmentStateEnum {
  NewBooking = 'NEW_BOOKING',
  PendingOrder = 'PENDING_ORDER',
  PendingConfirmation = 'PENDING_CONFIRMATION',
  FinalCheck = 'FINAL_CHECK',
  Ready = 'READY',
  Cancelled = 'CANCELLED',
  AuditIssue = 'AUDIT_ISSUE',
  FulfilmentIssue = 'FULFILMENT_ISSUE',
  CancelRequested = 'CANCEL_REQUESTED',
  CancelInProgress = 'CANCEL_IN_PROGRESS',
  ChangeRequested = 'CHANGE_REQUESTED',
  ChangeInProgress = 'CHANGE_IN_PROGRESS'
}

/** Attributes for itinerary */
export type ItineraryInput = {
  /** First name of the main contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the main contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Email of the main contact */
  email?: InputMaybe<Scalars['Email']['input']>;
  /** Phone number of the main contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the main contact */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** Address of the contact */
  address?: InputMaybe<Address>;
  /** Additional notes for the itinerary */
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for accepting a property room to the itinerary */
export type ItineraryInputPropertyRoom = {
  /** Title of the main contact for the room */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Given name of the main contact for the room */
  givenName: Scalars['String']['input'];
  /** Family name of the main contact for the room */
  familyName: Scalars['String']['input'];
  /** Email of the main contact for the room */
  email: Scalars['Email']['input'];
  /** Contact phone number of the main contact for the room */
  phone: Scalars['Phone']['input'];
  /** Indication of whether the traveller is smoking or not */
  smoking: Scalars['Boolean']['input'];
  /** Any special requests */
  specialRequest?: InputMaybe<Scalars['String']['input']>;
};

export type ItineraryResolverItineraryInput = {
  /** Itinerary ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Itinerary session_id */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** Itinerary public ID */
  publicId?: InputMaybe<Scalars['ID']['input']>;
  /** First name of the main contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the main contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Email of the main contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone of the main contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Name of the property */
  propertyName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the resort */
  resortName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of the region */
  regionName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the country */
  countryName?: InputMaybe<Scalars['String']['input']>;
  customerAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  postBookingAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  saleDate?: InputMaybe<Scalars['Date']['input']>;
  payableAmount?: InputMaybe<Scalars['Float']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  fulfilmentState?: InputMaybe<Array<ItineraryFulfilmentStateEnum>>;
  fulfilmentAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  liftTicketAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  rentalAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  transportationAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  lessonAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  f4AgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestedAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  inProgressAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  flightInfoAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  infoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  flightInfoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['Boolean']['input']>;
  preArrivalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  preArrivalSmsSent?: InputMaybe<Scalars['Boolean']['input']>;
  preArrivalCallUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  preArrivalCallOutcome?: InputMaybe<Array<PreArrivalCallOutcomesEnum>>;
  postBookingRequired?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingSmsSent?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingCallUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  postBookingCallOutcome?: InputMaybe<Array<PostBookingCallOutcomesEnum>>;
  nextPaymentDueAt?: InputMaybe<Scalars['Date']['input']>;
  propertyStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  liftTicketStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  rentalStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  transportationStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  insuranceStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  lessonStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  dateRange?: InputMaybe<ItineraryArrivalDepatureInput>;
  /** Itinerary state */
  state?: InputMaybe<Array<ItineraryStateEnum>>;
  /** Flag to check if manual F4 is required */
  manualFollowupEmail4Required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to check if property is manual fulfilment */
  propertyManualFulfilment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the rental product supplier */
  rentalProductSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  productFreeCancelDate?: InputMaybe<Scalars['Date']['input']>;
  lodgingFreeCancelDate?: InputMaybe<Scalars['Date']['input']>;
  tableNotes?: InputMaybe<Scalars['String']['input']>;
};

export type ItinerarySearchResolverFilterInput = {
  /** Itinerary ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Itinerary session_id */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** Itinerary old fake ID */
  oldFakeId?: InputMaybe<Scalars['String']['input']>;
  /** Ski.com quote ID */
  skicomQuoteId?: InputMaybe<Scalars['ID']['input']>;
  /** Itinerary public ID */
  publicId?: InputMaybe<Scalars['ID']['input']>;
  /** First name of the main contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the main contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Email of the main contact */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Phone of the main contact */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Name of the property */
  propertyName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the resort */
  resortName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Name of the region */
  regionName?: InputMaybe<Scalars['String']['input']>;
  /** Name of the country */
  countryName?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<ItinerarySearchResolverProductTypeEnum>>;
  fulfilmentState?: InputMaybe<Array<ItineraryFulfilmentStateEnum>>;
  customerAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  postBookingAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  fulfilmentAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  liftTicketAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  rentalAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  transportationAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  lessonAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  f4AgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestedAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  inProgressAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  flightInfoAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  infoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  flightInfoRequired?: InputMaybe<Scalars['Boolean']['input']>;
  modified?: InputMaybe<Scalars['Boolean']['input']>;
  preArrivalCallUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  preArrivalCallOutcome?: InputMaybe<Array<PreArrivalCallOutcomesEnum>>;
  preArrivalSmsSent?: InputMaybe<Scalars['Boolean']['input']>;
  preArrivalCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingCallUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  postBookingCallOutcome?: InputMaybe<Array<PostBookingCallOutcomesEnum>>;
  postBookingSmsSent?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingCallSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingCallUnsuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  propertyStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  liftTicketStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  rentalStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  lessonStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  transportationStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  insuranceStatus?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  /** Itinerary state */
  state?: InputMaybe<Array<ItineraryStateEnum>>;
  remainingBalancesCollected?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to check if manual F4 is required */
  manualFollowupEmail4Required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Flag to check if property is manual fulfilment */
  propertyManualFulfilment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the rental product supplier */
  rentalProductSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  liftTicketCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  rentalCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  lessonCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  transportationCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  insuranceCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer residency state code */
  customerResidencyState?: InputMaybe<Scalars['String']['input']>;
  /** Customer residency country code */
  customerResidencyCountry?: InputMaybe<Scalars['String']['input']>;
  lessonWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  arriveAt?: InputMaybe<Array<InputsComparisonDate>>;
  departAt?: InputMaybe<Array<InputsComparisonDate>>;
  nextPaymentDueAt?: InputMaybe<Array<InputsComparisonDate>>;
  paidAt?: InputMaybe<Array<InputsComparisonDate>>;
  payableAmount?: InputMaybe<Array<InputsComparisonInteger>>;
  productFreeCancelDate?: InputMaybe<Array<InputsComparisonDate>>;
  lodgingFreeCancelDate?: InputMaybe<Array<InputsComparisonDate>>;
  propertyOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
  liftTicketOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
  rentalOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
  lessonOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
  transportationOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
  insuranceOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
  and?: InputMaybe<Array<ItinerarySearchResolverFilterInput>>;
  or?: InputMaybe<Array<ItinerarySearchResolverFilterInput>>;
  not?: InputMaybe<ItinerarySearchResolverFilterInput>;
};

export enum ItinerarySearchResolverProductTypeEnum {
  None = 'NONE',
  LessonProduct = 'LESSON_PRODUCT',
  LiftTicketProduct = 'LIFT_TICKET_PRODUCT',
  RentalProduct = 'RENTAL_PRODUCT',
  TransportationProduct = 'TRANSPORTATION_PRODUCT',
  UpsellProduct = 'UPSELL_PRODUCT'
}

/** The connection type for ItinerarySearchkickResult. */
export type ItinerarySearchkickConnection = SearchkickPaginationInterface & {
  __typename?: 'ItinerarySearchkickConnection';
  /** Current page # */
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ItinerarySearchkickResultEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ItinerarySearchkickResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Current # of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total # of possible results */
  totalCount: Scalars['Int']['output'];
  /** Total # of possible pages */
  totalPages: Scalars['Int']['output'];
};

/** Itinerary Searchkick result */
export type ItinerarySearchkickResult = {
  __typename?: 'ItinerarySearchkickResult';
  /** The arrival date of the itinerary */
  arriveAt: Scalars['Date']['output'];
  /** Country name */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Currency */
  currency: Scalars['String']['output'];
  /** Current customer agent (for prearrival calls) */
  customerAgent?: Maybe<User>;
  customerResidencyCountry?: Maybe<Scalars['String']['output']>;
  customerResidencyState?: Maybe<Scalars['String']['output']>;
  /** The departure date of the itinerary */
  departAt: Scalars['Date']['output'];
  /** Email of the main contact */
  email?: Maybe<Scalars['Email']['output']>;
  f4Agent?: Maybe<User>;
  /** First name of the main contact */
  firstName?: Maybe<Scalars['String']['output']>;
  flightInfoAgent?: Maybe<User>;
  flightInfoRequired: Scalars['Boolean']['output'];
  /** Current fulfilment agent */
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: ItineraryFulfilmentStateEnum;
  /** Primary ID of the itinerary */
  id: Scalars['ID']['output'];
  inProgressAgent?: Maybe<User>;
  infoRequired: Scalars['Boolean']['output'];
  insuranceCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  insuranceOrderedAt?: Maybe<Scalars['Date']['output']>;
  insuranceStatus?: Maybe<LineItemFulfilmentStateEnum>;
  /** Last name of the main contact */
  lastName?: Maybe<Scalars['String']['output']>;
  lessonAgent?: Maybe<User>;
  lessonCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  lessonOrderedAt?: Maybe<Scalars['Date']['output']>;
  lessonStatus?: Maybe<LineItemFulfilmentStateEnum>;
  lessonWaiver?: Maybe<Scalars['Boolean']['output']>;
  liftTicketAgent?: Maybe<User>;
  liftTicketCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  liftTicketOrderedAt?: Maybe<Scalars['Date']['output']>;
  liftTicketStatus?: Maybe<LineItemFulfilmentStateEnum>;
  lodgingFreeCancelDate?: Maybe<Scalars['Date']['output']>;
  /** ID of the main itinerary */
  mainId?: Maybe<Scalars['ID']['output']>;
  /** Public facing ID of the main itinerary */
  mainPublicId?: Maybe<Scalars['ID']['output']>;
  manualFollowupEmail4Required: Scalars['Boolean']['output'];
  /** Flag to indicate the itinerary has changes */
  modified: Scalars['Boolean']['output'];
  /** Timestamp on when the next billable product will happen */
  nextPaymentDueAt?: Maybe<Scalars['Date']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Old fake ID */
  oldFakeId: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['Date']['output']>;
  /** Total payable price of all the line items incl. tax */
  payableAmount: Scalars['Float']['output'];
  /** Phone number of the main contact */
  phone?: Maybe<Scalars['String']['output']>;
  /** Current customer agent (for post booking calls) */
  postBookingAgent?: Maybe<User>;
  /** The result of the post booking call */
  postBookingCallOutcome?: Maybe<PostBookingCallOutcomesEnum>;
  /** Manual check for post booking call successful */
  postBookingCallSuccessful?: Maybe<Scalars['Boolean']['output']>;
  /** Manual check for post booking call unsuccessful */
  postBookingCallUnsuccessful?: Maybe<Scalars['Boolean']['output']>;
  /** The agent ID to carry out the post booking call */
  postBookingCallUserId?: Maybe<Scalars['ID']['output']>;
  /** The result of the pre-arrival call */
  preArrivalCallOutcome?: Maybe<PreArrivalCallOutcomesEnum>;
  /** The agent ID to carry out the pre-arrival call */
  preArrivalCallUserId?: Maybe<Scalars['ID']['output']>;
  /** Manual check for pre arrival call */
  preArrivalCompleted?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to indicate an SMS was sent */
  preArrivalSmsSent?: Maybe<Scalars['Boolean']['output']>;
  productFreeCancelDate?: Maybe<Scalars['Date']['output']>;
  /** List of products booked for this itinerary */
  products: Array<ProductTypeEnum>;
  productsRemainingDueAt?: Maybe<Scalars['Date']['output']>;
  propertyCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  propertyManualFulfilment: Scalars['Boolean']['output'];
  /** Property name */
  propertyName: Scalars['String']['output'];
  propertyOrderedAt?: Maybe<Scalars['Date']['output']>;
  propertyStatus?: Maybe<LineItemFulfilmentStateEnum>;
  /** Flag to indicate a post booking SMS was sent */
  psotBookingSmsSent?: Maybe<Scalars['Boolean']['output']>;
  /** Public facing ID */
  publicId: Scalars['ID']['output'];
  /** Region name */
  regionName?: Maybe<Scalars['String']['output']>;
  remainingBalancesCollected: Scalars['Boolean']['output'];
  rentalAgent?: Maybe<User>;
  rentalCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  rentalOrderedAt?: Maybe<Scalars['Date']['output']>;
  rentalProductSupplier?: Maybe<Scalars['String']['output']>;
  rentalStatus?: Maybe<LineItemFulfilmentStateEnum>;
  requestedAgent?: Maybe<User>;
  /** Resort name */
  resortName: Scalars['String']['output'];
  /** Date of the sale */
  saleDate?: Maybe<Scalars['Date']['output']>;
  /** Session ID */
  sessionId: Scalars['String']['output'];
  /** Ski.com Quote ID */
  skicomQuoteId?: Maybe<Scalars['Int']['output']>;
  /** Current state of the itinerary */
  state: ItineraryStateEnum;
  tableNotes?: Maybe<Scalars['String']['output']>;
  transportationAgent?: Maybe<User>;
  transportationCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  transportationOrderedAt?: Maybe<Scalars['Date']['output']>;
  transportationStatus?: Maybe<LineItemFulfilmentStateEnum>;
};


/** Itinerary Searchkick result */
export type ItinerarySearchkickResultPayableAmountArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type ItinerarySearchkickResultEdge = {
  __typename?: 'ItinerarySearchkickResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ItinerarySearchkickResult>;
};

export enum ItineraryStateEnum {
  Pending = 'PENDING',
  Partial = 'PARTIAL',
  Requested = 'REQUESTED',
  Duplicated = 'DUPLICATED',
  Paid = 'PAID',
  Abandoned = 'ABANDONED',
  Cancelled = 'CANCELLED'
}

/** Attributes for lesson additional information */
export type LessonAdditionalInformationInput = {
  /** Primary Emergency */
  primaryEmergency?: InputMaybe<Scalars['String']['input']>;
  /** Primary Emergency Phone Number */
  primaryEmergencyPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Alternative Emergency #1 */
  alternativeEmergencyOne?: InputMaybe<Scalars['String']['input']>;
  /** Alternative Emergency #1 Phone Number */
  emergencyOnePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Alternative Emergency #2 */
  alternativeEmergencyTwo?: InputMaybe<Scalars['String']['input']>;
  /** Alternative Emergency #2 Phone Number */
  emergencyTwoPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** List of Food Allergies */
  foodAllergies?: InputMaybe<Scalars['String']['input']>;
  /** List of Drug Allergies */
  drugAllergies?: InputMaybe<Scalars['String']['input']>;
  /** List of Medication */
  medication?: InputMaybe<Scalars['String']['input']>;
  /** List of Special Conditions */
  specialConditions?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for accepting a lesson product to the itinerary */
export type LessonLineItem = {
  /** First name of the traveller */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the traveller */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the traveller */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the product */
  productableId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  originalPayableAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Traveler # for grouping line items */
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  /** Skill level of the traveller taking the lesson */
  skill?: InputMaybe<LessonProductSkillTypeEnum>;
  /** Gear for the traveller taking the lesson */
  gear?: InputMaybe<LessonProductGearTypeEnum>;
  /** Age type of the traveller taking the lesson */
  age?: InputMaybe<LessonProductAgeTypeEnum>;
  /** Public or private group */
  lesson?: InputMaybe<LessonProductLessonTypeEnum>;
  /** Array of traveler indexes participating in a private lesson */
  participants?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Location of the lesson */
  fulfilmentInstructionLocation?: InputMaybe<Scalars['String']['input']>;
  /** Time range for checking in */
  checkinTime?: InputMaybe<Scalars['String']['input']>;
  /** Time range of the lesson duration */
  lessonTime?: InputMaybe<Scalars['String']['input']>;
};

export type LessonProduct = Product & {
  __typename?: 'LessonProduct';
  /** Lesson age type */
  age: LessonProductAgeTypeEnum;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Lift ticket product cancellation policies */
  cancellationPolicies?: Maybe<Scalars['String']['output']>;
  checkinTime: Scalars['String']['output'];
  /** The currency for the product price */
  currency?: Maybe<Scalars['String']['output']>;
  /** Number of days the product has to be purchased in advance */
  daysInAdvance: Scalars['Int']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product price discount */
  discount?: Maybe<Scalars['Float']['output']>;
  duration: Scalars['String']['output'];
  /** Fulfillment instructions for the lift ticket product */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  /** Lesson gear type */
  gear: LessonProductGearTypeEnum;
  groupDescription: Array<Scalars['String']['output']>;
  /** Lesson product id */
  id: Scalars['ID']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Lesson type */
  lesson: LessonProductLessonTypeEnum;
  lessonTime: Scalars['String']['output'];
  /** Product logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Maximum age required for the product */
  maxAge: Scalars['Int']['output'];
  /** Maximum quantity the lift ticket product can be purchased at one time */
  maxQty: Scalars['Int']['output'];
  /** Minimum age required for the product */
  minAge: Scalars['Int']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Other policies for the lift ticket product */
  otherPolicies?: Maybe<Scalars['String']['output']>;
  participants: Scalars['Int']['output'];
  /** Product payable price */
  payable?: Maybe<Scalars['Float']['output']>;
  /** Product payable price pre tax */
  pretaxPayable?: Maybe<Scalars['Float']['output']>;
  /** Product price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Resort that the product belongs to */
  resort: Resort;
  /** Product short name */
  shortName: Scalars['String']['output'];
  /** Skill type */
  skill: LessonProductSkillTypeEnum;
  skillDescription: Scalars['JSON']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** Product tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
};


export type LessonProductLogoArgs = {
  resize?: InputMaybe<ProductLogoSizeEnum>;
};

export enum LessonProductAgeTypeEnum {
  Adult = 'Adult',
  Child = 'Child',
  Senior = 'Senior',
  Teen = 'Teen',
  Infant = 'Infant',
  Toddler = 'Toddler'
}

/** The connection type for LessonProduct. */
export type LessonProductConnection = {
  __typename?: 'LessonProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LessonProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LessonProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** The connection type for LessonProduct. */
export type LessonProductConnectionWithFilterStatus = {
  __typename?: 'LessonProductConnectionWithFilterStatus';
  /** Products are only available if booked this number of daysin advance to start date */
  daysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LessonProductEdgeType>>>;
  /** Returns number of products that have been filtered outbecause of daysInAdvance */
  filteredByDaysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LessonProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LessonProductEdge = {
  __typename?: 'LessonProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LessonProduct>;
};

/** An edge in a connection. */
export type LessonProductEdgeType = {
  __typename?: 'LessonProductEdgeType';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LessonProduct>;
};

/** Filters for filtering out lesson products */
export type LessonProductFilterInput = {
  /** Ages of all the occupancies */
  age?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of gear for the lesson */
  gearType?: InputMaybe<Array<LessonProductGearTypeEnum>>;
  /** Age group for the lesson */
  ageType?: InputMaybe<Array<LessonProductAgeTypeEnum>>;
  /** Type of lesson */
  lessonType?: InputMaybe<Array<LessonProductLessonTypeEnum>>;
  /** Skill level for lessons */
  skillType?: InputMaybe<Array<LessonProductSkillTypeEnum>>;
};

export enum LessonProductGearTypeEnum {
  Snowboard = 'Snowboard',
  Ski = 'Ski'
}

export enum LessonProductLessonTypeEnum {
  Private = 'Private',
  Group = 'Group'
}

/** LineItem */
export type LessonProductLineItemType = {
  __typename?: 'LessonProductLineItemType';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  /** Date of arrival */
  arriveAt: Scalars['Date']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  /** Lesson location */
  fulfilmentInstructionLocation?: Maybe<Scalars['String']['output']>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  pretaxPayableAmount: Scalars['Float']['output'];
  product: LessonProduct;
  productSupplier?: Maybe<ProductSupplier>;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type LessonProductLineItemTypeNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for LessonProductLineItemType. */
export type LessonProductLineItemTypeConnection = {
  __typename?: 'LessonProductLineItemTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LessonProductLineItemTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LessonProductLineItemType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LessonProductLineItemTypeEdge = {
  __typename?: 'LessonProductLineItemTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LessonProductLineItemType>;
};

export enum LessonProductSkillTypeEnum {
  All = 'All',
  Beginner = 'Beginner',
  Intermediate = 'Intermediate',
  Advanced = 'Advanced'
}

/** Author */
export type LiftTicketBlackout = {
  __typename?: 'LiftTicketBlackout';
  /** Date of the blackout */
  date: Scalars['Date']['output'];
  /** The primary id of this author */
  id: Scalars['ID']['output'];
  /** The ID of the resort for this blackout date */
  resortId: Scalars['ID']['output'];
};

/** Attributes for accepting a lift ticket product to the itinerary */
export type LiftTicketLineItem = {
  /** First name of the traveller */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the traveller */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the traveller */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the product */
  productableId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  originalPayableAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Traveler # for grouping line items */
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
};

/** LiftTicketOrderType */
export type LiftTicketOrder = {
  __typename?: 'LiftTicketOrder';
  id: Scalars['ID']['output'];
  publicId: Scalars['ID']['output'];
  sessionId: Scalars['ID']['output'];
};

export type LiftTicketProduct = Product & {
  __typename?: 'LiftTicketProduct';
  /** Lift ticket product age type */
  age: Scalars['String']['output'];
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Lift ticket product cancellation policies */
  cancellationPolicies?: Maybe<Scalars['String']['output']>;
  /** The currency for the product price */
  currency?: Maybe<Scalars['String']['output']>;
  /** Number of days the lift ticket product covers */
  days: Scalars['Int']['output'];
  /** Number of days the product has to be purchased in advance */
  daysInAdvance: Scalars['Int']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product price discount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Fulfillment instructions for the lift ticket product */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  /** Lift ticket product id */
  id: Scalars['ID']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Product logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Maximum age required for the product */
  maxAge: Scalars['Int']['output'];
  /** Maximum quantity the lift ticket product can be purchased at one time */
  maxQty: Scalars['Int']['output'];
  /** Minimum age required for the product */
  minAge: Scalars['Int']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Other policies for the lift ticket product */
  otherPolicies?: Maybe<Scalars['String']['output']>;
  /** Product payable price */
  payable?: Maybe<Scalars['Float']['output']>;
  /** Product payable price pre tax */
  pretaxPayable?: Maybe<Scalars['Float']['output']>;
  /** Product price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Resort that the product belongs to */
  resort: Resort;
  /** Product short name */
  shortName: Scalars['String']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** Product tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
  /** Lift ticket product type */
  ticket: Scalars['String']['output'];
};


export type LiftTicketProductLogoArgs = {
  resize?: InputMaybe<ProductLogoSizeEnum>;
};

export enum LiftTicketProductAgeTypeEnum {
  Child = 'Child',
  Adult = 'Adult',
  Infant = 'Infant',
  Senior = 'Senior',
  Teen = 'Teen',
  Junior = 'Junior',
  Toddler = 'Toddler'
}

/** The connection type for LiftTicketProduct. */
export type LiftTicketProductConnection = {
  __typename?: 'LiftTicketProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LiftTicketProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LiftTicketProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** The connection type for LiftTicketProduct. */
export type LiftTicketProductConnectionWithFilterStatus = {
  __typename?: 'LiftTicketProductConnectionWithFilterStatus';
  /** Returns true if the lift ticket days cross any blackout dates */
  blackout?: Maybe<Scalars['Boolean']['output']>;
  /** Products are only available if booked this number of daysin advance to start date */
  daysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LiftTicketProductEdge>>>;
  /** Returns number of products that have been filtered outbecause of daysInAdvance */
  filteredByDaysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LiftTicketProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LiftTicketProductEdge = {
  __typename?: 'LiftTicketProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LiftTicketProduct>;
};

/** Filters for filtering out lift ticket products */
export type LiftTicketProductFilterInput = {
  /** Ages of all the occupancies */
  age?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Number of days */
  days?: InputMaybe<Scalars['Int']['input']>;
  /** Age group */
  ageType?: InputMaybe<Array<LiftTicketProductAgeTypeEnum>>;
  /** Lift ticket type */
  ticketType?: InputMaybe<Array<LiftTicketProductTicketTypeEnum>>;
};

/** LineItem */
export type LiftTicketProductLineItem = {
  __typename?: 'LiftTicketProductLineItem';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  /** Date of arrival */
  arriveAt: Scalars['Date']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Lift ticket fulfillment instructions */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  pretaxPayableAmount: Scalars['Float']['output'];
  product: LiftTicketProduct;
  productSupplier?: Maybe<ProductSupplier>;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type LiftTicketProductLineItemFulfillmentInstructionsArgs = {
  showWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  editMode?: InputMaybe<Scalars['Boolean']['input']>;
  forSms?: InputMaybe<Scalars['Boolean']['input']>;
};


/** LineItem */
export type LiftTicketProductLineItemNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for LiftTicketProductLineItem. */
export type LiftTicketProductLineItemConnection = {
  __typename?: 'LiftTicketProductLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LiftTicketProductLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LiftTicketProductLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LiftTicketProductLineItemEdge = {
  __typename?: 'LiftTicketProductLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LiftTicketProductLineItem>;
};

export enum LiftTicketProductTicketTypeEnum {
  DayPass = 'DayPass',
  SeasonPass = 'SeasonPass',
  EpicPass = 'EpicPass'
}

/** LineItem */
export type LineItem = {
  __typename?: 'LineItem';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  pretaxPayableAmount: Scalars['Float']['output'];
  product: ProductUnion;
  productSupplier?: Maybe<ProductSupplier>;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type LineItemNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum LineItemFulfilmentEventEnum {
  Reset = 'Reset',
  Order = 'Order',
  Confirm = 'Confirm',
  OrderMistake = 'OrderMistake',
  Unavailable = 'Unavailable',
  MarginIssue = 'MarginIssue',
  Cancel = 'Cancel',
  RequestChange = 'RequestChange',
  ProceedChange = 'ProceedChange',
  RequestCancel = 'RequestCancel',
  ProceedCancel = 'ProceedCancel'
}

export enum LineItemFulfilmentStateEnum {
  NewBooking = 'NEW_BOOKING',
  Ordered = 'ORDERED',
  Confirmed = 'CONFIRMED',
  Unavailable = 'UNAVAILABLE',
  OrderMistake = 'ORDER_MISTAKE',
  MarginIssue = 'MARGIN_ISSUE',
  ChangeRequested = 'CHANGE_REQUESTED',
  ChangeInProgress = 'CHANGE_IN_PROGRESS',
  CancelRequested = 'CANCEL_REQUESTED',
  CancelInProgress = 'CANCEL_IN_PROGRESS',
  Cancelled = 'CANCELLED'
}

/** Attributes for accepting a lift ticket order line item */
export type LineItemInput = {
  sku: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
};

export enum LineItemStateEnum {
  Pending = 'PENDING',
  Paid = 'PAID',
  Canceled = 'CANCELED',
  Finalized = 'FINALIZED',
  Duplicated = 'DUPLICATED'
}

export type ManualFulfilmentResolverManualFulfilmentInput = {
  /** Itinerary public ID */
  itineraryPublicId?: InputMaybe<Scalars['ID']['input']>;
  /** Primary key of the Itinerary */
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  /** Currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Supplier currency */
  supplierCurrency?: InputMaybe<Scalars['String']['input']>;
  /** First name of the main contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the main contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Normalized version of firstName */
  normalizedFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Normalized version of lastName */
  normalizedLastName?: InputMaybe<Scalars['String']['input']>;
  /** Itinerary state */
  itineraryState?: InputMaybe<Array<ItineraryStateEnum>>;
  itineraryFulfilmentState?: InputMaybe<Array<ItineraryFulfilmentStateEnum>>;
  /** Name of the property */
  propertyName?: InputMaybe<Scalars['String']['input']>;
  /** Property supplier URL */
  propertySupplierUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name of the resort */
  resortName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** State of the line item */
  state?: InputMaybe<Array<Scalars['String']['input']>>;
  fulfilmentState?: InputMaybe<Array<LineItemFulfilmentStateEnum>>;
  fulfilmentAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  assignedAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  payableAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  customerDepositAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  customerRemainingBalanceAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  customerRemainingBalanceDueAt?: InputMaybe<Array<InputsComparisonDate>>;
  customerRemainingPaid?: InputMaybe<Array<InputsComparisonFloat>>;
  portal?: InputMaybe<Scalars['String']['input']>;
  supplierLodgingTotal?: InputMaybe<Array<InputsComparisonFloat>>;
  supplierDepositAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  supplierDepositDueAt?: InputMaybe<Array<InputsComparisonDate>>;
  supplierDepositPaid?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRemainingBalanceAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  supplierRemainingBalanceDueAt?: InputMaybe<Array<InputsComparisonDate>>;
  supplierRemainingBalancePaid?: InputMaybe<Scalars['Boolean']['input']>;
  supplierOrderId?: InputMaybe<Scalars['ID']['input']>;
  supplierConfirmationNumber?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Array<InputsComparisonFloat>>;
  supplierRefundIssued?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRefundAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  supplierCreditIssued?: InputMaybe<Scalars['Boolean']['input']>;
  supplierCreditAmount?: InputMaybe<Array<InputsComparisonFloat>>;
  /** Flag to check if manual F4 is required */
  manualFollowupEmail4Required?: InputMaybe<Scalars['Boolean']['input']>;
  propertyCrosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  arriveAt?: InputMaybe<Array<InputsComparisonDate>>;
  departAt?: InputMaybe<Array<InputsComparisonDate>>;
  paidAt?: InputMaybe<Array<InputsComparisonDate>>;
  propertyOrderedAt?: InputMaybe<Array<InputsComparisonDate>>;
};

/** The connection type for ManualFulfilmentSearchkickResult. */
export type ManualFulfilmentSearchkickConnection = SearchkickPaginationInterface & {
  __typename?: 'ManualFulfilmentSearchkickConnection';
  /** Current page # */
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ManualFulfilmentSearchkickResultEdge>>>;
  metadata: Metadata;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ManualFulfilmentSearchkickResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Current # of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total # of possible results */
  totalCount: Scalars['Int']['output'];
  /** Total # of possible pages */
  totalPages: Scalars['Int']['output'];
};

/** Manual Fulfilment Searchkick result */
export type ManualFulfilmentSearchkickResult = {
  __typename?: 'ManualFulfilmentSearchkickResult';
  /** The arrival date of the itinerary */
  arriveAt: Scalars['Date']['output'];
  assignedAgent?: Maybe<User>;
  /** Currency */
  currency: Scalars['String']['output'];
  customerDepositAmount: Scalars['Float']['output'];
  customerRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  customerRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  customerRemainingBalancePaidAmount?: Maybe<Scalars['Float']['output']>;
  /** The departure date of the itinerary */
  departAt: Scalars['Date']['output'];
  /** First name of the main contact */
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentAgentId?: Maybe<Scalars['ID']['output']>;
  fulfilmentState?: Maybe<Scalars['String']['output']>;
  /** Primary key of the LineItem */
  id: Scalars['ID']['output'];
  itineraryFulfilmentState?: Maybe<ItineraryFulfilmentStateEnum>;
  /** Primary key of the Itinerary */
  itineraryId: Scalars['ID']['output'];
  /** Public facing Itinerary ID */
  itineraryPublicId: Scalars['ID']['output'];
  itineraryState?: Maybe<ItineraryStateEnum>;
  /** Last name of the main contact */
  lastName?: Maybe<Scalars['String']['output']>;
  margin: Scalars['Float']['output'];
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Date of the sale */
  paidAt: Scalars['Date']['output'];
  payableAmount: Scalars['Float']['output'];
  portal?: Maybe<Scalars['String']['output']>;
  propertyCrosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** Property name */
  propertyName: Scalars['String']['output'];
  propertyOrderedAt?: Maybe<Scalars['Date']['output']>;
  /** Property supplier URL */
  propertySupplierUrl?: Maybe<Scalars['String']['output']>;
  /** Resort name */
  resortName: Scalars['String']['output'];
  /** Session ID of the itinerary - use this instead of :id */
  sessionId: Scalars['ID']['output'];
  /** State of the property line item */
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['String']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier currency */
  supplierCurrency?: Maybe<Scalars['String']['output']>;
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierLodgingTotal?: Maybe<Scalars['Float']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued?: Maybe<Scalars['Boolean']['output']>;
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid?: Maybe<Scalars['Boolean']['output']>;
};

/** An edge in a connection. */
export type ManualFulfilmentSearchkickResultEdge = {
  __typename?: 'ManualFulfilmentSearchkickResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ManualFulfilmentSearchkickResult>;
};

export type Metadata = {
  __typename?: 'Metadata';
  currentPage: Scalars['Int']['output'];
  limitValue: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createCoupon?: Maybe<CreateCouponPayload>;
  /** Upload attachments to itinerary */
  createDirectUpload?: Maybe<CreateDirectUploadPayload>;
  createLiftTicketBlackout?: Maybe<CreateLiftTicketBlackoutPayload>;
  createPropertyProductReview?: Maybe<CreatePropertyProductReviewPayload>;
  createReview?: Maybe<CreateReviewPayload>;
  createUser?: Maybe<CreateUserPayload>;
  creditCard: CreditCardMutations;
  deactivateCoupon?: Maybe<DeactivateCouponPayload>;
  googleSignInUser?: Maybe<MutationsGoogleSignInUserPayload>;
  importComponents?: Maybe<ImportComponentsPayload>;
  importEquipmentRentals?: Maybe<ImportEquipmentRentalsPayload>;
  importGroundTransfers?: Maybe<ImportGroundTransfersPayload>;
  importLiftTickets?: Maybe<ImportLiftTicketsPayload>;
  importLodging?: Maybe<ImportLodgingPayload>;
  importRegion?: Maybe<ImportRegionPayload>;
  payment: PaymentMutations;
  postBookingCall: PostBookingCallMutations;
  preArrivalCall: PreArrivalCallMutations;
  productSupplier: ProductSupplierMutations;
  purchaseLiftTicket?: Maybe<MutationsLiftTicketOrdersPurchaseLiftTicketPayload>;
  removeLiftTicketBlackout?: Maybe<RemoveLiftTicketBlackoutPayload>;
  scheduledPayment: ScheduledPaymentMutations;
  signInUser?: Maybe<SignInUserPayload>;
  supportCase: SupportCaseMutations;
  supportNote: SupportNoteMutations;
  transferFulfilmentInstruction: TransferFulfilmentInstructionMutations;
  viewer?: Maybe<TypesViewerMutationType>;
};


export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};


export type MutationCreateDirectUploadArgs = {
  input: CreateDirectUploadInput;
};


export type MutationCreateLiftTicketBlackoutArgs = {
  input: CreateLiftTicketBlackoutInput;
};


export type MutationCreatePropertyProductReviewArgs = {
  input: CreatePropertyProductReviewInput;
};


export type MutationCreateReviewArgs = {
  resortId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
};


export type MutationCreateUserArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['Email']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeactivateCouponArgs = {
  input: DeactivateCouponInput;
};


export type MutationGoogleSignInUserArgs = {
  input: MutationsGoogleSignInUserInput;
};


export type MutationImportComponentsArgs = {
  resortId: Scalars['Int']['input'];
};


export type MutationImportEquipmentRentalsArgs = {
  resortId: Scalars['Int']['input'];
};


export type MutationImportGroundTransfersArgs = {
  resortId: Scalars['Int']['input'];
};


export type MutationImportLiftTicketsArgs = {
  resortId: Scalars['Int']['input'];
};


export type MutationImportLodgingArgs = {
  resortId: Scalars['Int']['input'];
};


export type MutationImportRegionArgs = {
  regionId: Scalars['Int']['input'];
};


export type MutationPurchaseLiftTicketArgs = {
  input: MutationsLiftTicketOrdersPurchaseLiftTicketInput;
};


export type MutationRemoveLiftTicketBlackoutArgs = {
  input: RemoveLiftTicketBlackoutInput;
};


export type MutationSignInUserArgs = {
  email: Scalars['Email']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated input type of MutationsCreditCardCreate */
export type MutationsCreditCardCreateInput = {
  userId: Scalars['ID']['input'];
  creditCard: CreditCard;
  currency: Scalars['String']['input'];
  reason: PaymentAddCardReasonEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsCreditCardCreate */
export type MutationsCreditCardCreatePayload = {
  __typename?: 'MutationsCreditCardCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditCard: UserCreditCard;
  user: User;
};

/** Autogenerated input type of MutationsCreditCardRemove */
export type MutationsCreditCardRemoveInput = {
  userId: Scalars['ID']['input'];
  creditCardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsCreditCardRemove */
export type MutationsCreditCardRemovePayload = {
  __typename?: 'MutationsCreditCardRemovePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditCard: UserCreditCard;
  user: User;
};

/** Autogenerated input type of MutationsCreditCardSetDefaultCard */
export type MutationsCreditCardSetDefaultCardInput = {
  userId: Scalars['ID']['input'];
  creditCardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsCreditCardSetDefaultCard */
export type MutationsCreditCardSetDefaultCardPayload = {
  __typename?: 'MutationsCreditCardSetDefaultCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditCard: UserCreditCard;
  user: User;
};

/** Autogenerated input type of MutationsGoogleSignInUser */
export type MutationsGoogleSignInUserInput = {
  token: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsGoogleSignInUser */
export type MutationsGoogleSignInUserPayload = {
  __typename?: 'MutationsGoogleSignInUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of MutationsLiftTicketOrdersPurchaseLiftTicket */
export type MutationsLiftTicketOrdersPurchaseLiftTicketInput = {
  creditCard: CreditCard;
  lineItems: Array<LineItemInput>;
  contactDetails: ContactDetailsInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsLiftTicketOrdersPurchaseLiftTicket */
export type MutationsLiftTicketOrdersPurchaseLiftTicketPayload = {
  __typename?: 'MutationsLiftTicketOrdersPurchaseLiftTicketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  liftTicketOrder?: Maybe<LiftTicketOrder>;
};

/** Autogenerated input type of MutationsPaymentProcessCharge */
export type MutationsPaymentProcessChargeInput = {
  /** Itinerary Public ID */
  itineraryId: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  reason: PaymentProcessChargeReasonEnum;
  /** Related cc for the payment */
  userCreditCardId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsPaymentProcessCharge */
export type MutationsPaymentProcessChargePayload = {
  __typename?: 'MutationsPaymentProcessChargePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Itinerary>;
  payment?: Maybe<Payment>;
};

/** Autogenerated input type of MutationsPaymentProcessRefund */
export type MutationsPaymentProcessRefundInput = {
  /** Payment Primary Key */
  paymentId: Scalars['ID']['input'];
  /** Refund amount */
  amount: Scalars['Float']['input'];
  /** Refund reason */
  reason: PaymentProcessRefundReasonEnum;
  /** Additional notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsPaymentProcessRefund */
export type MutationsPaymentProcessRefundPayload = {
  __typename?: 'MutationsPaymentProcessRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  payment: Payment;
  refund: Payment;
};

/** Autogenerated input type of MutationsPostBookingCallCreate */
export type MutationsPostBookingCallCreateInput = {
  userId: Scalars['ID']['input'];
  itineraryId: Scalars['ID']['input'];
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  outcome: PostBookingCallOutcomesEnum;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsPostBookingCallCreate */
export type MutationsPostBookingCallCreatePayload = {
  __typename?: 'MutationsPostBookingCallCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  postBookingCall: PostBookingCall;
};

/** Autogenerated input type of MutationsPostBookingCallUpdate */
export type MutationsPostBookingCallUpdateInput = {
  postBookingCallId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  outcome: PostBookingCallOutcomesEnum;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsPostBookingCallUpdate */
export type MutationsPostBookingCallUpdatePayload = {
  __typename?: 'MutationsPostBookingCallUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  postBookingCall?: Maybe<PostBookingCall>;
};

/** Autogenerated input type of MutationsPreArrivalCallCreate */
export type MutationsPreArrivalCallCreateInput = {
  userId: Scalars['ID']['input'];
  itineraryId: Scalars['ID']['input'];
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  outcome: PreArrivalCallOutcomesEnum;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsPreArrivalCallCreate */
export type MutationsPreArrivalCallCreatePayload = {
  __typename?: 'MutationsPreArrivalCallCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  preArrivalCall: PreArrivalCall;
};

/** Autogenerated input type of MutationsPreArrivalCallUpdate */
export type MutationsPreArrivalCallUpdateInput = {
  preArrivalCallId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  outcome: PreArrivalCallOutcomesEnum;
  comments?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsPreArrivalCallUpdate */
export type MutationsPreArrivalCallUpdatePayload = {
  __typename?: 'MutationsPreArrivalCallUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  preArrivalCall?: Maybe<PreArrivalCall>;
};

/** Autogenerated input type of MutationsProductSupplierActivate */
export type MutationsProductSupplierActivateInput = {
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierActivate */
export type MutationsProductSupplierActivatePayload = {
  __typename?: 'MutationsProductSupplierActivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier?: Maybe<ProductSupplier>;
};

/** Autogenerated input type of MutationsProductSupplierCreateAttachment */
export type MutationsProductSupplierCreateAttachmentInput = {
  /** Product supplier ID */
  id: Scalars['ID']['input'];
  /** Signed blob ID generated via `createDirectUpload` mutation */
  signedBlobId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierCreateAttachment */
export type MutationsProductSupplierCreateAttachmentPayload = {
  __typename?: 'MutationsProductSupplierCreateAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier: ProductSupplier;
};

/** Autogenerated input type of MutationsProductSupplierCreate */
export type MutationsProductSupplierCreateInput = {
  params: ProductSupplierInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierCreate */
export type MutationsProductSupplierCreatePayload = {
  __typename?: 'MutationsProductSupplierCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier?: Maybe<ProductSupplier>;
};

/** Autogenerated input type of MutationsProductSupplierDeactivate */
export type MutationsProductSupplierDeactivateInput = {
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierDeactivate */
export type MutationsProductSupplierDeactivatePayload = {
  __typename?: 'MutationsProductSupplierDeactivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier?: Maybe<ProductSupplier>;
};

/** Autogenerated input type of MutationsProductSupplierLock */
export type MutationsProductSupplierLockInput = {
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierLock */
export type MutationsProductSupplierLockPayload = {
  __typename?: 'MutationsProductSupplierLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier: ProductSupplier;
};

/** Autogenerated input type of MutationsProductSupplierRemoveAttachment */
export type MutationsProductSupplierRemoveAttachmentInput = {
  /** Product supplier ID */
  id: Scalars['ID']['input'];
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierRemoveAttachment */
export type MutationsProductSupplierRemoveAttachmentPayload = {
  __typename?: 'MutationsProductSupplierRemoveAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier: ProductSupplier;
};

/** Autogenerated input type of MutationsProductSupplierUnlock */
export type MutationsProductSupplierUnlockInput = {
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierUnlock */
export type MutationsProductSupplierUnlockPayload = {
  __typename?: 'MutationsProductSupplierUnlockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier: ProductSupplier;
};

/** Autogenerated input type of MutationsProductSupplierUpdate */
export type MutationsProductSupplierUpdateInput = {
  id: Scalars['ID']['input'];
  params: ProductSupplierInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsProductSupplierUpdate */
export type MutationsProductSupplierUpdatePayload = {
  __typename?: 'MutationsProductSupplierUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  productSupplier?: Maybe<ProductSupplier>;
};

/** Autogenerated input type of MutationsScheduledPaymentMarkAsPaid */
export type MutationsScheduledPaymentMarkAsPaidInput = {
  /** Itinerary ID */
  itineraryId: Scalars['ID']['input'];
  scheduledPaymentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsScheduledPaymentMarkAsPaid */
export type MutationsScheduledPaymentMarkAsPaidPayload = {
  __typename?: 'MutationsScheduledPaymentMarkAsPaidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Itinerary>;
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
};

/** Autogenerated input type of MutationsScheduledPaymentProcessCharge */
export type MutationsScheduledPaymentProcessChargeInput = {
  /** Itinerary ID */
  itineraryId: Scalars['ID']['input'];
  scheduledPaymentIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsScheduledPaymentProcessCharge */
export type MutationsScheduledPaymentProcessChargePayload = {
  __typename?: 'MutationsScheduledPaymentProcessChargePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Itinerary>;
  scheduledPayments?: Maybe<Array<ScheduledPayment>>;
};

/** Autogenerated input type of MutationsSupportCaseCreate */
export type MutationsSupportCaseCreateInput = {
  /** Itinerary ID related to this review */
  itineraryId: Scalars['ID']['input'];
  category: SupportCaseCategoryEnum;
  subcategory: SupportCaseSubcategoryEnum;
  caseType: SupportCaseTypeEnum;
  action: SupportCaseActionEnum;
  notes: Scalars['String']['input'];
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsSupportCaseCreate */
export type MutationsSupportCaseCreatePayload = {
  __typename?: 'MutationsSupportCaseCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  supportCase?: Maybe<SupportCase>;
};

/** Autogenerated input type of MutationsSupportCaseUpdate */
export type MutationsSupportCaseUpdateInput = {
  id: Scalars['ID']['input'];
  assignedToUserId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<SupportCaseCategoryEnum>;
  subcategory?: InputMaybe<SupportCaseSubcategoryEnum>;
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<SupportCaseTypeEnum>;
  action?: InputMaybe<SupportCaseActionEnum>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsSupportCaseUpdate */
export type MutationsSupportCaseUpdatePayload = {
  __typename?: 'MutationsSupportCaseUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  supportCase?: Maybe<SupportCase>;
};

/** Autogenerated input type of MutationsSupportNoteCreate */
export type MutationsSupportNoteCreateInput = {
  supportCaseId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsSupportNoteCreate */
export type MutationsSupportNoteCreatePayload = {
  __typename?: 'MutationsSupportNoteCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  supportCase: SupportCase;
  supportNote: SupportNote;
};

/** Autogenerated input type of MutationsSupportNoteUpdate */
export type MutationsSupportNoteUpdateInput = {
  supportNoteId: Scalars['ID']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsSupportNoteUpdate */
export type MutationsSupportNoteUpdatePayload = {
  __typename?: 'MutationsSupportNoteUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  supportCase: SupportCase;
  supportNote: SupportNote;
};

/** Autogenerated input type of MutationsTransferFulfilmentInstructionActivate */
export type MutationsTransferFulfilmentInstructionActivateInput = {
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsTransferFulfilmentInstructionActivate */
export type MutationsTransferFulfilmentInstructionActivatePayload = {
  __typename?: 'MutationsTransferFulfilmentInstructionActivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  transferFulfilmentInstruction?: Maybe<TransferFulfilmentInstruction>;
};

/** Autogenerated input type of MutationsTransferFulfilmentInstructionCreate */
export type MutationsTransferFulfilmentInstructionCreateInput = {
  params: TransferFulfilmentInstructionInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsTransferFulfilmentInstructionCreate */
export type MutationsTransferFulfilmentInstructionCreatePayload = {
  __typename?: 'MutationsTransferFulfilmentInstructionCreatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  transferFulfilmentInstruction?: Maybe<TransferFulfilmentInstruction>;
};

/** Autogenerated input type of MutationsTransferFulfilmentInstructionDeactivate */
export type MutationsTransferFulfilmentInstructionDeactivateInput = {
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsTransferFulfilmentInstructionDeactivate */
export type MutationsTransferFulfilmentInstructionDeactivatePayload = {
  __typename?: 'MutationsTransferFulfilmentInstructionDeactivatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  transferFulfilmentInstruction?: Maybe<TransferFulfilmentInstruction>;
};

/** Autogenerated input type of MutationsTransferFulfilmentInstructionUpdate */
export type MutationsTransferFulfilmentInstructionUpdateInput = {
  id: Scalars['ID']['input'];
  params: TransferFulfilmentInstructionInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsTransferFulfilmentInstructionUpdate */
export type MutationsTransferFulfilmentInstructionUpdatePayload = {
  __typename?: 'MutationsTransferFulfilmentInstructionUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  transferFulfilmentInstruction?: Maybe<TransferFulfilmentInstruction>;
};

/** Autogenerated input type of MutationsUserUpdate */
export type MutationsUserUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MutationsUserUpdate */
export type MutationsUserUpdatePayload = {
  __typename?: 'MutationsUserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export enum NotableTypeEnum {
  Itinerary = 'ITINERARY',
  Lineitem = 'LINEITEM'
}

export type NotableUnion = Itinerary;

export type Note = CreatedAtUpdatedAt & {
  __typename?: 'Note';
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  /** Note ID */
  id: Scalars['ID']['output'];
  /** Notable that this note belongs to */
  notable?: Maybe<NotableUnion>;
  /** Note text */
  text: Scalars['String']['output'];
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
  /** User that created the note */
  user: User;
};

/** The connection type for Note. */
export type NoteConnection = {
  __typename?: 'NoteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NoteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Note>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NoteEdge = {
  __typename?: 'NoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Note>;
};

export type Notification = {
  __typename?: 'Notification';
  /** Email of the Booking contact */
  email: Scalars['String']['output'];
  /** Event Id */
  eventId: Scalars['ID']['output'];
  /** Expedia Booking Id */
  expediaId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Relevant itinerary */
  itinerary: Itinerary;
  /** Notification message */
  message: Scalars['String']['output'];
  /** Whether the notification has been processed or not */
  processed: Scalars['Boolean']['output'];
  /** Event time */
  time: Scalars['DateTime']['output'];
  /** Event type */
  type: NotificationEventTypeEnum;
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Notification>;
};

export enum NotificationEventTypeEnum {
  AgentCreate = 'AgentCreate',
  AgentChange = 'AgentChange',
  AgentCancel = 'AgentCancel',
  SupplierCancel = 'SupplierCancel',
  FruadCancel = 'FruadCancel'
}

export enum OrderByDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Order by input */
export type OrderByInput = {
  /** Name of the field to be ordered by */
  field: Scalars['String']['input'];
  /** Direction of the order by */
  direction?: InputMaybe<OrderByDirectionEnum>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Attributes for accepting a passport */
export type Passport = {
  /** Passport number for the traveller */
  number: Scalars['String']['input'];
  /** Passport issue date */
  issueDate: Scalars['Date']['input'];
  /** Passport expiry date */
  expiryDate: Scalars['Date']['input'];
  /** Passport issue country */
  issueCountry: Scalars['String']['input'];
};

export type Payment = CreatedAtUpdatedAt & {
  __typename?: 'Payment';
  /** Payment amount */
  amount: Scalars['Float']['output'];
  /** Card fees collected for the payment */
  cardFees: Scalars['Float']['output'];
  /** Payment credit card's card merchant type */
  cardType?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  /** Payment currency */
  currency: Scalars['String']['output'];
  /** Additional data values */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Payment ID */
  id: Scalars['ID']['output'];
  /** Payment credit card's last 4 digits */
  last4?: Maybe<Scalars['String']['output']>;
  /** Payment notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** Parent Payment (for refunds) */
  parentPayment?: Maybe<Payment>;
  /** Payment reason */
  reason?: Maybe<PaymentReasonEnum>;
  /** Is Payment refundable */
  refundable: Scalars['Boolean']['output'];
  /** Refundable amount */
  refundableAmount: Scalars['Float']['output'];
  /** Refunded amount */
  refundedAmount: Scalars['Float']['output'];
  /** Child Payments (related refunds) */
  refunds?: Maybe<PaymentConnection>;
  /** Payment state */
  state: PaymentStateEnum;
  /** Payment transaction number */
  trxnNumber?: Maybe<Scalars['String']['output']>;
  /** Transaction type */
  trxnType?: Maybe<PaymentTrxnTypeEnum>;
  /** Payment type */
  type: PaymentMethodEnum;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};


export type PaymentRefundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  includeFailed?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PaymentAddCardReasonEnum {
  AddAdditionalCard = 'ADD_ADDITIONAL_CARD',
  OriginalCardExpired = 'ORIGINAL_CARD_EXPIRED',
  LostOriginalCard = 'LOST_ORIGINAL_CARD'
}

/** The connection type for Payment. */
export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Payment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Payment>;
};

export enum PaymentMethodEnum {
  CreditCard = 'CREDIT_CARD',
  Expedia = 'EXPEDIA',
  Priceline = 'PRICELINE'
}

export type PaymentMutations = {
  __typename?: 'PaymentMutations';
  processCharge?: Maybe<MutationsPaymentProcessChargePayload>;
  processRefund?: Maybe<MutationsPaymentProcessRefundPayload>;
};


export type PaymentMutationsProcessChargeArgs = {
  input: MutationsPaymentProcessChargeInput;
};


export type PaymentMutationsProcessRefundArgs = {
  input: MutationsPaymentProcessRefundInput;
};

export enum PaymentProcessChargeReasonEnum {
  AddOnProduct = 'ADD_ON_PRODUCT',
  RemainingLodgingBalance = 'REMAINING_LODGING_BALANCE',
  RemainingProductBalance = 'REMAINING_PRODUCT_BALANCE'
}

export enum PaymentProcessRefundReasonEnum {
  MilitaryDiscountAfterBooking = 'MILITARY_DISCOUNT_AFTER_BOOKING',
  SavedItineraryAfterBooking = 'SAVED_ITINERARY_AFTER_BOOKING',
  Cancellation = 'CANCELLATION',
  Compensation = 'COMPENSATION',
  Overcharged = 'OVERCHARGED',
  RefundForReferringAFriend = 'REFUND_FOR_REFERRING_A_FRIEND'
}

export enum PaymentReasonEnum {
  AddAdditionalCard = 'ADD_ADDITIONAL_CARD',
  OriginalCardExpired = 'ORIGINAL_CARD_EXPIRED',
  LostOriginalCard = 'LOST_ORIGINAL_CARD',
  AddOnProduct = 'ADD_ON_PRODUCT',
  RemainingLodgingBalance = 'REMAINING_LODGING_BALANCE',
  RemainingProductBalance = 'REMAINING_PRODUCT_BALANCE',
  MilitaryDiscountAfterBooking = 'MILITARY_DISCOUNT_AFTER_BOOKING',
  SavedItineraryAfterBooking = 'SAVED_ITINERARY_AFTER_BOOKING',
  Cancellation = 'CANCELLATION',
  Compensation = 'COMPENSATION',
  Overcharged = 'OVERCHARGED',
  RefundForReferringAFriend = 'REFUND_FOR_REFERRING_A_FRIEND'
}

export enum PaymentStateEnum {
  Success = 'SUCCESS',
  Pending = 'PENDING',
  Failed = 'FAILED',
  Refunded = 'REFUNDED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Cancelled = 'CANCELLED',
  Duplicated = 'DUPLICATED'
}

export enum PaymentTrxnTypeEnum {
  StoreCard = 'STORE_CARD',
  Payment = 'PAYMENT',
  Refund = 'REFUND'
}

/** Post booking call */
export type PostBookingCall = CreatedAtUpdatedAt & {
  __typename?: 'PostBookingCall';
  comments?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  itinerary: Itinerary;
  outcome: PostBookingCallOutcomesEnum;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  zendeskTicket?: Maybe<Scalars['String']['output']>;
};

/** The connection type for PostBookingCall. */
export type PostBookingCallConnection = {
  __typename?: 'PostBookingCallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PostBookingCallEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PostBookingCall>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PostBookingCallEdge = {
  __typename?: 'PostBookingCallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PostBookingCall>;
};

export type PostBookingCallMutations = {
  __typename?: 'PostBookingCallMutations';
  create?: Maybe<MutationsPostBookingCallCreatePayload>;
  update?: Maybe<MutationsPostBookingCallUpdatePayload>;
};


export type PostBookingCallMutationsCreateArgs = {
  input: MutationsPostBookingCallCreateInput;
};


export type PostBookingCallMutationsUpdateArgs = {
  input: MutationsPostBookingCallUpdateInput;
};

export enum PostBookingCallOutcomesEnum {
  Blank = 'BLANK',
  GoodToGo = 'GOOD_TO_GO',
  RequestCallback = 'REQUEST_CALLBACK',
  MakeChanges = 'MAKE_CHANGES',
  LeftVm = 'LEFT_VM',
  VmNotSetup = 'VM_NOT_SETUP',
  InvalidNumber = 'INVALID_NUMBER',
  HungUp = 'HUNG_UP',
  NoAnswer = 'NO_ANSWER',
  SmsSent = 'SMS_SENT'
}

/** Pre-arrival call */
export type PreArrivalCall = CreatedAtUpdatedAt & {
  __typename?: 'PreArrivalCall';
  comments?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  itinerary: Itinerary;
  outcome: PreArrivalCallOutcomesEnum;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  zendeskTicket?: Maybe<Scalars['String']['output']>;
};

/** The connection type for PreArrivalCall. */
export type PreArrivalCallConnection = {
  __typename?: 'PreArrivalCallConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PreArrivalCallEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PreArrivalCall>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PreArrivalCallEdge = {
  __typename?: 'PreArrivalCallEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PreArrivalCall>;
};

export type PreArrivalCallMutations = {
  __typename?: 'PreArrivalCallMutations';
  create?: Maybe<MutationsPreArrivalCallCreatePayload>;
  update?: Maybe<MutationsPreArrivalCallUpdatePayload>;
};


export type PreArrivalCallMutationsCreateArgs = {
  input: MutationsPreArrivalCallCreateInput;
};


export type PreArrivalCallMutationsUpdateArgs = {
  input: MutationsPreArrivalCallUpdateInput;
};

export enum PreArrivalCallOutcomesEnum {
  Blank = 'BLANK',
  GoodToGo = 'GOOD_TO_GO',
  RequestCallback = 'REQUEST_CALLBACK',
  MakeChanges = 'MAKE_CHANGES',
  LeftVm = 'LEFT_VM',
  VmNotSetup = 'VM_NOT_SETUP',
  InvalidNumber = 'INVALID_NUMBER',
  HungUp = 'HUNG_UP',
  NoAnswer = 'NO_ANSWER',
  SmsSent = 'SMS_SENT',
  PbcMadeRecently = 'PBC_MADE_RECENTLY'
}

export type PrismicImageType = {
  __typename?: 'PrismicImageType';
  /** Image alt */
  alt?: Maybe<Scalars['String']['output']>;
  /** Image height */
  height: Scalars['Int']['output'];
  /** Image url */
  url: Scalars['String']['output'];
  /** Image width */
  width: Scalars['Int']['output'];
};

/** Autogenerated input type of ProcessNotification */
export type ProcessNotificationInput = {
  /** EAN notification id */
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProcessNotification */
export type ProcessNotificationPayload = {
  __typename?: 'ProcessNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of ProcessPayment */
export type ProcessPaymentInput = {
  amount: Scalars['Float']['input'];
  notes: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProcessPayment */
export type ProcessPaymentPayload = {
  __typename?: 'ProcessPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Itinerary>;
  payment?: Maybe<Payment>;
};

export type Product = {
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Lift ticket product cancellation policies */
  cancellationPolicies?: Maybe<Scalars['String']['output']>;
  /** The currency for the product price */
  currency?: Maybe<Scalars['String']['output']>;
  /** Number of days the product has to be purchased in advance */
  daysInAdvance: Scalars['Int']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product price discount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Fulfillment instructions for the lift ticket product */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  /** Product Id */
  id: Scalars['ID']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Product logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Maximum age required for the product */
  maxAge: Scalars['Int']['output'];
  /** Maximum quantity the lift ticket product can be purchased at one time */
  maxQty: Scalars['Int']['output'];
  /** Minimum age required for the product */
  minAge: Scalars['Int']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Other policies for the lift ticket product */
  otherPolicies?: Maybe<Scalars['String']['output']>;
  /** Product payable price */
  payable?: Maybe<Scalars['Float']['output']>;
  /** Product payable price pre tax */
  pretaxPayable?: Maybe<Scalars['Float']['output']>;
  /** Product price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Resort that the product belongs to */
  resort: Resort;
  /** Product short name */
  shortName: Scalars['String']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** Product tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
};


export type ProductLogoArgs = {
  resize?: InputMaybe<ProductLogoSizeEnum>;
};

export enum ProductDiscountReasonEnum {
  MilitaryDiscount = 'MILITARY_DISCOUNT',
  Promotion = 'PROMOTION',
  SavedItinerary = 'SAVED_ITINERARY',
  Compensation = 'COMPENSATION',
  CancelCredit = 'CANCEL_CREDIT',
  Referral = 'REFERRAL',
  CreditForReferringAFriend = 'CREDIT_FOR_REFERRING_A_FRIEND'
}

export enum ProductEnum {
  Lesson = 'Lesson',
  LiftTicket = 'LiftTicket',
  Rental = 'Rental',
  Transportation = 'Transportation',
  Property = 'Property'
}

export enum ProductLogoSizeEnum {
  Original = 'Original',
  Small = 'Small'
}

export type ProductSupplier = {
  __typename?: 'ProductSupplier';
  /** Supplier active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier apex updated */
  apexUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier apex updated at */
  apexUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  audits?: Maybe<TypesProductSupplierAuditedTypeConnection>;
  /** Supplier email address */
  bookingPortalType?: Maybe<Scalars['String']['output']>;
  /** Supplier cancellation policy */
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  /** Supplier commission */
  commission?: Maybe<Scalars['Float']['output']>;
  /** Info on confirmation number source */
  confirmationNumberInstruction?: Maybe<Scalars['String']['output']>;
  /**
   * Info on confirmation number source
   * @deprecated Use confirmationNumberInstruction instead
   */
  confirmationNumberInstructions?: Maybe<Scalars['String']['output']>;
  /** Supplier contact email */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Supplier contact name */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Supplier contact phone mobile */
  contactPhoneMobile?: Maybe<Scalars['String']['output']>;
  /** Supplier contact phone office */
  contactPhoneOffice?: Maybe<Scalars['String']['output']>;
  /** Supplier contact position */
  contactPosition?: Maybe<Scalars['String']['output']>;
  /** Supplier contract link */
  contractLink?: Maybe<Scalars['String']['output']>;
  /** Supplier contract status */
  contractStatus?: Maybe<ProductSupplierContractStatusEnum>;
  /** Supplier contracting agent */
  contractingAgent?: Maybe<User>;
  /** Supplier Currency */
  currency?: Maybe<ProductSupplierCurrencyEnum>;
  /** Supplier deposit policy */
  depositPolicy?: Maybe<Scalars['String']['output']>;
  /** Supplier email address */
  email?: Maybe<Scalars['String']['output']>;
  fulfilmentAttachments: ActiveStorageConnection;
  /** Supplier fulfilment contact information */
  fulfilmentContactInformation?: Maybe<Scalars['String']['output']>;
  /** Supplier fulfilment notes */
  fulfilmentNotes?: Maybe<Scalars['String']['output']>;
  /** Supplier fulfilment reference number */
  fulfilmentReferenceNumber?: Maybe<Scalars['String']['output']>;
  /** Supplier id */
  id: Scalars['ID']['output'];
  /** Lock details */
  lock: TypesLockType;
  /** Check if main supplier */
  mainSupplier?: Maybe<Scalars['Boolean']['output']>;
  /** Supplier name */
  name?: Maybe<Scalars['String']['output']>;
  /** Supplier specific notes */
  note?: Maybe<Scalars['String']['output']>;
  officialTimetable?: Maybe<Scalars['String']['output']>;
  /** Supplier order */
  order?: Maybe<Scalars['Int']['output']>;
  /** Supplier password */
  password?: Maybe<Scalars['String']['output']>;
  /** Supplier payment bulk bill */
  paymentBulkBill?: Maybe<ProductSupplierPaymentBulkBillEnum>;
  /** Supplier payment frequency */
  paymentFrequency?: Maybe<ProductSupplierPaymentFrequencyEnum>;
  /** Supplier payment method */
  paymentMethod?: Maybe<ProductSupplierPaymentMethodEnum>;
  /** Supplier payment options */
  paymentOptions?: Maybe<Scalars['String']['output']>;
  /** Supplier phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Supplier pickup time location */
  pickupTimeLocation?: Maybe<ProductSupplierPickupTimeLocationEnum>;
  /** Supplier product supplier group */
  productSupplierGroup?: Maybe<ProductSupplierGroup>;
  /** Type of product that supplier supplies */
  productType: ProductSupplierProductTypeEnum;
  /** Supplier rate link */
  rateLink?: Maybe<Scalars['String']['output']>;
  /** Supplier rate status */
  rateStatus?: Maybe<ProductSupplierRateStatusEnum>;
  /** Resort that supplier services */
  resort: Resort;
  /** Supplier short name */
  shortName: Scalars['String']['output'];
  /** Supplier spreadsheet url */
  spreadsheetUrl?: Maybe<Scalars['String']['output']>;
  /** Supplier product */
  supplierProduct?: Maybe<Scalars['String']['output']>;
  /** Supplier type */
  supplierType?: Maybe<ProductSupplierSupplierTypeEnum>;
  transferFulfilmentInstructions: TransferFulfilmentInstructionConnection;
  /** Supplier website / Booking portal url */
  url?: Maybe<Scalars['String']['output']>;
  /** Supplier username */
  username?: Maybe<Scalars['String']['output']>;
  /** Supplier vouchers required */
  vouchersRequired?: Maybe<Scalars['Boolean']['output']>;
};


export type ProductSupplierAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  action?: InputMaybe<AuditActionEnum>;
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ProductSupplierFulfilmentAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductSupplierTransferFulfilmentInstructionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ProductSupplier. */
export type ProductSupplierConnection = {
  __typename?: 'ProductSupplierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductSupplierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductSupplier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export enum ProductSupplierContractStatusEnum {
  NeedToContact = 'need_to_contact',
  ReachedOut = 'reached_out',
  AwaitingEmail = 'awaiting_email',
  ContractUnderReview = 'contract_under_review',
  Signed = 'signed',
  Unnecessary = 'unnecessary',
  Unapplicable = 'unapplicable',
  Unready = 'unready'
}

export enum ProductSupplierCurrencyEnum {
  Usd = 'USD',
  Cad = 'CAD',
  Jpy = 'JPY',
  Nzd = 'NZD',
  Eur = 'EUR',
  Chf = 'CHF'
}

/** An edge in a connection. */
export type ProductSupplierEdge = {
  __typename?: 'ProductSupplierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductSupplier>;
};

export enum ProductSupplierFulfilmentMethodEnum {
  Email = 'EMAIL',
  Portal = 'PORTAL',
  Spreadsheet = 'SPREADSHEET'
}

export type ProductSupplierGroup = CreatedAtUpdatedAt & {
  __typename?: 'ProductSupplierGroup';
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  productSuppliers: ProductSupplierConnection;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};


export type ProductSupplierGroupProductSuppliersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Product Supplier Input */
export type ProductSupplierInput = {
  /** Resort ID of the product supplier */
  resortId?: InputMaybe<Scalars['Int']['input']>;
  /** Product type */
  productType?: InputMaybe<ProductSupplierProductTypeEnum>;
  /** Supplier product */
  supplierProduct?: InputMaybe<Scalars['String']['input']>;
  /** Supplier type */
  supplierType?: InputMaybe<ProductSupplierSupplierTypeEnum>;
  /** Property product ID when product type is ManualFulfilment */
  propertyProductId?: InputMaybe<Scalars['Int']['input']>;
  /** Web Booking URL */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Web Booking Username */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Web Booking Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Web Booking Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Spreadsheet Booking URL */
  spreadsheetUrl?: InputMaybe<Scalars['String']['input']>;
  /** Confirmation Number Instructions */
  confirmationNumberInstruction?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment Notes */
  fulfilmentNotes?: InputMaybe<Scalars['String']['input']>;
  /** Cancellation Policy */
  cancellationPolicy?: InputMaybe<Scalars['String']['input']>;
  /** Payment Bulk Bill */
  paymentBulkBill?: InputMaybe<ProductSupplierPaymentBulkBillEnum>;
  /** Payment Method */
  paymentMethod?: InputMaybe<ProductSupplierPaymentMethodEnum>;
  /** Payment Frequency */
  paymentFrequency?: InputMaybe<ProductSupplierPaymentFrequencyEnum>;
  /** Currency */
  currency?: InputMaybe<ProductSupplierCurrencyEnum>;
  /** Vouchers Required */
  vouchersRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order */
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Contract Status */
  contractStatus?: InputMaybe<ProductSupplierContractStatusEnum>;
  /** Rate Status */
  rateStatus?: InputMaybe<ProductSupplierRateStatusEnum>;
  /** Contract Link */
  contractLink?: InputMaybe<Scalars['String']['input']>;
  /** Rate Link */
  rateLink?: InputMaybe<Scalars['String']['input']>;
  /** Contracting Notes */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Contracting Agent ID */
  contractingAgentId?: InputMaybe<Scalars['Int']['input']>;
  /** Commission */
  commission?: InputMaybe<Scalars['Float']['input']>;
  /** Apex Updated */
  apexUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apex Updated At */
  apexUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  /** Contact Name */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Contact Position */
  contactPosition?: InputMaybe<Scalars['String']['input']>;
  /** Contact Email */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact Phone Office */
  contactPhoneOffice?: InputMaybe<Scalars['String']['input']>;
  /** Contact Phone Mobile */
  contactPhoneMobile?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment Contact Information */
  fulfilmentContactInformation?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment Reference Number */
  fulfilmentReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Supplier pickup time location */
  pickupTimeLocation?: InputMaybe<ProductSupplierPickupTimeLocationEnum>;
  /** Supplier deposit policy */
  depositPolicy?: InputMaybe<Scalars['String']['input']>;
  /** Supplier official timetable */
  officialTimetable?: InputMaybe<Scalars['String']['input']>;
};

export type ProductSupplierMutations = {
  __typename?: 'ProductSupplierMutations';
  activate?: Maybe<MutationsProductSupplierActivatePayload>;
  create?: Maybe<MutationsProductSupplierCreatePayload>;
  /**
   * Attach a direct S3 upload to product supplier fulfilment attachments
   * (by attaching a blob via signed ID)
   *
   */
  createAttachment?: Maybe<MutationsProductSupplierCreateAttachmentPayload>;
  deactivate?: Maybe<MutationsProductSupplierDeactivatePayload>;
  lock?: Maybe<MutationsProductSupplierLockPayload>;
  /** Removes attachments from product supplier */
  removeAttachment?: Maybe<MutationsProductSupplierRemoveAttachmentPayload>;
  unlock?: Maybe<MutationsProductSupplierUnlockPayload>;
  update?: Maybe<MutationsProductSupplierUpdatePayload>;
};


export type ProductSupplierMutationsActivateArgs = {
  input: MutationsProductSupplierActivateInput;
};


export type ProductSupplierMutationsCreateArgs = {
  input: MutationsProductSupplierCreateInput;
};


export type ProductSupplierMutationsCreateAttachmentArgs = {
  input: MutationsProductSupplierCreateAttachmentInput;
};


export type ProductSupplierMutationsDeactivateArgs = {
  input: MutationsProductSupplierDeactivateInput;
};


export type ProductSupplierMutationsLockArgs = {
  input: MutationsProductSupplierLockInput;
};


export type ProductSupplierMutationsRemoveAttachmentArgs = {
  input: MutationsProductSupplierRemoveAttachmentInput;
};


export type ProductSupplierMutationsUnlockArgs = {
  input: MutationsProductSupplierUnlockInput;
};


export type ProductSupplierMutationsUpdateArgs = {
  input: MutationsProductSupplierUpdateInput;
};

export enum ProductSupplierPaymentBulkBillEnum {
  BeforeTrip = 'before_trip',
  AfterTrip = 'after_trip',
  Unapplicable = 'unapplicable',
  Tbc = 'tbc'
}

export enum ProductSupplierPaymentFrequencyEnum {
  TimeOfBooking = 'time_of_booking',
  Within_14Days = 'within_14_days',
  Within_30Days = 'within_30_days',
  TimeOfArrival = 'time_of_arrival',
  DepositPolicy = 'deposit_policy',
  Daily = 'daily',
  Weekly = 'weekly',
  Fortnightly = 'fortnightly',
  Monthly = 'monthly',
  Seasonal = 'seasonal',
  Tbc = 'tbc'
}

export enum ProductSupplierPaymentMethodEnum {
  Automatic = 'automatic',
  ApproveAndAutomatic = 'approve_and_automatic',
  WireTransfer = 'wire_transfer',
  SubmitFormLink = 'submit_form_link',
  Tbc = 'tbc'
}

export enum ProductSupplierPickupTimeLocationEnum {
  Tbc = 'tbc',
  Inbound = 'inbound',
  Invoice = 'invoice'
}

export enum ProductSupplierProductTypeEnum {
  ManualFulfilment = 'MANUAL_FULFILMENT',
  LiftTicket = 'LIFT_TICKET',
  Rental = 'RENTAL',
  Transportation = 'TRANSPORTATION',
  Lesson = 'LESSON'
}

export enum ProductSupplierRateStatusEnum {
  Unavailable = 'unavailable',
  Available = 'available',
  SameAsLastSeason = 'same_as_last_season'
}

/** Product Supplier Input */
export type ProductSupplierSearchResolverFilterInput = {
  /** Resort ID of the product supplier */
  resortId?: InputMaybe<Scalars['Int']['input']>;
  /** Product Type */
  productType?: InputMaybe<Array<ProductSupplierProductTypeEnum>>;
  /** Supplier Product */
  supplierProduct?: InputMaybe<Scalars['String']['input']>;
  /** Supplier Type */
  supplierType?: InputMaybe<ProductSupplierSupplierTypeEnum>;
  /** Property product ID when product type is ManualFulfilment */
  propertyProductId?: InputMaybe<Scalars['Int']['input']>;
  /** URL */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Spreadsheet URL */
  spreadsheetUrl?: InputMaybe<Scalars['String']['input']>;
  /** Confirmation Number Instruction */
  confirmationNumberInstruction?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment Notes */
  fulfilmentNotes?: InputMaybe<Scalars['String']['input']>;
  /** Cancellation Policy */
  cancellationPolicy?: InputMaybe<Scalars['String']['input']>;
  /** Payment Bulk Bill */
  paymentBulkBill?: InputMaybe<Array<ProductSupplierPaymentBulkBillEnum>>;
  /** Payment Method */
  paymentMethod?: InputMaybe<Array<ProductSupplierPaymentMethodEnum>>;
  /** Payment Frequency */
  paymentFrequency?: InputMaybe<Array<ProductSupplierPaymentFrequencyEnum>>;
  /** Currency */
  currency?: InputMaybe<ProductSupplierCurrencyEnum>;
  /** Vouchers Required */
  vouchersRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Order */
  order?: InputMaybe<Scalars['String']['input']>;
  /** Contract Status */
  contractStatus?: InputMaybe<Array<ProductSupplierContractStatusEnum>>;
  /** Rate Status */
  rateStatus?: InputMaybe<Array<ProductSupplierRateStatusEnum>>;
  /** Contract Link */
  contractLink?: InputMaybe<Scalars['String']['input']>;
  /** Rate Link */
  rateLink?: InputMaybe<Scalars['String']['input']>;
  /** Contracting Notes */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Contracting Agent ID */
  contractingAgentId?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Commission */
  commission?: InputMaybe<Scalars['String']['input']>;
  /** Apex Updated */
  apexUpdated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apex Updated At */
  apexUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  /** Contact Name */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Contact Position */
  contactPosition?: InputMaybe<Scalars['String']['input']>;
  /** Contact Email */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact Phone Office */
  contactPhoneOffice?: InputMaybe<Scalars['String']['input']>;
  /** Contact Phone Mobile */
  contactPhoneMobile?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment Contact Information */
  fulfilmentContactInformation?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment Reference Number */
  fulfilmentReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** Supplier pickup time location */
  pickupTimeLocation?: InputMaybe<ProductSupplierPickupTimeLocationEnum>;
  /** Supplier deposit policy */
  depositPolicy?: InputMaybe<Scalars['String']['input']>;
  /** Supplier official timetable */
  officialTimetable?: InputMaybe<Scalars['String']['input']>;
  /** Product Supplier ID */
  supplierId?: InputMaybe<Scalars['ID']['input']>;
  /** Name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Name */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** Resort Name */
  resortName?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Payment Options */
  paymentOptions?: InputMaybe<Scalars['String']['input']>;
  /** Fulfilment methods */
  fulfilmentMethods?: InputMaybe<Array<ProductSupplierFulfilmentMethodEnum>>;
  fulfilmentContactLastUpdatedAt?: InputMaybe<Array<InputsComparisonDate>>;
  fulfilmentDetailLastUpdatedAt?: InputMaybe<Array<InputsComparisonDate>>;
  contractingContactLastUpdatedAt?: InputMaybe<Array<InputsComparisonDate>>;
  contractingDetailLastUpdatedAt?: InputMaybe<Array<InputsComparisonDate>>;
  or?: InputMaybe<Array<ProductSupplierSearchResolverFilterInput>>;
  and?: InputMaybe<Array<ProductSupplierSearchResolverFilterInput>>;
  not?: InputMaybe<ProductSupplierSearchResolverFilterInput>;
};

/** The connection type for ProductSupplierSearchkickResult. */
export type ProductSupplierSearchkickConnection = SearchkickPaginationInterface & {
  __typename?: 'ProductSupplierSearchkickConnection';
  /** Current page # */
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductSupplierSearchkickResultEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductSupplierSearchkickResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Current # of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total # of possible results */
  totalCount: Scalars['Int']['output'];
  /** Total # of possible pages */
  totalPages: Scalars['Int']['output'];
};

export type ProductSupplierSearchkickResult = {
  __typename?: 'ProductSupplierSearchkickResult';
  /** Active */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Apex Updated */
  apexUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Cancellation Policy */
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  /** Commission */
  commission?: Maybe<Scalars['String']['output']>;
  /** Confirmation Number Instruction */
  confirmationNumberInstruction?: Maybe<Scalars['String']['output']>;
  /** Contact Email */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** Contact Name */
  contactName?: Maybe<Scalars['String']['output']>;
  /** Contact Phone Mobile */
  contactPhoneMobile?: Maybe<Scalars['String']['output']>;
  /** Contact Phone Office */
  contactPhoneOffice?: Maybe<Scalars['String']['output']>;
  /** Contact Position */
  contactPosition?: Maybe<Scalars['String']['output']>;
  /** Contract Link */
  contractLink?: Maybe<Scalars['String']['output']>;
  /** Contract Status */
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** Contracting Agent */
  contractingAgent?: Maybe<User>;
  contractingContactLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  contractingDetailLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  fulfilmentContactLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  fulfilmentDetailLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Fulfilment Notes */
  fulfilmentNotes?: Maybe<Scalars['String']['output']>;
  /** Primary key */
  id: Scalars['ID']['output'];
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  /** Order */
  order?: Maybe<Scalars['String']['output']>;
  /** Password */
  password?: Maybe<Scalars['String']['output']>;
  /** Payment Bulk Bill */
  paymentBulkBill?: Maybe<Scalars['String']['output']>;
  /** Payment Frequency */
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  /** Payment Method */
  paymentMethod?: Maybe<Scalars['String']['output']>;
  /** Payment Options */
  paymentOptions?: Maybe<Scalars['String']['output']>;
  /** Product Type */
  productType?: Maybe<Scalars['String']['output']>;
  /** Rate Link */
  rateLink?: Maybe<Scalars['String']['output']>;
  /** Rate Status */
  rateStatus?: Maybe<Scalars['String']['output']>;
  /** Resort Name */
  resortName?: Maybe<Scalars['String']['output']>;
  /** Short Name */
  shortName?: Maybe<Scalars['String']['output']>;
  /** Spreadsheet URL */
  spreadsheetUrl?: Maybe<Scalars['String']['output']>;
  /** Supplier Product */
  supplierProduct?: Maybe<Scalars['String']['output']>;
  /** Supplier Type */
  supplierType?: Maybe<Scalars['String']['output']>;
  transferFulfilmentInstructions?: Maybe<Array<TransferFulfilmentInstructionSearchkickResult>>;
  /** URL */
  url?: Maybe<Scalars['String']['output']>;
  /** Username */
  username?: Maybe<Scalars['String']['output']>;
  /** Vouchers null */
  vouchersRequired: Scalars['Boolean']['output'];
};

/** An edge in a connection. */
export type ProductSupplierSearchkickResultEdge = {
  __typename?: 'ProductSupplierSearchkickResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductSupplierSearchkickResult>;
};

export enum ProductSupplierSupplierTypeEnum {
  CoWest = 'co_west',
  Jonview = 'jonview',
  Vrpp = 'vrpp',
  Wholesale = 'wholesale',
  Retail = 'retail',
  Inntopia = 'inntopia',
  Synxis = 'synxis',
  Roomboss = 'roomboss'
}

export enum ProductTypeEnum {
  LiftTicketProduct = 'LIFT_TICKET_PRODUCT',
  RentalProduct = 'RENTAL_PRODUCT',
  TransportationProduct = 'TRANSPORTATION_PRODUCT',
  UpsellProduct = 'UPSELL_PRODUCT',
  LessonProduct = 'LESSON_PRODUCT'
}

export type ProductUnion = LessonProduct | LiftTicketProduct | PropertyProduct | RentalProduct | TransportationProduct | UpsellProduct;

/** The connection type for PropertyProduct. */
export type PropertyAvailabilityConnection = {
  __typename?: 'PropertyAvailabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PropertyAvailabilityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PropertyProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total # of edges returned from the connection */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PropertyAvailabilityEdge = {
  __typename?: 'PropertyAvailabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The driving distance from the resort in miles */
  drivingDistance?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge. */
  node?: Maybe<PropertyProduct>;
};

export type PropertyAvailabilityReturn = {
  __typename?: 'PropertyAvailabilityReturn';
  rooms: Array<ExpediaPropertyRoomAvailability>;
  tokens: Scalars['JSON']['output'];
};

/** ExpediaPropertyBedGroupAvailability - An individual bed group */
export type PropertyBedGroupAvailability = {
  __typename?: 'PropertyBedGroupAvailability';
  /**
   * The bed configuration for a given room. This array can be empty for the
   * related bed group.
   *
   */
  configuration?: Maybe<Array<Scalars['JSON']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Token for checking current price */
  tokens?: Maybe<Scalars['JSON']['output']>;
};

/** Attributes for accepting a property billing contact to the itinerary */
export type PropertyBillingContact = {
  /** Given name of the billing contact */
  givenName: Scalars['String']['input'];
  /** Family name of the billing contact */
  familyName: Scalars['String']['input'];
  /** Email of the billing contact */
  email: Scalars['Email']['input'];
  /** Contact phone number of the billing contact */
  phone: Scalars['Phone']['input'];
  /** Address of the billing contact */
  address: Address;
};

export type PropertyDistance = {
  __typename?: 'PropertyDistance';
  altCategory?: Maybe<Scalars['String']['output']>;
  altDistanceTo?: Maybe<PropertyDistanceDistanceToUnion>;
  altDriveDistance?: Maybe<Scalars['Int']['output']>;
  altWalkTime?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  distanceTo?: Maybe<PropertyDistanceDistanceToUnion>;
  driveDistance?: Maybe<Scalars['Int']['output']>;
  fulfilmentText?: Maybe<Scalars['String']['output']>;
  /** Primary id */
  id: Scalars['ID']['output'];
  resort: Resort;
  walkTime?: Maybe<Scalars['String']['output']>;
};

/** The connection type for PropertyDistance. */
export type PropertyDistanceConnection = {
  __typename?: 'PropertyDistanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PropertyDistanceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PropertyDistance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PropertyDistanceDistanceToUnion = RentalLocation | ResortLift | TicketOffice;

/** An edge in a connection. */
export type PropertyDistanceEdge = {
  __typename?: 'PropertyDistanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PropertyDistance>;
};

/** Attributes for accepting a property product to the itinerary */
export type PropertyLineItem = {
  /** First name of the traveller */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the traveller */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the traveller */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the product */
  productableId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  originalPayableAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Traveler # for grouping line items */
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  rooms: Array<ItineraryInputPropertyRoom>;
  billingContact: PropertyBillingContact;
};

export type PropertyProduct = Coordinates & {
  __typename?: 'PropertyProduct';
  /** Property address */
  address?: Maybe<Scalars['JSON']['output']>;
  /** EAN Images belonging to this property */
  allImages: ImageConnection;
  /** Alternative properties */
  alternativeProperties: PropertyAvailabilityConnection;
  /** All amenities available at the property */
  amenities?: Maybe<Array<Maybe<Amenity>>>;
  /** Property attractions */
  attractions?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Property attributes */
  attributes?: Maybe<Scalars['JSON']['output']>;
  /**
   * Whether this property is in Australia
   * @deprecated No longer used
   */
  australian: Scalars['Boolean']['output'];
  availability?: Maybe<PropertyAvailabilityReturn>;
  /** Property category */
  category: Scalars['String']['output'];
  /** Property checkin information */
  checkin: Scalars['JSON']['output'];
  /** Property check-in begin time */
  checkinBeginTime?: Maybe<Scalars['String']['output']>;
  /** Property check-in end time */
  checkinEndTime?: Maybe<Scalars['String']['output']>;
  /** Property check-in instructions */
  checkinInstructions?: Maybe<Scalars['String']['output']>;
  /** Property check-in special instructions */
  checkinSpecialInstructions?: Maybe<Scalars['String']['output']>;
  /** Property checkout information */
  checkout: Scalars['JSON']['output'];
  /** Property check-out time */
  checkoutTime?: Maybe<Scalars['String']['output']>;
  /** Name of the closest chair lift to the resort */
  closestChairLift: Scalars['JSON']['output'];
  /** Whether this property is curated */
  curated: Scalars['JSON']['output'];
  curatedPropertyDatum?: Maybe<CuratedPropertyDatum>;
  /** Custom summary paragraph for this hotel */
  customSummary?: Maybe<Scalars['String']['output']>;
  /** Custom tagline for this hotel */
  customTagline?: Maybe<Scalars['String']['output']>;
  /** The date the property's content was added */
  dateEntered?: Maybe<Scalars['DateTime']['output']>;
  /** Property descriptions */
  descriptions: Scalars['JSON']['output'];
  /** Distance to the resort */
  distances: Scalars['JSON']['output'];
  /** Property fax number */
  fax?: Maybe<Scalars['String']['output']>;
  /** Is featured property */
  featured: Scalars['Boolean']['output'];
  /** Property features */
  features: Array<Scalars['String']['output']>;
  /** Information related to a property's fees */
  fees: Scalars['JSON']['output'];
  /** Rating information provided by guests who stayed at this property */
  guestRating?: Maybe<ExpediaGuestRating>;
  /** Property guest reviews */
  guestReviews: PropertyProductReviewConnection;
  hasCuratedData: Scalars['Boolean']['output'];
  /** Property hero image */
  heroImage?: Maybe<Image>;
  /** Unique property id */
  id: Scalars['ID']['output'];
  /** Array of Expedia Images */
  images: Array<Image>;
  /** Formatted checkin information points */
  instructions: Scalars['JSON']['output'];
  /** Key amenities available at the property */
  keyAmenities?: Maybe<Array<Scalars['String']['output']>>;
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Additional content */
  liftopiaContent?: Maybe<Scalars['JSON']['output']>;
  /** Longitude */
  longitude: Scalars['Float']['output'];
  /** Whether this product is manually fulfilled or not */
  manualFulfilment?: Maybe<Scalars['Boolean']['output']>;
  /** Property name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Formatted information on optional fees */
  optionalFees?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Property phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Information about property policies that guests need to be aware of */
  policies: Scalars['JSON']['output'];
  propertyDistances?: Maybe<PropertyDistanceConnection>;
  /** Information about the property’s star rating */
  propertyRating?: Maybe<ExpediaPropertyRating>;
  /** Property ranking */
  rank: Scalars['Int']['output'];
  /**
   * Additional content about the rates which the hotel offers.
   * This should be used in conjunction with the pricing and other rate-related
   * information used in shopping.
   *
   */
  rates: Array<PropertyRate>;
  /**
   * Property ratings
   * @deprecated Use propertyRating / guestRating field instead
   */
  ratings?: Maybe<Scalars['JSON']['output']>;
  /** Property's rental locations */
  rentalLocations: RentalLocationConnection;
  /** Whether this property is discounted on resort */
  resortDiscounted: Scalars['JSON']['output'];
  /** Whether this property is featured on resort */
  resortFeatured: Scalars['JSON']['output'];
  /** Property resorts new */
  resorts: PropertyProductResortConnection;
  /**
   * Property resorts
   * @deprecated Use resorts field with PropertyProductResortConnectionType instead
   */
  resortsOld?: Maybe<Array<Resort>>;
  /** Property's rooms */
  rooms: Array<PropertyRoom>;
  /** Ski.com lodge ID */
  skicomId?: Maybe<Scalars['Int']['output']>;
  /** Ski.com room ID */
  skicomUnitId?: Maybe<Scalars['Int']['output']>;
  /** Property static map url */
  staticMapUrl: Scalars['String']['output'];
  /** Property's ticket offices */
  ticketOffices: TicketOfficeConnection;
  /** Tripadvisor content */
  tripadvisor?: Maybe<TripAdvisorContent>;
  /**
   * Tripadvisor content / reviews
   * @deprecated Use tripadvisor field instead
   */
  tripadvisorContent?: Maybe<Scalars['JSON']['output']>;
  /** Walking time to the closest chair lift in minutes */
  walkTime?: Maybe<Scalars['JSON']['output']>;
};


export type PropertyProductAllImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyProductAlternativePropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  availability: PropertyProductAvailabilityFilterInput;
};


export type PropertyProductAvailabilityArgs = {
  availability?: InputMaybe<PropertyProductAvailabilityFilterInput>;
};


export type PropertyProductGuestReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyProductPropertyDistancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyProductRentalLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyProductResortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PropertyProductTicketOfficesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters for filtering out property products based on availabilities */
export type PropertyProductAvailabilityFilterInput = {
  arrival: Scalars['Date']['input'];
  departure: Scalars['Date']['input'];
  occupancy: Array<Scalars['ExpediaPropertyRoomOccupancy']['input']>;
  salesChannel?: InputMaybe<Scalars['String']['input']>;
  isPackage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of rooms to return per property product - rooms are sorted in order of price */
  roomCount?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rates to return per room - room rates are sorted in order of cancellation policy / mor / price */
  roomRateCount?: InputMaybe<Scalars['Int']['input']>;
};

export enum PropertyProductCategoryEnum {
  /** Hotel */
  Hotel = 'Hotel',
  /** B&B and Inns */
  BbAndInns = 'BBAndInns',
  /** Lodge */
  Lodge = 'Lodge',
  /** Condo */
  Condo = 'Condo',
  /** Vacation Home */
  VacationHome = 'VacationHome',
  /** Hostel */
  Hostel = 'Hostel',
  /** Townhouse */
  Townhouse = 'Townhouse',
  /** Other */
  Other = 'Other'
}

/** Filters for filtering out property products */
export type PropertyProductFilterInput = {
  /** Property Category */
  category?: InputMaybe<Array<PropertyProductCategoryEnum>>;
  /** Property Amenity */
  propertyAmenities?: InputMaybe<Array<PropertyProductPropertyAmenityEnum>>;
  /** Driving Distance - this is deprecated - use distances instead */
  maxDrivingDistance?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Distance to the resort */
  distances?: InputMaybe<Array<IntegerRangeInput>>;
  /** Property Rating */
  propertyRating?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Guest Rating */
  guestRating?: InputMaybe<Scalars['Float']['input']>;
  /** Property Price */
  price?: InputMaybe<FloatRangeInput>;
  availability?: InputMaybe<PropertyProductAvailabilityFilterInput>;
  /** Get recommended properties only */
  recommended?: InputMaybe<Scalars['Boolean']['input']>;
  /** Region Featured Type */
  regionFeaturedType?: InputMaybe<RegionPropertyProductFeaturedTypeEnum>;
};

/** LineItem */
export type PropertyProductLineItem = {
  __typename?: 'PropertyProductLineItem';
  /** Biling contact address */
  address?: Maybe<Scalars['JSON']['output']>;
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  /** Date of arrival */
  arriveAt: Scalars['Date']['output'];
  assignedAgent?: Maybe<User>;
  /** Property line item room bed group */
  bedGroup?: Maybe<BedGroup>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * Expedia property confirmation number
   * @deprecated Use supplier_order_id instead
   */
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /**
   * Property confirmation numbers
   * @deprecated Use supplier_confirmation_number instead
   */
  confirmationNumbers?: Maybe<Scalars['JSON']['output']>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  covidPublicHealthOrderData?: Maybe<Scalars['JSON']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  /** Date of departure */
  departAt: Scalars['Date']['output'];
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Property inventory type */
  inventoryType: Scalars['String']['output'];
  isCanceled: Scalars['Boolean']['output'];
  /** Is the property on request */
  isOnRequest: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  messageCenterHref?: Maybe<Scalars['String']['output']>;
  /** Number of nights */
  nights: Scalars['Int']['output'];
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  parkingInstructionData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  /** Billing contact phone number */
  phone?: Maybe<Scalars['String']['output']>;
  pretaxPayableAmount: Scalars['Float']['output'];
  product: PropertyProduct;
  productSupplier?: Maybe<ProductSupplier>;
  /** Rate */
  rate: PropertyRoomRate;
  /** Resort */
  resort?: Maybe<Resort>;
  /** Resort fees */
  resortFees?: Maybe<Scalars['JSON']['output']>;
  /** Resort fees amount */
  resortFeesAmount: Scalars['Float']['output'];
  /** Property line item room */
  room: PropertyRoom;
  /** Special request */
  specialRequest?: Maybe<Scalars['String']['output']>;
  /** Is special request fulfilled */
  specialRequestFulfilled: Scalars['Boolean']['output'];
  /** Property line item current state */
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type PropertyProductLineItemNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum PropertyProductOrderByEnum {
  DrivingDistance = 'DrivingDistance',
  TravellerRating = 'TravellerRating',
  Price = 'Price',
  Discount = 'Discount',
  Default = 'Default'
}

/** Order by input */
export type PropertyProductOrderByInput = {
  /** Name of the field to be ordered by */
  field: PropertyProductOrderByEnum;
  /** Direction of the order by */
  direction?: InputMaybe<OrderByDirectionEnum>;
};

export enum PropertyProductPropertyAmenityEnum {
  /** Kitchen */
  Kitchen = 'Kitchen',
  /** Bar */
  Bar = 'Bar',
  /** Free Breakfast */
  FreeBreakfast = 'FreeBreakfast',
  /** Hot Tub */
  HotTub = 'HotTub',
  /** Pool */
  Pool = 'Pool',
  /** Restaurant */
  Restaurant = 'Restaurant',
  /** Shuttle Service */
  ShuttleService = 'ShuttleService',
  /** Ski Storage */
  SkiStorage = 'SkiStorage',
  /** Pet Friendly */
  PetFriendly = 'PetFriendly'
}

/** The connection type for Resort. */
export type PropertyProductResortConnection = {
  __typename?: 'PropertyProductResortConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PropertyProductResortEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Resort>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PropertyProductResortEdge = {
  __typename?: 'PropertyProductResortEdge';
  /** Name of the closest chair lift to the resort */
  chairLift?: Maybe<Scalars['String']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Whether the property is discounted */
  discounted: Scalars['Boolean']['output'];
  /** Distances to the resort */
  distances: Array<PropertyDistance>;
  /** Distance to the resort */
  drivingDistance: Scalars['Int']['output'];
  /** Whether the property is featured */
  featured: Scalars['Boolean']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Resort>;
  /** Ranking of the property */
  ranking?: Maybe<Scalars['Int']['output']>;
  /** Walking time to the closest chair lift in minutes */
  walkTime?: Maybe<Scalars['Int']['output']>;
};

export type PropertyProductReview = {
  __typename?: 'PropertyProductReview';
  /** Other channel */
  cacOther?: Maybe<Scalars['String']['output']>;
  /** Short review comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** How did the customer find us */
  customerAcquisitionChannel?: Maybe<Scalars['String']['output']>;
  /** Primary id */
  id: Scalars['ID']['output'];
  /** Date of the review */
  rawReviewedAt: Scalars['DateTime']['output'];
  /** Date time of the review */
  reviewedAt: Scalars['DateTime']['output'];
  /** Name of the reviewer */
  reviewerName?: Maybe<Scalars['String']['output']>;
  /** Review score out of 5 */
  score?: Maybe<Scalars['Int']['output']>;
  /** Source of the review */
  source: Scalars['String']['output'];
  /** Date of the stay */
  stayedAt?: Maybe<Scalars['Date']['output']>;
  /** Review title */
  title?: Maybe<Scalars['String']['output']>;
  /** Source of the verification */
  verificationSource?: Maybe<VerificationSourceEnum>;
};

/** The connection type for PropertyProductReview. */
export type PropertyProductReviewConnection = {
  __typename?: 'PropertyProductReviewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PropertyProductReviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PropertyProductReview>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PropertyProductReviewEdge = {
  __typename?: 'PropertyProductReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PropertyProductReview>;
};

export enum PropertyProductRoomTypeEnum {
  /** Room */
  Room = 'room',
  /** Condo */
  Condo = 'condo',
  /** Loft */
  Loft = 'loft',
  /** Suite */
  Suite = 'suite',
  /** Villa */
  Villa = 'villa'
}

/**
 * Additional content about the rates which the hotel offers.
 * This should be used in conjunction with the pricing and other rate-related information used in shopping.
 *
 */
export type PropertyRate = {
  __typename?: 'PropertyRate';
  /**
   * This lists all of the amenities available with a specific rate, including
   * value adds, such as breakfast. See our amenities reference for current known
   * amenity ID and name values.
   *
   */
  amenities: Array<Amenity>;
  /** Unique identifier for a rate. */
  id: Scalars['ID']['output'];
};

/** Room information */
export type PropertyRoom = {
  __typename?: 'PropertyRoom';
  /** EAN Images belonging to this room */
  allImages: ImageConnection;
  amenities: Array<Amenity>;
  area?: Maybe<Scalars['String']['output']>;
  /** A map of the room's bed groups. */
  bedGroups: Array<BedGroup>;
  /** Provides an overview description of a room. */
  descriptions?: Maybe<Scalars['String']['output']>;
  /** Provides a formatted version of description */
  details?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier for a room type. */
  id: Scalars['ID']['output'];
  /**
   * EAN Images belonging to this room
   * @deprecated Use allImages connection field instead
   */
  images: Array<Image>;
  maxOccupancyAdults?: Maybe<Scalars['Int']['output']>;
  maxOccupancyChildren?: Maybe<Scalars['Int']['output']>;
  maxOccupancyTotal?: Maybe<Scalars['Int']['output']>;
  /** Room type name. */
  name: Scalars['String']['output'];
  /** Query for this room's rates */
  rates: Array<PropertyRoomRate>;
  roomType: PropertyProductRoomTypeEnum;
  views?: Maybe<Array<PropertyRoomView>>;
};


/** Room information */
export type PropertyRoomAllImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Room information */
export type PropertyRoomRatesArgs = {
  arrival: Scalars['Date']['input'];
  departure: Scalars['Date']['input'];
  occupancy: Array<Scalars['ExpediaPropertyRoomOccupancy']['input']>;
  isPackage?: InputMaybe<Scalars['Boolean']['input']>;
  roomRateCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Rate information for a room */
export type PropertyRoomRate = {
  __typename?: 'PropertyRoomRate';
  /** Rate amenities. */
  amenities?: Maybe<Array<Amenity>>;
  /** Amount of the property room rate before any discounts being applied */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Number of rooms available with this rate. */
  availableRooms: Scalars['Int']['output'];
  /** A map of the room’s bed groups. */
  bedGroups?: Maybe<Array<PropertyBedGroupAvailability>>;
  /** Array of cancel_penalty objects containing cancel penalty information. Will not be populated on non refundable. */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Request currency */
  currency: Scalars['String']['output'];
  /** Returns the amounts and dates for when any deposits are due. Any required deposits are collected between the due date provided in the response and the check-in date. */
  depositPolicies?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Indicates if a deposit is required for the property */
  depositRequired: Scalars['Boolean']['output'];
  /** Discount applied to the property room rate */
  discount: Scalars['Float']['output'];
  /** Total fees payable */
  fees: Scalars['Float']['output'];
  /**
   * Member Only Deal. DEPRECATED. Use sale_scenario.member instead.
   * @deprecated Removed from EAN API v2.4
   */
  fencedDeal: Scalars['Boolean']['output'];
  /** Rate ID. */
  id: Scalars['ID']['output'];
  /** Indicates if the rate has a member deal available. */
  memberDealAvailable: Scalars['Boolean']['output'];
  merchantOfRecord: Scalars['String']['output'];
  /** A map of room information by occupancy. */
  occupancies?: Maybe<Scalars['JSON']['output']>;
  /** Payable amount of property room rate */
  payable: Scalars['Float']['output'];
  /** Description of rate rule. */
  promoDescription?: Maybe<Scalars['String']['output']>;
  /** Rate Rule Id. */
  promoId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the rate is refundable. */
  refundable: Scalars['Boolean']['output'];
  /** What kind of rate */
  saleScenario: PropertyRoomRateSaleScenario;
  /** Amount of the property room rate before any discounts being applied */
  strikethrough?: Maybe<Scalars['Float']['output']>;
  /** Tax amount of the property room rate */
  taxAmount: Scalars['Float']['output'];
  /** Tokens for fetching payment options and deposit policies */
  tokens: Scalars['JSON']['output'];
};

/** Sale scenario object under room rate type */
export type PropertyRoomRateSaleScenario = {
  __typename?: 'PropertyRoomRateSaleScenario';
  /** Whether it is corporate rate. */
  corporate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether it is distribution rate. */
  distribution?: Maybe<Scalars['Boolean']['output']>;
  /** Whether it is member rate. */
  member?: Maybe<Scalars['Boolean']['output']>;
  /** Whether it is package rate. */
  package?: Maybe<Scalars['Boolean']['output']>;
};

/** Information for a room view */
export type PropertyRoomView = {
  __typename?: 'PropertyRoomView';
  /** Room view ID */
  id: Scalars['ID']['output'];
  /** Room view name */
  name: Scalars['String']['output'];
};

export type QueryType = {
  __typename?: 'QueryType';
  allCoupons: CouponConnection;
  /** Destination autocomplete field */
  allDestinations: Array<Scalars['JSON']['output']>;
  /** All blackout dates */
  allLiftTicketBlackouts: Array<LiftTicketBlackout>;
  allPosts: BlogPostConnection;
  /** @deprecated Use users field instead */
  allUsers: UserConnection;
  apexReady: Scalars['Boolean']['output'];
  blogCategory?: Maybe<BlogCategory>;
  blogPost?: Maybe<BlogPost>;
  cardFees: Scalars['Float']['output'];
  cardsFees: Scalars['JSON']['output'];
  coupon?: Maybe<Coupon>;
  /** A list of properties for daily deals */
  dailyDeals: Array<Scalars['JSON']['output']>;
  gmk: Scalars['String']['output'];
  itineraries: ItinerarySearchkickConnection;
  itinerary: TypesItineraryQueryType;
  manualFulfilmentLineItems?: Maybe<ManualFulfilmentSearchkickConnection>;
  product: TypesProductQueryType;
  productSupplier?: Maybe<ProductSupplier>;
  /** List of unique supplier products */
  productSupplierProducts?: Maybe<Array<Scalars['String']['output']>>;
  /** List of unique supplier short names */
  productSupplierShortNames: Array<Scalars['String']['output']>;
  productSuppliers: ProductSupplierSearchkickConnection;
  region?: Maybe<Region>;
  /** All regions */
  regions: RegionConnection;
  /** Resort that the product belongs to */
  resort?: Maybe<Resort>;
  /** Return all active resorts */
  resorts: ResortConnection;
  review?: Maybe<Review>;
  subregion: Subregion;
  supportCases?: Maybe<SupportCaseSearchkickConnection>;
  trustpilotLatestReviews?: Maybe<Array<Scalars['JSON']['output']>>;
  trustpilotReviews: Scalars['Int']['output'];
  user: User;
  users: UserConnection;
  viewer: TypesViewerQueryType;
};


export type QueryTypeAllCouponsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderByInput>;
};


export type QueryTypeAllDestinationsArgs = {
  query: Scalars['String']['input'];
  types: Array<DestinationTypeEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeAllPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeAllUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeBlogCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeBlogPostArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeCardFeesArgs = {
  cardType: Scalars['String']['input'];
};


export type QueryTypeCouponArgs = {
  code: Scalars['String']['input'];
};


export type QueryTypeDailyDealsArgs = {
  slug: Scalars['String']['input'];
  isSkiInSkiOut?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTypeGmkArgs = {
  requestUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeItinerariesArgs = {
  filter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeManualFulfilmentLineItemsArgs = {
  filter?: InputMaybe<ManualFulfilmentResolverManualFulfilmentInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeProductSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTypeProductSuppliersArgs = {
  filter?: InputMaybe<ProductSupplierSearchResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeRegionArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeRegionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  excludeSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTypeResortArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTypeResortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeReviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTypeSubregionArgs = {
  slug: Scalars['String']['input'];
};


export type QueryTypeSupportCasesArgs = {
  filter?: InputMaybe<SupportCaseResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTypeUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  admin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RankedContent = {
  __typename?: 'RankedContent';
  /** Main content */
  content: Scalars['String']['output'];
  /** The primary id of this content */
  id: Scalars['ID']['output'];
  /** Ranking number */
  ranking: Scalars['Int']['output'];
  /** Associated resort */
  resort: Resort;
  title?: Maybe<Scalars['String']['output']>;
};


export type RankedContentContentArgs = {
  isAmp?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for RankedContent. */
export type RankedContentConnection = {
  __typename?: 'RankedContentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RankedContentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RankedContent>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RankedContentEdge = {
  __typename?: 'RankedContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RankedContent>;
};

/** Region */
export type Region = {
  __typename?: 'Region';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The URL path of the region banner */
  banner: Scalars['String']['output'];
  /** Get content by slug */
  content?: Maybe<Content>;
  continent: Continent;
  country: Country;
  /** The primary id of this region */
  id: Scalars['ID']['output'];
  /** Whether region is visible on packages or not */
  isVisibleOnPackages: Scalars['Boolean']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  mainRegion?: Maybe<Region>;
  /** The name of this region */
  name: Scalars['String']['output'];
  packageZoomLevel?: Maybe<Scalars['Float']['output']>;
  /** The URL path of this region */
  path: Scalars['String']['output'];
  /** Query for PropertyProducts and their availability / pricing for specific region */
  propertyProducts: RegionPropertyProductConnection;
  /** Resorts belonging to this region */
  resorts: ResortConnection;
  /** The SEO description of this region */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** The friendly id of this region */
  slug: Scalars['String']['output'];
  /** Subregions belonging to this region */
  subregions?: Maybe<SubregionConnection>;
};


/** Region */
export type RegionContentArgs = {
  slug: Scalars['String']['input'];
};


/** Region */
export type RegionPropertyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<PropertyProductFilterInput>;
};


/** Region */
export type RegionResortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  curated?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Region */
export type RegionSubregionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Region. */
export type RegionConnection = {
  __typename?: 'RegionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RegionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Region>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegionEdge = {
  __typename?: 'RegionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Region>;
};

/** The connection type for PropertyProduct. */
export type RegionPropertyProductConnection = {
  __typename?: 'RegionPropertyProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RegionPropertyProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PropertyProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RegionPropertyProductEdge = {
  __typename?: 'RegionPropertyProductEdge';
  /** Name of the closest chair lift to the resort */
  chairLift?: Maybe<Scalars['String']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Distance to the resort */
  drivingDistance: Scalars['Int']['output'];
  featuredType?: Maybe<RegionPropertyProductFeaturedTypeEnum>;
  /** The item at the end of the edge. */
  node?: Maybe<PropertyProduct>;
  /** Curated ranking for the resort */
  ranking: Scalars['Int']['output'];
  /** Discounted property for the region */
  regionDiscounted: Scalars['Boolean']['output'];
  /** Featured property for the region */
  regionFeatured: Scalars['Boolean']['output'];
  /** Curated ranking for the region */
  regionRanking?: Maybe<Scalars['Int']['output']>;
  /** Mapped resort for this region property product */
  resort: Resort;
  /** Region properties image alt tag */
  seoAltTag?: Maybe<Scalars['String']['output']>;
  /** Walking time to the closest chair lift in minutes */
  walkTime?: Maybe<Scalars['Int']['output']>;
};

export enum RegionPropertyProductFeaturedTypeEnum {
  Both = 'BOTH',
  SkiInSkiOut = 'SKI_IN_SKI_OUT',
  SkiOnly = 'SKI_ONLY'
}

/** Related Content */
export type RelatedContent = {
  __typename?: 'RelatedContent';
  /** The category of related content */
  category: Scalars['String']['output'];
  /** The primary id of related content */
  id: Scalars['ID']['output'];
  /** Related content image URL */
  image: Scalars['String']['output'];
  /** The name of related content */
  name: Scalars['String']['output'];
  /** The url of related content */
  url: Scalars['String']['output'];
};


/** Related Content */
export type RelatedContentImageArgs = {
  style?: InputMaybe<RelatedContentImageStyleEnum>;
};

export enum RelatedContentImageStyleEnum {
  Original = 'ORIGINAL',
  Medium = 'MEDIUM',
  Thumb = 'THUMB'
}

/** Autogenerated input type of RemoveAttachment */
export type RemoveAttachmentInput = {
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveAttachment */
export type RemoveAttachmentPayload = {
  __typename?: 'RemoveAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of RemoveCoupon */
export type RemoveCouponInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveDuplicate */
export type RemoveDuplicatePayload = {
  __typename?: 'RemoveDuplicatePayload';
  itinerary?: Maybe<Itinerary>;
};

/** Autogenerated input type of RemoveLiftTicketBlackout */
export type RemoveLiftTicketBlackoutInput = {
  /** ID of the resort */
  resortId: Scalars['ID']['input'];
  /** Date in format of yyyy-mm-dd */
  date: Scalars['Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveLiftTicketBlackout */
export type RemoveLiftTicketBlackoutPayload = {
  __typename?: 'RemoveLiftTicketBlackoutPayload';
  /** Whether this date is blacked out */
  blackout?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Date of the blackout */
  date?: Maybe<Scalars['Date']['output']>;
};

/** Attributes for accepting a rental product to the itinerary */
export type RentalLineItem = {
  /** First name of the traveller */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the traveller */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the traveller */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the product */
  productableId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  originalPayableAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Traveler # for grouping line items */
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  /** Height of the traveller in inches */
  height?: InputMaybe<Scalars['String']['input']>;
  /** Weight of the traveller in pounds */
  weight?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the traveller */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Size of the shoe */
  shoeSize?: InputMaybe<Scalars['String']['input']>;
  /** Lodging detail */
  deliverTo?: InputMaybe<Scalars['String']['input']>;
  /** Pick up date and time */
  pickupAt?: InputMaybe<Scalars['String']['input']>;
  /** Drop off date and time */
  dropoffAt?: InputMaybe<Scalars['String']['input']>;
  /** Skill level */
  skillLevel?: InputMaybe<SkillLevelEnum>;
  /** Zendesk Ticket # */
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  /** Helmet inclusion as part of rentals */
  helmetIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Rental location */
export type RentalLocation = Coordinates & {
  __typename?: 'RentalLocation';
  /** The address of the rental location */
  address: Scalars['String']['output'];
  /** The availability of helmet rentals at the rental location */
  helmetAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The value of the helmet price at the rental location */
  helmetPrice: Scalars['Float']['output'];
  helmetType?: Maybe<RentalLocationHelmetTypeEnum>;
  /** The primary id of rental location */
  id: Scalars['ID']['output'];
  /** Is the rental location a premium location */
  isPremium: Scalars['Boolean']['output'];
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Longitude */
  longitude: Scalars['Float']['output'];
  /** The name of the rental location */
  name: Scalars['String']['output'];
  /** The premium of the rental location */
  premium: Scalars['JSON']['output'];
  /** The supplier of the rental location */
  productSupplier?: Maybe<ProductSupplier>;
  /** The resort of the rental location */
  resort: Resort;
  /** Associated resort id */
  resortId: Scalars['ID']['output'];
  /** The store name of the rental location */
  storeName?: Maybe<Scalars['String']['output']>;
  /** The supplier of the rental location */
  supplier?: Maybe<Scalars['String']['output']>;
};

/** The connection type for RentalLocation. */
export type RentalLocationConnection = {
  __typename?: 'RentalLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RentalLocationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RentalLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RentalLocationEdge = {
  __typename?: 'RentalLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RentalLocation>;
};

export enum RentalLocationHelmetTypeEnum {
  PackageRate = 'PackageRate',
  AddonRate = 'AddonRate',
  Included = 'Included',
  NotAvailable = 'NotAvailable'
}

export type RentalProduct = Product & {
  __typename?: 'RentalProduct';
  age: Scalars['String']['output'];
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Lift ticket product cancellation policies */
  cancellationPolicies?: Maybe<Scalars['String']['output']>;
  /** The currency for the product price */
  currency?: Maybe<Scalars['String']['output']>;
  /** Number of days the lift ticket product covers */
  days: Scalars['Int']['output'];
  /** Number of days the product has to be purchased in advance */
  daysInAdvance: Scalars['Int']['output'];
  deliverToLodging: Scalars['Boolean']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product price discount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Fulfillment instructions for the lift ticket product */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  gear: Scalars['String']['output'];
  gearLevel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Product logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Maximum age required for the product */
  maxAge: Scalars['Int']['output'];
  /** Maximum quantity the lift ticket product can be purchased at one time */
  maxQty: Scalars['Int']['output'];
  /** Minimum age required for the product */
  minAge: Scalars['Int']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Other policies for the lift ticket product */
  otherPolicies?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this product is a package or not */
  package: Scalars['Boolean']['output'];
  /** Product payable price */
  payable?: Maybe<Scalars['Float']['output']>;
  /** Product payable price pre tax */
  pretaxPayable?: Maybe<Scalars['Float']['output']>;
  /** Product price */
  price?: Maybe<Scalars['Float']['output']>;
  rental: Scalars['String']['output'];
  /** Resort that the product belongs to */
  resort: Resort;
  /** Product short name */
  shortName: Scalars['String']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** Product tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
};


export type RentalProductLogoArgs = {
  resize?: InputMaybe<ProductLogoSizeEnum>;
};

export enum RentalProductAgeTypeEnum {
  Child = 'Child',
  Adult = 'Adult',
  Teen = 'Teen',
  Senior = 'Senior'
}

/** The connection type for RentalProduct. */
export type RentalProductConnection = {
  __typename?: 'RentalProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RentalProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RentalProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** The connection type for RentalProduct. */
export type RentalProductConnectionWithFilterStatus = {
  __typename?: 'RentalProductConnectionWithFilterStatus';
  /** Products are only available if booked this number of daysin advance to start date */
  daysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RentalProductEdge>>>;
  /** Returns number of products that have been filtered outbecause of daysInAdvance */
  filteredByDaysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RentalProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RentalProductEdge = {
  __typename?: 'RentalProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RentalProduct>;
};

/** Filters for filtering out rental products */
export type RentalProductFilterInput = {
  /** Ages of all the occupancies */
  age?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of gear */
  gearType?: InputMaybe<Array<RentalProductGearTypeEnum>>;
  /** Level of gear */
  gearLevel?: InputMaybe<Array<RentalProductGearLevelEnum>>;
  /** Age group for the gear */
  ageType?: InputMaybe<Array<RentalProductAgeTypeEnum>>;
  /** Type of rental */
  rentalType?: InputMaybe<Array<RentalProductRentalTypeEnum>>;
  /** Deliver to lodging */
  deliverToLodging?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether it is a package product or not */
  package?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of days */
  days?: InputMaybe<Scalars['Int']['input']>;
};

export enum RentalProductGearLevelEnum {
  Demo = 'Demo',
  Performance = 'Performance',
  Basic = 'Basic'
}

export enum RentalProductGearTypeEnum {
  Snowboard = 'Snowboard',
  Ski = 'Ski',
  Protection = 'Protection'
}

/** LineItem */
export type RentalProductLineItem = {
  __typename?: 'RentalProductLineItem';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  /** Date of arrival */
  arriveAt: Scalars['Date']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  /** Lodging detail */
  deliverTo?: Maybe<Scalars['String']['output']>;
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  /** Drop off date and time */
  dropoffAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Rental fulfillment instructions */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  /** Gender of the traveller */
  gender?: Maybe<Scalars['String']['output']>;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Height of the traveller in inches */
  height?: Maybe<Scalars['String']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  /** Pick up date and time */
  pickupAt?: Maybe<Scalars['String']['output']>;
  pretaxPayableAmount: Scalars['Float']['output'];
  product: RentalProduct;
  productSupplier?: Maybe<ProductSupplier>;
  /**
   * Rental fulfillment instructions
   * @deprecated Use fulfillment_instructions instead
   */
  rentalFulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  /** Closest rental location */
  rentalLocation?: Maybe<RentalLocation>;
  /** Size of the shoe */
  shoeSize?: Maybe<Scalars['String']['output']>;
  /** Equipment skill level */
  skillLevel?: Maybe<SkillLevelEnum>;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
  /** Weight of the traveller in pounds */
  weight?: Maybe<Scalars['String']['output']>;
  /** Zendesk Ticket # */
  zendeskTicket?: Maybe<Scalars['String']['output']>;
};


/** LineItem */
export type RentalProductLineItemFulfillmentInstructionsArgs = {
  editMode?: InputMaybe<Scalars['Boolean']['input']>;
};


/** LineItem */
export type RentalProductLineItemNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for RentalProductLineItem. */
export type RentalProductLineItemConnection = {
  __typename?: 'RentalProductLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RentalProductLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RentalProductLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RentalProductLineItemEdge = {
  __typename?: 'RentalProductLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RentalProductLineItem>;
};

export enum RentalProductRentalTypeEnum {
  PickUp = 'PickUp',
  Delivery = 'Delivery'
}

/** Resort */
export type Resort = Coordinates & {
  __typename?: 'Resort';
  /** The resort's address fields */
  address: ResortAddress;
  /** Resort advanced runs percentage */
  advancedRunsPercentage?: Maybe<Scalars['Float']['output']>;
  /** The advices of the resort */
  advices?: Maybe<Array<ResortAdvice>>;
  /** Airports linked to this resort */
  airports: ResortAirportConnection;
  /** Product supplier */
  allProductSuppliers: ProductSupplierConnection;
  /** Resort attributes */
  attributes?: Maybe<Array<ResortAttribute>>;
  /** The URL of resort banner */
  banner: Scalars['String']['output'];
  /** Resort base elevation */
  baseElevation?: Maybe<Scalars['String']['output']>;
  /** Resort beginner runs percentage */
  beginnerRunsPercentage?: Maybe<Scalars['Float']['output']>;
  /** The country that the resort belongs to */
  country: Country;
  /** Resort COVID protocols */
  covidProtocols?: Maybe<ResortCovidProtocol>;
  currentSeason?: Maybe<ResortSeason>;
  /** Whether the banner is a dark image */
  darkBanner: Scalars['Boolean']['output'];
  /** Resort drop elevation */
  dropElevation?: Maybe<Scalars['String']['output']>;
  /** Resort expert runs percentage */
  expertRunsPercentage?: Maybe<Scalars['Float']['output']>;
  /** Whether resort is featured or not */
  featured: Scalars['Boolean']['output'];
  /** The primary id of this resort */
  id: Scalars['ID']['output'];
  images: ActiveStorageConnection;
  /** Resort intermediate runs percentage */
  intermediateRunsPercentage?: Maybe<Scalars['Float']['output']>;
  /** Is resort currently open */
  isCurrentlyOpen: Scalars['Boolean']['output'];
  /** Whether resort is visible on packages or not */
  isVisibleOnPackages: Scalars['Boolean']['output'];
  /** Content of resort known for */
  knownFor?: Maybe<ResortAttribute>;
  lat: Scalars['Float']['output'];
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Query for LessonProducts */
  lessonProducts: LessonProductConnectionWithFilterStatus;
  /** Blackout dates for this resort */
  liftTicketBlackouts: Array<LiftTicketBlackout>;
  /** Lift ticket info for listing page */
  liftTicketInfo?: Maybe<Scalars['String']['output']>;
  /** Query for LiftTicketProducts */
  liftTicketProducts: LiftTicketProductConnectionWithFilterStatus;
  lng: Scalars['Float']['output'];
  /** HTML Lodging areas content */
  lodgingAreas?: Maybe<Scalars['String']['output']>;
  /** HTML Lodging overview content */
  lodgingOverview?: Maybe<Scalars['String']['output']>;
  /** The URL of resort logo */
  logo: Scalars['String']['output'];
  /** Latitude of logo on the map */
  logoLat?: Maybe<Scalars['Float']['output']>;
  /** Longitude of logo on the map */
  logoLng?: Maybe<Scalars['Float']['output']>;
  /** Longitude */
  longitude: Scalars['Float']['output'];
  /** The name of this resort */
  name: Scalars['String']['output'];
  /** Overall price range of resort */
  overallPriceRange?: Maybe<Scalars['Int']['output']>;
  /** Latitude used on resort package map */
  packageLat: Scalars['Float']['output'];
  /** Longitude used on resort package map */
  packageLng: Scalars['Float']['output'];
  packageZoomLevel?: Maybe<Scalars['Float']['output']>;
  /** The URL path of the resort */
  path: Scalars['String']['output'];
  /** Resort's phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Resort popular lifts */
  popularLifts: Array<ResortLift>;
  /** Rough price range for Google rich snippet */
  priceRange: Scalars['String']['output'];
  /**
   * Product supplier
   * @deprecated Use all_product_suppliers instead
   */
  productSuppliers: Array<ProductSupplier>;
  /** Number of products for the resort */
  productsCount: Scalars['Int']['output'];
  /** Description / FAQ of products */
  productsDescription: Scalars['JSON']['output'];
  /** Query for PropertyProducts and their availability / pricing for specific resort */
  propertyProducts: ResortPropertyProductConnection;
  /** The region that the resort belongs to */
  region: Region;
  /** Latitude of logo used on region package map */
  regionLogoLat?: Maybe<Scalars['Float']['output']>;
  /** Longitude of logo used on region package map */
  regionLogoLng?: Maybe<Scalars['Float']['output']>;
  /**
   * Query for PropertyProducts and their availability / pricing for specific region
   * @deprecated Properties nested at the resort level no longer required, use RegionType#property_product instead
   */
  regionPropertyProducts: RegionPropertyProductConnection;
  /** All related region top x contents */
  regionTopXContents: ContentConnection;
  /** Resort rental locations */
  rentalLocations?: Maybe<Array<RentalLocation>>;
  /** Query for RentalProducts */
  rentalProducts: RentalProductConnectionWithFilterStatus;
  /** resort base areas */
  resortBaseAreas?: Maybe<ResortBaseAreaConnection>;
  /** Resort content pages */
  resortContents: Array<ResortContent>;
  reviewCount: Scalars['Int']['output'];
  reviewScoreAvg?: Maybe<Scalars['Float']['output']>;
  seasons: ResortSeasonConnection;
  /** The SEO description of this resort */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Prefill outbound transfer pickup location */
  showForOutboundTransfer: Scalars['Boolean']['output'];
  /** Resort skiable area */
  skiableArea?: Maybe<Scalars['String']['output']>;
  /** Ski.com ID */
  skicomId?: Maybe<Scalars['Int']['output']>;
  /** The friendly id of this resort */
  slug: Scalars['String']['output'];
  /** Resort static map url */
  staticMapUrl: Scalars['String']['output'];
  /** The subregion that the resort belongs to */
  subregion?: Maybe<Subregion>;
  /** Resort summit elevation */
  summitElevation?: Maybe<Scalars['String']['output']>;
  ticketOffices?: Maybe<Array<TicketOffice>>;
  /** The name of this resort for top x */
  topXName?: Maybe<Scalars['String']['output']>;
  trailMaps: ActiveStorageConnection;
  /** Query for TransportationProducts */
  transportationProducts: TransportationProductConnectionWithFilterStatus;
  /** All transportation suppliers for this resort */
  transportationSuppliers: Array<TransportationSupplier>;
  upcomingSeason?: Maybe<ResortSeason>;
};


/** Resort */
export type ResortAirportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Resort */
export type ResortAllProductSuppliersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<ProductSupplierProductTypeEnum>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  mainSupplierOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Resort */
export type ResortAttributesArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Resort */
export type ResortBannerArgs = {
  size?: InputMaybe<BannerSizeEnum>;
};


/** Resort */
export type ResortImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Resort */
export type ResortLessonProductsArgs = {
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  startAt: Scalars['Date']['input'];
};


/** Resort */
export type ResortLiftTicketProductsArgs = {
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  daysExact?: InputMaybe<Scalars['Boolean']['input']>;
  startAt: Scalars['Date']['input'];
  ticketTypes?: InputMaybe<Array<LiftTicketProductTicketTypeEnum>>;
};


/** Resort */
export type ResortProductSuppliersArgs = {
  productType?: InputMaybe<ProductSupplierProductTypeEnum>;
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  mainSupplierOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Resort */
export type ResortProductsCountArgs = {
  productType: ProductEnum;
};


/** Resort */
export type ResortPropertyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  filterBy?: InputMaybe<PropertyProductFilterInput>;
};


/** Resort */
export type ResortRegionPropertyProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  regionSlug: Scalars['String']['input'];
  filterBy?: InputMaybe<PropertyProductFilterInput>;
};


/** Resort */
export type ResortRegionTopXContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Resort */
export type ResortRentalProductsArgs = {
  ageTypes?: InputMaybe<Array<RentalProductAgeTypeEnum>>;
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  daysExact?: InputMaybe<Scalars['Boolean']['input']>;
  gearLevels?: InputMaybe<Array<RentalProductGearLevelEnum>>;
  gearTypes?: InputMaybe<Array<RentalProductGearTypeEnum>>;
  rentalTypes?: InputMaybe<Array<RentalProductRentalTypeEnum>>;
  startAt: Scalars['Date']['input'];
};


/** Resort */
export type ResortResortBaseAreasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Resort */
export type ResortSeasonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Resort */
export type ResortTrailMapsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Resort */
export type ResortTransportationProductsArgs = {
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  passengerTypes?: InputMaybe<Array<TransportationProductPassengerTypeEnum>>;
  startAt: Scalars['Date']['input'];
  ticketTypes?: InputMaybe<Array<TransportationProductTicketTypeEnum>>;
  transportationTypes?: InputMaybe<Array<TransportationProductTransportationTypeEnum>>;
};

/** Resort Address */
export type ResortAddress = {
  __typename?: 'ResortAddress';
  country?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type ResortAdvice = {
  __typename?: 'ResortAdvice';
  /** The advice content */
  advice: Scalars['String']['output'];
  /** The primary id of this advice */
  id: Scalars['ID']['output'];
  /** Good / Bad */
  isGood: Scalars['Boolean']['output'];
};

/** The connection type for Airport. */
export type ResortAirportConnection = {
  __typename?: 'ResortAirportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResortAirportEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Airport>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResortAirportEdge = {
  __typename?: 'ResortAirportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  distance?: Maybe<Scalars['String']['output']>;
  drivingDistance?: Maybe<Scalars['Int']['output']>;
  drivingTime?: Maybe<Scalars['String']['output']>;
  /** The item at the end of the edge. */
  node?: Maybe<Airport>;
  recommended: Scalars['Boolean']['output'];
};

export type ResortAttribute = {
  __typename?: 'ResortAttribute';
  /** Attribute content (value) */
  content: Scalars['String']['output'];
  /** The primary id of this attribute */
  id: Scalars['ID']['output'];
  /** Attribute info */
  info?: Maybe<Scalars['String']['output']>;
  /** Attribute name (key) */
  name: Scalars['String']['output'];
  /** Number for ranking */
  ranking: Scalars['Int']['output'];
};

/** Resort base area */
export type ResortBaseArea = {
  __typename?: 'ResortBaseArea';
  /** The primary id of resort base area */
  id: Scalars['ID']['output'];
  /** The lat of the resort base area */
  lat: Scalars['Float']['output'];
  /** The lng of the resort base area */
  lng?: Maybe<Scalars['Float']['output']>;
  /** The name of the resort base area */
  name: Scalars['String']['output'];
};

/** The connection type for ResortBaseArea. */
export type ResortBaseAreaConnection = {
  __typename?: 'ResortBaseAreaConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResortBaseAreaEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ResortBaseArea>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResortBaseAreaEdge = {
  __typename?: 'ResortBaseAreaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ResortBaseArea>;
};

/** The connection type for Resort. */
export type ResortConnection = {
  __typename?: 'ResortConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResortEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Resort>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ResortContent = {
  __typename?: 'ResortContent';
  /** The primary id of this content */
  id: Scalars['ID']['output'];
  /** Label for nav bar */
  label: Scalars['String']['output'];
  /** URL slug */
  slug: Scalars['String']['output'];
};

/** COVID protocols for resorts */
export type ResortCovidProtocol = {
  __typename?: 'ResortCovidProtocol';
  country: Scalars['String']['output'];
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  protocol: Scalars['String']['output'];
  sources?: Maybe<Array<Scalars['String']['output']>>;
  state: Scalars['String']['output'];
  suggestionsLinks?: Maybe<Array<Scalars['JSON']['output']>>;
};

/** An edge in a connection. */
export type ResortEdge = {
  __typename?: 'ResortEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Resort>;
};

/** ResortLift */
export type ResortLift = Coordinates & {
  __typename?: 'ResortLift';
  /** Primary ID */
  id: Scalars['ID']['output'];
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Longitude */
  longitude: Scalars['Float']['output'];
  /** Lift name */
  name: Scalars['String']['output'];
};

/** The connection type for PropertyProduct. */
export type ResortPropertyProductConnection = {
  __typename?: 'ResortPropertyProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResortPropertyProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PropertyProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResortPropertyProductEdge = {
  __typename?: 'ResortPropertyProductEdge';
  /** Name of the closest chair lift to the resort */
  chairLift?: Maybe<Scalars['String']['output']>;
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Whether the property is discounted */
  discounted: Scalars['Boolean']['output'];
  /** Distance to the resort */
  drivingDistance: Scalars['Int']['output'];
  /** Whether the property is featured */
  featured: Scalars['Boolean']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PropertyProduct>;
  /** Ranking of the property */
  ranking?: Maybe<Scalars['Int']['output']>;
  /** Walking time to the closest chair lift in minutes */
  walkTime?: Maybe<Scalars['Int']['output']>;
};

/** ResortSeason */
export type ResortSeason = {
  __typename?: 'ResortSeason';
  /** Closing date for the season */
  closingDate?: Maybe<Scalars['Date']['output']>;
  /** Closing status */
  closingStatus?: Maybe<ResortSeasonOpenCloseStatusEnum>;
  id: Scalars['ID']['output'];
  /** Is closing date for the season estimated */
  isClosingDateEstimated: Scalars['Boolean']['output'];
  /**
   * Whether season dates are estimate
   * @deprecated Use is_opening_date_estimate and is_closing_date_estimate
   */
  isEstimate: Scalars['Boolean']['output'];
  /** Is opening date for the season estimated */
  isOpeningDateEstimated: Scalars['Boolean']['output'];
  /** Opening date for the season */
  openingDate?: Maybe<Scalars['Date']['output']>;
  /** Opening status */
  openingStatus?: Maybe<ResortSeasonOpenCloseStatusEnum>;
  /** Season start year */
  startYear: Scalars['String']['output'];
};

/** The connection type for ResortSeason. */
export type ResortSeasonConnection = {
  __typename?: 'ResortSeasonConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ResortSeasonEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ResortSeason>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ResortSeasonEdge = {
  __typename?: 'ResortSeasonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ResortSeason>;
};

export enum ResortSeasonOpenCloseStatusEnum {
  DataUnavailable = 'DATA_UNAVAILABLE',
  Ongoing = 'ONGOING',
  Closed = 'CLOSED',
  ClosedDueToCovid19 = 'CLOSED_DUE_TO_COVID19'
}

/** Review */
export type Review = {
  __typename?: 'Review';
  /** Time the review was approved */
  approvedAt: Scalars['DateTime']['output'];
  /** Author's First name and last initial */
  authorName: Scalars['String']['output'];
  /** URL of the author's avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Reviewer's comment */
  comment: Scalars['String']['output'];
  /** Primary id */
  id: Scalars['ID']['output'];
  /** Reviewer's rider level */
  riderLevel?: Maybe<Scalars['String']['output']>;
  /** Reviewer's rider type - Snowboarder or Skier */
  riderType?: Maybe<Scalars['String']['output']>;
  /** Aggregate score */
  score: Scalars['Float']['output'];
  /** Aggregate score as a word */
  scoreAsText: Scalars['String']['output'];
};

/** The connection type for Review. */
export type ReviewConnection = {
  __typename?: 'ReviewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Review>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReviewEdge = {
  __typename?: 'ReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Review>;
};

export enum ScalarComparisonEnum {
  Eq = 'EQ',
  Not = 'NOT',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export type ScheduledPayment = CreatedAtUpdatedAt & {
  __typename?: 'ScheduledPayment';
  /** Scheduled Payment amount */
  amount: Scalars['Float']['output'];
  cardFees: Scalars['Float']['output'];
  chargeable: Scalars['Boolean']['output'];
  collectionSource?: Maybe<ScheduledPaymentCollectionSourceEnum>;
  coupon?: Maybe<Coupon>;
  couponDiscount: Scalars['Float']['output'];
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  /** Payment ID */
  id: Scalars['ID']['output'];
  isModified: Scalars['Boolean']['output'];
  itinerary: Itinerary;
  lineItem: LineItem;
  payment?: Maybe<Payment>;
  paymentType: Scalars['String']['output'];
  processAt: Scalars['DateTime']['output'];
  processed: Scalars['Boolean']['output'];
  state: ScheduledPaymentStateEnum;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};

export enum ScheduledPaymentCollectionSourceEnum {
  Snowpak = 'SNOWPAK',
  Property = 'PROPERTY',
  Expedia = 'EXPEDIA',
  Priceline = 'PRICELINE'
}

/** The connection type for ScheduledPayment. */
export type ScheduledPaymentConnection = {
  __typename?: 'ScheduledPaymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ScheduledPaymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ScheduledPayment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ScheduledPaymentEdge = {
  __typename?: 'ScheduledPaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ScheduledPayment>;
};

export type ScheduledPaymentMutations = {
  __typename?: 'ScheduledPaymentMutations';
  markAsPaid?: Maybe<MutationsScheduledPaymentMarkAsPaidPayload>;
  processCharge?: Maybe<MutationsScheduledPaymentProcessChargePayload>;
};


export type ScheduledPaymentMutationsMarkAsPaidArgs = {
  input: MutationsScheduledPaymentMarkAsPaidInput;
};


export type ScheduledPaymentMutationsProcessChargeArgs = {
  input: MutationsScheduledPaymentProcessChargeInput;
};

export enum ScheduledPaymentPaymentTypeEnum {
  Deposit = 'DEPOSIT',
  Scheduled = 'SCHEDULED',
  All = 'ALL'
}

export enum ScheduledPaymentStateEnum {
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Failed = 'FAILED',
  Archived = 'ARCHIVED',
  Cancelled = 'CANCELLED',
  Refunded = 'REFUNDED',
  PartiallyRefunded = 'PARTIALLY_REFUNDED'
}

/** Used for searchkick related inputs */
export type SearchkickOrderByInput = {
  /** Name of the field to be ordered by */
  field: Scalars['String']['input'];
  /** Direction of the order by */
  direction?: InputMaybe<OrderByDirectionEnum>;
};

export type SearchkickPaginationInterface = {
  /** Current page # */
  currentPage: Scalars['Int']['output'];
  /** Current # of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total # of possible results */
  totalCount: Scalars['Int']['output'];
  /** Total # of possible pages */
  totalPages: Scalars['Int']['output'];
};

/** Autogenerated input type of SendEmail */
export type SendEmailInput = {
  emailType: EmailTypeEnum;
  emailAddress?: InputMaybe<Scalars['Email']['input']>;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SendEmail */
export type SendEmailPayload = {
  __typename?: 'SendEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated return type of SignInUser */
export type SignInUserPayload = {
  __typename?: 'SignInUserPayload';
  accessToken: Scalars['String']['output'];
  client: Scalars['String']['output'];
  user: User;
};

export enum SkillLevelEnum {
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE',
  Advanced = 'ADVANCED'
}

/** Subregion */
export type Subregion = {
  __typename?: 'Subregion';
  /** The URL path of the region banner */
  banner: Scalars['String']['output'];
  /** The slug of the bundle listing page */
  bundleSlug?: Maybe<Scalars['String']['output']>;
  /** Get content by slug */
  content?: Maybe<Content>;
  /** The primary id of this subregion */
  id: Scalars['ID']['output'];
  /** Whether subregion is visible on packages or not */
  isVisibleOnPackages: Scalars['Boolean']['output'];
  /** The name of this subregion */
  name: Scalars['String']['output'];
  /** The URL path of this region */
  path: Scalars['String']['output'];
  /** The region that the Subregion belongs to */
  region: Region;
  /** Resorts belonging to this region */
  resorts?: Maybe<ResortConnection>;
  /** The friendly id of this subregion */
  slug: Scalars['String']['output'];
};


/** Subregion */
export type SubregionContentArgs = {
  slug: Scalars['String']['input'];
};


/** Subregion */
export type SubregionResortsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Subregion. */
export type SubregionConnection = {
  __typename?: 'SubregionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubregionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Subregion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SubregionEdge = {
  __typename?: 'SubregionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Subregion>;
};

export type SupportCase = {
  __typename?: 'SupportCase';
  action: SupportCaseActionEnum;
  assignedTo?: Maybe<User>;
  caseType: SupportCaseTypeEnum;
  category: SupportCaseCategoryEnum;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The primary id of this attribute */
  id: Scalars['ID']['output'];
  itinerary: Itinerary;
  notes?: Maybe<Scalars['String']['output']>;
  subcategory: SupportCaseSubcategoryEnum;
  supportNotes: Array<SupportNote>;
  updatedAt: Scalars['DateTime']['output'];
  zendeskTicket?: Maybe<Scalars['String']['output']>;
};

export enum SupportCaseActionEnum {
  Pending = 'PENDING',
  Problematic = 'PROBLEMATIC',
  Resolved = 'RESOLVED'
}

export enum SupportCaseCategoryEnum {
  Audit = 'AUDIT',
  Fulfilment = 'FULFILMENT',
  Changes = 'CHANGES',
  Cancellation = 'CANCELLATION',
  Lodging = 'LODGING',
  NonLodging = 'NON_LODGING',
  Payment = 'PAYMENT',
  Other = 'OTHER'
}

export type SupportCaseMutations = {
  __typename?: 'SupportCaseMutations';
  create?: Maybe<MutationsSupportCaseCreatePayload>;
  update?: Maybe<MutationsSupportCaseUpdatePayload>;
};


export type SupportCaseMutationsCreateArgs = {
  input: MutationsSupportCaseCreateInput;
};


export type SupportCaseMutationsUpdateArgs = {
  input: MutationsSupportCaseUpdateInput;
};

export type SupportCaseResolverFilterInput = {
  /** Primary Key of the SupportCase */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Public ID of the related main Itinerary */
  itineraryPublicId?: InputMaybe<Scalars['ID']['input']>;
  /** First name of the main contact */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the main contact */
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  propertyName?: InputMaybe<Scalars['String']['input']>;
  resortName?: InputMaybe<Array<Scalars['String']['input']>>;
  fulfilmentState?: InputMaybe<Array<ItineraryFulfilmentStateEnum>>;
  caseId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Array<SupportCaseCategoryEnum>>;
  subcategory?: InputMaybe<Array<SupportCaseSubcategoryEnum>>;
  action?: InputMaybe<Array<SupportCaseActionEnum>>;
  caseType?: InputMaybe<Array<SupportCaseTypeEnum>>;
  assignedToUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByUserId?: InputMaybe<Array<Scalars['ID']['input']>>;
  arriveAt?: InputMaybe<Array<InputsComparisonDate>>;
  departAt?: InputMaybe<Array<InputsComparisonDate>>;
  createdAt?: InputMaybe<Array<InputsComparisonDate>>;
};

/** The connection type for SupportCaseSearchkickResult. */
export type SupportCaseSearchkickConnection = SearchkickPaginationInterface & {
  __typename?: 'SupportCaseSearchkickConnection';
  /** Current page # */
  currentPage: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SupportCaseSearchkickResultEdge>>>;
  metadata: Metadata;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SupportCaseSearchkickResult>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Current # of items per page */
  pageSize: Scalars['Int']['output'];
  /** Total # of possible results */
  totalCount: Scalars['Int']['output'];
  /** Total # of possible pages */
  totalPages: Scalars['Int']['output'];
};

/** Support Case Searchkick results */
export type SupportCaseSearchkickResult = {
  __typename?: 'SupportCaseSearchkickResult';
  action?: Maybe<SupportCaseActionEnum>;
  /** The arrival date of the itinerary */
  arriveAt: Scalars['Date']['output'];
  assignedTo?: Maybe<User>;
  caseType?: Maybe<SupportCaseTypeEnum>;
  category?: Maybe<SupportCaseCategoryEnum>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  /** The departure date of the itinerary */
  departAt: Scalars['Date']['output'];
  /** Email of the main contact */
  email?: Maybe<Scalars['Email']['output']>;
  /** First name of the main contact */
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentState?: Maybe<ItineraryFulfilmentStateEnum>;
  /** Primary key */
  id: Scalars['ID']['output'];
  /** Public facing ID */
  itineraryPublicId: Scalars['ID']['output'];
  /** Last name of the main contact */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Public facing ID of the latest confirmed */
  latestConfirmedItineraryPublicId: Scalars['ID']['output'];
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Phone number of the main contact */
  phone?: Maybe<Scalars['String']['output']>;
  /** Property name */
  propertyName: Scalars['String']['output'];
  /** Resort name */
  resortName: Scalars['String']['output'];
  subcategory?: Maybe<SupportCaseSubcategoryEnum>;
};

/** An edge in a connection. */
export type SupportCaseSearchkickResultEdge = {
  __typename?: 'SupportCaseSearchkickResultEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportCaseSearchkickResult>;
};

export enum SupportCaseSubcategoryEnum {
  ProductDays = 'PRODUCT_DAYS',
  ProductDate = 'PRODUCT_DATE',
  Age = 'AGE',
  Name = 'NAME',
  Combination = 'COMBINATION',
  Bug = 'BUG',
  Unavailable = 'UNAVAILABLE',
  OrderMistake = 'ORDER_MISTAKE',
  MarginIssue = 'MARGIN_ISSUE',
  Product = 'PRODUCT',
  Lodging = 'LODGING',
  Room = 'ROOM',
  Resort = 'RESORT',
  RescheduleTrip = 'RESCHEDULE_TRIP',
  CustomerInfo = 'CUSTOMER_INFO',
  FlightDetails = 'FLIGHT_DETAILS',
  CancellationOfEntirePackage = 'CANCELLATION_OF_ENTIRE_PACKAGE',
  CancellationOfLodgingOnly = 'CANCELLATION_OF_LODGING_ONLY',
  SupplierPaymentIssue = 'SUPPLIER_PAYMENT_ISSUE',
  IncorrectInformation = 'INCORRECT_INFORMATION',
  BookingRejected = 'BOOKING_REJECTED',
  CheckInIssue = 'CHECK_IN_ISSUE',
  UnpleasantStay = 'UNPLEASANT_STAY',
  PickUpIssue = 'PICK_UP_ISSUE',
  Coupon = 'COUPON',
  PriceMatch = 'PRICE_MATCH',
  RemainingBalance = 'REMAINING_BALANCE',
  CreditCard = 'CREDIT_CARD',
  Miscellaneous = 'MISCELLANEOUS',
  TestBookings = 'TEST_BOOKINGS',
  OldNotes = 'OLD_NOTES',
  RentalDelivery = 'RENTAL_DELIVERY',
  PreArrival = 'PRE_ARRIVAL',
  TransferRequests = 'TRANSFER_REQUESTS',
  SpecialRequests = 'SPECIAL_REQUESTS',
  LiabilityWaiver = 'LIABILITY_WAIVER'
}

export enum SupportCaseTypeEnum {
  Inquiry = 'INQUIRY',
  Confirmed = 'CONFIRMED'
}

export type SupportNote = CreatedAtUpdatedAt & {
  __typename?: 'SupportNote';
  content: Scalars['String']['output'];
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  /** The primary id of this attribute */
  id: Scalars['ID']['output'];
  supportCase: SupportCase;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
  zendeskTicket?: Maybe<Scalars['String']['output']>;
};

export type SupportNoteMutations = {
  __typename?: 'SupportNoteMutations';
  create?: Maybe<MutationsSupportNoteCreatePayload>;
  update?: Maybe<MutationsSupportNoteUpdatePayload>;
};


export type SupportNoteMutationsCreateArgs = {
  input: MutationsSupportNoteCreateInput;
};


export type SupportNoteMutationsUpdateArgs = {
  input: MutationsSupportNoteUpdateInput;
};

export type TicketOffice = Coordinates & {
  __typename?: 'TicketOffice';
  active: Scalars['Boolean']['output'];
  alternativeAddress: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  /** Primary ID */
  id: Scalars['ID']['output'];
  /** Latitude */
  latitude: Scalars['Float']['output'];
  /** Longitude */
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  resort: Resort;
};

/** The connection type for TicketOffice. */
export type TicketOfficeConnection = {
  __typename?: 'TicketOfficeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TicketOfficeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TicketOffice>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TicketOfficeEdge = {
  __typename?: 'TicketOfficeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TicketOffice>;
};

/** Autogenerated input type of TrackItineraryView */
export type TrackItineraryViewInput = {
  /** ID of the itinerary */
  id: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TrackItineraryView */
export type TrackItineraryViewPayload = {
  __typename?: 'TrackItineraryViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TransferFulfilmentInstruction = CreatedAtUpdatedAt & {
  __typename?: 'TransferFulfilmentInstruction';
  active: Scalars['Boolean']['output'];
  airport?: Maybe<Scalars['String']['output']>;
  audits?: Maybe<TypesTransferFulfilmentInstructionAuditedTypeConnection>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  direction?: Maybe<TransferFulfilmentInstructionDirectionEnum>;
  /** Primary ID */
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  productSupplier: ProductSupplier;
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};


export type TransferFulfilmentInstructionAuditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  action?: InputMaybe<AuditActionEnum>;
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The connection type for TransferFulfilmentInstruction. */
export type TransferFulfilmentInstructionConnection = {
  __typename?: 'TransferFulfilmentInstructionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransferFulfilmentInstructionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TransferFulfilmentInstruction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export enum TransferFulfilmentInstructionDirectionEnum {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

/** An edge in a connection. */
export type TransferFulfilmentInstructionEdge = {
  __typename?: 'TransferFulfilmentInstructionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TransferFulfilmentInstruction>;
};

/** Transfer Fulfilment Instruction Input */
export type TransferFulfilmentInstructionInput = {
  /** Product supplier ID of the fulfilment instruction */
  productSupplierId: Scalars['Int']['input'];
  /** Name of the fulfilment instruction */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Direction of the fulfilment instruction */
  direction?: InputMaybe<TransferFulfilmentInstructionDirectionEnum>;
  /** Airport of the fulfilment instruction */
  airport?: InputMaybe<Scalars['String']['input']>;
  /** Contact number of the fulfilment instruction */
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  /** Instructions of the fulfilment instruction */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /** Ordering of the fulfilment instruction */
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type TransferFulfilmentInstructionMutations = {
  __typename?: 'TransferFulfilmentInstructionMutations';
  activate?: Maybe<MutationsTransferFulfilmentInstructionActivatePayload>;
  create?: Maybe<MutationsTransferFulfilmentInstructionCreatePayload>;
  deactivate?: Maybe<MutationsTransferFulfilmentInstructionDeactivatePayload>;
  update?: Maybe<MutationsTransferFulfilmentInstructionUpdatePayload>;
};


export type TransferFulfilmentInstructionMutationsActivateArgs = {
  input: MutationsTransferFulfilmentInstructionActivateInput;
};


export type TransferFulfilmentInstructionMutationsCreateArgs = {
  input: MutationsTransferFulfilmentInstructionCreateInput;
};


export type TransferFulfilmentInstructionMutationsDeactivateArgs = {
  input: MutationsTransferFulfilmentInstructionDeactivateInput;
};


export type TransferFulfilmentInstructionMutationsUpdateArgs = {
  input: MutationsTransferFulfilmentInstructionUpdateInput;
};

export type TransferFulfilmentInstructionSearchkickResult = {
  __typename?: 'TransferFulfilmentInstructionSearchkickResult';
  active: Scalars['Boolean']['output'];
  airport?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<TransferFulfilmentInstructionDirectionEnum>;
  /** Primary ID */
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Attributes for inbound and outbound transport information */
export type TransportDetailInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  transferFulfilmentInstructionId?: InputMaybe<Scalars['ID']['input']>;
  transferCompany?: InputMaybe<Scalars['String']['input']>;
  confirmationNumber?: InputMaybe<Scalars['String']['input']>;
  pickUpLocation?: InputMaybe<Scalars['String']['input']>;
  pickUpTime?: InputMaybe<Scalars['String']['input']>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for accepting flight details for transfer products */
export type TransportationFlight = {
  /** Date time of arrival */
  arriveAt?: InputMaybe<Scalars['String']['input']>;
  /** Date time of departure */
  departAt?: InputMaybe<Scalars['String']['input']>;
  /** Flight airline */
  airline?: InputMaybe<Scalars['String']['input']>;
  /** Flight airline */
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  /** Location of the traveller for pickup / dropoff */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Related Zendesk Ticket # */
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  /** Domestic or International */
  terminal?: InputMaybe<Scalars['String']['input']>;
};

/** Attributes for accepting a transfer product to the itinerary */
export type TransportationLineItem = {
  /** First name of the traveller */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the traveller */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth of the traveller */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** ID of the product */
  productableId?: InputMaybe<Scalars['ID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  originalPayableAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Traveler # for grouping line items */
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  /** Phone number of the traveller */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Flight arrival detail of the traveller */
  flightArrival?: InputMaybe<TransportationFlight>;
  /** Flight departure detail of the traveller */
  flightDeparture?: InputMaybe<TransportationFlight>;
};

export type TransportationProduct = Product & {
  __typename?: 'TransportationProduct';
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Lift ticket product cancellation policies */
  cancellationPolicies?: Maybe<Scalars['String']['output']>;
  /** The currency for the product price */
  currency?: Maybe<Scalars['String']['output']>;
  /** Number of days the product has to be purchased in advance */
  daysInAdvance: Scalars['Int']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product price discount */
  discount?: Maybe<Scalars['Float']['output']>;
  flightDetailRequired: Scalars['Boolean']['output'];
  /** Fulfillment instructions for the lift ticket product */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Product logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Maximum age required for the product */
  maxAge: Scalars['Int']['output'];
  /** Maximum quantity the lift ticket product can be purchased at one time */
  maxQty: Scalars['Int']['output'];
  /** Minimum age required for the product */
  minAge: Scalars['Int']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Other policies for the lift ticket product */
  otherPolicies?: Maybe<Scalars['String']['output']>;
  passenger: Scalars['String']['output'];
  /** Product payable price */
  payable?: Maybe<Scalars['Float']['output']>;
  /** Product payable price pre tax */
  pretaxPayable?: Maybe<Scalars['Float']['output']>;
  /** Product price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Resort that the product belongs to */
  resort: Resort;
  /** Product short name */
  shortName: Scalars['String']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** Product tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
  ticket: Scalars['String']['output'];
  transportation: Scalars['String']['output'];
};


export type TransportationProductLogoArgs = {
  resize?: InputMaybe<ProductLogoSizeEnum>;
};

/** The connection type for TransportationProduct. */
export type TransportationProductConnection = {
  __typename?: 'TransportationProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransportationProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TransportationProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** The connection type for TransportationProduct. */
export type TransportationProductConnectionWithFilterStatus = {
  __typename?: 'TransportationProductConnectionWithFilterStatus';
  /** Products are only available if booked this number of daysin advance to start date */
  daysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransportationProductEdge>>>;
  /** Returns number of products that have been filtered outbecause of daysInAdvance */
  filteredByDaysInAdvance?: Maybe<Scalars['Int']['output']>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TransportationProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransportationProductEdge = {
  __typename?: 'TransportationProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TransportationProduct>;
};

/** Filters for filtering out transportation products */
export type TransportationProductFilterInput = {
  /** Ages of all the occupancies */
  age?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Type of transfer */
  transportationType?: InputMaybe<Array<TransportationProductTransportationTypeEnum>>;
  /** Type of ticket */
  ticketType?: InputMaybe<Array<TransportationProductTicketTypeEnum>>;
  /** Type of passenger */
  passengerType?: InputMaybe<Array<TransportationProductPassengerTypeEnum>>;
};

/** LineItem */
export type TransportationProductLineItem = {
  __typename?: 'TransportationProductLineItem';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  /** Alternative supplier pickup date */
  altSupplierPickupDate?: Maybe<Scalars['Date']['output']>;
  /** Alternative supplier pickup time */
  altSupplierPickupTime?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  /** Date of arrival */
  arriveAt: Scalars['Date']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Flight arrival detail of the traveller */
  flightArrival?: Maybe<Scalars['JSON']['output']>;
  /** Flight departure detail of the traveller */
  flightDeparture?: Maybe<Scalars['JSON']['output']>;
  /** Hash of flight_arrival and flight_departure for uniqueness */
  flightHash?: Maybe<Scalars['String']['output']>;
  /** Transportation fulfillment instructions */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  pretaxPayableAmount: Scalars['Float']['output'];
  product: TransportationProduct;
  productSupplier?: Maybe<ProductSupplier>;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  /** Supplier pickup date */
  supplierPickupDate?: Maybe<Scalars['Date']['output']>;
  /** Supplier pickup time */
  supplierPickupTime?: Maybe<Scalars['String']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type TransportationProductLineItemNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for TransportationProductLineItem. */
export type TransportationProductLineItemConnection = {
  __typename?: 'TransportationProductLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransportationProductLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TransportationProductLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransportationProductLineItemEdge = {
  __typename?: 'TransportationProductLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TransportationProductLineItem>;
};

export enum TransportationProductPassengerTypeEnum {
  Child = 'Child',
  Adult = 'Adult',
  Senior = 'Senior',
  Infant = 'Infant'
}

export enum TransportationProductTicketTypeEnum {
  SingleToAirport = 'SingleToAirport',
  SingleFromAirport = 'SingleFromAirport',
  Return = 'Return',
  SingleToTown = 'SingleToTown'
}

export enum TransportationProductTransportationTypeEnum {
  Charter = 'Charter',
  Shuttle = 'Shuttle'
}

export type TransportationSupplier = {
  __typename?: 'TransportationSupplier';
  /** Whether this is active */
  active: Scalars['Boolean']['output'];
  /** The fulfilment instructions for the domestic terminal */
  fulfilmentInstructionsDomestic?: Maybe<Scalars['String']['output']>;
  /** The fulfilment instructions for the international terminal */
  fulfilmentInstructionsInternational?: Maybe<Scalars['String']['output']>;
  /** Primary ID */
  id: Scalars['ID']['output'];
  /** The name of this transportation company */
  name: Scalars['String']['output'];
  /** Whether this is the primary supplier for this resort */
  primary: Scalars['Boolean']['output'];
};

/** TravelerDetail */
export type TravelerDetail = {
  __typename?: 'TravelerDetail';
  dob?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender */
  gender?: Maybe<GenderEnum>;
  height?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  pickupAt?: Maybe<Scalars['PickupAt']['output']>;
  shoeSize?: Maybe<Scalars['String']['output']>;
  skillLevel?: Maybe<SkillLevelEnum>;
  travelerIdx: Scalars['Int']['output'];
  weight?: Maybe<Scalars['String']['output']>;
  zendeskTicket?: Maybe<Scalars['String']['output']>;
};

/** Attributes for traveler detail */
export type TravelerDetailInput = {
  /** The index of traveler */
  travelerIdx: Scalars['Int']['input'];
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth */
  dob?: InputMaybe<Scalars['Date']['input']>;
  /** Gender */
  gender?: InputMaybe<GenderEnum>;
  /** Height */
  height?: InputMaybe<Scalars['String']['input']>;
  /** Weight */
  weight?: InputMaybe<Scalars['String']['input']>;
  /** Shoe size */
  shoeSize?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<SkillLevelEnum>;
  /** Pick up date/ time */
  pickupAt?: InputMaybe<Scalars['PickupAt']['input']>;
  /** Zendesk ticket */
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
};

export type TripAdvisorContent = {
  __typename?: 'TripAdvisorContent';
  /** Address */
  addressObj: Scalars['JSON']['output'];
  /** Property category */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Tripadvisor location_id */
  locationId: Scalars['Int']['output'];
  /** Location of property */
  locationString: Scalars['String']['output'];
  /** Longitude */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Property name */
  name: Scalars['String']['output'];
  /** Number of reviews */
  numReviews: Scalars['Int']['output'];
  /** Number of photos */
  photoCount: Scalars['Int']['output'];
  /** Price level in $$$ signs */
  priceLevel: Scalars['String']['output'];
  /** Ranking details */
  rankingData?: Maybe<TripAdvisorRankingData>;
  /** Aggregated Rating */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Rating image's URL */
  ratingImageUrl?: Maybe<Scalars['String']['output']>;
  /** Ratings broken down by score 1-5 */
  reviewRatingCount?: Maybe<Scalars['JSON']['output']>;
  /** Detailed review samples */
  reviews: Array<TripAdvisorReview>;
  /** Subratings by hotel attribute */
  subratings: Array<TripAdvisorSubrating>;
  /** Tags by reviewers */
  tripTypes: Array<TripAdvisorTripType>;
  /** URL to property on Tripadvisor */
  webUrl: Scalars['String']['output'];
  /** URL for leaving review on Tripadvisor */
  writeReviewUrl: Scalars['String']['output'];
};

export type TripAdvisorRankingData = {
  __typename?: 'TripAdvisorRankingData';
  /** Ranking location id */
  geolocationId: Scalars['String']['output'];
  /** Ranking location */
  geolocationName: Scalars['String']['output'];
  /** Rank */
  ranking: Scalars['Int']['output'];
  /** Total ranked properties in geolocation */
  rankingOutOf: Scalars['Int']['output'];
  /** Friendly string with ranking */
  rankingString?: Maybe<Scalars['String']['output']>;
};

export type TripAdvisorReview = {
  __typename?: 'TripAdvisorReview';
  /** Helpful votes count */
  helpfulVotes: Scalars['Int']['output'];
  /** ID */
  id: Scalars['String']['output'];
  /** Is review machine translated */
  isMachineTranslated: Scalars['Boolean']['output'];
  /** Language code */
  lang: Scalars['String']['output'];
  /** location_id */
  locationId: Scalars['String']['output'];
  /** Publication date */
  publishedDate: Scalars['String']['output'];
  /** Rating 1-5 */
  rating: Scalars['Int']['output'];
  /** Rating image's URL */
  ratingImageUrl: Scalars['String']['output'];
  /** Review text */
  text?: Maybe<Scalars['String']['output']>;
  /** Tripadvisor Review's title */
  title?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM */
  travelDate?: Maybe<Scalars['String']['output']>;
  /** URL to actual review on Tripadvisor */
  url: Scalars['String']['output'];
  /** Review user */
  user: TripAdvisorUser;
};

export type TripAdvisorSubrating = {
  __typename?: 'TripAdvisorSubrating';
  /** Localized friendly name */
  localizedName: Scalars['String']['output'];
  /** Base name */
  name: Scalars['String']['output'];
  /** Url of rating score image */
  ratingImageUrl: Scalars['String']['output'];
  /** Rating value */
  value: Scalars['Float']['output'];
};

export type TripAdvisorTripType = {
  __typename?: 'TripAdvisorTripType';
  /** TripType's localized name */
  localizedName: Scalars['String']['output'];
  /** TripType's name */
  name: Scalars['String']['output'];
  /** Number of times this TripType was tagged to property by reviewer */
  value: Scalars['Int']['output'];
};

export type TripAdvisorUser = {
  __typename?: 'TripAdvisorUser';
  /** User's location */
  userLocationName?: Maybe<Scalars['String']['output']>;
  /** User's name */
  username: Scalars['String']['output'];
};

export enum TypesItineraryEnumsProductTypeEnum {
  LiftTicket = 'LIFT_TICKET',
  Rental = 'RENTAL',
  Transportation = 'TRANSPORTATION'
}

/** Attributes for accepting a bundle product to the itinerary */
export type TypesItineraryInputsBundleProduct = {
  /** Traveller data */
  travellers: Array<BundleTraveller>;
};

export type TypesItineraryItineraryLockType = {
  __typename?: 'TypesItineraryItineraryLockType';
  itinerary: Itinerary;
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<User>;
};

export type TypesItineraryMutationType = {
  __typename?: 'TypesItineraryMutationType';
  addAndFinalizeBundleProduct?: Maybe<AddAndFinalizeBundleProductPayload>;
  addLesson?: Maybe<AddLessonPayload>;
  addLiftTicket?: Maybe<AddLiftTicketPayload>;
  addProperty?: Maybe<AddPropertyPayload>;
  addRental?: Maybe<AddRentalPayload>;
  addScheduledPayment?: Maybe<AddScheduledPaymentPayload>;
  addTransportation?: Maybe<AddTransportationPayload>;
  addUpsell?: Maybe<AddUpsellPayload>;
  applyCoupon?: Maybe<Itinerary>;
  assignAgent?: Maybe<AssignAgentPayload>;
  assignLineItemAgent?: Maybe<AssignLineItemAgentPayload>;
  cancelProperty?: Maybe<CancelPropertyPayload>;
  clearRefundableAmount?: Maybe<ClearRefundableAmountPayload>;
  /**
   * Attach a direct S3 upload to itinerary fulfilment attachments
   * (by attaching a blob via signed ID)
   *
   */
  createAttachment?: Maybe<CreateAttachmentPayload>;
  duplicateItinerary?: Maybe<DuplicateItineraryPayload>;
  emailItinerary?: Maybe<EmailItineraryPayload>;
  finalize?: Maybe<Itinerary>;
  finalizeDuplicate?: Maybe<FinalizeDuplicatePayload>;
  finalizeDuplicateWithoutPayment?: Maybe<FinalizeDuplicateWithoutPaymentPayload>;
  finalizeWithoutPayment?: Maybe<FinalizeWithoutPaymentPayload>;
  lock?: Maybe<TypesItineraryMutationsLockPayload>;
  processNotification?: Maybe<ProcessNotificationPayload>;
  /** @deprecated Use Mutations::Payment::ProcessCharge instead */
  processPayment?: Maybe<ProcessPaymentPayload>;
  /** Removes attachments from itinerary */
  removeAttachment?: Maybe<RemoveAttachmentPayload>;
  removeCoupon?: Maybe<Itinerary>;
  removeDuplicate?: Maybe<RemoveDuplicatePayload>;
  removeProduct?: Maybe<Itinerary>;
  sendEmail?: Maybe<SendEmailPayload>;
  unlock?: Maybe<TypesItineraryMutationsUnlockPayload>;
  unsubscribeReviewEmail?: Maybe<UnsubscribeReviewEmailPayload>;
  unsubscribeSavedItineraryEmail?: Maybe<UnsubscribeSavedItineraryEmailPayload>;
  update?: Maybe<Itinerary>;
  updateData?: Maybe<UpdateItineraryDataPayload>;
  updateFulfilmentState?: Maybe<UpdateItineraryFulfilmentStatePayload>;
  updateLesson?: Maybe<UpdateProductPayload>;
  updateLessonProduct?: Maybe<UpdateLessonProductPayload>;
  updateLiftTicket?: Maybe<UpdateProductPayload>;
  updateLiftTicketProduct?: Maybe<UpdateLiftTicketProductPayload>;
  /** @deprecated Use updateLineItemPortalId for different types of products */
  updateLiftTicketVoucher?: Maybe<UpdateLineItemPortalIdPayload>;
  updateLineItem?: Maybe<UpdateLineItemPayload>;
  updateLineItemFulfilmentState?: Maybe<UpdateLineItemFulfilmentStatePayload>;
  updateLineItemPortalId?: Maybe<UpdateLineItemPortalIdPayload>;
  updateLineItemSupplier?: Maybe<UpdateLineItemSupplierPayload>;
  updateProperty?: Maybe<UpdatePropertyPayload>;
  updatePropertyLineItem?: Maybe<UpdatePropertyLineItemPayload>;
  updateRental?: Maybe<UpdateProductPayload>;
  updateRentalProduct?: Maybe<UpdateRentalProductPayload>;
  updateScheduledPayment?: Maybe<UpdateScheduledPaymentPayload>;
  updateStates?: Maybe<UpdateItineraryStatesPayload>;
  updateTableNotes?: Maybe<UpdateTableNotesPayload>;
  updateTransportDetails?: Maybe<UpdateTransportDetailsPayload>;
  updateTransportation?: Maybe<UpdateProductPayload>;
  updateTransportationProduct?: Maybe<UpdateTransportationProductPayload>;
  updateTravelerDetails?: Maybe<Itinerary>;
  updateUpsell?: Maybe<UpdateProductPayload>;
  validateItinerary?: Maybe<ValidateItineraryPayload>;
};


export type TypesItineraryMutationTypeAddAndFinalizeBundleProductArgs = {
  input: AddAndFinalizeBundleProductInput;
};


export type TypesItineraryMutationTypeAddLessonArgs = {
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  newPackage?: InputMaybe<Scalars['Boolean']['input']>;
  participants?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type TypesItineraryMutationTypeAddLiftTicketArgs = {
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  newPackage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryMutationTypeAddPropertyArgs = {
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  newPackage?: InputMaybe<Scalars['Boolean']['input']>;
  endAt: Scalars['Date']['input'];
  occupancy: Array<Scalars['ExpediaPropertyRoomOccupancy']['input']>;
  refundable: Scalars['Boolean']['input'];
  cancelPenalties?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  saleScenario?: InputMaybe<Scalars['JSON']['input']>;
  merchantOfRecord?: InputMaybe<Scalars['String']['input']>;
  depositPolicies?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  rates: Scalars['JSON']['input'];
  testVersion?: InputMaybe<Scalars['String']['input']>;
  fromRegion?: InputMaybe<Scalars['Boolean']['input']>;
  skicomAppId?: InputMaybe<Scalars['String']['input']>;
  skicomLeadSourceId?: InputMaybe<Scalars['Int']['input']>;
  skicomPid?: InputMaybe<Scalars['String']['input']>;
  skicomGclid?: InputMaybe<Scalars['String']['input']>;
  skicomQuoteId?: InputMaybe<Scalars['Int']['input']>;
  resort: Scalars['JSON']['input'];
  resortId?: InputMaybe<Scalars['ID']['input']>;
  priceCheckingToken: Scalars['String']['input'];
  paymentOptionsToken: Scalars['String']['input'];
  rateId: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
  utmParams?: InputMaybe<Scalars['String']['input']>;
  itineraryContextData?: InputMaybe<Scalars['String']['input']>;
};


export type TypesItineraryMutationTypeAddRentalArgs = {
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  newPackage?: InputMaybe<Scalars['Boolean']['input']>;
  helmetIncluded?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryMutationTypeAddScheduledPaymentArgs = {
  input: AddScheduledPaymentInput;
};


export type TypesItineraryMutationTypeAddTransportationArgs = {
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  newPackage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryMutationTypeAddUpsellArgs = {
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  newPackage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryMutationTypeApplyCouponArgs = {
  code: Scalars['String']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryMutationTypeAssignAgentArgs = {
  input: AssignAgentInput;
};


export type TypesItineraryMutationTypeAssignLineItemAgentArgs = {
  input: AssignLineItemAgentInput;
};


export type TypesItineraryMutationTypeCancelPropertyArgs = {
  input: CancelPropertyInput;
};


export type TypesItineraryMutationTypeClearRefundableAmountArgs = {
  input: ClearRefundableAmountInput;
};


export type TypesItineraryMutationTypeCreateAttachmentArgs = {
  input: CreateAttachmentInput;
};


export type TypesItineraryMutationTypeDuplicateItineraryArgs = {
  input: DuplicateItineraryInput;
};


export type TypesItineraryMutationTypeEmailItineraryArgs = {
  input: EmailItineraryInput;
};


export type TypesItineraryMutationTypeFinalizeArgs = {
  creditCard?: InputMaybe<CreditCard>;
  splitVersion?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryMutationTypeFinalizeDuplicateArgs = {
  input: FinalizeDuplicateInput;
};


export type TypesItineraryMutationTypeFinalizeDuplicateWithoutPaymentArgs = {
  input: FinalizeDuplicateWithoutPaymentInput;
};


export type TypesItineraryMutationTypeFinalizeWithoutPaymentArgs = {
  input: FinalizeWithoutPaymentInput;
};


export type TypesItineraryMutationTypeLockArgs = {
  input: TypesItineraryMutationsLockInput;
};


export type TypesItineraryMutationTypeProcessNotificationArgs = {
  input: ProcessNotificationInput;
};


export type TypesItineraryMutationTypeProcessPaymentArgs = {
  input: ProcessPaymentInput;
};


export type TypesItineraryMutationTypeRemoveAttachmentArgs = {
  input: RemoveAttachmentInput;
};


export type TypesItineraryMutationTypeRemoveCouponArgs = {
  input: RemoveCouponInput;
};


export type TypesItineraryMutationTypeRemoveProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type TypesItineraryMutationTypeSendEmailArgs = {
  input: SendEmailInput;
};


export type TypesItineraryMutationTypeUnlockArgs = {
  input: TypesItineraryMutationsUnlockInput;
};


export type TypesItineraryMutationTypeUnsubscribeReviewEmailArgs = {
  input: UnsubscribeReviewEmailInput;
};


export type TypesItineraryMutationTypeUnsubscribeSavedItineraryEmailArgs = {
  input: UnsubscribeSavedItineraryEmailInput;
};


export type TypesItineraryMutationTypeUpdateArgs = {
  input?: InputMaybe<ItineraryInput>;
};


export type TypesItineraryMutationTypeUpdateDataArgs = {
  input: UpdateItineraryDataInput;
};


export type TypesItineraryMutationTypeUpdateFulfilmentStateArgs = {
  input: UpdateItineraryFulfilmentStateInput;
};


export type TypesItineraryMutationTypeUpdateLessonArgs = {
  id: Scalars['ID']['input'];
  data: LessonLineItem;
};


export type TypesItineraryMutationTypeUpdateLessonProductArgs = {
  input: UpdateLessonProductInput;
};


export type TypesItineraryMutationTypeUpdateLiftTicketArgs = {
  id: Scalars['ID']['input'];
  data: LiftTicketLineItem;
};


export type TypesItineraryMutationTypeUpdateLiftTicketProductArgs = {
  input: UpdateLiftTicketProductInput;
};


export type TypesItineraryMutationTypeUpdateLiftTicketVoucherArgs = {
  input: UpdateLineItemPortalIdInput;
};


export type TypesItineraryMutationTypeUpdateLineItemArgs = {
  input: UpdateLineItemInput;
};


export type TypesItineraryMutationTypeUpdateLineItemFulfilmentStateArgs = {
  input: UpdateLineItemFulfilmentStateInput;
};


export type TypesItineraryMutationTypeUpdateLineItemPortalIdArgs = {
  input: UpdateLineItemPortalIdInput;
};


export type TypesItineraryMutationTypeUpdateLineItemSupplierArgs = {
  input: UpdateLineItemSupplierInput;
};


export type TypesItineraryMutationTypeUpdatePropertyArgs = {
  id: Scalars['ID']['input'];
  data: PropertyLineItem;
};


export type TypesItineraryMutationTypeUpdatePropertyLineItemArgs = {
  input: UpdatePropertyLineItemInput;
};


export type TypesItineraryMutationTypeUpdateRentalArgs = {
  id: Scalars['ID']['input'];
  data: RentalLineItem;
};


export type TypesItineraryMutationTypeUpdateRentalProductArgs = {
  input: UpdateRentalProductInput;
};


export type TypesItineraryMutationTypeUpdateScheduledPaymentArgs = {
  input: UpdateScheduledPaymentInput;
};


export type TypesItineraryMutationTypeUpdateStatesArgs = {
  input: UpdateItineraryStatesInput;
};


export type TypesItineraryMutationTypeUpdateTableNotesArgs = {
  input: UpdateTableNotesInput;
};


export type TypesItineraryMutationTypeUpdateTransportDetailsArgs = {
  input: UpdateTransportDetailsInput;
};


export type TypesItineraryMutationTypeUpdateTransportationArgs = {
  id: Scalars['ID']['input'];
  data: TransportationLineItem;
};


export type TypesItineraryMutationTypeUpdateTransportationProductArgs = {
  input: UpdateTransportationProductInput;
};


export type TypesItineraryMutationTypeUpdateTravelerDetailsArgs = {
  travelerDetails?: InputMaybe<Array<InputMaybe<TravelerDetailInput>>>;
};


export type TypesItineraryMutationTypeUpdateUpsellArgs = {
  id: Scalars['ID']['input'];
  data: UpsellLineItem;
};


export type TypesItineraryMutationTypeValidateItineraryArgs = {
  input: ValidateItineraryInput;
};

/** Autogenerated input type of TypesItineraryMutationsLock */
export type TypesItineraryMutationsLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TypesItineraryMutationsLock */
export type TypesItineraryMutationsLockPayload = {
  __typename?: 'TypesItineraryMutationsLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of TypesItineraryMutationsUnlock */
export type TypesItineraryMutationsUnlockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of TypesItineraryMutationsUnlock */
export type TypesItineraryMutationsUnlockPayload = {
  __typename?: 'TypesItineraryMutationsUnlockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

export type TypesItineraryQueryType = {
  __typename?: 'TypesItineraryQueryType';
  /** @deprecated Use itineraries for new admin */
  allItineraries: ItineraryConnection;
  allNotifications: NotificationConnection;
  itineraries?: Maybe<ItinerarySearchkickConnection>;
  /** Itinerary */
  itinerary?: Maybe<Itinerary>;
};


export type TypesItineraryQueryTypeAllItinerariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Array<ItineraryStateEnum>>;
};


export type TypesItineraryQueryTypeAllNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  processed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TypesItineraryQueryTypeItinerariesArgs = {
  filter?: InputMaybe<ItineraryResolverItineraryInput>;
  orderByNew?: InputMaybe<Array<SearchkickOrderByInput>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesItineraryQueryTypeItineraryArgs = {
  id: Scalars['ID']['input'];
};

export type TypesLockType = {
  __typename?: 'TypesLockType';
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  lockedBy?: Maybe<User>;
};

export type TypesProductQueryType = {
  __typename?: 'TypesProductQueryType';
  allLessons: LessonProductConnection;
  /** @deprecated use liftTickets field instead */
  allLiftTickets: LiftTicketProductConnection;
  allProperties: PropertyAvailabilityConnection;
  /** @deprecated use rentals field instead */
  allRentals: RentalProductConnection;
  /** @deprecated use transportations field instead */
  allTransportations: TransportationProductConnection;
  allUpsells: UpsellProductConnection;
  bundle?: Maybe<Bundle>;
  lesson?: Maybe<LessonProduct>;
  /** Query for LessonProducts */
  lessons: LessonProductConnectionWithFilterStatus;
  liftTicket?: Maybe<LiftTicketProduct>;
  liftTicketData: Scalars['JSON']['output'];
  /** Query for LiftTicketProducts */
  liftTickets: LiftTicketProductConnectionWithFilterStatus;
  /**
   * An indivdual property object in the map of property objects.
   * @deprecated use propertyNew field instead
   */
  property?: Maybe<PropertyProduct>;
  /** Property information */
  propertyNew?: Maybe<PropertyProduct>;
  rental?: Maybe<RentalProduct>;
  /** Query for RentalProducts */
  rentals: RentalProductConnectionWithFilterStatus;
  transportation?: Maybe<TransportationProduct>;
  /** Query for TransportationProducts */
  transportations: TransportationProductConnectionWithFilterStatus;
  upsell?: Maybe<UpsellProduct>;
};


export type TypesProductQueryTypeAllLessonsArgs = {
  resortSlug?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  filterBy?: InputMaybe<LessonProductFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesProductQueryTypeAllLiftTicketsArgs = {
  resortSlug?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  filterBy?: InputMaybe<LiftTicketProductFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesProductQueryTypeAllPropertiesArgs = {
  resortSlug: Scalars['String']['input'];
  filterBy?: InputMaybe<PropertyProductFilterInput>;
  orderBy?: InputMaybe<Array<InputMaybe<PropertyProductOrderByInput>>>;
  fullSearch?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesProductQueryTypeAllRentalsArgs = {
  resortSlug?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  filterBy?: InputMaybe<RentalProductFilterInput>;
  rentalLocationId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesProductQueryTypeAllTransportationsArgs = {
  resortSlug?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  filterBy?: InputMaybe<TransportationProductFilterInput>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesProductQueryTypeAllUpsellsArgs = {
  resortSlug?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  orderBy?: InputMaybe<Array<OrderByInput>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type TypesProductQueryTypeBundleArgs = {
  slug: Scalars['String']['input'];
};


export type TypesProductQueryTypeLessonArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};


export type TypesProductQueryTypeLessonsArgs = {
  resortSlug: Scalars['String']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
};


export type TypesProductQueryTypeLiftTicketArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};


export type TypesProductQueryTypeLiftTicketsArgs = {
  resortSlug: Scalars['String']['input'];
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  startAt: Scalars['Date']['input'];
  ticketTypes?: InputMaybe<Array<LiftTicketProductTicketTypeEnum>>;
};


export type TypesProductQueryTypePropertyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  availability?: InputMaybe<PropertyProductAvailabilityFilterInput>;
};


export type TypesProductQueryTypePropertyNewArgs = {
  id: Scalars['ID']['input'];
  regionSlug?: InputMaybe<Scalars['String']['input']>;
};


export type TypesProductQueryTypeRentalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};


export type TypesProductQueryTypeRentalsArgs = {
  resortSlug: Scalars['String']['input'];
  ageTypes?: InputMaybe<Array<RentalProductAgeTypeEnum>>;
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  days?: InputMaybe<Scalars['Int']['input']>;
  gearLevels?: InputMaybe<Array<RentalProductGearLevelEnum>>;
  gearTypes?: InputMaybe<Array<RentalProductGearTypeEnum>>;
  rentalTypes?: InputMaybe<Array<RentalProductRentalTypeEnum>>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};


export type TypesProductQueryTypeTransportationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
};


export type TypesProductQueryTypeTransportationsArgs = {
  resortSlug: Scalars['String']['input'];
  ages?: InputMaybe<Array<Scalars['Int']['input']>>;
  passengerTypes?: InputMaybe<Array<TransportationProductPassengerTypeEnum>>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  ticketTypes?: InputMaybe<Array<TransportationProductTicketTypeEnum>>;
  transportationTypes?: InputMaybe<Array<TransportationProductTransportationTypeEnum>>;
};


export type TypesProductQueryTypeUpsellArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['Date']['input']>;
  productType: UpsellProductTypeEnum;
};

export type TypesProductSupplierAuditedType = {
  __typename?: 'TypesProductSupplierAuditedType';
  action: Scalars['String']['output'];
  associatedAuditable?: Maybe<AuditedUnion>;
  auditable: AuditedUnion;
  auditableType: Scalars['String']['output'];
  changes?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  typedChanges: Array<AuditedChange>;
  user?: Maybe<User>;
  /** Audit change version */
  version: Scalars['Int']['output'];
};

/** The connection type for TypesProductSupplierAuditedType. */
export type TypesProductSupplierAuditedTypeConnection = {
  __typename?: 'TypesProductSupplierAuditedTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TypesProductSupplierAuditedTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TypesProductSupplierAuditedType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TypesProductSupplierAuditedTypeEdge = {
  __typename?: 'TypesProductSupplierAuditedTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TypesProductSupplierAuditedType>;
};

export type TypesTransferFulfilmentInstructionAuditedType = {
  __typename?: 'TypesTransferFulfilmentInstructionAuditedType';
  action: Scalars['String']['output'];
  associatedAuditable?: Maybe<AuditedUnion>;
  auditable: AuditedUnion;
  auditableType: Scalars['String']['output'];
  changes?: Maybe<Scalars['JSON']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  typedChanges: Array<AuditedChange>;
  user?: Maybe<User>;
  /** Audit change version */
  version: Scalars['Int']['output'];
};

/** The connection type for TypesTransferFulfilmentInstructionAuditedType. */
export type TypesTransferFulfilmentInstructionAuditedTypeConnection = {
  __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TypesTransferFulfilmentInstructionAuditedTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TypesTransferFulfilmentInstructionAuditedType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TypesTransferFulfilmentInstructionAuditedTypeEdge = {
  __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TypesTransferFulfilmentInstructionAuditedType>;
};

/** PaperTrail version */
export type TypesVersion = {
  __typename?: 'TypesVersion';
  changes: Array<TypesVersionChange>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
  whodunnit?: Maybe<Scalars['String']['output']>;
};

/** PaperTrail version change object */
export type TypesVersionChange = {
  __typename?: 'TypesVersionChange';
  attribute: Scalars['String']['output'];
  from?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** The connection type for TypesVersion. */
export type TypesVersionConnection = {
  __typename?: 'TypesVersionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TypesVersionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<TypesVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TypesVersionEdge = {
  __typename?: 'TypesVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<TypesVersion>;
};

export type TypesViewerMutationType = {
  __typename?: 'TypesViewerMutationType';
  createNote?: Maybe<CreateNotePayload>;
  itinerary: TypesItineraryMutationType;
  trackItineraryView?: Maybe<TrackItineraryViewPayload>;
  user: UserMutations;
};


export type TypesViewerMutationTypeCreateNoteArgs = {
  input: CreateNoteInput;
};


export type TypesViewerMutationTypeItineraryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type TypesViewerMutationTypeTrackItineraryViewArgs = {
  input: TrackItineraryViewInput;
};

export type TypesViewerQueryType = {
  __typename?: 'TypesViewerQueryType';
  itinerary: Itinerary;
  user?: Maybe<User>;
};


export type TypesViewerQueryTypeItineraryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of UnsubscribeReviewEmail */
export type UnsubscribeReviewEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnsubscribeReviewEmail */
export type UnsubscribeReviewEmailPayload = {
  __typename?: 'UnsubscribeReviewEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UnsubscribeSavedItineraryEmail */
export type UnsubscribeSavedItineraryEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnsubscribeSavedItineraryEmail */
export type UnsubscribeSavedItineraryEmailPayload = {
  __typename?: 'UnsubscribeSavedItineraryEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateItineraryData */
export type UpdateItineraryDataInput = {
  data: Scalars['JSON']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateItineraryData */
export type UpdateItineraryDataPayload = {
  __typename?: 'UpdateItineraryDataPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateItineraryFulfilmentState */
export type UpdateItineraryFulfilmentStateInput = {
  event: ItineraryFulfilmentEventEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateItineraryFulfilmentState */
export type UpdateItineraryFulfilmentStatePayload = {
  __typename?: 'UpdateItineraryFulfilmentStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateItineraryStates */
export type UpdateItineraryStatesInput = {
  productsConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  supplierPaid?: InputMaybe<Scalars['Boolean']['input']>;
  remainingBalancePaid?: InputMaybe<Scalars['Boolean']['input']>;
  followupEmail2Sent?: InputMaybe<Scalars['Boolean']['input']>;
  followupEmail3Sent?: InputMaybe<Scalars['Boolean']['input']>;
  followupEmail4Sent?: InputMaybe<Scalars['Boolean']['input']>;
  manualFollowupEmail4Required?: InputMaybe<Scalars['Boolean']['input']>;
  isProblematic?: InputMaybe<Scalars['Boolean']['input']>;
  productsOrdered?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceReceived?: InputMaybe<Scalars['Boolean']['input']>;
  isAudited?: InputMaybe<Scalars['Boolean']['input']>;
  isModified?: InputMaybe<Scalars['Boolean']['input']>;
  fulfilmentState?: InputMaybe<ItineraryFulfilmentStateEnum>;
  supplierNotes?: InputMaybe<Scalars['String']['input']>;
  isRetailRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isConfirmationNumberReceived?: InputMaybe<Scalars['Boolean']['input']>;
  isInformationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFlightsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  preArrivalCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingCallSuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  postBookingCallUnsuccessful?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateItineraryStates */
export type UpdateItineraryStatesPayload = {
  __typename?: 'UpdateItineraryStatesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateLessonProduct */
export type UpdateLessonProductInput = {
  /** ID of the itinerary line item */
  lineItemId: Scalars['ID']['input'];
  /** SKU of a new product */
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  /** Array of traveler indexes participating in a private lesson */
  participants?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLessonProduct */
export type UpdateLessonProductPayload = {
  __typename?: 'UpdateLessonProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdateLiftTicketProduct */
export type UpdateLiftTicketProductInput = {
  /** ID of the itinerary line item */
  lineItemId: Scalars['ID']['input'];
  /** SKU of a new product */
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLiftTicketProduct */
export type UpdateLiftTicketProductPayload = {
  __typename?: 'UpdateLiftTicketProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdateLineItemFulfilmentState */
export type UpdateLineItemFulfilmentStateInput = {
  lineItemId: Scalars['ID']['input'];
  event: LineItemFulfilmentEventEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLineItemFulfilmentState */
export type UpdateLineItemFulfilmentStatePayload = {
  __typename?: 'UpdateLineItemFulfilmentStatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdateLineItem */
export type UpdateLineItemInput = {
  lineItemId: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  costAmount?: InputMaybe<Scalars['Float']['input']>;
  feesAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Treated as the alternative or outbound suppplier order id */
  altSupplierOrderId?: InputMaybe<Scalars['String']['input']>;
  supplierConfirmationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Treated as the alternative or outbound supplier confirmation number */
  altSupplierConfirmationNumber?: InputMaybe<Scalars['String']['input']>;
  supplierDepositAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierDepositDueAt?: InputMaybe<Scalars['Date']['input']>;
  supplierDepositPaid?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRemainingBalanceAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierRemainingBalanceDueAt?: InputMaybe<Scalars['Date']['input']>;
  supplierRemainingBalancePaid?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRefundIssued?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRefundAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierCreditIssued?: InputMaybe<Scalars['Boolean']['input']>;
  supplierCreditAmount?: InputMaybe<Scalars['Float']['input']>;
  lessonWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  crosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  lessonAdditionalInformation?: InputMaybe<LessonAdditionalInformationInput>;
  supplierPickupDate?: InputMaybe<Scalars['Date']['input']>;
  supplierPickupTime?: InputMaybe<Scalars['String']['input']>;
  altSupplierPickupDate?: InputMaybe<Scalars['Date']['input']>;
  altSupplierPickupTime?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLineItem */
export type UpdateLineItemPayload = {
  __typename?: 'UpdateLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdateLineItemPortalId */
export type UpdateLineItemPortalIdInput = {
  voucher: Scalars['String']['input'];
  productType?: InputMaybe<TypesItineraryEnumsProductTypeEnum>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLineItemPortalId */
export type UpdateLineItemPortalIdPayload = {
  __typename?: 'UpdateLineItemPortalIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateLineItemSupplier */
export type UpdateLineItemSupplierInput = {
  lineItemId: Scalars['ID']['input'];
  productSupplierId: Scalars['ID']['input'];
  isAlternative?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLineItemSupplier */
export type UpdateLineItemSupplierPayload = {
  __typename?: 'UpdateLineItemSupplierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated return type of UpdateProduct */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdatePropertyLineItem */
export type UpdatePropertyLineItemInput = {
  lineItemId: Scalars['ID']['input'];
  startAt?: InputMaybe<Scalars['Date']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  taxAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  costAmount?: InputMaybe<Scalars['Float']['input']>;
  feesAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierOrderId?: InputMaybe<Scalars['String']['input']>;
  /** Treated as the alternative or outbound suppplier order id */
  altSupplierOrderId?: InputMaybe<Scalars['String']['input']>;
  supplierConfirmationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Treated as the alternative or outbound supplier confirmation number */
  altSupplierConfirmationNumber?: InputMaybe<Scalars['String']['input']>;
  supplierDepositAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierDepositDueAt?: InputMaybe<Scalars['Date']['input']>;
  supplierDepositPaid?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRemainingBalanceAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierRemainingBalanceDueAt?: InputMaybe<Scalars['Date']['input']>;
  supplierRemainingBalancePaid?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRefundIssued?: InputMaybe<Scalars['Boolean']['input']>;
  supplierRefundAmount?: InputMaybe<Scalars['Float']['input']>;
  supplierCreditIssued?: InputMaybe<Scalars['Boolean']['input']>;
  supplierCreditAmount?: InputMaybe<Scalars['Float']['input']>;
  lessonWaiver?: InputMaybe<Scalars['Boolean']['input']>;
  crosscheck?: InputMaybe<Scalars['Boolean']['input']>;
  zendeskTicket?: InputMaybe<Scalars['String']['input']>;
  lessonAdditionalInformation?: InputMaybe<LessonAdditionalInformationInput>;
  supplierPickupDate?: InputMaybe<Scalars['Date']['input']>;
  supplierPickupTime?: InputMaybe<Scalars['String']['input']>;
  altSupplierPickupDate?: InputMaybe<Scalars['Date']['input']>;
  altSupplierPickupTime?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['Date']['input']>;
  occupancy?: InputMaybe<Array<Scalars['ExpediaPropertyRoomOccupancy']['input']>>;
  roomId?: InputMaybe<Scalars['ID']['input']>;
  bedGroup?: InputMaybe<BedTypeInput>;
  cancellationPolicies?: InputMaybe<Array<CancellationPolicyInput>>;
  billingContactAddress?: InputMaybe<Address>;
  specialRequest?: InputMaybe<Scalars['String']['input']>;
  specialRequestFulfilled?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePropertyLineItem */
export type UpdatePropertyLineItemPayload = {
  __typename?: 'UpdatePropertyLineItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated return type of UpdateProperty */
export type UpdatePropertyPayload = {
  __typename?: 'UpdatePropertyPayload';
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdateRentalProduct */
export type UpdateRentalProductInput = {
  /** ID of the itinerary line item */
  lineItemId: Scalars['ID']['input'];
  /** SKU of a new product */
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  helmetIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateRentalProduct */
export type UpdateRentalProductPayload = {
  __typename?: 'UpdateRentalProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Autogenerated input type of UpdateScheduledPayment */
export type UpdateScheduledPaymentInput = {
  scheduledPaymentId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  cardFees?: InputMaybe<Scalars['Float']['input']>;
  processAt?: InputMaybe<Scalars['Date']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateScheduledPayment */
export type UpdateScheduledPaymentPayload = {
  __typename?: 'UpdateScheduledPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  scheduledPayment: ScheduledPayment;
};

/** Autogenerated input type of UpdateTableNotes */
export type UpdateTableNotesInput = {
  tableNotes: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTableNotes */
export type UpdateTableNotesPayload = {
  __typename?: 'UpdateTableNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateTransportDetails */
export type UpdateTransportDetailsInput = {
  inbound?: InputMaybe<TransportDetailInput>;
  outbound?: InputMaybe<TransportDetailInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTransportDetails */
export type UpdateTransportDetailsPayload = {
  __typename?: 'UpdateTransportDetailsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
};

/** Autogenerated input type of UpdateTransportationProduct */
export type UpdateTransportationProductInput = {
  /** ID of the itinerary line item */
  lineItemId: Scalars['ID']['input'];
  /** SKU of a new product */
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTransportationProduct */
export type UpdateTransportationProductPayload = {
  __typename?: 'UpdateTransportationProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  itinerary: Itinerary;
  lineItem: LineItem;
};

/** Attributes for accepting an upsell product to the itinerary */
export type UpsellLineItem = {
  /** First name of the traveller */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the traveller */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Date of birth */
  dob?: InputMaybe<Scalars['String']['input']>;
  /** ID of the product */
  productableId?: InputMaybe<Scalars['ID']['input']>;
  /** Amount of the insurance */
  amount?: InputMaybe<Scalars['Float']['input']>;
  originalPayableAmount?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Traveler # for grouping line items */
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  /** Gender of the traveller */
  gender?: InputMaybe<Scalars['String']['input']>;
};

export type UpsellProduct = Product & {
  __typename?: 'UpsellProduct';
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  /** Lift ticket product cancellation policies */
  cancellationPolicies?: Maybe<Scalars['String']['output']>;
  /** The currency for the product price */
  currency?: Maybe<Scalars['String']['output']>;
  /** Number of days the product has to be purchased in advance */
  daysInAdvance: Scalars['Int']['output'];
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Product price discount */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Fulfillment instructions for the lift ticket product */
  fulfillmentInstructions?: Maybe<Scalars['String']['output']>;
  /** Product Id */
  id: Scalars['ID']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Indicates whether the product is a percentage based pricing */
  isPercentage: Scalars['Boolean']['output'];
  /** Product logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Maximum age required for the product */
  maxAge: Scalars['Int']['output'];
  /** Maximum quantity the lift ticket product can be purchased at one time */
  maxQty: Scalars['Int']['output'];
  /** Minimum age required for the product */
  minAge: Scalars['Int']['output'];
  /** Product name */
  name: Scalars['String']['output'];
  /** Number of days before product full amount collection */
  numOfDaysBeforePayingFullAmount: Scalars['Int']['output'];
  /** Other policies for the lift ticket product */
  otherPolicies?: Maybe<Scalars['String']['output']>;
  /** Product payable price */
  payable?: Maybe<Scalars['Float']['output']>;
  /** Percentage */
  percentage: Scalars['Float']['output'];
  /** Product payable price pre tax */
  pretaxPayable?: Maybe<Scalars['Float']['output']>;
  /** Product price */
  price?: Maybe<Scalars['Float']['output']>;
  /** Product type */
  productType: UpsellProductTypeEnum;
  /** Resort that the product belongs to */
  resort: Resort;
  /** Product short name */
  shortName: Scalars['String']['output'];
  /** Product SKU */
  sku: Scalars['String']['output'];
  /** Product tax amount */
  taxAmount?: Maybe<Scalars['Float']['output']>;
};


export type UpsellProductLogoArgs = {
  resize?: InputMaybe<ProductLogoSizeEnum>;
};


export type UpsellProductPriceArgs = {
  basePrice?: InputMaybe<Scalars['Float']['input']>;
};

/** The connection type for UpsellProduct. */
export type UpsellProductConnection = {
  __typename?: 'UpsellProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UpsellProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UpsellProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UpsellProductEdge = {
  __typename?: 'UpsellProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UpsellProduct>;
};

/** LineItem */
export type UpsellProductLineItem = {
  __typename?: 'UpsellProductLineItem';
  ageAtArrival?: Maybe<Scalars['Int']['output']>;
  altProductSupplier?: Maybe<ProductSupplier>;
  altSupplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  altSupplierOrderId?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  /** Total amount inc tax before discounts */
  amountIncTax: Scalars['Float']['output'];
  assignedAgent?: Maybe<User>;
  /** Product cancellation penalties */
  cancelPenalties?: Maybe<Array<Scalars['JSON']['output']>>;
  costAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of the cost amount */
  costAmountCurrency?: Maybe<Scalars['String']['output']>;
  crosscheck?: Maybe<Scalars['Boolean']['output']>;
  /** The currency for the line item */
  currency: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  depositPercentage: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  displayableTaxAmount: Scalars['Float']['output'];
  dob?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fulfilmentAgent?: Maybe<User>;
  fulfilmentState: LineItemFulfilmentStateEnum;
  /** Gender of the traveller */
  gender?: Maybe<Scalars['String']['output']>;
  hasOverrideData: Scalars['Boolean']['output'];
  hasPriceChanges?: Maybe<Scalars['Boolean']['output']>;
  /** Helmet included part of the rental equipment */
  helmetIncluded?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPending: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  manualFulfilment: Scalars['Boolean']['output'];
  markedAsCancelled?: Maybe<Scalars['Boolean']['output']>;
  /** Normalized version of firstName */
  normalizedFirstName?: Maybe<Scalars['String']['output']>;
  /** Normalized version of lastName */
  normalizedLastName?: Maybe<Scalars['String']['output']>;
  /** Line item notes */
  notes?: Maybe<NoteConnection>;
  overrideData?: Maybe<Scalars['JSON']['output']>;
  payableAmount: Scalars['Float']['output'];
  pretaxPayableAmount: Scalars['Float']['output'];
  product: UpsellProduct;
  productSupplier?: Maybe<ProductSupplier>;
  productType: UpsellProductTypeEnum;
  state: LineItemStateEnum;
  supplierConfirmationNumber?: Maybe<Scalars['ID']['output']>;
  supplierCreditAmount?: Maybe<Scalars['Float']['output']>;
  supplierCreditIssued: Scalars['Boolean']['output'];
  supplierDepositAmount?: Maybe<Scalars['Float']['output']>;
  supplierDepositDueAt?: Maybe<Scalars['Date']['output']>;
  supplierDepositPaid?: Maybe<Scalars['Boolean']['output']>;
  supplierOrderId?: Maybe<Scalars['ID']['output']>;
  supplierRefundAmount?: Maybe<Scalars['Float']['output']>;
  supplierRefundIssued: Scalars['Boolean']['output'];
  supplierRemainingBalanceAmount?: Maybe<Scalars['Float']['output']>;
  supplierRemainingBalanceDueAt?: Maybe<Scalars['Date']['output']>;
  supplierRemainingBalancePaid: Scalars['Boolean']['output'];
  taxAmount: Scalars['Float']['output'];
  travelerIdx: Scalars['Int']['output'];
};


/** LineItem */
export type UpsellProductLineItemNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for UpsellProductLineItem. */
export type UpsellProductLineItemConnection = {
  __typename?: 'UpsellProductLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UpsellProductLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UpsellProductLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UpsellProductLineItemEdge = {
  __typename?: 'UpsellProductLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UpsellProductLineItem>;
};

export enum UpsellProductTypeEnum {
  Insurance = 'Insurance'
}

/** User */
export type User = {
  __typename?: 'User';
  /** The user is an admin */
  admin?: Maybe<Scalars['Boolean']['output']>;
  /** User's credit cards */
  creditCards?: Maybe<UserCreditCardConnection>;
  /** The user's email */
  email: Scalars['Email']['output'];
  /** The user's first name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user's first name and last name */
  fullName: Scalars['String']['output'];
  /** The primary key for this user */
  id: Scalars['ID']['output'];
  /** List of itineraries that are created by the user */
  itineraries: ItineraryConnection;
  /** The user's last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user's phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** List of viewed itineraries by admin */
  recentItineraries?: Maybe<Array<Itinerary>>;
  /** The user's referral coupon code */
  referralCouponCode?: Maybe<Scalars['String']['output']>;
};


/** User */
export type UserCreditCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** User */
export type UserItinerariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreditCard = CreatedAtUpdatedAt & {
  __typename?: 'UserCreditCard';
  cardType: Scalars['String']['output'];
  /** The created at date time */
  createdAt: Scalars['DateTime']['output'];
  defaultCard: Scalars['Boolean']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  paymentGateway: Scalars['String']['output'];
  /** The updated at date time */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for UserCreditCard. */
export type UserCreditCardConnection = {
  __typename?: 'UserCreditCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserCreditCardEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserCreditCard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserCreditCardEdge = {
  __typename?: 'UserCreditCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserCreditCard>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserMutations = {
  __typename?: 'UserMutations';
  update?: Maybe<MutationsUserUpdatePayload>;
};


export type UserMutationsUpdateArgs = {
  input: MutationsUserUpdateInput;
};

/** Autogenerated input type of ValidateItinerary */
export type ValidateItineraryInput = {
  skipPropertyValidation?: InputMaybe<Scalars['Boolean']['input']>;
  skipProductsValidation?: InputMaybe<Scalars['Boolean']['input']>;
  skipInsuranceUpdateIfPropertyNotChanged?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateItinerary */
export type ValidateItineraryPayload = {
  __typename?: 'ValidateItineraryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['JSON']['output']>>;
  invalidLineItems?: Maybe<Array<LineItem>>;
  itinerary: Itinerary;
};

export enum VerificationSourceEnum {
  Expedia = 'EXPEDIA',
  Hotels = 'HOTELS',
  Vrbo = 'VRBO'
}

export type GetItinerariesCountQueryVariables = Exact<{
  newBookingFilter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  pendingOrderFilter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  notReadyBookingFilter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  urgentBookingFilter?: InputMaybe<ItinerarySearchResolverFilterInput>;
}>;


export type GetItinerariesCountQuery = { __typename?: 'QueryType', newBookings: { __typename?: 'ItinerarySearchkickConnection', totalCount: number }, pendingOrders: { __typename?: 'ItinerarySearchkickConnection', totalCount: number }, notReadyBookings: { __typename?: 'ItinerarySearchkickConnection', totalCount: number }, urgentBookings: { __typename?: 'ItinerarySearchkickConnection', totalCount: number } };

export type ImportComponentsMutationVariables = Exact<{
  resortId: Scalars['Int']['input'];
}>;


export type ImportComponentsMutation = { __typename?: 'Mutation', importComponents?: { __typename?: 'ImportComponentsPayload', message: string } | null };

export type ImportEquipmentRentalsMutationVariables = Exact<{
  resortId: Scalars['Int']['input'];
}>;


export type ImportEquipmentRentalsMutation = { __typename?: 'Mutation', importEquipmentRentals?: { __typename?: 'ImportEquipmentRentalsPayload', message: string } | null };

export type ImportGroundTransfersMutationVariables = Exact<{
  resortId: Scalars['Int']['input'];
}>;


export type ImportGroundTransfersMutation = { __typename?: 'Mutation', importGroundTransfers?: { __typename?: 'ImportGroundTransfersPayload', message: string } | null };

export type ImportLiftTicketsMutationVariables = Exact<{
  resortId: Scalars['Int']['input'];
}>;


export type ImportLiftTicketsMutation = { __typename?: 'Mutation', importLiftTickets?: { __typename?: 'ImportLiftTicketsPayload', message: string } | null };

export type ImportRegionMutationVariables = Exact<{
  regionId: Scalars['Int']['input'];
}>;


export type ImportRegionMutation = { __typename?: 'Mutation', importRegion?: { __typename?: 'ImportRegionPayload', message: string } | null };

export type ItineraryDuplicationRelationFieldsFragment = { __typename?: 'Itinerary', main: { __typename?: 'Itinerary', id: string, publicId: string, state: ItineraryStateEnum }, parent?: { __typename?: 'Itinerary', id: string, publicId: string, state: ItineraryStateEnum } | null, child?: { __typename?: 'Itinerary', id: string, publicId: string, state: ItineraryStateEnum } | null };

export type ImportLodgingMutationVariables = Exact<{
  resortId: Scalars['Int']['input'];
}>;


export type ImportLodgingMutation = { __typename?: 'Mutation', importLodging?: { __typename?: 'ImportLodgingPayload', message: string } | null };

export type ItineraryLockFieldsFragment = { __typename?: 'Itinerary', lock: { __typename?: 'TypesItineraryItineraryLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } };

export type ItineraryPaginationFieldsFragment = { __typename?: 'ItinerarySearchkickConnection', currentPage: number, totalCount: number, totalPages: number, pageSize: number };

export type UserCoreFieldsFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null };

export type ItineraryPricingFieldsFragment = { __typename?: 'Itinerary', isPaid: boolean, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, currency: string };

export type GetItineraryCheckoutPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  skip: Scalars['Boolean']['input'];
}>;


export type GetItineraryCheckoutPageQuery = { __typename?: 'QueryType', itinerary?: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, isPaid: boolean, sessionId: string, publicId: string, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, isPending: boolean } } | null } };

export type GetItineraryCommunicationsPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryCommunicationsPageQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, sessionId: string, email?: any | null, state: ItineraryStateEnum, fulfilmentState: ItineraryFulfilmentStateEnum, normalizedFirstName?: string | null, normalizedLastName?: string | null, phone?: string | null, lineItems: Array<{ __typename?: 'LineItem', id: string, fulfilmentState: LineItemFulfilmentStateEnum, product: { __typename: 'LessonProduct' } | { __typename: 'LiftTicketProduct' } | { __typename: 'PropertyProduct' } | { __typename: 'RentalProduct' } | { __typename: 'TransportationProduct' } | { __typename: 'UpsellProduct' } }>, main: { __typename?: 'Itinerary', id: string, email?: any | null, publicId: string } } | null } };

export type GetProductSupplierQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductSupplierQuery = { __typename?: 'QueryType', productSupplier?: { __typename?: 'ProductSupplier', id: string, active?: boolean | null, apexUpdated?: boolean | null, apexUpdatedAt?: any | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, commission?: number | null, confirmationNumberInstruction?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhoneMobile?: string | null, contactPhoneOffice?: string | null, contactPosition?: string | null, contractLink?: string | null, contractStatus?: ProductSupplierContractStatusEnum | null, currency?: ProductSupplierCurrencyEnum | null, depositPolicy?: string | null, email?: string | null, fulfilmentContactInformation?: string | null, fulfilmentNotes?: string | null, fulfilmentReferenceNumber?: string | null, mainSupplier?: boolean | null, name?: string | null, shortName: string, note?: string | null, officialTimetable?: string | null, order?: number | null, password?: string | null, paymentBulkBill?: ProductSupplierPaymentBulkBillEnum | null, paymentFrequency?: ProductSupplierPaymentFrequencyEnum | null, paymentMethod?: ProductSupplierPaymentMethodEnum | null, paymentOptions?: string | null, phone?: string | null, pickupTimeLocation?: ProductSupplierPickupTimeLocationEnum | null, productType: ProductSupplierProductTypeEnum, rateLink?: string | null, rateStatus?: ProductSupplierRateStatusEnum | null, spreadsheetUrl?: string | null, supplierProduct?: string | null, supplierType?: ProductSupplierSupplierTypeEnum | null, url?: string | null, username?: string | null, vouchersRequired?: boolean | null, contractingAgent?: { __typename?: 'User', id: string, email: any, firstName?: string | null, lastName?: string | null, fullName: string, phone?: string | null } | null, productSupplierGroup?: { __typename?: 'ProductSupplierGroup', id: string, productSuppliers: { __typename?: 'ProductSupplierConnection', nodes?: Array<{ __typename?: 'ProductSupplier', id: string, name?: string | null, active?: boolean | null } | null> | null } } | null, resort: { __typename?: 'Resort', id: string, name: string, slug: string }, transferFulfilmentInstructions: { __typename?: 'TransferFulfilmentInstructionConnection', nodes?: Array<{ __typename?: 'TransferFulfilmentInstruction', active: boolean, airport?: string | null, contactNumber?: string | null, createdAt: any, direction?: TransferFulfilmentInstructionDirectionEnum | null, instructions?: string | null, name?: string | null, order: number, updatedAt: any, instructionId: string, audits?: { __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesTransferFulfilmentInstructionAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null } | null> | null }, fulfilmentContactAudit?: { __typename?: 'TypesProductSupplierAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesProductSupplierAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null, fulfilmentDetailsAudit?: { __typename?: 'TypesProductSupplierAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesProductSupplierAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null, contractingContactAudit?: { __typename?: 'TypesProductSupplierAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesProductSupplierAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null, contractingDetailsAudit?: { __typename?: 'TypesProductSupplierAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesProductSupplierAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null } | null };

export type UpdateProductSupplierMutationVariables = Exact<{
  input: MutationsProductSupplierUpdateInput;
}>;


export type UpdateProductSupplierMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', update?: { __typename?: 'MutationsProductSupplierUpdatePayload', productSupplier?: { __typename?: 'ProductSupplier', id: string } | null } | null } };

export type GetItineraryCallsPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  skip: Scalars['Boolean']['input'];
}>;


export type GetItineraryCallsPageQuery = { __typename?: 'QueryType', itinerary?: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, main: { __typename?: 'Itinerary', id: string, publicId: string, internalId: string, preArrivalCalls?: { __typename?: 'PreArrivalCallConnection', nodes?: Array<{ __typename?: 'PreArrivalCall', id: string, comments?: string | null, createdAt: any, outcome: PreArrivalCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null> | null } | null, postBookingCalls?: { __typename?: 'PostBookingCallConnection', nodes?: Array<{ __typename?: 'PostBookingCall', id: string, comments?: string | null, createdAt: any, outcome: PostBookingCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null> | null } | null } } | null } };

export type CoreCouponFieldsFragment = { __typename?: 'Coupon', active: boolean, code?: string | null, createdAt: any, currency?: string | null, discountPercentage?: number | null, discountValue?: number | null, name: string, expiresAt?: any | null, maxUse?: number | null, numOfPaidUses: number, reason?: ProductDiscountReasonEnum | null, remainingAmount: number, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null };

export type GetCustomerInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomerInfoQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, normalizedFirstName?: string | null, normalizedLastName?: string | null, email?: any | null, phone?: string | null, state: ItineraryStateEnum, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, data: any } } | null } };

export type GetViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerQuery = { __typename?: 'QueryType', viewer: { __typename?: 'TypesViewerQueryType', user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email: any, admin?: boolean | null } | null } };

export type TrackItineraryViewMutationVariables = Exact<{
  input: TrackItineraryViewInput;
}>;


export type TrackItineraryViewMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', trackItineraryView?: { __typename?: 'TrackItineraryViewPayload', success: boolean } | null } | null };

export type RemoveLineItemMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RemoveLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', removeProduct?: { __typename?: 'Itinerary', id: string } | null } } | null };

export type DeactivateCouponMutationVariables = Exact<{
  input: DeactivateCouponInput;
}>;


export type DeactivateCouponMutation = { __typename?: 'Mutation', deactivateCoupon?: { __typename?: 'DeactivateCouponPayload', coupon: { __typename?: 'Coupon', id: string, active: boolean } } | null };

export type GetFulfilmentItinerariesQueryVariables = Exact<{
  filter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFulfilmentItinerariesQuery = { __typename?: 'QueryType', itineraries: { __typename?: 'ItinerarySearchkickConnection', currentPage: number, totalCount: number, totalPages: number, pageSize: number, nodes?: Array<{ __typename?: 'ItinerarySearchkickResult', id: string, arriveAt: any, countryName?: string | null, customerResidencyState?: string | null, customerResidencyCountry?: string | null, currency: string, departAt: any, email?: any | null, infoRequired: boolean, insuranceStatus?: LineItemFulfilmentStateEnum | null, insuranceOrderedAt?: any | null, flightInfoRequired: boolean, fulfilmentState: ItineraryFulfilmentStateEnum, propertyManualFulfilment: boolean, lessonStatus?: LineItemFulfilmentStateEnum | null, lessonOrderedAt?: any | null, liftTicketStatus?: LineItemFulfilmentStateEnum | null, liftTicketOrderedAt?: any | null, modified: boolean, nextPaymentDueAt?: any | null, normalizedFirstName?: string | null, normalizedLastName?: string | null, phone?: string | null, propertyName: string, propertyStatus?: LineItemFulfilmentStateEnum | null, publicId: string, mainPublicId?: string | null, regionName?: string | null, remainingBalancesCollected: boolean, resortName: string, paidAt?: any | null, payableAmount: number, preArrivalCompleted?: boolean | null, preArrivalCallOutcome?: PreArrivalCallOutcomesEnum | null, products: Array<ProductTypeEnum>, rentalStatus?: LineItemFulfilmentStateEnum | null, rentalOrderedAt?: any | null, sessionId: string, transportationStatus?: LineItemFulfilmentStateEnum | null, transportationOrderedAt?: any | null, state: ItineraryStateEnum, manualFollowupEmail4Required: boolean, rentalProductSupplier?: string | null, productFreeCancelDate?: any | null, lodgingFreeCancelDate?: any | null, propertyCrosscheck?: boolean | null, liftTicketCrosscheck?: boolean | null, rentalCrosscheck?: boolean | null, lessonCrosscheck?: boolean | null, transportationCrosscheck?: boolean | null, insuranceCrosscheck?: boolean | null, lessonWaiver?: boolean | null, tableNotes?: string | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, liftTicketAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, rentalAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, lessonAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, transportationAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, f4Agent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, requestedAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, inProgressAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, flightInfoAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, customerAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, postBookingAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } };

export type CouponCreateMutationVariables = Exact<{
  input: CreateCouponInput;
}>;


export type CouponCreateMutation = { __typename?: 'Mutation', createCoupon?: { __typename?: 'CreateCouponPayload', coupon?: { __typename?: 'Coupon', id: string, active: boolean, code?: string | null, createdAt: any, currency?: string | null, discountPercentage?: number | null, discountValue?: number | null, name: string, expiresAt?: any | null, maxUse?: number | null, numOfPaidUses: number, reason?: ProductDiscountReasonEnum | null, remainingAmount: number, originItinerary?: { __typename?: 'Itinerary', main: { __typename?: 'Itinerary', publicId: string } } | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null };

export type GetCouponQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetCouponQuery = { __typename?: 'QueryType', coupon?: { __typename?: 'Coupon', id: string, active: boolean, code?: string | null, createdAt: any, currency?: string | null, discountPercentage?: number | null, discountValue?: number | null, name: string, expiresAt?: any | null, maxUse?: number | null, numOfPaidUses: number, reason?: ProductDiscountReasonEnum | null, remainingAmount: number, originItinerary?: { __typename?: 'Itinerary', main: { __typename?: 'Itinerary', publicId: string } } | null, itineraries: Array<{ __typename?: 'Itinerary', id: string, publicId: string, paidAt?: any | null }>, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetCallItinerariesQueryVariables = Exact<{
  filter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCallItinerariesQuery = { __typename?: 'QueryType', itineraries: { __typename?: 'ItinerarySearchkickConnection', currentPage: number, totalCount: number, totalPages: number, pageSize: number, nodes?: Array<{ __typename?: 'ItinerarySearchkickResult', id: string, paidAt?: any | null, arriveAt: any, countryName?: string | null, currency: string, departAt: any, fulfilmentState: ItineraryFulfilmentStateEnum, modified: boolean, firstName?: string | null, lastName?: string | null, normalizedFirstName?: string | null, normalizedLastName?: string | null, propertyName: string, publicId: string, regionName?: string | null, resortName: string, payableAmount: number, preArrivalCompleted?: boolean | null, preArrivalCallOutcome?: PreArrivalCallOutcomesEnum | null, postBookingCallSuccessful?: boolean | null, postBookingCallUnsuccessful?: boolean | null, postBookingCallOutcome?: PostBookingCallOutcomesEnum | null, products: Array<ProductTypeEnum>, sessionId: string, state: ItineraryStateEnum, preArrivalSmsSent?: boolean | null, flightInfoRequired: boolean, customerResidencyCountry?: string | null, lessonWaiver?: boolean | null, customerAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, postBookingAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } };

export type GetAllCouponsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllCouponsQuery = { __typename?: 'QueryType', allCoupons: { __typename?: 'CouponConnection', edges?: Array<{ __typename?: 'CouponEdge', node?: { __typename?: 'Coupon', id: string, active: boolean, code?: string | null, createdAt: any, currency?: string | null, discountPercentage?: number | null, discountValue?: number | null, name: string, expiresAt?: any | null, maxUse?: number | null, numOfPaidUses: number, reason?: ProductDiscountReasonEnum | null, remainingAmount: number, originItinerary?: { __typename?: 'Itinerary', main: { __typename?: 'Itinerary', publicId: string } } | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } | null> | null } };

export type GetProductSuppliersQueryVariables = Exact<{
  filter?: InputMaybe<ProductSupplierSearchResolverFilterInput>;
  order?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProductSuppliersQuery = { __typename?: 'QueryType', productSuppliers: { __typename?: 'ProductSupplierSearchkickConnection', currentPage: number, totalCount: number, totalPages: number, pageSize: number, nodes?: Array<{ __typename?: 'ProductSupplierSearchkickResult', active?: boolean | null, apexUpdated?: boolean | null, cancellationPolicy?: string | null, commission?: string | null, confirmationNumberInstruction?: string | null, contactEmail?: string | null, contactName?: string | null, contactPhoneMobile?: string | null, contactPhoneOffice?: string | null, contactPosition?: string | null, contractingContactLastUpdatedAt?: any | null, contractingDetailLastUpdatedAt?: any | null, contractLink?: string | null, contractStatus?: string | null, currency?: string | null, email?: string | null, fulfilmentContactLastUpdatedAt?: any | null, fulfilmentDetailLastUpdatedAt?: any | null, fulfilmentNotes?: string | null, id: string, name?: string | null, note?: string | null, order?: string | null, password?: string | null, paymentBulkBill?: string | null, paymentFrequency?: string | null, paymentMethod?: string | null, paymentOptions?: string | null, productType?: string | null, rateLink?: string | null, rateStatus?: string | null, resortName?: string | null, shortName?: string | null, spreadsheetUrl?: string | null, supplierProduct?: string | null, supplierType?: string | null, url?: string | null, username?: string | null, vouchersRequired: boolean, supplierId: string, contractingAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, transferFulfilmentInstructions?: Array<{ __typename?: 'TransferFulfilmentInstructionSearchkickResult', active: boolean, airport?: string | null, contactNumber?: string | null, direction?: TransferFulfilmentInstructionDirectionEnum | null, id: string, instructions?: string | null, name?: string | null, order: number, updatedAt?: any | null }> | null } | null> | null } };

export type GetItinerariesQueryVariables = Exact<{
  filter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetItinerariesQuery = { __typename?: 'QueryType', itineraries: { __typename?: 'ItinerarySearchkickConnection', currentPage: number, totalCount: number, totalPages: number, pageSize: number, nodes?: Array<{ __typename?: 'ItinerarySearchkickResult', id: string, arriveAt: any, countryName?: string | null, currency: string, departAt: any, email?: any | null, infoRequired: boolean, flightInfoRequired: boolean, fulfilmentState: ItineraryFulfilmentStateEnum, modified: boolean, nextPaymentDueAt?: any | null, normalizedFirstName?: string | null, normalizedLastName?: string | null, phone?: string | null, propertyName: string, publicId: string, regionName?: string | null, remainingBalancesCollected: boolean, resortName: string, paidAt?: any | null, payableAmount: number, preArrivalCompleted?: boolean | null, preArrivalCallOutcome?: PreArrivalCallOutcomesEnum | null, products: Array<ProductTypeEnum>, sessionId: string, state: ItineraryStateEnum, propertyManualFulfilment: boolean, skicomQuoteId?: number | null, oldFakeId: string, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } };

export type GetViewerItineraryHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetViewerItineraryHistoryQuery = { __typename?: 'QueryType', viewer: { __typename?: 'TypesViewerQueryType', user?: { __typename?: 'User', id: string, recentItineraries?: Array<{ __typename?: 'Itinerary', id: string, publicId: string, email?: any | null, fulfilmentState: ItineraryFulfilmentStateEnum, normalizedFirstName?: string | null, normalizedLastName?: string | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, product: { __typename?: 'PropertyProduct', id: string, name: string }, resort?: { __typename?: 'Resort', id: string, name: string } | null } }> | null } | null } };

export type ActivateTransferFulfilmentInstructionMutationVariables = Exact<{
  input: MutationsTransferFulfilmentInstructionActivateInput;
}>;


export type ActivateTransferFulfilmentInstructionMutation = { __typename?: 'Mutation', transferFulfilmentInstruction: { __typename?: 'TransferFulfilmentInstructionMutations', activate?: { __typename?: 'MutationsTransferFulfilmentInstructionActivatePayload', transferFulfilmentInstruction?: { __typename?: 'TransferFulfilmentInstruction', active: boolean, airport?: string | null, contactNumber?: string | null, createdAt: any, direction?: TransferFulfilmentInstructionDirectionEnum | null, instructions?: string | null, name?: string | null, order: number, updatedAt: any, instructionId: string, audits?: { __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesTransferFulfilmentInstructionAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null } | null } | null } };

export type DeactivateTransferFulfilmentInstructionMutationVariables = Exact<{
  input: MutationsTransferFulfilmentInstructionDeactivateInput;
}>;


export type DeactivateTransferFulfilmentInstructionMutation = { __typename?: 'Mutation', transferFulfilmentInstruction: { __typename?: 'TransferFulfilmentInstructionMutations', deactivate?: { __typename?: 'MutationsTransferFulfilmentInstructionDeactivatePayload', transferFulfilmentInstruction?: { __typename?: 'TransferFulfilmentInstruction', active: boolean, airport?: string | null, contactNumber?: string | null, createdAt: any, direction?: TransferFulfilmentInstructionDirectionEnum | null, instructions?: string | null, name?: string | null, order: number, updatedAt: any, instructionId: string, audits?: { __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesTransferFulfilmentInstructionAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null } | null } | null } };

export type GetManualFulfilmentLineItemsQueryVariables = Exact<{
  filter?: InputMaybe<ManualFulfilmentResolverManualFulfilmentInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetManualFulfilmentLineItemsQuery = { __typename?: 'QueryType', manualFulfilmentLineItems?: { __typename?: 'ManualFulfilmentSearchkickConnection', currentPage: number, pageSize: number, totalCount: number, totalPages: number, nodes?: Array<{ __typename?: 'ManualFulfilmentSearchkickResult', id: string, arriveAt: any, currency: string, supplierCurrency?: string | null, departAt: any, customerDepositAmount: number, customerRemainingBalanceAmount?: number | null, customerRemainingBalanceDueAt?: any | null, customerRemainingBalancePaidAmount?: number | null, fulfilmentState?: string | null, fulfilmentAgentId?: string | null, sessionId: string, itineraryFulfilmentState?: ItineraryFulfilmentStateEnum | null, itineraryId: string, itineraryPublicId: string, normalizedFirstName?: string | null, normalizedLastName?: string | null, margin: number, paidAt: any, payableAmount: number, propertyName: string, resortName: string, supplierDepositAmount?: number | null, supplierDepositDueAt?: any | null, supplierDepositPaid?: boolean | null, supplierConfirmationNumber?: string | null, supplierCreditIssued?: boolean | null, supplierCreditAmount?: number | null, supplierLodgingTotal?: number | null, supplierRefundIssued?: boolean | null, supplierRefundAmount?: number | null, supplierRemainingBalanceAmount?: number | null, supplierRemainingBalanceDueAt?: any | null, supplierRemainingBalancePaid?: boolean | null, supplierOrderId?: string | null, propertySupplierUrl?: string | null, itineraryState?: ItineraryStateEnum | null, propertyOrderedAt?: any | null, propertyCrosscheck?: boolean | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, assignedAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type UpdateTransferFulfilmentInstructionMutationVariables = Exact<{
  input: MutationsTransferFulfilmentInstructionUpdateInput;
}>;


export type UpdateTransferFulfilmentInstructionMutation = { __typename?: 'Mutation', transferFulfilmentInstruction: { __typename?: 'TransferFulfilmentInstructionMutations', update?: { __typename?: 'MutationsTransferFulfilmentInstructionUpdatePayload', transferFulfilmentInstruction?: { __typename?: 'TransferFulfilmentInstruction', active: boolean, airport?: string | null, contactNumber?: string | null, createdAt: any, direction?: TransferFulfilmentInstructionDirectionEnum | null, instructions?: string | null, name?: string | null, order: number, updatedAt: any, instructionId: string, audits?: { __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesTransferFulfilmentInstructionAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null } | null } | null } };

export type GetSupportCasesQueryVariables = Exact<{
  filter?: InputMaybe<SupportCaseResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSupportCasesQuery = { __typename?: 'QueryType', supportCases?: { __typename?: 'SupportCaseSearchkickConnection', currentPage: number, pageSize: number, totalCount: number, totalPages: number, nodes?: Array<{ __typename?: 'SupportCaseSearchkickResult', id: string, itineraryPublicId: string, normalizedFirstName?: string | null, normalizedLastName?: string | null, email?: any | null, phone?: string | null, propertyName: string, resortName: string, arriveAt: any, departAt: any, fulfilmentState?: ItineraryFulfilmentStateEnum | null, createdAt?: any | null, category?: SupportCaseCategoryEnum | null, subcategory?: SupportCaseSubcategoryEnum | null, action?: SupportCaseActionEnum | null, caseType?: SupportCaseTypeEnum | null, latestConfirmedItineraryPublicId: string, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type AddRentalMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  helmetIncluded?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddRentalMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addProduct?: { __typename?: 'AddRentalPayload', itinerary: { __typename?: 'Itinerary', id: string, updatedAt: any }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type FindItineraryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FindItineraryQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, duplicated: Array<{ __typename?: 'Itinerary', id: string, publicId: string, createdAt: any, isConfirmed: boolean }> } | null } };

export type AddLessonMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
  participants?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type AddLessonMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addProduct?: { __typename?: 'AddLessonPayload', itinerary: { __typename?: 'Itinerary', id: string, updatedAt: any }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type AddLiftTicketMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddLiftTicketMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addProduct?: { __typename?: 'AddLiftTicketPayload', itinerary: { __typename?: 'Itinerary', id: string, updatedAt: any }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type CreateTransferFulfilmentInstructionMutationVariables = Exact<{
  input: MutationsTransferFulfilmentInstructionCreateInput;
}>;


export type CreateTransferFulfilmentInstructionMutation = { __typename?: 'Mutation', transferFulfilmentInstruction: { __typename?: 'TransferFulfilmentInstructionMutations', create?: { __typename?: 'MutationsTransferFulfilmentInstructionCreatePayload', transferFulfilmentInstruction?: { __typename?: 'TransferFulfilmentInstruction', active: boolean, airport?: string | null, contactNumber?: string | null, createdAt: any, direction?: TransferFulfilmentInstructionDirectionEnum | null, instructions?: string | null, name?: string | null, order: number, updatedAt: any, instructionId: string, audits?: { __typename?: 'TypesTransferFulfilmentInstructionAuditedTypeConnection', nodes?: Array<{ __typename?: 'TypesTransferFulfilmentInstructionAuditedType', id: string, createdAt: any, user?: { __typename?: 'User', id: string, fullName: string } | null } | null> | null } | null } | null } | null } };

export type AddTransportationMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
  travelerIdx?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddTransportationMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addProduct?: { __typename?: 'AddTransportationPayload', itinerary: { __typename?: 'Itinerary', id: string, updatedAt: any }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type GetItineraryUserCreditCardsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  skip: Scalars['Boolean']['input'];
}>;


export type GetItineraryUserCreditCardsQuery = { __typename?: 'QueryType', itinerary?: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, currency: string, state: ItineraryStateEnum, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, creditCards?: { __typename?: 'UserCreditCardConnection', nodes?: Array<{ __typename?: 'UserCreditCard', id: string, createdAt: any, cardType: string, defaultCard: boolean, expiresAt: any, last4: string, paymentGateway: string } | null> | null } | null } | null } | null } };

export type RemoveCreditCardMutationVariables = Exact<{
  input: MutationsCreditCardRemoveInput;
}>;


export type RemoveCreditCardMutation = { __typename?: 'Mutation', creditCard: { __typename?: 'CreditCardMutations', remove?: { __typename?: 'MutationsCreditCardRemovePayload', creditCard: { __typename?: 'UserCreditCard', id: string } } | null } };

export type AddUpsellMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  sku: Scalars['ID']['input'];
  startAt: Scalars['Date']['input'];
}>;


export type AddUpsellMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addProduct?: { __typename?: 'AddUpsellPayload', itinerary: { __typename?: 'Itinerary', id: string, updatedAt: any }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type RemoveDuplicateMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
}>;


export type RemoveDuplicateMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', removeDuplicate?: { __typename?: 'RemoveDuplicatePayload', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, duplicated: Array<{ __typename?: 'Itinerary', id: string }>, main: { __typename?: 'Itinerary', id: string, duplicated: Array<{ __typename?: 'Itinerary', id: string }> } } | null } | null } } | null };

export type SetDefaultCreditCardMutationVariables = Exact<{
  input: MutationsCreditCardSetDefaultCardInput;
}>;


export type SetDefaultCreditCardMutation = { __typename?: 'Mutation', creditCard: { __typename?: 'CreditCardMutations', setDefaultCard?: { __typename?: 'MutationsCreditCardSetDefaultCardPayload', creditCard: { __typename?: 'UserCreditCard', id: string } } | null } };

export type GetItineraryStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  skip: Scalars['Boolean']['input'];
}>;


export type GetItineraryStateQuery = { __typename?: 'QueryType', itinerary?: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, normalizedFirstName?: string | null, normalizedLastName?: string | null, totalAmount: number, totalPayable: number, couponDiscount: number, currency: string, state: ItineraryStateEnum, fulfilmentState: ItineraryFulfilmentStateEnum, isDuplicated: boolean, isPaid: boolean, isCancelled: boolean, isConfirmed: boolean, isModified: boolean, preArrivalCompleted: boolean, postBookingCallSuccessful: boolean, postBookingCallUnsuccessful?: boolean | null, manualFollowupEmail4Required: boolean, isInformationRequired: boolean, isFlightsRequired: boolean, refundableAmount?: number | null, child?: { __typename?: 'Itinerary', id: string, publicId: string, state: ItineraryStateEnum } | null, main: { __typename?: 'Itinerary', id: string, publicId: string, state: ItineraryStateEnum }, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, hasOverrideData: boolean }, scheduledPayments?: { __typename?: 'ScheduledPaymentConnection', nodes?: Array<{ __typename?: 'ScheduledPayment', id: string, isModified: boolean } | null> | null } | null } | null } };

export type ClearRefundableAmountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ClearRefundableAmountInput;
}>;


export type ClearRefundableAmountMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', clearRefundableAmount?: { __typename?: 'ClearRefundableAmountPayload', itinerary: { __typename?: 'Itinerary', id: string, refundableAmount?: number | null } } | null } } | null };

export type DuplicateItineraryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: DuplicateItineraryInput;
}>;


export type DuplicateItineraryMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', duplicateItinerary?: { __typename?: 'DuplicateItineraryPayload', itinerary: { __typename?: 'Itinerary', id: string, publicId: string } } | null } } | null };

export type UpdateItineraryStatesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateItineraryStatesInput;
}>;


export type UpdateItineraryStatesMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateItineraryStates?: { __typename?: 'UpdateItineraryStatesPayload', itinerary: { __typename?: 'Itinerary', id: string, publicId: string, isFlightsRequired: boolean } } | null } } | null };

export type UpdateItineraryDataMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  input: UpdateItineraryDataInput;
}>;


export type UpdateItineraryDataMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateData?: { __typename?: 'UpdateItineraryDataPayload', itinerary: { __typename?: 'Itinerary', id: string, data?: any | null, liftTicketLineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string, fulfillmentInstructions?: string | null } | null> | null }, rentalLineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string, fulfillmentInstructions?: string | null } | null> | null } } } | null } } | null };

export type AssignLineItemAgentMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  input: AssignLineItemAgentInput;
}>;


export type AssignLineItemAgentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', assignLineItemAgent?: { __typename?: 'AssignLineItemAgentPayload', lineItem: { __typename?: 'LineItem', id: string, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, assignedAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null } } | null } } | null };

export type UpdateItineraryFulfilmentStateMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  input: UpdateItineraryFulfilmentStateInput;
}>;


export type UpdateItineraryFulfilmentStateMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateFulfilmentState?: { __typename?: 'UpdateItineraryFulfilmentStatePayload', itinerary: { __typename?: 'Itinerary', id: string, fulfilmentState: ItineraryFulfilmentStateEnum } } | null } } | null };

export type GetCustomerItinerariesQueryVariables = Exact<{
  filter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  order?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
}>;


export type GetCustomerItinerariesQuery = { __typename?: 'QueryType', itineraries: { __typename?: 'ItinerarySearchkickConnection', nodes?: Array<{ __typename?: 'ItinerarySearchkickResult', id: string, state: ItineraryStateEnum, fulfilmentState: ItineraryFulfilmentStateEnum, arriveAt: any, payableAmount: number, mainId?: string | null, mainPublicId?: string | null, publicId: string } | null> | null } };

export type UpdateLessonLineItemMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  data: LessonLineItem;
}>;


export type UpdateLessonLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateLesson?: { __typename?: 'UpdateProductPayload', lineItem: { __typename?: 'LineItem', id: string, firstName?: string | null, lastName?: string | null, dob?: any | null } } | null } } | null };

export type UpdateLiftTicketLineItemMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  data: LiftTicketLineItem;
}>;


export type UpdateLiftTicketLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateLiftTicket?: { __typename?: 'UpdateProductPayload', lineItem: { __typename?: 'LineItem', id: string, firstName?: string | null, lastName?: string | null, dob?: any | null } } | null } } | null };

export type UpdateLineItemSupplierDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLineItemInput;
}>;


export type UpdateLineItemSupplierDataMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateLineItem?: { __typename?: 'UpdateLineItemPayload', lineItem: { __typename?: 'LineItem', id: string, data: any, costAmount?: number | null, supplierOrderId?: string | null, supplierConfirmationNumber?: string | null } } | null } } | null };

export type UpdateLineItemSupplierMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateLineItemSupplierInput;
}>;


export type UpdateLineItemSupplierMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateLineItemSupplier?: { __typename?: 'UpdateLineItemSupplierPayload', lineItem: { __typename?: 'LineItem', id: string, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null } | null } } | null } } | null };

export type SendEmailMutationVariables = Exact<{
  itineraryId: Scalars['ID']['input'];
  input: SendEmailInput;
}>;


export type SendEmailMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', sendEmail?: { __typename?: 'SendEmailPayload', itinerary: { __typename?: 'Itinerary', id: string, fulfilmentState: ItineraryFulfilmentStateEnum } } | null } } | null };

export type UpdateRentalLineItemMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  data: RentalLineItem;
}>;


export type UpdateRentalLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateRental?: { __typename?: 'UpdateProductPayload', lineItem: { __typename?: 'LineItem', id: string, firstName?: string | null, lastName?: string | null } } | null } } | null };

export type UpdateUpsellLineItemMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  data: UpsellLineItem;
}>;


export type UpdateUpsellLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateUpsell?: { __typename?: 'UpdateProductPayload', lineItem: { __typename?: 'LineItem', id: string, amount: number, firstName?: string | null, lastName?: string | null, dob?: any | null } } | null } } | null };

export type UpdateLineItemFulfilmentStateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLineItemFulfilmentStateInput;
}>;


export type UpdateLineItemFulfilmentStateMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateLineItemFulfilmentState?: { __typename?: 'UpdateLineItemFulfilmentStatePayload', itinerary: { __typename?: 'Itinerary', id: string, fulfilmentState: ItineraryFulfilmentStateEnum }, lineItem: { __typename?: 'LineItem', id: string, fulfilmentState: LineItemFulfilmentStateEnum } } | null } } | null };

export type ItineraryEmailSendFieldsFragment = { __typename?: 'Itinerary', id: string, publicId: string, email?: any | null, state: ItineraryStateEnum, fulfilmentState: ItineraryFulfilmentStateEnum, lineItems: Array<{ __typename?: 'LineItem', id: string, fulfilmentState: LineItemFulfilmentStateEnum, product: { __typename: 'LessonProduct' } | { __typename: 'LiftTicketProduct' } | { __typename: 'PropertyProduct' } | { __typename: 'RentalProduct' } | { __typename: 'TransportationProduct' } | { __typename: 'UpsellProduct' } }> };

export type GetLessonLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLessonLineItemsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, arriveAt: any, departAt: any, isDraftDuplicate: boolean, isPaid: boolean, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, currency: string, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', normalizedFirstName?: string | null, normalizedLastName?: string | null, dob?: any | null, travelerIdx: number }> | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, resort?: { __typename?: 'Resort', id: string, slug: string, name: string } | null }, lineItems: { __typename?: 'LessonProductLineItemTypeConnection', nodes?: Array<{ __typename?: 'LessonProductLineItemType', id: string, data: any, travelerIdx: number, arriveAt: any, dob?: any | null, costAmount?: number | null, costAmountCurrency?: string | null, currency: string, payableAmount: number, fulfilmentState: LineItemFulfilmentStateEnum, fulfilmentInstructionLocation?: string | null, hasPriceChanges?: boolean | null, supplierOrderId?: string | null, supplierConfirmationNumber?: string | null, crosscheck?: boolean | null, firstName?: string | null, lastName?: string | null, product: { __typename?: 'LessonProduct', id: string, name: string, sku: string, age: LessonProductAgeTypeEnum, fulfillmentInstructions?: string | null, daysInAdvance: number, skill: LessonProductSkillTypeEnum, participants: number, duration: string, checkinTime: string, lessonTime: string, size: LessonProductLessonTypeEnum, sport: LessonProductGearTypeEnum, resort: { __typename?: 'Resort', id: string, name: string, slug: string, productSuppliers: Array<{ __typename?: 'ProductSupplier', id: string, name?: string | null, shortName: string, url?: string | null, bookingPortalType?: string | null, mainSupplier?: boolean | null, cancellationPolicy?: string | null, currency?: ProductSupplierCurrencyEnum | null }> } }, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, shortName: string, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, currency?: ProductSupplierCurrencyEnum | null, vouchersRequired?: boolean | null } | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } } | null } };

export type UpdateTransportationLineItemMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  data: TransportationLineItem;
}>;


export type UpdateTransportationLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateTransportation?: { __typename?: 'UpdateProductPayload', lineItem: { __typename?: 'LineItem', id: string, firstName?: string | null, lastName?: string | null } } | null } } | null };

export type GetItineraryLodgingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryLodgingQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, sessionId: string, currency: string, isDraftDuplicate: boolean, isPaid: boolean, parentId?: string | null, cancelPenalties?: Array<any> | null, state: ItineraryStateEnum, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, liftTicketLineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string } | null> | null }, rentalLineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string } | null> | null }, lessonLineItems: { __typename?: 'LessonProductLineItemTypeConnection', nodes?: Array<{ __typename?: 'LessonProductLineItemType', id: string } | null> | null }, transportationLineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string } | null> | null }, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, isPaid: boolean, inventoryType: string, manualFulfilment: boolean, arriveAt: any, departAt: any, nights: number, amount: number, taxAmount: number, discountAmount: number, costAmount?: number | null, costAmountCurrency?: string | null, payableAmount: number, hasPriceChanges?: boolean | null, amountIncTax: number, resortFeesAmount: number, markedAsCancelled?: boolean | null, state: LineItemStateEnum, data: any, specialRequest?: string | null, specialRequestFulfilled: boolean, confirmationNumbers?: any | null, messageCenterHref?: string | null, fulfilmentState: LineItemFulfilmentStateEnum, supplierOrderId?: string | null, supplierConfirmationNumber?: string | null, supplierDepositAmount?: number | null, supplierDepositDueAt?: any | null, supplierDepositPaid?: boolean | null, supplierRemainingBalanceAmount?: number | null, supplierRemainingBalanceDueAt?: any | null, supplierRemainingBalancePaid: boolean, supplierRefundIssued: boolean, supplierRefundAmount?: number | null, supplierCreditIssued: boolean, supplierCreditAmount?: number | null, crosscheck?: boolean | null, bedGroup?: { __typename?: 'BedGroup', id?: string | null, description?: string | null, configuration?: Array<any> | null } | null, room: { __typename?: 'PropertyRoom', id: string, name: string }, rate: { __typename?: 'PropertyRoomRate', id: string, cancelPenalties?: Array<any> | null, refundable: boolean, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null, tokens?: any | null }> | null }, product: { __typename?: 'PropertyProduct', id: string, address?: any | null, checkin: any, name: string, phone?: string | null }, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, paymentOptions?: string | null, url?: string | null, fulfilmentNotes?: string | null, currency?: ProductSupplierCurrencyEnum | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, depositPolicy?: string | null, productType: ProductSupplierProductTypeEnum, paymentBulkBill?: ProductSupplierPaymentBulkBillEnum | null, paymentMethod?: ProductSupplierPaymentMethodEnum | null, paymentFrequency?: ProductSupplierPaymentFrequencyEnum | null } | null, resort?: { __typename?: 'Resort', productSuppliers: Array<{ __typename?: 'ProductSupplier', id: string, order?: number | null, name?: string | null, shortName: string }> } | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null } | null } } | null } };

export type PropertyCancelMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CancelPropertyInput;
}>;


export type PropertyCancelMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', cancelProperty?: { __typename?: 'CancelPropertyPayload', itinerary: { __typename?: 'Itinerary', id: string, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, state: LineItemStateEnum, fulfilmentState: LineItemFulfilmentStateEnum, markedAsCancelled?: boolean | null } } } | null } } | null };

export type GetItineraryIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  skip: Scalars['Boolean']['input'];
}>;


export type GetItineraryIdsQuery = { __typename?: 'QueryType', itinerary?: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, sessionId: string, internalId: string, lineItems: Array<{ __typename?: 'LineItem', id: string, firstName?: string | null, lastName?: string | null, product: { __typename?: 'LessonProduct', id: string, name: string } | { __typename?: 'LiftTicketProduct', id: string, name: string } | { __typename?: 'PropertyProduct', id: string, name: string } | { __typename?: 'RentalProduct', id: string, name: string } | { __typename?: 'TransportationProduct', id: string, name: string } | { __typename?: 'UpsellProduct', id: string, name: string } }> } | null } };

export type GetInsuranceLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetInsuranceLineItemsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, publicId: string, arriveAt: any, isDraftDuplicate: boolean, paidAt?: any | null, state: ItineraryStateEnum, travelerDetails?: Array<any> | null, isPaid: boolean, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, currency: string, lastScheduledPayment?: { __typename?: 'ScheduledPayment', id: string, processAt: any } | null, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', travelerIdx: number }> | null, lineItems: { __typename?: 'UpsellProductLineItemConnection', nodes?: Array<{ __typename?: 'UpsellProductLineItem', id: string, costAmount?: number | null, costAmountCurrency?: string | null, currency: string, payableAmount: number, hasPriceChanges?: boolean | null, gender?: string | null, fulfilmentState: LineItemFulfilmentStateEnum, supplierOrderId?: string | null, supplierConfirmationNumber?: string | null, crosscheck?: boolean | null, product: { __typename?: 'UpsellProduct', id: string, name: string }, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, productSupplier?: { __typename?: 'ProductSupplier', id: string, currency?: ProductSupplierCurrencyEnum | null } | null } | null> | null }, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, data: any, arriveAt: any, departAt: any, resort?: { __typename?: 'Resort', id: string, country: { __typename?: 'Country', id: string, name: string }, region: { __typename?: 'Region', id: string, name: string, slug: string } } | null } } | null } };

export type GetLiftTicketLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetLiftTicketLineItemsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, arriveAt: any, departAt: any, isDraftDuplicate: boolean, isPaid: boolean, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, currency: string, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', normalizedFirstName?: string | null, normalizedLastName?: string | null, dob?: any | null, travelerIdx: number }> | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, resort?: { __typename?: 'Resort', id: string, slug: string, name: string } | null }, lineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string, data: any, travelerIdx: number, arriveAt: any, dob?: any | null, costAmount?: number | null, costAmountCurrency?: string | null, currency: string, payableAmount: number, fulfillmentInstructions?: string | null, hasPriceChanges?: boolean | null, fulfilmentState: LineItemFulfilmentStateEnum, supplierOrderId?: string | null, supplierConfirmationNumber?: string | null, crosscheck?: boolean | null, firstName?: string | null, lastName?: string | null, fulfillmentInstructionsForSms?: string | null, product: { __typename?: 'LiftTicketProduct', id: string, name: string, sku: string, age: string, daysInAdvance: number, description?: string | null, ticket: string, resort: { __typename?: 'Resort', id: string, name: string, slug: string, productSuppliers: Array<{ __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, currency?: ProductSupplierCurrencyEnum | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null }> } }, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, currency?: ProductSupplierCurrencyEnum | null, vouchersRequired?: boolean | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null } | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } } | null } };

export type UpdateLodgingConfirmationNumberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateItineraryDataInput;
}>;


export type UpdateLodgingConfirmationNumberMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateData?: { __typename?: 'UpdateItineraryDataPayload', itinerary: { __typename?: 'Itinerary', id: string, data?: any | null } } | null } } | null };

export type GetItineraryLogsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetItineraryLogsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, firstName?: string | null, audits?: { __typename?: 'AuditedConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, hasPreviousPage: boolean }, edges?: Array<{ __typename?: 'AuditedEdge', node?: { __typename?: 'Audited', id: string, action: string, auditableType: string, createdAt: any, comment?: string | null, changes?: any | null, auditable: { __typename?: 'Itinerary', id: string, publicId: string } | { __typename?: 'ItineraryEmailLog', id: string, type: ItineraryEmailLogTypeEnum, state: ItineraryEmailLogStateEnum, address?: string | null, sentBy?: { __typename?: 'User', fullName: string } | null } | { __typename?: 'LineItem', id: string, product: { __typename?: 'LessonProduct', id: string, name: string } | { __typename?: 'LiftTicketProduct', id: string, name: string } | { __typename?: 'PropertyProduct', id: string, name: string } | { __typename?: 'RentalProduct', id: string, name: string } | { __typename?: 'TransportationProduct', id: string, name: string } | { __typename?: 'UpsellProduct', id: string, name: string } } | { __typename?: 'Payment', id: string, amount: number, trxnType?: PaymentTrxnTypeEnum | null, parentPayment?: { __typename?: 'Payment', id: string } | null } | { __typename?: 'SupportCase', id: string } | { __typename?: 'SupportNote', id: string }, user?: { __typename?: 'User', id: string, fullName: string } | null, typedChanges: Array<{ __typename?: 'AuditedChange', attribute: string, from?: { __typename: 'AuditedChangeRecordBoolean', boolean: boolean } | { __typename: 'AuditedChangeRecordDate', date: any } | { __typename: 'AuditedChangeRecordDateTime', dateTime: any } | { __typename: 'AuditedChangeRecordFloat', float: number } | { __typename: 'AuditedChangeRecordInteger', integer: number } | { __typename: 'AuditedChangeRecordString', string: string } | { __typename: 'Itinerary', id: string, publicId: string, email?: any | null } | { __typename: 'LessonProduct', id: string, name: string } | { __typename: 'LiftTicketProduct', id: string, name: string } | { __typename: 'PropertyProduct' } | { __typename: 'RentalProduct', id: string, name: string } | { __typename: 'TransportationProduct', id: string, name: string } | { __typename: 'UpsellProduct', id: string, name: string } | { __typename: 'User', id: string, fullName: string } | { __typename: 'UserCreditCard', id: string, last4: string, createdAt: any } | null, to?: { __typename: 'AuditedChangeRecordBoolean', boolean: boolean } | { __typename: 'AuditedChangeRecordDate', date: any } | { __typename: 'AuditedChangeRecordDateTime', dateTime: any } | { __typename: 'AuditedChangeRecordFloat', float: number } | { __typename: 'AuditedChangeRecordInteger', integer: number } | { __typename: 'AuditedChangeRecordString', string: string } | { __typename: 'Itinerary', id: string, publicId: string, email?: any | null } | { __typename: 'LessonProduct', id: string, name: string } | { __typename: 'LiftTicketProduct', id: string, name: string } | { __typename: 'PropertyProduct' } | { __typename: 'RentalProduct', id: string, name: string } | { __typename: 'TransportationProduct', id: string, name: string } | { __typename: 'UpsellProduct', id: string, name: string } | { __typename: 'User', id: string, fullName: string } | { __typename: 'UserCreditCard', id: string, last4: string, createdAt: any } | null }> } | null } | null> | null } | null } | null } };

type ItineraryLogChangeFields_AuditedChangeRecordBoolean_Fragment = { __typename?: 'AuditedChangeRecordBoolean', boolean: boolean };

type ItineraryLogChangeFields_AuditedChangeRecordDate_Fragment = { __typename?: 'AuditedChangeRecordDate', date: any };

type ItineraryLogChangeFields_AuditedChangeRecordDateTime_Fragment = { __typename?: 'AuditedChangeRecordDateTime', dateTime: any };

type ItineraryLogChangeFields_AuditedChangeRecordFloat_Fragment = { __typename?: 'AuditedChangeRecordFloat', float: number };

type ItineraryLogChangeFields_AuditedChangeRecordInteger_Fragment = { __typename?: 'AuditedChangeRecordInteger', integer: number };

type ItineraryLogChangeFields_AuditedChangeRecordString_Fragment = { __typename?: 'AuditedChangeRecordString', string: string };

type ItineraryLogChangeFields_Itinerary_Fragment = { __typename?: 'Itinerary', id: string, publicId: string, email?: any | null };

type ItineraryLogChangeFields_LessonProduct_Fragment = { __typename?: 'LessonProduct', id: string, name: string };

type ItineraryLogChangeFields_LiftTicketProduct_Fragment = { __typename?: 'LiftTicketProduct', id: string, name: string };

type ItineraryLogChangeFields_PropertyProduct_Fragment = { __typename?: 'PropertyProduct' };

type ItineraryLogChangeFields_RentalProduct_Fragment = { __typename?: 'RentalProduct', id: string, name: string };

type ItineraryLogChangeFields_TransportationProduct_Fragment = { __typename?: 'TransportationProduct', id: string, name: string };

type ItineraryLogChangeFields_UpsellProduct_Fragment = { __typename?: 'UpsellProduct', id: string, name: string };

type ItineraryLogChangeFields_User_Fragment = { __typename?: 'User', id: string, fullName: string };

type ItineraryLogChangeFields_UserCreditCard_Fragment = { __typename?: 'UserCreditCard', id: string, last4: string, createdAt: any };

export type ItineraryLogChangeFieldsFragment = ItineraryLogChangeFields_AuditedChangeRecordBoolean_Fragment | ItineraryLogChangeFields_AuditedChangeRecordDate_Fragment | ItineraryLogChangeFields_AuditedChangeRecordDateTime_Fragment | ItineraryLogChangeFields_AuditedChangeRecordFloat_Fragment | ItineraryLogChangeFields_AuditedChangeRecordInteger_Fragment | ItineraryLogChangeFields_AuditedChangeRecordString_Fragment | ItineraryLogChangeFields_Itinerary_Fragment | ItineraryLogChangeFields_LessonProduct_Fragment | ItineraryLogChangeFields_LiftTicketProduct_Fragment | ItineraryLogChangeFields_PropertyProduct_Fragment | ItineraryLogChangeFields_RentalProduct_Fragment | ItineraryLogChangeFields_TransportationProduct_Fragment | ItineraryLogChangeFields_UpsellProduct_Fragment | ItineraryLogChangeFields_User_Fragment | ItineraryLogChangeFields_UserCreditCard_Fragment;

export type GetItineraryOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryOverviewQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, currency: string, paidAt?: any | null, cancellationCutoffAt?: any | null, data?: any | null, cancelPenalties?: Array<any> | null, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', travelerIdx: number, firstName?: string | null, lastName?: string | null, dob?: any | null }> | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, isCanceled: boolean, arriveAt: any, supplierConfirmationNumber?: string | null, departAt: any, payableAmount: number, amountIncTax: number, fulfilmentState: LineItemFulfilmentStateEnum, specialRequest?: string | null, specialRequestFulfilled: boolean, room: { __typename?: 'PropertyRoom', id: string, name: string }, rate: { __typename?: 'PropertyRoomRate', id: string, refundable: boolean, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null }> | null }, product: { __typename?: 'PropertyProduct', id: string, address?: any | null, checkin: any, checkout: any, name: string, phone?: string | null, descriptions: any, curatedPropertyDatum?: { __typename?: 'CuratedPropertyDatum', checkinSpecialInstructions?: string | null } | null }, resort?: { __typename?: 'Resort', id: string, covidProtocols?: { __typename?: 'ResortCovidProtocol', id: string, name: string, group: string, state: string, country: string, protocol: string, suggestionsLinks?: Array<any> | null, sources?: Array<string> | null } | null } | null }, liftTicketLineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, dob?: any | null, payableAmount: number, supplierConfirmationNumber?: string | null, fulfillmentInstructions?: string | null, fulfilmentState: LineItemFulfilmentStateEnum, firstName?: string | null, lastName?: string | null, productSupplier?: { __typename?: 'ProductSupplier', id: string, cancellationPolicy?: string | null } | null, product: { __typename?: 'LiftTicketProduct', id: string, name: string } } | null> | null }, rentalLineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, dob?: any | null, payableAmount: number, supplierConfirmationNumber?: string | null, fulfillmentInstructions?: string | null, fulfilmentState: LineItemFulfilmentStateEnum, helmetIncluded?: boolean | null, firstName?: string | null, lastName?: string | null, productSupplier?: { __typename?: 'ProductSupplier', id: string, cancellationPolicy?: string | null } | null, product: { __typename?: 'RentalProduct', id: string, name: string, days: number } } | null> | null }, lessonLineItems: { __typename?: 'LessonProductLineItemTypeConnection', nodes?: Array<{ __typename?: 'LessonProductLineItemType', id: string, data: any, travelerIdx: number, isCanceled: boolean, arriveAt: any, dob?: any | null, payableAmount: number, supplierConfirmationNumber?: string | null, fulfilmentInstructionLocation?: string | null, fulfilmentState: LineItemFulfilmentStateEnum, firstName?: string | null, lastName?: string | null, productSupplier?: { __typename?: 'ProductSupplier', id: string, cancellationPolicy?: string | null } | null, product: { __typename?: 'LessonProduct', id: string, sku: string, name: string, checkinTime: string, lessonTime: string } } | null> | null }, transportationLineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, dob?: any | null, payableAmount: number, supplierConfirmationNumber?: string | null, altSupplierConfirmationNumber?: string | null, fulfillmentInstructions?: string | null, fulfilmentState: LineItemFulfilmentStateEnum, firstName?: string | null, lastName?: string | null, productSupplier?: { __typename?: 'ProductSupplier', id: string, cancellationPolicy?: string | null } | null, product: { __typename?: 'TransportationProduct', id: string, name: string } } | null> | null }, upsellLineItems: { __typename?: 'UpsellProductLineItemConnection', nodes?: Array<{ __typename?: 'UpsellProductLineItem', id: string, isCanceled: boolean, payableAmount: number, supplierConfirmationNumber?: string | null, fulfilmentState: LineItemFulfilmentStateEnum } | null> | null } } | null } };

export type ValidateItineraryMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  input: ValidateItineraryInput;
}>;


export type ValidateItineraryMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', validateItinerary?: { __typename?: 'ValidateItineraryPayload', itinerary: { __typename?: 'Itinerary', id: string }, invalidLineItems?: Array<{ __typename?: 'LineItem', id: string }> | null } | null } } | null };

export type GetItineraryOverviewCheckoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryOverviewCheckoutQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, hasLineItemsChanged: boolean, publicId: string, calculatedPriceBreakdown: any, couponDiscount: number, currency: string, totalPayable: number, travelerDetails?: Array<any> | null, cancelPenalties?: Array<any> | null, cancellationCutoffAt?: any | null, sessionId: string, parent?: { __typename?: 'Itinerary', id: string, publicId: string, calculatedPriceBreakdown: any, couponDiscount: number, currency: string, totalPayable: number, travelerDetails?: Array<any> | null, cancelPenalties?: Array<any> | null, cancellationCutoffAt?: any | null, coupon?: { __typename?: 'Coupon', id: string, code?: string | null, currency?: string | null } | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, arriveAt: any, isCanceled: boolean, data: any, departAt: any, inventoryType: string, payableAmount: number, cancelPenalties?: Array<any> | null, fulfilmentState: LineItemFulfilmentStateEnum, manualFulfilment: boolean, hasPriceChanges?: boolean | null, specialRequest?: string | null, room: { __typename?: 'PropertyRoom', id: string, name: string }, bedGroup?: { __typename?: 'BedGroup', id?: string | null, description?: string | null, configuration?: Array<any> | null } | null, rate: { __typename?: 'PropertyRoomRate', id: string, refundable: boolean, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null }> | null }, product: { __typename?: 'PropertyProduct', id: string, name: string, manualFulfilment?: boolean | null } }, liftTicketLineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LiftTicketProduct', id: string, name: string } } | null> | null }, rentalLineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, helmetIncluded?: boolean | null, product: { __typename?: 'RentalProduct', id: string, name: string } } | null> | null }, lessonLineItems: { __typename?: 'LessonProductLineItemTypeConnection', nodes?: Array<{ __typename?: 'LessonProductLineItemType', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LessonProduct', id: string, name: string } } | null> | null }, transportationLineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'TransportationProduct', id: string, name: string } } | null> | null }, upsellLineItems: { __typename?: 'UpsellProductLineItemConnection', nodes?: Array<{ __typename?: 'UpsellProductLineItem', id: string, payableAmount: number } | null> | null } } | null, coupon?: { __typename?: 'Coupon', id: string, code?: string | null, currency?: string | null } | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, inventoryType: string, manualFulfilment: boolean, state: LineItemStateEnum, arriveAt: any, isCanceled: boolean, data: any, departAt: any, payableAmount: number, cancelPenalties?: Array<any> | null, fulfilmentState: LineItemFulfilmentStateEnum, hasPriceChanges?: boolean | null, specialRequest?: string | null, room: { __typename?: 'PropertyRoom', id: string, name: string }, bedGroup?: { __typename?: 'BedGroup', id?: string | null, description?: string | null, configuration?: Array<any> | null } | null, rate: { __typename?: 'PropertyRoomRate', id: string, refundable: boolean, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null }> | null }, product: { __typename?: 'PropertyProduct', id: string, name: string, manualFulfilment?: boolean | null } }, liftTicketLineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LiftTicketProduct', id: string, name: string } } | null> | null }, rentalLineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, helmetIncluded?: boolean | null, product: { __typename?: 'RentalProduct', id: string, name: string } } | null> | null }, lessonLineItems: { __typename?: 'LessonProductLineItemTypeConnection', nodes?: Array<{ __typename?: 'LessonProductLineItemType', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LessonProduct', id: string, name: string } } | null> | null }, transportationLineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'TransportationProduct', id: string, name: string } } | null> | null }, upsellLineItems: { __typename?: 'UpsellProductLineItemConnection', nodes?: Array<{ __typename?: 'UpsellProductLineItem', id: string, payableAmount: number } | null> | null }, userCreditCards: { __typename?: 'UserCreditCardConnection', nodes?: Array<{ __typename?: 'UserCreditCard', id: string, last4: string, cardType: string, defaultCard: boolean } | null> | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null } };

export type ItineraryCheckoutOverviewFieldsFragment = { __typename?: 'Itinerary', id: string, publicId: string, calculatedPriceBreakdown: any, couponDiscount: number, currency: string, totalPayable: number, travelerDetails?: Array<any> | null, cancelPenalties?: Array<any> | null, cancellationCutoffAt?: any | null, coupon?: { __typename?: 'Coupon', id: string, code?: string | null, currency?: string | null } | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, arriveAt: any, isCanceled: boolean, data: any, departAt: any, inventoryType: string, payableAmount: number, cancelPenalties?: Array<any> | null, fulfilmentState: LineItemFulfilmentStateEnum, manualFulfilment: boolean, hasPriceChanges?: boolean | null, specialRequest?: string | null, room: { __typename?: 'PropertyRoom', id: string, name: string }, bedGroup?: { __typename?: 'BedGroup', id?: string | null, description?: string | null, configuration?: Array<any> | null } | null, rate: { __typename?: 'PropertyRoomRate', id: string, refundable: boolean, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null }> | null }, product: { __typename?: 'PropertyProduct', id: string, name: string, manualFulfilment?: boolean | null } }, liftTicketLineItems: { __typename?: 'LiftTicketProductLineItemConnection', nodes?: Array<{ __typename?: 'LiftTicketProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LiftTicketProduct', id: string, name: string } } | null> | null }, rentalLineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, helmetIncluded?: boolean | null, product: { __typename?: 'RentalProduct', id: string, name: string } } | null> | null }, lessonLineItems: { __typename?: 'LessonProductLineItemTypeConnection', nodes?: Array<{ __typename?: 'LessonProductLineItemType', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LessonProduct', id: string, name: string } } | null> | null }, transportationLineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'TransportationProduct', id: string, name: string } } | null> | null }, upsellLineItems: { __typename?: 'UpsellProductLineItemConnection', nodes?: Array<{ __typename?: 'UpsellProductLineItem', id: string, payableAmount: number } | null> | null } };

export type GetItineraryPaymentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeFailed?: InputMaybe<Scalars['Boolean']['input']>;
  trxnType?: InputMaybe<Array<PaymentTrxnTypeEnum> | PaymentTrxnTypeEnum>;
  skip: Scalars['Boolean']['input'];
}>;


export type GetItineraryPaymentsQuery = { __typename?: 'QueryType', itinerary?: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, state: ItineraryStateEnum, couponCode?: string | null, couponDiscount: number, currency: string, paidAt?: any | null, userCreditCards: { __typename?: 'UserCreditCardConnection', nodes?: Array<{ __typename?: 'UserCreditCard', id: string, cardType: string, defaultCard: boolean, expiresAt: any, last4: string } | null> | null }, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, rate: { __typename?: 'PropertyRoomRate', id: string, merchantOfRecord: string } }, child?: { __typename?: 'Itinerary', id: string, publicId: string, state: ItineraryStateEnum } | null, payments?: { __typename?: 'PaymentConnection', nodes?: Array<{ __typename?: 'Payment', id: string, amount: number, cardType?: string | null, last4?: string | null, createdAt: any, currency: string, notes?: string | null, reason?: PaymentReasonEnum | null, refundable: boolean, refundableAmount: number, state: PaymentStateEnum, type: PaymentMethodEnum, trxnNumber?: string | null, trxnType?: PaymentTrxnTypeEnum | null, refunds?: { __typename?: 'PaymentConnection', nodes?: Array<{ __typename?: 'Payment', id: string, amount: number, createdAt: any, currency: string, notes?: string | null, reason?: PaymentReasonEnum | null, state: PaymentStateEnum, trxnType?: PaymentTrxnTypeEnum | null } | null> | null } | null } | null> | null } | null, snowpakScheduledPayments?: { __typename?: 'ScheduledPaymentConnection', nodes?: Array<{ __typename?: 'ScheduledPayment', id: string, amount: number, currency: string, chargeable: boolean, collectionSource?: ScheduledPaymentCollectionSourceEnum | null, processAt: any, processed: boolean, paymentType: string, isModified: boolean, state: ScheduledPaymentStateEnum, payment?: { __typename?: 'Payment', id: string } | null, lineItem: { __typename?: 'LineItem', id: string, product: { __typename: 'LessonProduct', id: string, name: string } | { __typename: 'LiftTicketProduct', id: string, name: string } | { __typename: 'PropertyProduct', id: string, name: string } | { __typename: 'RentalProduct', id: string, name: string } | { __typename: 'TransportationProduct', id: string, name: string } | { __typename: 'UpsellProduct', id: string, name: string } } } | null> | null } | null, expediaScheduledPayments?: { __typename?: 'ScheduledPaymentConnection', nodes?: Array<{ __typename?: 'ScheduledPayment', id: string, amount: number, currency: string, chargeable: boolean, collectionSource?: ScheduledPaymentCollectionSourceEnum | null, processAt: any, processed: boolean, paymentType: string, isModified: boolean, state: ScheduledPaymentStateEnum, payment?: { __typename?: 'Payment', id: string } | null, lineItem: { __typename?: 'LineItem', id: string, product: { __typename: 'LessonProduct', id: string, name: string } | { __typename: 'LiftTicketProduct', id: string, name: string } | { __typename: 'PropertyProduct', id: string, name: string } | { __typename: 'RentalProduct', id: string, name: string } | { __typename: 'TransportationProduct', id: string, name: string } | { __typename: 'UpsellProduct', id: string, name: string } } } | null> | null } | null, coupon?: { __typename?: 'Coupon', id: string, code?: string | null, currency?: string | null, discountValue?: number | null, reason?: ProductDiscountReasonEnum | null } | null, relatedCoupons: Array<{ __typename?: 'Coupon', id: string, code?: string | null, currency?: string | null, discountValue?: number | null, reason?: ProductDiscountReasonEnum | null }> } | null } };

export type ItineraryPostBookingCallsFieldsFragment = { __typename?: 'Itinerary', id: string, main: { __typename?: 'Itinerary', id: string, publicId: string, internalId: string, postBookingCalls?: { __typename?: 'PostBookingCallConnection', nodes?: Array<{ __typename?: 'PostBookingCall', id: string, comments?: string | null, createdAt: any, outcome: PostBookingCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null> | null } | null } };

export type GetHelmetPriceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetHelmetPriceQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, product: { __typename?: 'PropertyProduct', id: string, rentalLocations: { __typename?: 'RentalLocationConnection', nodes?: Array<{ __typename?: 'RentalLocation', id: string, helmetAvailable?: boolean | null, helmetPrice: number, resort: { __typename?: 'Resort', id: string, slug: string } } | null> | null } } } } | null } };

export type ItineraryPreArrivalCallsFieldsFragment = { __typename?: 'Itinerary', id: string, main: { __typename?: 'Itinerary', id: string, publicId: string, internalId: string, preArrivalCalls?: { __typename?: 'PreArrivalCallConnection', nodes?: Array<{ __typename?: 'PreArrivalCall', id: string, comments?: string | null, createdAt: any, outcome: PreArrivalCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null> | null } | null } };

export type GetSnowPakLinksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSnowPakLinksQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, sessionId: string, currency: string, state: ItineraryStateEnum, isPaid: boolean, skicomQuoteId?: number | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, arriveAt: any, departAt: any, data: any, product: { __typename?: 'PropertyProduct', id: string, name: string } } } | null } };

export type GetRentalLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRentalLineItemsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, arriveAt: any, departAt: any, currency: string, isDraftDuplicate: boolean, publicId: string, isPaid: boolean, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', normalizedFirstName?: string | null, normalizedLastName?: string | null, dob?: any | null, gender?: GenderEnum | null, travelerIdx: number }> | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, product: { __typename?: 'PropertyProduct', id: string, rentalLocations: { __typename?: 'RentalLocationConnection', nodes?: Array<{ __typename?: 'RentalLocation', id: string, isPremium: boolean, premium: any, resort: { __typename?: 'Resort', id: string, slug: string } } | null> | null } }, resort?: { __typename?: 'Resort', id: string, slug: string, name: string } | null }, lineItems: { __typename?: 'RentalProductLineItemConnection', nodes?: Array<{ __typename?: 'RentalProductLineItem', id: string, data: any, travelerIdx: number, arriveAt: any, dob?: any | null, costAmount?: number | null, costAmountCurrency?: string | null, currency: string, payableAmount: number, hasPriceChanges?: boolean | null, fulfillmentInstructions?: string | null, height?: string | null, weight?: string | null, gender?: string | null, shoeSize?: string | null, deliverTo?: string | null, pickupAt?: string | null, dropoffAt?: string | null, helmetIncluded?: boolean | null, fulfilmentState: LineItemFulfilmentStateEnum, supplierOrderId?: string | null, supplierConfirmationNumber?: string | null, zendeskTicket?: string | null, skillLevel?: SkillLevelEnum | null, crosscheck?: boolean | null, firstName?: string | null, lastName?: string | null, rentalLocation?: { __typename?: 'RentalLocation', id: string, name: string, storeName?: string | null, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, currency?: ProductSupplierCurrencyEnum | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null } | null } | null, product: { __typename?: 'RentalProduct', id: string, sku: string, days: number, name: string, payable?: number | null, daysInAdvance: number, resort: { __typename?: 'Resort', id: string, name: string, slug: string, productSuppliers: Array<{ __typename?: 'ProductSupplier', id: string, name?: string | null, shortName: string, currency?: ProductSupplierCurrencyEnum | null }> } }, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, currency?: ProductSupplierCurrencyEnum | null, vouchersRequired?: boolean | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null } | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } } | null } };

export type SearchItinerariesQueryVariables = Exact<{
  filter?: InputMaybe<ItinerarySearchResolverFilterInput>;
  orderBy?: InputMaybe<Array<SearchkickOrderByInput> | SearchkickOrderByInput>;
  skip: Scalars['Boolean']['input'];
}>;


export type SearchItinerariesQuery = { __typename?: 'QueryType', itineraries?: { __typename?: 'ItinerarySearchkickConnection', edges?: Array<{ __typename?: 'ItinerarySearchkickResultEdge', node?: { __typename?: 'ItinerarySearchkickResult', id: string, arriveAt: any, email?: any | null, normalizedFirstName?: string | null, normalizedLastName?: string | null, state: ItineraryStateEnum, fulfilmentState: ItineraryFulfilmentStateEnum, propertyName: string, publicId: string, resortName: string } | null } | null> | null } };

export type ItineraryDuplicationTreeFieldsFragment = { __typename?: 'Itinerary', id: string, internalId: string, isConfirmed: boolean, parentId?: string | null, publicId: string, state: ItineraryStateEnum, duplicated: Array<{ __typename?: 'Itinerary', id: string, internalId: string, isConfirmed: boolean, parentId?: string | null, publicId: string, state: ItineraryStateEnum }> };

export type GetItineraryTreeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryTreeQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, internalId: string, isConfirmed: boolean, parentId?: string | null, publicId: string, state: ItineraryStateEnum, main: { __typename?: 'Itinerary', id: string, internalId: string, isConfirmed: boolean, parentId?: string | null, publicId: string, state: ItineraryStateEnum, duplicated: Array<{ __typename?: 'Itinerary', id: string, internalId: string, isConfirmed: boolean, parentId?: string | null, publicId: string, state: ItineraryStateEnum }> }, duplicated: Array<{ __typename?: 'Itinerary', id: string, internalId: string, isConfirmed: boolean, parentId?: string | null, publicId: string, state: ItineraryStateEnum }> } | null } };

export type GetItinerarySupportCasesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  skip: Scalars['Boolean']['input'];
}>;


export type GetItinerarySupportCasesQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, mainId: string, main: { __typename?: 'Itinerary', id: string, supportCases: Array<{ __typename?: 'SupportCase', id: string, action: SupportCaseActionEnum, caseType: SupportCaseTypeEnum, category: SupportCaseCategoryEnum, subcategory: SupportCaseSubcategoryEnum, notes?: string | null, createdAt: any, updatedAt: any, zendeskTicket?: string | null, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, supportNotes: Array<{ __typename?: 'SupportNote', id: string, content: string, zendeskTicket?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null }> }> } } | null } };

export type GetTransportationLineItemsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTransportationLineItemsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, sessionId: string, arriveAt: any, departAt: any, currency: string, data?: any | null, isDraftDuplicate: boolean, isPaid: boolean, isCancelled: boolean, totalAmount: number, totalPayable: number, couponDiscount: number, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', normalizedFirstName?: string | null, normalizedLastName?: string | null, dob?: any | null, travelerIdx: number }> | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, isCanceled: boolean, arriveAt: any, departAt: any, resort?: { __typename?: 'Resort', id: string, slug: string, showForOutboundTransfer: boolean, name: string, airports: { __typename?: 'ResortAirportConnection', edges?: Array<{ __typename?: 'ResortAirportEdge', node?: { __typename?: 'Airport', id: string, name: string, iataCode: string } | null } | null> | null } } | null, product: { __typename?: 'PropertyProduct', id: string, address?: any | null, name: string } }, lineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string, travelerIdx: number, arriveAt: any, dob?: any | null, costAmount?: number | null, costAmountCurrency?: string | null, currency: string, payableAmount: number, hasPriceChanges?: boolean | null, fulfillmentInstructions?: string | null, flightArrival?: any | null, flightDeparture?: any | null, flightHash?: string | null, isCanceled: boolean, fulfilmentState: LineItemFulfilmentStateEnum, supplierOrderId?: string | null, altSupplierOrderId?: string | null, supplierConfirmationNumber?: string | null, altSupplierConfirmationNumber?: string | null, crosscheck?: boolean | null, supplierPickupDate?: any | null, altSupplierPickupDate?: any | null, supplierPickupTime?: string | null, altSupplierPickupTime?: string | null, firstName?: string | null, lastName?: string | null, product: { __typename?: 'TransportationProduct', id: string, name: string, daysInAdvance: number, resort: { __typename?: 'Resort', id: string, name: string, slug: string, productSuppliers: Array<{ __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, mainSupplier?: boolean | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, currency?: ProductSupplierCurrencyEnum | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null, pickupTimeLocation?: ProductSupplierPickupTimeLocationEnum | null, productType: ProductSupplierProductTypeEnum }> } }, productSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, currency?: ProductSupplierCurrencyEnum | null, vouchersRequired?: boolean | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null, pickupTimeLocation?: ProductSupplierPickupTimeLocationEnum | null, productType: ProductSupplierProductTypeEnum } | null, altProductSupplier?: { __typename?: 'ProductSupplier', id: string, name?: string | null, url?: string | null, bookingPortalType?: string | null, cancellationPolicy?: string | null, confirmationNumberInstruction?: string | null, vouchersRequired?: boolean | null, shortName: string, order?: number | null, username?: string | null, password?: string | null, spreadsheetUrl?: string | null, email?: string | null, fulfilmentNotes?: string | null, pickupTimeLocation?: ProductSupplierPickupTimeLocationEnum | null, productType: ProductSupplierProductTypeEnum } | null, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } } | null } };

export type GetTravelerDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTravelerDetailsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, sessionId: string, arriveAt: any, isDuplicated: boolean, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', travelerIdx: number, normalizedFirstName?: string | null, normalizedLastName?: string | null, dob?: any | null, gender?: GenderEnum | null, height?: string | null, weight?: string | null, shoeSize?: string | null, skillLevel?: SkillLevelEnum | null, pickupAt?: any | null, zendeskTicket?: string | null }> | null } | null } };

export type ItineraryZendeskLinksFieldsFragment = { __typename?: 'Itinerary', publicId: string, normalizedFirstName?: string | null, normalizedLastName?: string | null, phone?: string | null, email?: any | null, main: { __typename?: 'Itinerary', id: string, email?: any | null, publicId: string } };

export type AssignItineraryAgentMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  input: AssignAgentInput;
}>;


export type AssignItineraryAgentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', assignAgent?: { __typename?: 'AssignAgentPayload', itinerary: { __typename?: 'Itinerary', id: string, internalId: string, fulfilmentAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, customerAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, liftTicketAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, rentalAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, lessonAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, transportationAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, f4Agent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, requestedAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, inProgressAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, flightInfoAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, postBookingAgent?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null } } | null } } | null };

export type UpdateTableNotesMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateTableNotesInput;
}>;


export type UpdateTableNotesMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateTableNotes?: { __typename?: 'UpdateTableNotesPayload', itinerary: { __typename?: 'Itinerary', id: string, data?: any | null } } | null } } | null };

export type UpdateSupportCaseAgentMutationVariables = Exact<{
  input: MutationsSupportCaseUpdateInput;
}>;


export type UpdateSupportCaseAgentMutation = { __typename?: 'Mutation', supportCase: { __typename?: 'SupportCaseMutations', update?: { __typename?: 'MutationsSupportCaseUpdatePayload', supportCase?: { __typename?: 'SupportCase', id: string, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null } | null } | null } };

export type GetUsersQueryVariables = Exact<{
  isAdmin: Scalars['Boolean']['input'];
}>;


export type GetUsersQuery = { __typename?: 'QueryType', users: { __typename?: 'UserConnection', nodes?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null> | null } };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'QueryType', apexReady: boolean, regions: { __typename?: 'RegionConnection', nodes?: Array<{ __typename?: 'Region', id: string, name: string } | null> | null } };

export type GetPropertyQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
}>;


export type GetPropertyQuery = { __typename?: 'QueryType', product: { __typename?: 'TypesProductQueryType', propertyNew?: { __typename?: 'PropertyProduct', id: string, name: string } | null } };

export type CreateProductSupplierMutationVariables = Exact<{
  input: MutationsProductSupplierCreateInput;
}>;


export type CreateProductSupplierMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', create?: { __typename?: 'MutationsProductSupplierCreatePayload', productSupplier?: { __typename?: 'ProductSupplier', id: string } | null } | null } };

export type GetResortsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResortsQuery = { __typename?: 'QueryType', apexReady: boolean, resorts: { __typename?: 'ResortConnection', nodes?: Array<{ __typename?: 'Resort', id: string, name: string, skicomId?: number | null, availableLiftTicketsCount: number } | null> | null } };

export type GetProductSupplierLockStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductSupplierLockStateQuery = { __typename?: 'QueryType', productSupplier?: { __typename?: 'ProductSupplier', id: string, lock: { __typename?: 'TypesLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } | null };

export type LockProductSupplierMutationVariables = Exact<{
  input: MutationsProductSupplierLockInput;
}>;


export type LockProductSupplierMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', lock?: { __typename?: 'MutationsProductSupplierLockPayload', productSupplier: { __typename?: 'ProductSupplier', id: string, lock: { __typename?: 'TypesLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } } | null } };

export type ActivateProductSupplierMutationVariables = Exact<{
  input: MutationsProductSupplierActivateInput;
}>;


export type ActivateProductSupplierMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', activate?: { __typename?: 'MutationsProductSupplierActivatePayload', productSupplier?: { __typename?: 'ProductSupplier', id: string } | null } | null } };

export type UnlockProductSupplierMutationVariables = Exact<{
  input: MutationsProductSupplierUnlockInput;
}>;


export type UnlockProductSupplierMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', unlock?: { __typename?: 'MutationsProductSupplierUnlockPayload', productSupplier: { __typename?: 'ProductSupplier', id: string, lock: { __typename?: 'TypesLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } } | null } };

export type GetProductSupplierFulfilmentAttachmentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetProductSupplierFulfilmentAttachmentsQuery = { __typename?: 'QueryType', productSupplier?: { __typename?: 'ProductSupplier', id: string, fulfilmentAttachments: { __typename?: 'ActiveStorageConnection', nodes?: Array<{ __typename?: 'ActiveStorage', id: string, filename: string, url?: string | null, createdAt: any } | null> | null } } | null };

export type ProductSupplierCreateAttachmentMutationVariables = Exact<{
  input: MutationsProductSupplierCreateAttachmentInput;
}>;


export type ProductSupplierCreateAttachmentMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', createAttachment?: { __typename?: 'MutationsProductSupplierCreateAttachmentPayload', productSupplier: { __typename?: 'ProductSupplier', id: string } } | null } };

export type GetProductSupplierShortNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductSupplierShortNamesQuery = { __typename?: 'QueryType', productSupplierShortNames: Array<string> };

export type GetItineraryFulfilmentAttachmentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryFulfilmentAttachmentsQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, fulfilmentAttachments: { __typename?: 'ActiveStorageConnection', nodes?: Array<{ __typename?: 'ActiveStorage', id: string, filename: string, url?: string | null } | null> | null } } | null } };

export type DeactivateProductSupplierMutationVariables = Exact<{
  input: MutationsProductSupplierDeactivateInput;
}>;


export type DeactivateProductSupplierMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', deactivate?: { __typename?: 'MutationsProductSupplierDeactivatePayload', productSupplier?: { __typename?: 'ProductSupplier', id: string } | null } | null } };

export type CreateDirectUploadMutationVariables = Exact<{
  input: CreateDirectUploadInput;
}>;


export type CreateDirectUploadMutation = { __typename?: 'Mutation', createDirectUpload?: { __typename?: 'CreateDirectUploadPayload', directUpload: { __typename?: 'DirectUpload', id: string, url: string, headers: string, blobId: string, signedBlobId: string } } | null };

export type CreditCardCreateMutationVariables = Exact<{
  input: MutationsCreditCardCreateInput;
}>;


export type CreditCardCreateMutation = { __typename?: 'Mutation', creditCard: { __typename?: 'CreditCardMutations', create?: { __typename?: 'MutationsCreditCardCreatePayload', creditCard: { __typename?: 'UserCreditCard', id: string } } | null } };

export type GetProductSupplierProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductSupplierProductsQuery = { __typename?: 'QueryType', productSupplierProducts?: Array<string> | null };

export type ItineraryCreateAttachmentMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: CreateAttachmentInput;
}>;


export type ItineraryCreateAttachmentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', createAttachment?: { __typename?: 'CreateAttachmentPayload', itinerary: { __typename?: 'Itinerary', id: string } } | null } } | null };

export type UserCreditCardFormFieldsFragment = { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null };

export type GetItineraryLockStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetItineraryLockStateQuery = { __typename?: 'QueryType', itinerary: { __typename?: 'TypesItineraryQueryType', itinerary?: { __typename?: 'Itinerary', id: string, state: ItineraryStateEnum, firstName?: string | null, lock: { __typename?: 'TypesItineraryItineraryLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } | null } };

export type LockItineraryMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: TypesItineraryMutationsLockInput;
}>;


export type LockItineraryMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', lock?: { __typename?: 'TypesItineraryMutationsLockPayload', itinerary: { __typename?: 'Itinerary', id: string, lock: { __typename?: 'TypesItineraryItineraryLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } } | null } } | null };

export type UpdateCustomerInfoMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  input?: InputMaybe<ItineraryInput>;
}>;


export type UpdateCustomerInfoMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', update?: { __typename?: 'Itinerary', id: string, publicId: string } | null } } | null };

export type UnlockItineraryMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: TypesItineraryMutationsUnlockInput;
}>;


export type UnlockItineraryMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', unlock?: { __typename?: 'TypesItineraryMutationsUnlockPayload', itinerary: { __typename?: 'Itinerary', id: string, lock: { __typename?: 'TypesItineraryItineraryLockType', lockedAt?: any | null, lockedBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null } } } | null } } | null };

export type UpdateTravelerDetailsMutationVariables = Exact<{
  itinerarySessionId: Scalars['ID']['input'];
  travelerDetails?: InputMaybe<Array<InputMaybe<TravelerDetailInput>> | InputMaybe<TravelerDetailInput>>;
}>;


export type UpdateTravelerDetailsMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateTravelerDetails?: { __typename?: 'Itinerary', id: string, normalizedTravelerDetails?: Array<{ __typename?: 'TravelerDetail', travelerIdx: number, normalizedFirstName?: string | null, normalizedLastName?: string | null, dob?: any | null, gender?: GenderEnum | null, height?: string | null, weight?: string | null, shoeSize?: string | null, skillLevel?: SkillLevelEnum | null, pickupAt?: any | null, zendeskTicket?: string | null }> | null } | null } } | null };

export type UpdatePropertyLineItemMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  input: UpdatePropertyLineItemInput;
}>;


export type UpdatePropertyLineItemMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updatePropertyLineItem?: { __typename?: 'UpdatePropertyLineItemPayload', itinerary: { __typename?: 'Itinerary', id: string, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, hasOverrideData: boolean, specialRequestFulfilled: boolean } }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type AddPropertyMutationVariables = Exact<{
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId?: InputMaybe<Scalars['ID']['input']>;
  startAt: Scalars['Date']['input'];
  endAt: Scalars['Date']['input'];
  occupancy: Array<Scalars['ExpediaPropertyRoomOccupancy']['input']> | Scalars['ExpediaPropertyRoomOccupancy']['input'];
  priceCheckingToken: Scalars['String']['input'];
  paymentOptionsToken: Scalars['String']['input'];
  rateId: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
  sku: Scalars['ID']['input'];
  cancelPenalties?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>> | InputMaybe<Scalars['JSON']['input']>>;
  resort: Scalars['JSON']['input'];
  refundable: Scalars['Boolean']['input'];
  merchantOfRecord: Scalars['String']['input'];
  depositPolicies?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>> | InputMaybe<Scalars['JSON']['input']>>;
  rate: Scalars['JSON']['input'];
}>;


export type AddPropertyMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addProperty?: { __typename?: 'AddPropertyPayload', itinerary: { __typename?: 'Itinerary', id: string, publicId: string }, lineItem: { __typename?: 'LineItem', id: string } } | null } } | null };

export type GetPropertyAvailabilityQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  arrival: Scalars['Date']['input'];
  departure: Scalars['Date']['input'];
  occupancy: Array<Scalars['ExpediaPropertyRoomOccupancy']['input']> | Scalars['ExpediaPropertyRoomOccupancy']['input'];
  isPackage: Scalars['Boolean']['input'];
}>;


export type GetPropertyAvailabilityQuery = { __typename?: 'QueryType', product: { __typename?: 'TypesProductQueryType', propertyNew?: { __typename?: 'PropertyProduct', id: string, name: string, resortsOld?: Array<{ __typename?: 'Resort', id: string, name: string, slug: string, region: { __typename?: 'Region', id: string, slug: string } }> | null, rooms: Array<{ __typename?: 'PropertyRoom', id: string, name: string, rates: Array<{ __typename?: 'PropertyRoomRate', id: string, availableRooms: number, cancelPenalties?: Array<any> | null, currency: string, depositRequired: boolean, discount: number, merchantOfRecord: string, payable: number, refundable: boolean, strikethrough?: number | null, tokens: any, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null, tokens?: any | null }> | null }> }> } | null } };

export type ApplyCouponMutationVariables = Exact<{
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  force: Scalars['Boolean']['input'];
}>;


export type ApplyCouponMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', applyCoupon?: { __typename?: 'Itinerary', couponDiscount: number, coupon?: { __typename?: 'Coupon', id: string, remainingAmount: number } | null } | null } } | null };

export type UpdateContactDetailMutationVariables = Exact<{
  itineraryId?: InputMaybe<Scalars['ID']['input']>;
  lineItemId: Scalars['ID']['input'];
  data: PropertyLineItem;
}>;


export type UpdateContactDetailMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateProperty?: { __typename?: 'UpdatePropertyPayload', itinerary: { __typename?: 'Itinerary', id: string, publicId: string } } | null } } | null };

export type CovidProtocolFieldsFragment = { __typename?: 'Resort', covidProtocols?: { __typename?: 'ResortCovidProtocol', id: string, name: string, group: string, state: string, country: string, protocol: string, suggestionsLinks?: Array<any> | null, sources?: Array<string> | null } | null };

export type FinalizeDuplicateMutationVariables = Exact<{
  itinerarySessionId?: InputMaybe<Scalars['ID']['input']>;
  input: FinalizeDuplicateInput;
}>;


export type FinalizeDuplicateMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', finalizeDuplicate?: { __typename?: 'FinalizeDuplicatePayload', itinerary: { __typename?: 'Itinerary', id: string } } | null } } | null };

export type PropertyProductLineItemCheckoutOverviewFieldsFragment = { __typename?: 'PropertyProductLineItem', id: string, arriveAt: any, isCanceled: boolean, data: any, departAt: any, inventoryType: string, payableAmount: number, cancelPenalties?: Array<any> | null, fulfilmentState: LineItemFulfilmentStateEnum, manualFulfilment: boolean, hasPriceChanges?: boolean | null, specialRequest?: string | null, room: { __typename?: 'PropertyRoom', id: string, name: string }, bedGroup?: { __typename?: 'BedGroup', id?: string | null, description?: string | null, configuration?: Array<any> | null } | null, rate: { __typename?: 'PropertyRoomRate', id: string, refundable: boolean, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null }> | null }, product: { __typename?: 'PropertyProduct', id: string, name: string, manualFulfilment?: boolean | null } };

export type GetPropertyRoomsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPropertyRoomsQuery = { __typename?: 'QueryType', product: { __typename?: 'TypesProductQueryType', property?: { __typename?: 'PropertyProduct', id: string, rooms: Array<{ __typename?: 'PropertyRoom', id: string, name: string, bedGroups: Array<{ __typename?: 'BedGroup', id?: string | null, description?: string | null, configuration?: Array<any> | null }> }> } | null } };

export type ItineraryDuplicateCheckoutFieldsFragment = { __typename?: 'Itinerary', id: string, publicId: string, sessionId: string, cancelPenalties?: Array<any> | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, inventoryType: string, manualFulfilment: boolean, state: LineItemStateEnum }, userCreditCards: { __typename?: 'UserCreditCardConnection', nodes?: Array<{ __typename?: 'UserCreditCard', id: string, last4: string, cardType: string, defaultCard: boolean } | null> | null }, user?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null };

export type AddScheduledPaymentMutationVariables = Exact<{
  itineraryId: Scalars['ID']['input'];
  input: AddScheduledPaymentInput;
}>;


export type AddScheduledPaymentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', addScheduledPayment?: { __typename?: 'AddScheduledPaymentPayload', itinerary: { __typename?: 'Itinerary', id: string, scheduledPayments?: { __typename?: 'ScheduledPaymentConnection', nodes?: Array<{ __typename?: 'ScheduledPayment', id: string, amount: number, processAt: any } | null> | null } | null } } | null } } | null };

export type LessonProductLineItemCheckoutOverviewFieldsFragment = { __typename?: 'LessonProductLineItemType', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LessonProduct', id: string, name: string } };

export type LiftTicketProductLineItemCheckoutOverviewFieldsFragment = { __typename?: 'LiftTicketProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'LiftTicketProduct', id: string, name: string } };

export type PaymentTableFieldsFragment = { __typename?: 'Payment', id: string, amount: number, cardType?: string | null, last4?: string | null, createdAt: any, currency: string, notes?: string | null, reason?: PaymentReasonEnum | null, refundable: boolean, refundableAmount: number, state: PaymentStateEnum, type: PaymentMethodEnum, trxnNumber?: string | null, trxnType?: PaymentTrxnTypeEnum | null, refunds?: { __typename?: 'PaymentConnection', nodes?: Array<{ __typename?: 'Payment', id: string, amount: number, createdAt: any, currency: string, notes?: string | null, reason?: PaymentReasonEnum | null, state: PaymentStateEnum, trxnType?: PaymentTrxnTypeEnum | null } | null> | null } | null };

export type PaymentProcessChargeMutationVariables = Exact<{
  input: MutationsPaymentProcessChargeInput;
}>;


export type PaymentProcessChargeMutation = { __typename?: 'Mutation', payment: { __typename?: 'PaymentMutations', processCharge?: { __typename?: 'MutationsPaymentProcessChargePayload', payment?: { __typename?: 'Payment', id: string, amount: number, trxnNumber?: string | null, trxnType?: PaymentTrxnTypeEnum | null } | null, itinerary?: { __typename?: 'Itinerary', id: string, payments?: { __typename?: 'PaymentConnection', edges?: Array<{ __typename?: 'PaymentEdge', node?: { __typename?: 'Payment', id: string } | null } | null> | null } | null } | null } | null } };

export type ScheduledPaymentMarkAsPaidMutationVariables = Exact<{
  input: MutationsScheduledPaymentMarkAsPaidInput;
}>;


export type ScheduledPaymentMarkAsPaidMutation = { __typename?: 'Mutation', scheduledPayment: { __typename?: 'ScheduledPaymentMutations', markAsPaid?: { __typename?: 'MutationsScheduledPaymentMarkAsPaidPayload', itinerary?: { __typename?: 'Itinerary', id: string } | null } | null } };

export type RentalProductLineItemCheckoutOverviewFieldsFragment = { __typename?: 'RentalProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, helmetIncluded?: boolean | null, product: { __typename?: 'RentalProduct', id: string, name: string } };

export type UserCreditCardPaymentProcessFieldsFragment = { __typename?: 'UserCreditCard', id: string, cardType: string, defaultCard: boolean, expiresAt: any, last4: string };

export type ScheduledPaymentProcessChargeMutationVariables = Exact<{
  input: MutationsScheduledPaymentProcessChargeInput;
}>;


export type ScheduledPaymentProcessChargeMutation = { __typename?: 'Mutation', scheduledPayment: { __typename?: 'ScheduledPaymentMutations', processCharge?: { __typename?: 'MutationsScheduledPaymentProcessChargePayload', itinerary?: { __typename?: 'Itinerary', id: string } | null } | null } };

export type ScheduledPaymentTableFieldsFragment = { __typename?: 'ScheduledPayment', id: string, amount: number, currency: string, chargeable: boolean, collectionSource?: ScheduledPaymentCollectionSourceEnum | null, processAt: any, processed: boolean, paymentType: string, isModified: boolean, state: ScheduledPaymentStateEnum, payment?: { __typename?: 'Payment', id: string } | null, lineItem: { __typename?: 'LineItem', id: string, product: { __typename: 'LessonProduct', id: string, name: string } | { __typename: 'LiftTicketProduct', id: string, name: string } | { __typename: 'PropertyProduct', id: string, name: string } | { __typename: 'RentalProduct', id: string, name: string } | { __typename: 'TransportationProduct', id: string, name: string } | { __typename: 'UpsellProduct', id: string, name: string } } };

export type PaymentProcessRefundMutationVariables = Exact<{
  input: MutationsPaymentProcessRefundInput;
}>;


export type PaymentProcessRefundMutation = { __typename?: 'Mutation', payment: { __typename?: 'PaymentMutations', processRefund?: { __typename?: 'MutationsPaymentProcessRefundPayload', payment: { __typename?: 'Payment', id: string }, refund: { __typename?: 'Payment', id: string } } | null } };

export type UpdateScheduledPaymentMutationVariables = Exact<{
  itineraryId: Scalars['ID']['input'];
  input: UpdateScheduledPaymentInput;
}>;


export type UpdateScheduledPaymentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateScheduledPayment?: { __typename?: 'UpdateScheduledPaymentPayload', itinerary: { __typename?: 'Itinerary', id: string, scheduledPayments?: { __typename?: 'ScheduledPaymentConnection', nodes?: Array<{ __typename?: 'ScheduledPayment', id: string, amount: number, processAt: any, isModified: boolean } | null> | null } | null } } | null } } | null };

export type PostBookingCallCreateMutationVariables = Exact<{
  input: MutationsPostBookingCallCreateInput;
}>;


export type PostBookingCallCreateMutation = { __typename?: 'Mutation', postBookingCall: { __typename?: 'PostBookingCallMutations', create?: { __typename?: 'MutationsPostBookingCallCreatePayload', itinerary: { __typename?: 'Itinerary', id: string, postBookingCalls?: { __typename?: 'PostBookingCallConnection', nodes?: Array<{ __typename?: 'PostBookingCall', id: string, comments?: string | null, createdAt: any, outcome: PostBookingCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null> | null } | null } } | null } };

export type PostBookingCallUpdateMutationVariables = Exact<{
  input: MutationsPostBookingCallUpdateInput;
}>;


export type PostBookingCallUpdateMutation = { __typename?: 'Mutation', postBookingCall: { __typename?: 'PostBookingCallMutations', update?: { __typename?: 'MutationsPostBookingCallUpdatePayload', postBookingCall?: { __typename?: 'PostBookingCall', id: string, comments?: string | null, createdAt: any, outcome: PostBookingCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null } | null } };

export type TransportationProductLineItemCheckoutOverviewFieldsFragment = { __typename?: 'TransportationProductLineItem', id: string, travelerIdx: number, isCanceled: boolean, arriveAt: any, firstName?: string | null, lastName?: string | null, dob?: any | null, payableAmount: number, product: { __typename?: 'TransportationProduct', id: string, name: string } };

export type PreArrivalCallUpdateMutationVariables = Exact<{
  input: MutationsPreArrivalCallUpdateInput;
}>;


export type PreArrivalCallUpdateMutation = { __typename?: 'Mutation', preArrivalCall: { __typename?: 'PreArrivalCallMutations', update?: { __typename?: 'MutationsPreArrivalCallUpdatePayload', preArrivalCall?: { __typename?: 'PreArrivalCall', id: string, comments?: string | null, createdAt: any, outcome: PreArrivalCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null } | null } };

export type PreArrivalCallCreateMutationVariables = Exact<{
  input: MutationsPreArrivalCallCreateInput;
}>;


export type PreArrivalCallCreateMutation = { __typename?: 'Mutation', preArrivalCall: { __typename?: 'PreArrivalCallMutations', create?: { __typename?: 'MutationsPreArrivalCallCreatePayload', itinerary: { __typename?: 'Itinerary', id: string, preArrivalCalls?: { __typename?: 'PreArrivalCallConnection', nodes?: Array<{ __typename?: 'PreArrivalCall', id: string, comments?: string | null, createdAt: any, outcome: PreArrivalCallOutcomesEnum, zendeskTicket?: string | null, user: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } } | null> | null } | null } } | null } };

export type SupportCaseCreateMutationVariables = Exact<{
  input: MutationsSupportCaseCreateInput;
}>;


export type SupportCaseCreateMutation = { __typename?: 'Mutation', supportCase: { __typename?: 'SupportCaseMutations', create?: { __typename?: 'MutationsSupportCaseCreatePayload', itinerary: { __typename?: 'Itinerary', id: string, mainId: string, main: { __typename?: 'Itinerary', id: string, supportCases: Array<{ __typename?: 'SupportCase', id: string, action: SupportCaseActionEnum, caseType: SupportCaseTypeEnum, category: SupportCaseCategoryEnum, subcategory: SupportCaseSubcategoryEnum, notes?: string | null, createdAt: any, updatedAt: any, zendeskTicket?: string | null, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, supportNotes: Array<{ __typename?: 'SupportNote', id: string, content: string, zendeskTicket?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null }> }> } } } | null } };

export type SupportCaseTableFieldsFragment = { __typename?: 'SupportCase', id: string, action: SupportCaseActionEnum, caseType: SupportCaseTypeEnum, category: SupportCaseCategoryEnum, subcategory: SupportCaseSubcategoryEnum, notes?: string | null, createdAt: any, updatedAt: any, zendeskTicket?: string | null, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, supportNotes: Array<{ __typename?: 'SupportNote', id: string, content: string, zendeskTicket?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null }> };

export type SupportCaseUpdateMutationVariables = Exact<{
  input: MutationsSupportCaseUpdateInput;
}>;


export type SupportCaseUpdateMutation = { __typename?: 'Mutation', supportCase: { __typename?: 'SupportCaseMutations', update?: { __typename?: 'MutationsSupportCaseUpdatePayload', supportCase?: { __typename?: 'SupportCase', id: string, action: SupportCaseActionEnum, caseType: SupportCaseTypeEnum, category: SupportCaseCategoryEnum, subcategory: SupportCaseSubcategoryEnum, notes?: string | null, createdAt: any, updatedAt: any, zendeskTicket?: string | null, assignedTo?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null, supportNotes: Array<{ __typename?: 'SupportNote', id: string, content: string, zendeskTicket?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null }> } | null } | null } };

export type SupportNoteCreateMutationVariables = Exact<{
  input: MutationsSupportNoteCreateInput;
}>;


export type SupportNoteCreateMutation = { __typename?: 'Mutation', supportNote: { __typename?: 'SupportNoteMutations', create?: { __typename?: 'MutationsSupportNoteCreatePayload', supportCase: { __typename?: 'SupportCase', id: string, supportNotes: Array<{ __typename?: 'SupportNote', id: string, content: string, createdAt: any, zendeskTicket?: string | null, createdBy?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName: string, admin?: boolean | null } | null }> } } | null } };

export type ProductSupplierRemoveAttachmentMutationVariables = Exact<{
  input: MutationsProductSupplierRemoveAttachmentInput;
}>;


export type ProductSupplierRemoveAttachmentMutation = { __typename?: 'Mutation', productSupplier: { __typename?: 'ProductSupplierMutations', removeAttachment?: { __typename?: 'MutationsProductSupplierRemoveAttachmentPayload', productSupplier: { __typename?: 'ProductSupplier', id: string } } | null } };

export type ItineraryRemoveAttachmentMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: RemoveAttachmentInput;
}>;


export type ItineraryRemoveAttachmentMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', removeAttachment?: { __typename?: 'RemoveAttachmentPayload', itinerary: { __typename?: 'Itinerary', id: string } } | null } } | null };

export type UpdateTransportDetailsMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  input: UpdateTransportDetailsInput;
}>;


export type UpdateTransportDetailsMutation = { __typename?: 'Mutation', viewer?: { __typename?: 'TypesViewerMutationType', itinerary: { __typename?: 'TypesItineraryMutationType', updateTransportDetails?: { __typename?: 'UpdateTransportDetailsPayload', itinerary: { __typename?: 'Itinerary', id: string, data?: any | null, propertyLineItem: { __typename?: 'PropertyProductLineItem', id: string, resort?: { __typename?: 'Resort', id: string, showForOutboundTransfer: boolean } | null, product: { __typename?: 'PropertyProduct', name: string } }, lineItems: { __typename?: 'TransportationProductLineItemConnection', nodes?: Array<{ __typename?: 'TransportationProductLineItem', id: string, isCanceled: boolean, travelerIdx: number, supplierConfirmationNumber?: string | null, altSupplierConfirmationNumber?: string | null, supplierPickupTime?: string | null, altSupplierPickupTime?: string | null, firstName?: string | null } | null> | null } } } | null } } | null };

export type GetProductsQueryVariables = Exact<{
  resortSlug: Scalars['String']['input'];
  startAt: Scalars['Date']['input'];
}>;


export type GetProductsQuery = { __typename?: 'QueryType', product: { __typename?: 'TypesProductQueryType', liftTickets: { __typename?: 'LiftTicketProductConnectionWithFilterStatus', nodes?: Array<{ __typename?: 'LiftTicketProduct', age: string, days: number, id: string, currency?: string | null, name: string, payable?: number | null, sku: string } | null> | null }, rentals: { __typename?: 'RentalProductConnectionWithFilterStatus', nodes?: Array<{ __typename?: 'RentalProduct', age: string, days: number, gear: string, gearLevel: string, id: string, currency?: string | null, name: string, payable?: number | null, sku: string } | null> | null }, lessons: { __typename?: 'LessonProductConnectionWithFilterStatus', nodes?: Array<{ __typename?: 'LessonProduct', age: LessonProductAgeTypeEnum, gear: LessonProductGearTypeEnum, id: string, currency?: string | null, name: string, payable?: number | null, sku: string, size: LessonProductLessonTypeEnum } | null> | null }, transportations: { __typename?: 'TransportationProductConnectionWithFilterStatus', nodes?: Array<{ __typename?: 'TransportationProduct', minAge: number, id: string, currency?: string | null, name: string, payable?: number | null, sku: string } | null> | null } } };

type ProductOptionFields_LessonProduct_Fragment = { __typename?: 'LessonProduct', id: string, currency?: string | null, name: string, payable?: number | null, sku: string };

type ProductOptionFields_LiftTicketProduct_Fragment = { __typename?: 'LiftTicketProduct', id: string, currency?: string | null, name: string, payable?: number | null, sku: string };

type ProductOptionFields_RentalProduct_Fragment = { __typename?: 'RentalProduct', id: string, currency?: string | null, name: string, payable?: number | null, sku: string };

type ProductOptionFields_TransportationProduct_Fragment = { __typename?: 'TransportationProduct', id: string, currency?: string | null, name: string, payable?: number | null, sku: string };

type ProductOptionFields_UpsellProduct_Fragment = { __typename?: 'UpsellProduct', id: string, currency?: string | null, name: string, payable?: number | null, sku: string };

export type ProductOptionFieldsFragment = ProductOptionFields_LessonProduct_Fragment | ProductOptionFields_LiftTicketProduct_Fragment | ProductOptionFields_RentalProduct_Fragment | ProductOptionFields_TransportationProduct_Fragment | ProductOptionFields_UpsellProduct_Fragment;

export type RateRowFieldsFragment = { __typename?: 'PropertyRoomRate', availableRooms: number, cancelPenalties?: Array<any> | null, currency: string, depositRequired: boolean, discount: number, merchantOfRecord: string, payable: number, refundable: boolean, strikethrough?: number | null, tokens: any, bedGroups?: Array<{ __typename?: 'PropertyBedGroupAvailability', configuration?: Array<any> | null, tokens?: any | null }> | null };

export type CreditCardLabelFieldsFragment = { __typename?: 'UserCreditCard', id: string, last4: string, cardType: string, defaultCard: boolean };

export const ItineraryDuplicationRelationFieldsFragmentDoc = gql`
    fragment ItineraryDuplicationRelationFields on Itinerary {
  main {
    id
    publicId
    state
  }
  parent {
    id
    publicId
    state
  }
  child {
    id
    publicId
    state
  }
}
    `;
export const ItineraryLockFieldsFragmentDoc = gql`
    fragment ItineraryLockFields on Itinerary {
  lock {
    lockedAt
    lockedBy {
      id
      firstName
      lastName
    }
  }
}
    `;
export const ItineraryPaginationFieldsFragmentDoc = gql`
    fragment ItineraryPaginationFields on ItinerarySearchkickConnection {
  currentPage
  totalCount
  totalPages
  pageSize
}
    `;
export const ItineraryPricingFieldsFragmentDoc = gql`
    fragment ItineraryPricingFields on Itinerary {
  isPaid
  isCancelled
  totalAmount
  totalPayable
  couponDiscount
  currency
}
    `;
export const CoreCouponFieldsFragmentDoc = gql`
    fragment CoreCouponFields on Coupon {
  active
  code
  createdAt
  currency
  discountPercentage
  discountValue
  name
  expiresAt
  maxUse
  numOfPaidUses
  reason
  remainingAmount
  createdBy {
    id
    firstName
    lastName
  }
}
    `;
export const ItineraryEmailSendFieldsFragmentDoc = gql`
    fragment ItineraryEmailSendFields on Itinerary {
  id
  publicId
  email
  state
  fulfilmentState
  lineItems {
    id
    product {
      __typename
    }
    fulfilmentState
  }
}
    `;
export const ItineraryLogChangeFieldsFragmentDoc = gql`
    fragment ItineraryLogChangeFields on AuditedChangeRecordUnion {
  ... on AuditedChangeRecordBoolean {
    boolean
  }
  ... on AuditedChangeRecordDate {
    date
  }
  ... on AuditedChangeRecordDateTime {
    dateTime
  }
  ... on AuditedChangeRecordFloat {
    float
  }
  ... on AuditedChangeRecordInteger {
    integer
  }
  ... on AuditedChangeRecordString {
    string
  }
  ... on User {
    id
    fullName
  }
  ... on UserCreditCard {
    id
    last4
    createdAt
  }
  ... on Itinerary {
    id
    publicId
    email
  }
  ... on LessonProduct {
    id
    name
  }
  ... on LiftTicketProduct {
    id
    name
  }
  ... on RentalProduct {
    id
    name
  }
  ... on TransportationProduct {
    id
    name
  }
  ... on UpsellProduct {
    id
    name
  }
}
    `;
export const PropertyProductLineItemCheckoutOverviewFieldsFragmentDoc = gql`
    fragment PropertyProductLineItemCheckoutOverviewFields on PropertyProductLineItem {
  id
  arriveAt
  isCanceled
  data
  departAt
  inventoryType
  payableAmount
  cancelPenalties
  fulfilmentState
  manualFulfilment
  hasPriceChanges
  specialRequest
  room {
    id
    name
  }
  bedGroup {
    id
    description
    configuration
  }
  rate {
    id
    bedGroups {
      configuration
    }
    refundable
  }
  product {
    id
    name
    manualFulfilment
  }
}
    `;
export const LiftTicketProductLineItemCheckoutOverviewFieldsFragmentDoc = gql`
    fragment LiftTicketProductLineItemCheckoutOverviewFields on LiftTicketProductLineItem {
  id
  travelerIdx
  isCanceled
  arriveAt
  firstName
  lastName
  dob
  payableAmount
  product {
    id
    name
  }
}
    `;
export const RentalProductLineItemCheckoutOverviewFieldsFragmentDoc = gql`
    fragment RentalProductLineItemCheckoutOverviewFields on RentalProductLineItem {
  id
  travelerIdx
  isCanceled
  arriveAt
  firstName
  lastName
  dob
  payableAmount
  product {
    id
    name
  }
  helmetIncluded
}
    `;
export const LessonProductLineItemCheckoutOverviewFieldsFragmentDoc = gql`
    fragment LessonProductLineItemCheckoutOverviewFields on LessonProductLineItemType {
  id
  travelerIdx
  isCanceled
  arriveAt
  firstName
  lastName
  dob
  payableAmount
  product {
    id
    name
  }
}
    `;
export const TransportationProductLineItemCheckoutOverviewFieldsFragmentDoc = gql`
    fragment TransportationProductLineItemCheckoutOverviewFields on TransportationProductLineItem {
  id
  travelerIdx
  isCanceled
  arriveAt
  firstName
  lastName
  dob
  payableAmount
  product {
    id
    name
  }
}
    `;
export const ItineraryCheckoutOverviewFieldsFragmentDoc = gql`
    fragment ItineraryCheckoutOverviewFields on Itinerary {
  id
  publicId
  calculatedPriceBreakdown
  coupon {
    id
    code
    currency
  }
  couponDiscount
  currency
  totalPayable
  travelerDetails
  cancelPenalties
  cancellationCutoffAt
  propertyLineItem {
    id
    ...PropertyProductLineItemCheckoutOverviewFields
  }
  liftTicketLineItems {
    nodes {
      ...LiftTicketProductLineItemCheckoutOverviewFields
    }
  }
  rentalLineItems {
    nodes {
      ...RentalProductLineItemCheckoutOverviewFields
    }
  }
  lessonLineItems {
    nodes {
      ...LessonProductLineItemCheckoutOverviewFields
    }
  }
  transportationLineItems {
    nodes {
      ...TransportationProductLineItemCheckoutOverviewFields
    }
  }
  upsellLineItems {
    nodes {
      id
      payableAmount
    }
  }
}
    ${PropertyProductLineItemCheckoutOverviewFieldsFragmentDoc}
${LiftTicketProductLineItemCheckoutOverviewFieldsFragmentDoc}
${RentalProductLineItemCheckoutOverviewFieldsFragmentDoc}
${LessonProductLineItemCheckoutOverviewFieldsFragmentDoc}
${TransportationProductLineItemCheckoutOverviewFieldsFragmentDoc}`;
export const ItineraryPostBookingCallsFieldsFragmentDoc = gql`
    fragment ItineraryPostBookingCallsFields on Itinerary {
  id
  main {
    id
    publicId
    internalId
    postBookingCalls {
      nodes {
        id
        comments
        createdAt
        outcome
        zendeskTicket
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const ItineraryPreArrivalCallsFieldsFragmentDoc = gql`
    fragment ItineraryPreArrivalCallsFields on Itinerary {
  id
  main {
    id
    publicId
    internalId
    preArrivalCalls {
      nodes {
        id
        comments
        createdAt
        outcome
        zendeskTicket
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const ItineraryDuplicationTreeFieldsFragmentDoc = gql`
    fragment ItineraryDuplicationTreeFields on Itinerary {
  id
  internalId
  isConfirmed
  parentId
  publicId
  state
  duplicated {
    id
    internalId
    isConfirmed
    parentId
    publicId
    state
  }
}
    `;
export const ItineraryZendeskLinksFieldsFragmentDoc = gql`
    fragment ItineraryZendeskLinksFields on Itinerary {
  publicId
  normalizedFirstName
  normalizedLastName
  phone
  email
  main {
    id
    email
    publicId
  }
}
    `;
export const UserCreditCardFormFieldsFragmentDoc = gql`
    fragment UserCreditCardFormFields on User {
  id
  firstName
  lastName
}
    `;
export const CovidProtocolFieldsFragmentDoc = gql`
    fragment CovidProtocolFields on Resort {
  covidProtocols {
    id
    name
    group
    state
    country
    protocol
    suggestionsLinks
    sources
  }
}
    `;
export const CreditCardLabelFieldsFragmentDoc = gql`
    fragment CreditCardLabelFields on UserCreditCard {
  id
  last4
  cardType
  defaultCard
}
    `;
export const ItineraryDuplicateCheckoutFieldsFragmentDoc = gql`
    fragment ItineraryDuplicateCheckoutFields on Itinerary {
  id
  publicId
  sessionId
  cancelPenalties
  propertyLineItem {
    id
    inventoryType
    manualFulfilment
    state
  }
  userCreditCards {
    nodes {
      id
      ...CreditCardLabelFields
    }
  }
  user {
    id
    firstName
    lastName
  }
}
    ${CreditCardLabelFieldsFragmentDoc}`;
export const PaymentTableFieldsFragmentDoc = gql`
    fragment PaymentTableFields on Payment {
  id
  amount
  cardType
  last4
  createdAt
  currency
  notes
  reason
  refundable
  refundableAmount
  state
  type
  trxnNumber
  trxnType
  refunds(includeFailed: $includeFailed) {
    nodes {
      id
      amount
      createdAt
      currency
      notes
      reason
      state
      trxnType
    }
  }
}
    `;
export const UserCreditCardPaymentProcessFieldsFragmentDoc = gql`
    fragment UserCreditCardPaymentProcessFields on UserCreditCard {
  id
  cardType
  defaultCard
  expiresAt
  last4
}
    `;
export const ScheduledPaymentTableFieldsFragmentDoc = gql`
    fragment ScheduledPaymentTableFields on ScheduledPayment {
  id
  amount
  currency
  chargeable
  collectionSource
  processAt
  processed
  paymentType
  isModified
  payment {
    id
  }
  state
  lineItem {
    id
    product {
      ... on PropertyProduct {
        id
        name
      }
      ... on Product {
        id
        name
      }
      __typename
    }
  }
}
    `;
export const UserCoreFieldsFragmentDoc = gql`
    fragment UserCoreFields on User {
  id
  firstName
  lastName
  fullName
  admin
}
    `;
export const SupportCaseTableFieldsFragmentDoc = gql`
    fragment SupportCaseTableFields on SupportCase {
  id
  action
  assignedTo {
    ...UserCoreFields
  }
  caseType
  category
  createdBy {
    ...UserCoreFields
  }
  subcategory
  notes
  createdAt
  updatedAt
  zendeskTicket
  supportNotes {
    id
    createdBy {
      ...UserCoreFields
    }
    content
    zendeskTicket
    createdAt
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export const ProductOptionFieldsFragmentDoc = gql`
    fragment ProductOptionFields on Product {
  id
  currency
  name
  payable
  sku
}
    `;
export const RateRowFieldsFragmentDoc = gql`
    fragment RateRowFields on PropertyRoomRate {
  availableRooms
  bedGroups {
    configuration
    tokens
  }
  cancelPenalties
  currency
  depositRequired
  discount
  merchantOfRecord
  payable
  refundable
  strikethrough
  tokens
}
    `;
export const GetItinerariesCountDocument = gql`
    query GetItinerariesCount($newBookingFilter: ItinerarySearchResolverFilterInput, $pendingOrderFilter: ItinerarySearchResolverFilterInput, $notReadyBookingFilter: ItinerarySearchResolverFilterInput, $urgentBookingFilter: ItinerarySearchResolverFilterInput) {
  newBookings: itineraries(filter: $newBookingFilter) {
    totalCount
  }
  pendingOrders: itineraries(filter: $pendingOrderFilter) {
    totalCount
  }
  notReadyBookings: itineraries(filter: $notReadyBookingFilter) {
    totalCount
  }
  urgentBookings: itineraries(filter: $urgentBookingFilter) {
    totalCount
  }
}
    `;

/**
 * __useGetItinerariesCountQuery__
 *
 * To run a query within a React component, call `useGetItinerariesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItinerariesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItinerariesCountQuery({
 *   variables: {
 *      newBookingFilter: // value for 'newBookingFilter'
 *      pendingOrderFilter: // value for 'pendingOrderFilter'
 *      notReadyBookingFilter: // value for 'notReadyBookingFilter'
 *      urgentBookingFilter: // value for 'urgentBookingFilter'
 *   },
 * });
 */
export function useGetItinerariesCountQuery(baseOptions?: Apollo.QueryHookOptions<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>(GetItinerariesCountDocument, options);
      }
export function useGetItinerariesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>(GetItinerariesCountDocument, options);
        }
export function useGetItinerariesCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>(GetItinerariesCountDocument, options);
        }
export type GetItinerariesCountQueryHookResult = ReturnType<typeof useGetItinerariesCountQuery>;
export type GetItinerariesCountLazyQueryHookResult = ReturnType<typeof useGetItinerariesCountLazyQuery>;
export type GetItinerariesCountSuspenseQueryHookResult = ReturnType<typeof useGetItinerariesCountSuspenseQuery>;
export type GetItinerariesCountQueryResult = Apollo.QueryResult<GetItinerariesCountQuery, GetItinerariesCountQueryVariables>;
export const ImportComponentsDocument = gql`
    mutation ImportComponents($resortId: Int!) {
  importComponents(resortId: $resortId) {
    message
  }
}
    `;
export type ImportComponentsMutationFn = Apollo.MutationFunction<ImportComponentsMutation, ImportComponentsMutationVariables>;

/**
 * __useImportComponentsMutation__
 *
 * To run a mutation, you first call `useImportComponentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportComponentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importComponentsMutation, { data, loading, error }] = useImportComponentsMutation({
 *   variables: {
 *      resortId: // value for 'resortId'
 *   },
 * });
 */
export function useImportComponentsMutation(baseOptions?: Apollo.MutationHookOptions<ImportComponentsMutation, ImportComponentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportComponentsMutation, ImportComponentsMutationVariables>(ImportComponentsDocument, options);
      }
export type ImportComponentsMutationHookResult = ReturnType<typeof useImportComponentsMutation>;
export type ImportComponentsMutationResult = Apollo.MutationResult<ImportComponentsMutation>;
export type ImportComponentsMutationOptions = Apollo.BaseMutationOptions<ImportComponentsMutation, ImportComponentsMutationVariables>;
export const ImportEquipmentRentalsDocument = gql`
    mutation ImportEquipmentRentals($resortId: Int!) {
  importEquipmentRentals(resortId: $resortId) {
    message
  }
}
    `;
export type ImportEquipmentRentalsMutationFn = Apollo.MutationFunction<ImportEquipmentRentalsMutation, ImportEquipmentRentalsMutationVariables>;

/**
 * __useImportEquipmentRentalsMutation__
 *
 * To run a mutation, you first call `useImportEquipmentRentalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportEquipmentRentalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importEquipmentRentalsMutation, { data, loading, error }] = useImportEquipmentRentalsMutation({
 *   variables: {
 *      resortId: // value for 'resortId'
 *   },
 * });
 */
export function useImportEquipmentRentalsMutation(baseOptions?: Apollo.MutationHookOptions<ImportEquipmentRentalsMutation, ImportEquipmentRentalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportEquipmentRentalsMutation, ImportEquipmentRentalsMutationVariables>(ImportEquipmentRentalsDocument, options);
      }
export type ImportEquipmentRentalsMutationHookResult = ReturnType<typeof useImportEquipmentRentalsMutation>;
export type ImportEquipmentRentalsMutationResult = Apollo.MutationResult<ImportEquipmentRentalsMutation>;
export type ImportEquipmentRentalsMutationOptions = Apollo.BaseMutationOptions<ImportEquipmentRentalsMutation, ImportEquipmentRentalsMutationVariables>;
export const ImportGroundTransfersDocument = gql`
    mutation ImportGroundTransfers($resortId: Int!) {
  importGroundTransfers(resortId: $resortId) {
    message
  }
}
    `;
export type ImportGroundTransfersMutationFn = Apollo.MutationFunction<ImportGroundTransfersMutation, ImportGroundTransfersMutationVariables>;

/**
 * __useImportGroundTransfersMutation__
 *
 * To run a mutation, you first call `useImportGroundTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportGroundTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importGroundTransfersMutation, { data, loading, error }] = useImportGroundTransfersMutation({
 *   variables: {
 *      resortId: // value for 'resortId'
 *   },
 * });
 */
export function useImportGroundTransfersMutation(baseOptions?: Apollo.MutationHookOptions<ImportGroundTransfersMutation, ImportGroundTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportGroundTransfersMutation, ImportGroundTransfersMutationVariables>(ImportGroundTransfersDocument, options);
      }
export type ImportGroundTransfersMutationHookResult = ReturnType<typeof useImportGroundTransfersMutation>;
export type ImportGroundTransfersMutationResult = Apollo.MutationResult<ImportGroundTransfersMutation>;
export type ImportGroundTransfersMutationOptions = Apollo.BaseMutationOptions<ImportGroundTransfersMutation, ImportGroundTransfersMutationVariables>;
export const ImportLiftTicketsDocument = gql`
    mutation ImportLiftTickets($resortId: Int!) {
  importLiftTickets(resortId: $resortId) {
    message
  }
}
    `;
export type ImportLiftTicketsMutationFn = Apollo.MutationFunction<ImportLiftTicketsMutation, ImportLiftTicketsMutationVariables>;

/**
 * __useImportLiftTicketsMutation__
 *
 * To run a mutation, you first call `useImportLiftTicketsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLiftTicketsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLiftTicketsMutation, { data, loading, error }] = useImportLiftTicketsMutation({
 *   variables: {
 *      resortId: // value for 'resortId'
 *   },
 * });
 */
export function useImportLiftTicketsMutation(baseOptions?: Apollo.MutationHookOptions<ImportLiftTicketsMutation, ImportLiftTicketsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLiftTicketsMutation, ImportLiftTicketsMutationVariables>(ImportLiftTicketsDocument, options);
      }
export type ImportLiftTicketsMutationHookResult = ReturnType<typeof useImportLiftTicketsMutation>;
export type ImportLiftTicketsMutationResult = Apollo.MutationResult<ImportLiftTicketsMutation>;
export type ImportLiftTicketsMutationOptions = Apollo.BaseMutationOptions<ImportLiftTicketsMutation, ImportLiftTicketsMutationVariables>;
export const ImportRegionDocument = gql`
    mutation ImportRegion($regionId: Int!) {
  importRegion(regionId: $regionId) {
    message
  }
}
    `;
export type ImportRegionMutationFn = Apollo.MutationFunction<ImportRegionMutation, ImportRegionMutationVariables>;

/**
 * __useImportRegionMutation__
 *
 * To run a mutation, you first call `useImportRegionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRegionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRegionMutation, { data, loading, error }] = useImportRegionMutation({
 *   variables: {
 *      regionId: // value for 'regionId'
 *   },
 * });
 */
export function useImportRegionMutation(baseOptions?: Apollo.MutationHookOptions<ImportRegionMutation, ImportRegionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRegionMutation, ImportRegionMutationVariables>(ImportRegionDocument, options);
      }
export type ImportRegionMutationHookResult = ReturnType<typeof useImportRegionMutation>;
export type ImportRegionMutationResult = Apollo.MutationResult<ImportRegionMutation>;
export type ImportRegionMutationOptions = Apollo.BaseMutationOptions<ImportRegionMutation, ImportRegionMutationVariables>;
export const ImportLodgingDocument = gql`
    mutation ImportLodging($resortId: Int!) {
  importLodging(resortId: $resortId) {
    message
  }
}
    `;
export type ImportLodgingMutationFn = Apollo.MutationFunction<ImportLodgingMutation, ImportLodgingMutationVariables>;

/**
 * __useImportLodgingMutation__
 *
 * To run a mutation, you first call `useImportLodgingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportLodgingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importLodgingMutation, { data, loading, error }] = useImportLodgingMutation({
 *   variables: {
 *      resortId: // value for 'resortId'
 *   },
 * });
 */
export function useImportLodgingMutation(baseOptions?: Apollo.MutationHookOptions<ImportLodgingMutation, ImportLodgingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportLodgingMutation, ImportLodgingMutationVariables>(ImportLodgingDocument, options);
      }
export type ImportLodgingMutationHookResult = ReturnType<typeof useImportLodgingMutation>;
export type ImportLodgingMutationResult = Apollo.MutationResult<ImportLodgingMutation>;
export type ImportLodgingMutationOptions = Apollo.BaseMutationOptions<ImportLodgingMutation, ImportLodgingMutationVariables>;
export const GetItineraryCheckoutPageDocument = gql`
    query GetItineraryCheckoutPage($id: ID!, $skip: Boolean!) {
  itinerary @skip(if: $skip) {
    itinerary(id: $id) {
      id
      isPaid
      sessionId
      publicId
      propertyLineItem {
        id
        isPending
      }
    }
  }
}
    `;

/**
 * __useGetItineraryCheckoutPageQuery__
 *
 * To run a query within a React component, call `useGetItineraryCheckoutPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryCheckoutPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryCheckoutPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItineraryCheckoutPageQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>(GetItineraryCheckoutPageDocument, options);
      }
export function useGetItineraryCheckoutPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>(GetItineraryCheckoutPageDocument, options);
        }
export function useGetItineraryCheckoutPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>(GetItineraryCheckoutPageDocument, options);
        }
export type GetItineraryCheckoutPageQueryHookResult = ReturnType<typeof useGetItineraryCheckoutPageQuery>;
export type GetItineraryCheckoutPageLazyQueryHookResult = ReturnType<typeof useGetItineraryCheckoutPageLazyQuery>;
export type GetItineraryCheckoutPageSuspenseQueryHookResult = ReturnType<typeof useGetItineraryCheckoutPageSuspenseQuery>;
export type GetItineraryCheckoutPageQueryResult = Apollo.QueryResult<GetItineraryCheckoutPageQuery, GetItineraryCheckoutPageQueryVariables>;
export const GetItineraryCommunicationsPageDocument = gql`
    query GetItineraryCommunicationsPage($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      publicId
      sessionId
      ...ItineraryEmailSendFields
      ...ItineraryZendeskLinksFields
    }
  }
}
    ${ItineraryEmailSendFieldsFragmentDoc}
${ItineraryZendeskLinksFieldsFragmentDoc}`;

/**
 * __useGetItineraryCommunicationsPageQuery__
 *
 * To run a query within a React component, call `useGetItineraryCommunicationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryCommunicationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryCommunicationsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryCommunicationsPageQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>(GetItineraryCommunicationsPageDocument, options);
      }
export function useGetItineraryCommunicationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>(GetItineraryCommunicationsPageDocument, options);
        }
export function useGetItineraryCommunicationsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>(GetItineraryCommunicationsPageDocument, options);
        }
export type GetItineraryCommunicationsPageQueryHookResult = ReturnType<typeof useGetItineraryCommunicationsPageQuery>;
export type GetItineraryCommunicationsPageLazyQueryHookResult = ReturnType<typeof useGetItineraryCommunicationsPageLazyQuery>;
export type GetItineraryCommunicationsPageSuspenseQueryHookResult = ReturnType<typeof useGetItineraryCommunicationsPageSuspenseQuery>;
export type GetItineraryCommunicationsPageQueryResult = Apollo.QueryResult<GetItineraryCommunicationsPageQuery, GetItineraryCommunicationsPageQueryVariables>;
export const GetProductSupplierDocument = gql`
    query getProductSupplier($id: ID!) {
  productSupplier(id: $id) {
    id
    active
    apexUpdated
    apexUpdatedAt
    bookingPortalType
    cancellationPolicy
    commission
    confirmationNumberInstruction
    contactEmail
    contactName
    contactPhoneMobile
    contactPhoneOffice
    contactPosition
    contractingAgent {
      id
      email
      firstName
      lastName
      fullName
      phone
    }
    contractLink
    contractStatus
    currency
    depositPolicy
    email
    fulfilmentContactInformation
    fulfilmentNotes
    fulfilmentReferenceNumber
    mainSupplier
    name
    shortName
    note
    officialTimetable
    order
    password
    paymentBulkBill
    paymentFrequency
    paymentMethod
    paymentOptions
    phone
    pickupTimeLocation
    productSupplierGroup {
      id
      productSuppliers {
        nodes {
          id
          name
          active
        }
      }
    }
    productType
    rateLink
    rateStatus
    resort {
      id
      name
      slug
    }
    spreadsheetUrl
    supplierProduct
    supplierType
    url
    username
    vouchersRequired
    transferFulfilmentInstructions {
      nodes {
        active
        airport
        contactNumber
        createdAt
        direction
        instructionId: id
        instructions
        name
        order
        updatedAt
        audits(first: 1) {
          nodes {
            id
            createdAt
            user {
              id
              fullName
            }
          }
        }
      }
    }
    fulfilmentContactAudit: audits(
      fields: ["fulfilment_contact_information", "fulfilment_reference_number"]
      action: UPDATE
      first: 1
    ) {
      nodes {
        id
        createdAt
        user {
          id
          fullName
        }
      }
    }
    fulfilmentDetailsAudit: audits(
      fields: ["url", "username", "password", "email", "spreadsheet_url", "confirmation_number_instruction", "fulfilment_notes", "cancellation_policy", "payment_bulk_bill", "payment_method", "payment_frequency", "currency", "vouchers_required"]
      action: UPDATE
      first: 1
    ) {
      nodes {
        id
        createdAt
        user {
          id
          fullName
        }
      }
    }
    contractingContactAudit: audits(
      fields: ["contact_name", "contact_position", "contact_phone_office", "contact_phone_mobile", "contact_email"]
      action: UPDATE
      first: 1
    ) {
      nodes {
        id
        createdAt
        user {
          id
          fullName
        }
      }
    }
    contractingDetailsAudit: audits(
      fields: ["contracting_agent_id", "contract_status", "contract_link", "rate_status", "rate_link", "note", "commission", "apex_updated", "apex_updated_at"]
      action: UPDATE
      first: 1
    ) {
      nodes {
        id
        createdAt
        user {
          id
          fullName
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductSupplierQuery__
 *
 * To run a query within a React component, call `useGetProductSupplierQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSupplierQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSupplierQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductSupplierQuery(baseOptions: Apollo.QueryHookOptions<GetProductSupplierQuery, GetProductSupplierQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSupplierQuery, GetProductSupplierQueryVariables>(GetProductSupplierDocument, options);
      }
export function useGetProductSupplierLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSupplierQuery, GetProductSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSupplierQuery, GetProductSupplierQueryVariables>(GetProductSupplierDocument, options);
        }
export function useGetProductSupplierSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSupplierQuery, GetProductSupplierQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSupplierQuery, GetProductSupplierQueryVariables>(GetProductSupplierDocument, options);
        }
export type GetProductSupplierQueryHookResult = ReturnType<typeof useGetProductSupplierQuery>;
export type GetProductSupplierLazyQueryHookResult = ReturnType<typeof useGetProductSupplierLazyQuery>;
export type GetProductSupplierSuspenseQueryHookResult = ReturnType<typeof useGetProductSupplierSuspenseQuery>;
export type GetProductSupplierQueryResult = Apollo.QueryResult<GetProductSupplierQuery, GetProductSupplierQueryVariables>;
export const UpdateProductSupplierDocument = gql`
    mutation updateProductSupplier($input: MutationsProductSupplierUpdateInput!) {
  productSupplier {
    update(input: $input) {
      productSupplier {
        id
      }
    }
  }
}
    `;
export type UpdateProductSupplierMutationFn = Apollo.MutationFunction<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>;

/**
 * __useUpdateProductSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductSupplierMutation, { data, loading, error }] = useUpdateProductSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>(UpdateProductSupplierDocument, options);
      }
export type UpdateProductSupplierMutationHookResult = ReturnType<typeof useUpdateProductSupplierMutation>;
export type UpdateProductSupplierMutationResult = Apollo.MutationResult<UpdateProductSupplierMutation>;
export type UpdateProductSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateProductSupplierMutation, UpdateProductSupplierMutationVariables>;
export const GetItineraryCallsPageDocument = gql`
    query GetItineraryCallsPage($id: ID!, $skip: Boolean!) {
  itinerary @skip(if: $skip) {
    itinerary(id: $id) {
      id
      ...ItineraryPreArrivalCallsFields
      ...ItineraryPostBookingCallsFields
    }
  }
}
    ${ItineraryPreArrivalCallsFieldsFragmentDoc}
${ItineraryPostBookingCallsFieldsFragmentDoc}`;

/**
 * __useGetItineraryCallsPageQuery__
 *
 * To run a query within a React component, call `useGetItineraryCallsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryCallsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryCallsPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItineraryCallsPageQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>(GetItineraryCallsPageDocument, options);
      }
export function useGetItineraryCallsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>(GetItineraryCallsPageDocument, options);
        }
export function useGetItineraryCallsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>(GetItineraryCallsPageDocument, options);
        }
export type GetItineraryCallsPageQueryHookResult = ReturnType<typeof useGetItineraryCallsPageQuery>;
export type GetItineraryCallsPageLazyQueryHookResult = ReturnType<typeof useGetItineraryCallsPageLazyQuery>;
export type GetItineraryCallsPageSuspenseQueryHookResult = ReturnType<typeof useGetItineraryCallsPageSuspenseQuery>;
export type GetItineraryCallsPageQueryResult = Apollo.QueryResult<GetItineraryCallsPageQuery, GetItineraryCallsPageQueryVariables>;
export const GetCustomerInfoDocument = gql`
    query getCustomerInfo($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      publicId
      normalizedFirstName
      normalizedLastName
      email
      phone
      state
      propertyLineItem {
        id
        data
      }
    }
  }
}
    `;

/**
 * __useGetCustomerInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomerInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
      }
export function useGetCustomerInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
        }
export function useGetCustomerInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>(GetCustomerInfoDocument, options);
        }
export type GetCustomerInfoQueryHookResult = ReturnType<typeof useGetCustomerInfoQuery>;
export type GetCustomerInfoLazyQueryHookResult = ReturnType<typeof useGetCustomerInfoLazyQuery>;
export type GetCustomerInfoSuspenseQueryHookResult = ReturnType<typeof useGetCustomerInfoSuspenseQuery>;
export type GetCustomerInfoQueryResult = Apollo.QueryResult<GetCustomerInfoQuery, GetCustomerInfoQueryVariables>;
export const GetViewerDocument = gql`
    query GetViewer {
  viewer {
    user {
      id
      firstName
      lastName
      email
      admin
    }
  }
}
    `;

/**
 * __useGetViewerQuery__
 *
 * To run a query within a React component, call `useGetViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
      }
export function useGetViewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
        }
export function useGetViewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewerQuery, GetViewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewerQuery, GetViewerQueryVariables>(GetViewerDocument, options);
        }
export type GetViewerQueryHookResult = ReturnType<typeof useGetViewerQuery>;
export type GetViewerLazyQueryHookResult = ReturnType<typeof useGetViewerLazyQuery>;
export type GetViewerSuspenseQueryHookResult = ReturnType<typeof useGetViewerSuspenseQuery>;
export type GetViewerQueryResult = Apollo.QueryResult<GetViewerQuery, GetViewerQueryVariables>;
export const TrackItineraryViewDocument = gql`
    mutation TrackItineraryView($input: TrackItineraryViewInput!) {
  viewer {
    trackItineraryView(input: $input) {
      success
    }
  }
}
    `;
export type TrackItineraryViewMutationFn = Apollo.MutationFunction<TrackItineraryViewMutation, TrackItineraryViewMutationVariables>;

/**
 * __useTrackItineraryViewMutation__
 *
 * To run a mutation, you first call `useTrackItineraryViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackItineraryViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackItineraryViewMutation, { data, loading, error }] = useTrackItineraryViewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTrackItineraryViewMutation(baseOptions?: Apollo.MutationHookOptions<TrackItineraryViewMutation, TrackItineraryViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackItineraryViewMutation, TrackItineraryViewMutationVariables>(TrackItineraryViewDocument, options);
      }
export type TrackItineraryViewMutationHookResult = ReturnType<typeof useTrackItineraryViewMutation>;
export type TrackItineraryViewMutationResult = Apollo.MutationResult<TrackItineraryViewMutation>;
export type TrackItineraryViewMutationOptions = Apollo.BaseMutationOptions<TrackItineraryViewMutation, TrackItineraryViewMutationVariables>;
export const RemoveLineItemDocument = gql`
    mutation RemoveLineItem($itinerarySessionId: ID!, $lineItemId: ID) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      removeProduct(id: $lineItemId) {
        id
      }
    }
  }
}
    `;
export type RemoveLineItemMutationFn = Apollo.MutationFunction<RemoveLineItemMutation, RemoveLineItemMutationVariables>;

/**
 * __useRemoveLineItemMutation__
 *
 * To run a mutation, you first call `useRemoveLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLineItemMutation, { data, loading, error }] = useRemoveLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      lineItemId: // value for 'lineItemId'
 *   },
 * });
 */
export function useRemoveLineItemMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLineItemMutation, RemoveLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLineItemMutation, RemoveLineItemMutationVariables>(RemoveLineItemDocument, options);
      }
export type RemoveLineItemMutationHookResult = ReturnType<typeof useRemoveLineItemMutation>;
export type RemoveLineItemMutationResult = Apollo.MutationResult<RemoveLineItemMutation>;
export type RemoveLineItemMutationOptions = Apollo.BaseMutationOptions<RemoveLineItemMutation, RemoveLineItemMutationVariables>;
export const DeactivateCouponDocument = gql`
    mutation DeactivateCoupon($input: DeactivateCouponInput!) {
  deactivateCoupon(input: $input) {
    coupon {
      id
      active
    }
  }
}
    `;
export type DeactivateCouponMutationFn = Apollo.MutationFunction<DeactivateCouponMutation, DeactivateCouponMutationVariables>;

/**
 * __useDeactivateCouponMutation__
 *
 * To run a mutation, you first call `useDeactivateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCouponMutation, { data, loading, error }] = useDeactivateCouponMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateCouponMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateCouponMutation, DeactivateCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateCouponMutation, DeactivateCouponMutationVariables>(DeactivateCouponDocument, options);
      }
export type DeactivateCouponMutationHookResult = ReturnType<typeof useDeactivateCouponMutation>;
export type DeactivateCouponMutationResult = Apollo.MutationResult<DeactivateCouponMutation>;
export type DeactivateCouponMutationOptions = Apollo.BaseMutationOptions<DeactivateCouponMutation, DeactivateCouponMutationVariables>;
export const GetFulfilmentItinerariesDocument = gql`
    query GetFulfilmentItineraries($filter: ItinerarySearchResolverFilterInput, $orderBy: [SearchkickOrderByInput!], $page: Int, $pageSize: Int) {
  itineraries(
    filter: $filter
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    ...ItineraryPaginationFields
    nodes {
      id
      arriveAt
      countryName
      customerResidencyState
      customerResidencyCountry
      currency
      departAt
      email
      infoRequired
      insuranceStatus
      insuranceOrderedAt
      flightInfoRequired
      fulfilmentAgent {
        id
        firstName
        lastName
      }
      liftTicketAgent {
        id
        firstName
        lastName
      }
      rentalAgent {
        id
        firstName
        lastName
      }
      lessonAgent {
        id
        firstName
        lastName
      }
      transportationAgent {
        id
        firstName
        lastName
      }
      f4Agent {
        id
        firstName
        lastName
      }
      requestedAgent {
        id
        firstName
        lastName
      }
      inProgressAgent {
        id
        firstName
        lastName
      }
      flightInfoAgent {
        id
        firstName
        lastName
      }
      customerAgent {
        id
        firstName
        lastName
      }
      postBookingAgent {
        id
        firstName
        lastName
      }
      fulfilmentState
      propertyManualFulfilment
      lessonStatus
      lessonOrderedAt
      liftTicketStatus
      liftTicketOrderedAt
      modified
      nextPaymentDueAt
      normalizedFirstName
      normalizedLastName
      phone
      propertyName
      propertyStatus
      publicId
      mainPublicId
      regionName
      remainingBalancesCollected
      resortName
      paidAt
      payableAmount
      preArrivalCompleted
      preArrivalCallOutcome
      products
      rentalStatus
      rentalOrderedAt
      sessionId
      transportationStatus
      transportationOrderedAt
      state
      manualFollowupEmail4Required
      rentalProductSupplier
      productFreeCancelDate
      lodgingFreeCancelDate
      propertyCrosscheck
      liftTicketCrosscheck
      rentalCrosscheck
      lessonCrosscheck
      transportationCrosscheck
      insuranceCrosscheck
      lessonWaiver
      tableNotes
    }
  }
}
    ${ItineraryPaginationFieldsFragmentDoc}`;

/**
 * __useGetFulfilmentItinerariesQuery__
 *
 * To run a query within a React component, call `useGetFulfilmentItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFulfilmentItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFulfilmentItinerariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetFulfilmentItinerariesQuery(baseOptions?: Apollo.QueryHookOptions<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>(GetFulfilmentItinerariesDocument, options);
      }
export function useGetFulfilmentItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>(GetFulfilmentItinerariesDocument, options);
        }
export function useGetFulfilmentItinerariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>(GetFulfilmentItinerariesDocument, options);
        }
export type GetFulfilmentItinerariesQueryHookResult = ReturnType<typeof useGetFulfilmentItinerariesQuery>;
export type GetFulfilmentItinerariesLazyQueryHookResult = ReturnType<typeof useGetFulfilmentItinerariesLazyQuery>;
export type GetFulfilmentItinerariesSuspenseQueryHookResult = ReturnType<typeof useGetFulfilmentItinerariesSuspenseQuery>;
export type GetFulfilmentItinerariesQueryResult = Apollo.QueryResult<GetFulfilmentItinerariesQuery, GetFulfilmentItinerariesQueryVariables>;
export const CouponCreateDocument = gql`
    mutation CouponCreate($input: CreateCouponInput!) {
  createCoupon(input: $input) {
    coupon {
      id
      originItinerary {
        main {
          publicId
        }
      }
      ...CoreCouponFields
    }
  }
}
    ${CoreCouponFieldsFragmentDoc}`;
export type CouponCreateMutationFn = Apollo.MutationFunction<CouponCreateMutation, CouponCreateMutationVariables>;

/**
 * __useCouponCreateMutation__
 *
 * To run a mutation, you first call `useCouponCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCouponCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [couponCreateMutation, { data, loading, error }] = useCouponCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCouponCreateMutation(baseOptions?: Apollo.MutationHookOptions<CouponCreateMutation, CouponCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CouponCreateMutation, CouponCreateMutationVariables>(CouponCreateDocument, options);
      }
export type CouponCreateMutationHookResult = ReturnType<typeof useCouponCreateMutation>;
export type CouponCreateMutationResult = Apollo.MutationResult<CouponCreateMutation>;
export type CouponCreateMutationOptions = Apollo.BaseMutationOptions<CouponCreateMutation, CouponCreateMutationVariables>;
export const GetCouponDocument = gql`
    query GetCoupon($code: String!) {
  coupon(code: $code) {
    id
    originItinerary {
      main {
        publicId
      }
    }
    itineraries {
      id
      publicId
      paidAt
    }
    ...CoreCouponFields
  }
}
    ${CoreCouponFieldsFragmentDoc}`;

/**
 * __useGetCouponQuery__
 *
 * To run a query within a React component, call `useGetCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetCouponQuery(baseOptions: Apollo.QueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
      }
export function useGetCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export function useGetCouponSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCouponQuery, GetCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCouponQuery, GetCouponQueryVariables>(GetCouponDocument, options);
        }
export type GetCouponQueryHookResult = ReturnType<typeof useGetCouponQuery>;
export type GetCouponLazyQueryHookResult = ReturnType<typeof useGetCouponLazyQuery>;
export type GetCouponSuspenseQueryHookResult = ReturnType<typeof useGetCouponSuspenseQuery>;
export type GetCouponQueryResult = Apollo.QueryResult<GetCouponQuery, GetCouponQueryVariables>;
export const GetCallItinerariesDocument = gql`
    query GetCallItineraries($filter: ItinerarySearchResolverFilterInput, $orderBy: [SearchkickOrderByInput!], $page: Int, $pageSize: Int) {
  itineraries(
    filter: $filter
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    ...ItineraryPaginationFields
    nodes {
      id
      paidAt
      arriveAt
      countryName
      currency
      departAt
      customerAgent {
        id
        firstName
        lastName
      }
      fulfilmentState
      modified
      firstName
      lastName
      normalizedFirstName
      normalizedLastName
      propertyName
      publicId
      regionName
      resortName
      payableAmount
      preArrivalCompleted
      preArrivalCallOutcome
      postBookingCallSuccessful
      postBookingCallUnsuccessful
      postBookingAgent {
        id
        firstName
        lastName
      }
      postBookingCallOutcome
      products
      sessionId
      state
      preArrivalSmsSent
      flightInfoRequired
      customerResidencyCountry
      lessonWaiver
    }
  }
}
    ${ItineraryPaginationFieldsFragmentDoc}`;

/**
 * __useGetCallItinerariesQuery__
 *
 * To run a query within a React component, call `useGetCallItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallItinerariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetCallItinerariesQuery(baseOptions?: Apollo.QueryHookOptions<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>(GetCallItinerariesDocument, options);
      }
export function useGetCallItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>(GetCallItinerariesDocument, options);
        }
export function useGetCallItinerariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>(GetCallItinerariesDocument, options);
        }
export type GetCallItinerariesQueryHookResult = ReturnType<typeof useGetCallItinerariesQuery>;
export type GetCallItinerariesLazyQueryHookResult = ReturnType<typeof useGetCallItinerariesLazyQuery>;
export type GetCallItinerariesSuspenseQueryHookResult = ReturnType<typeof useGetCallItinerariesSuspenseQuery>;
export type GetCallItinerariesQueryResult = Apollo.QueryResult<GetCallItinerariesQuery, GetCallItinerariesQueryVariables>;
export const GetAllCouponsDocument = gql`
    query GetAllCoupons($first: Int) {
  allCoupons(first: $first, orderBy: {field: "id", direction: DESC}) {
    edges {
      node {
        id
        originItinerary {
          main {
            publicId
          }
        }
        ...CoreCouponFields
      }
    }
  }
}
    ${CoreCouponFieldsFragmentDoc}`;

/**
 * __useGetAllCouponsQuery__
 *
 * To run a query within a React component, call `useGetAllCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCouponsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetAllCouponsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCouponsQuery, GetAllCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCouponsQuery, GetAllCouponsQueryVariables>(GetAllCouponsDocument, options);
      }
export function useGetAllCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCouponsQuery, GetAllCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCouponsQuery, GetAllCouponsQueryVariables>(GetAllCouponsDocument, options);
        }
export function useGetAllCouponsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCouponsQuery, GetAllCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCouponsQuery, GetAllCouponsQueryVariables>(GetAllCouponsDocument, options);
        }
export type GetAllCouponsQueryHookResult = ReturnType<typeof useGetAllCouponsQuery>;
export type GetAllCouponsLazyQueryHookResult = ReturnType<typeof useGetAllCouponsLazyQuery>;
export type GetAllCouponsSuspenseQueryHookResult = ReturnType<typeof useGetAllCouponsSuspenseQuery>;
export type GetAllCouponsQueryResult = Apollo.QueryResult<GetAllCouponsQuery, GetAllCouponsQueryVariables>;
export const GetProductSuppliersDocument = gql`
    query GetProductSuppliers($filter: ProductSupplierSearchResolverFilterInput, $order: [SearchkickOrderByInput!], $page: Int, $pageSize: Int) {
  productSuppliers(
    filter: $filter
    orderBy: $order
    page: $page
    pageSize: $pageSize
  ) {
    currentPage
    totalCount
    totalPages
    pageSize
    nodes {
      supplierId: id
      active
      apexUpdated
      cancellationPolicy
      commission
      confirmationNumberInstruction
      contactEmail
      contactName
      contactPhoneMobile
      contactPhoneOffice
      contactPosition
      contractingAgent {
        id
        firstName
        lastName
      }
      contractingContactLastUpdatedAt
      contractingDetailLastUpdatedAt
      contractLink
      contractStatus
      currency
      email
      fulfilmentContactLastUpdatedAt
      fulfilmentDetailLastUpdatedAt
      fulfilmentNotes
      id
      name
      note
      order
      password
      paymentBulkBill
      paymentFrequency
      paymentMethod
      paymentOptions
      productType
      rateLink
      rateStatus
      resortName
      shortName
      spreadsheetUrl
      supplierProduct
      supplierType
      transferFulfilmentInstructions {
        active
        airport
        contactNumber
        direction
        id
        instructions
        name
        order
        updatedAt
      }
      url
      username
      vouchersRequired
    }
  }
}
    `;

/**
 * __useGetProductSuppliersQuery__
 *
 * To run a query within a React component, call `useGetProductSuppliersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSuppliersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSuppliersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetProductSuppliersQuery(baseOptions?: Apollo.QueryHookOptions<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>(GetProductSuppliersDocument, options);
      }
export function useGetProductSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>(GetProductSuppliersDocument, options);
        }
export function useGetProductSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>(GetProductSuppliersDocument, options);
        }
export type GetProductSuppliersQueryHookResult = ReturnType<typeof useGetProductSuppliersQuery>;
export type GetProductSuppliersLazyQueryHookResult = ReturnType<typeof useGetProductSuppliersLazyQuery>;
export type GetProductSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetProductSuppliersSuspenseQuery>;
export type GetProductSuppliersQueryResult = Apollo.QueryResult<GetProductSuppliersQuery, GetProductSuppliersQueryVariables>;
export const GetItinerariesDocument = gql`
    query GetItineraries($filter: ItinerarySearchResolverFilterInput, $orderBy: [SearchkickOrderByInput!], $page: Int, $pageSize: Int) {
  itineraries(
    filter: $filter
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    ...ItineraryPaginationFields
    nodes {
      id
      arriveAt
      countryName
      currency
      departAt
      email
      infoRequired
      flightInfoRequired
      fulfilmentAgent {
        id
        firstName
        lastName
      }
      fulfilmentState
      modified
      nextPaymentDueAt
      normalizedFirstName
      normalizedLastName
      phone
      propertyName
      publicId
      regionName
      remainingBalancesCollected
      resortName
      paidAt
      payableAmount
      preArrivalCompleted
      preArrivalCallOutcome
      products
      sessionId
      state
      propertyManualFulfilment
      skicomQuoteId
      oldFakeId
    }
  }
}
    ${ItineraryPaginationFieldsFragmentDoc}`;

/**
 * __useGetItinerariesQuery__
 *
 * To run a query within a React component, call `useGetItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItinerariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetItinerariesQuery(baseOptions?: Apollo.QueryHookOptions<GetItinerariesQuery, GetItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItinerariesQuery, GetItinerariesQueryVariables>(GetItinerariesDocument, options);
      }
export function useGetItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItinerariesQuery, GetItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItinerariesQuery, GetItinerariesQueryVariables>(GetItinerariesDocument, options);
        }
export function useGetItinerariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItinerariesQuery, GetItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItinerariesQuery, GetItinerariesQueryVariables>(GetItinerariesDocument, options);
        }
export type GetItinerariesQueryHookResult = ReturnType<typeof useGetItinerariesQuery>;
export type GetItinerariesLazyQueryHookResult = ReturnType<typeof useGetItinerariesLazyQuery>;
export type GetItinerariesSuspenseQueryHookResult = ReturnType<typeof useGetItinerariesSuspenseQuery>;
export type GetItinerariesQueryResult = Apollo.QueryResult<GetItinerariesQuery, GetItinerariesQueryVariables>;
export const GetViewerItineraryHistoryDocument = gql`
    query GetViewerItineraryHistory {
  viewer {
    user {
      id
      recentItineraries {
        id
        publicId
        email
        fulfilmentState
        normalizedFirstName
        normalizedLastName
        propertyLineItem {
          id
          product {
            id
            name
          }
          resort {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetViewerItineraryHistoryQuery__
 *
 * To run a query within a React component, call `useGetViewerItineraryHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewerItineraryHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewerItineraryHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetViewerItineraryHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>(GetViewerItineraryHistoryDocument, options);
      }
export function useGetViewerItineraryHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>(GetViewerItineraryHistoryDocument, options);
        }
export function useGetViewerItineraryHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>(GetViewerItineraryHistoryDocument, options);
        }
export type GetViewerItineraryHistoryQueryHookResult = ReturnType<typeof useGetViewerItineraryHistoryQuery>;
export type GetViewerItineraryHistoryLazyQueryHookResult = ReturnType<typeof useGetViewerItineraryHistoryLazyQuery>;
export type GetViewerItineraryHistorySuspenseQueryHookResult = ReturnType<typeof useGetViewerItineraryHistorySuspenseQuery>;
export type GetViewerItineraryHistoryQueryResult = Apollo.QueryResult<GetViewerItineraryHistoryQuery, GetViewerItineraryHistoryQueryVariables>;
export const ActivateTransferFulfilmentInstructionDocument = gql`
    mutation activateTransferFulfilmentInstruction($input: MutationsTransferFulfilmentInstructionActivateInput!) {
  transferFulfilmentInstruction {
    activate(input: $input) {
      transferFulfilmentInstruction {
        active
        airport
        contactNumber
        createdAt
        direction
        instructionId: id
        instructions
        name
        order
        updatedAt
        audits(first: 1) {
          nodes {
            id
            createdAt
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
}
    `;
export type ActivateTransferFulfilmentInstructionMutationFn = Apollo.MutationFunction<ActivateTransferFulfilmentInstructionMutation, ActivateTransferFulfilmentInstructionMutationVariables>;

/**
 * __useActivateTransferFulfilmentInstructionMutation__
 *
 * To run a mutation, you first call `useActivateTransferFulfilmentInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateTransferFulfilmentInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateTransferFulfilmentInstructionMutation, { data, loading, error }] = useActivateTransferFulfilmentInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateTransferFulfilmentInstructionMutation(baseOptions?: Apollo.MutationHookOptions<ActivateTransferFulfilmentInstructionMutation, ActivateTransferFulfilmentInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateTransferFulfilmentInstructionMutation, ActivateTransferFulfilmentInstructionMutationVariables>(ActivateTransferFulfilmentInstructionDocument, options);
      }
export type ActivateTransferFulfilmentInstructionMutationHookResult = ReturnType<typeof useActivateTransferFulfilmentInstructionMutation>;
export type ActivateTransferFulfilmentInstructionMutationResult = Apollo.MutationResult<ActivateTransferFulfilmentInstructionMutation>;
export type ActivateTransferFulfilmentInstructionMutationOptions = Apollo.BaseMutationOptions<ActivateTransferFulfilmentInstructionMutation, ActivateTransferFulfilmentInstructionMutationVariables>;
export const DeactivateTransferFulfilmentInstructionDocument = gql`
    mutation deactivateTransferFulfilmentInstruction($input: MutationsTransferFulfilmentInstructionDeactivateInput!) {
  transferFulfilmentInstruction {
    deactivate(input: $input) {
      transferFulfilmentInstruction {
        active
        airport
        contactNumber
        createdAt
        direction
        instructionId: id
        instructions
        name
        order
        updatedAt
        audits(first: 1) {
          nodes {
            id
            createdAt
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
}
    `;
export type DeactivateTransferFulfilmentInstructionMutationFn = Apollo.MutationFunction<DeactivateTransferFulfilmentInstructionMutation, DeactivateTransferFulfilmentInstructionMutationVariables>;

/**
 * __useDeactivateTransferFulfilmentInstructionMutation__
 *
 * To run a mutation, you first call `useDeactivateTransferFulfilmentInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateTransferFulfilmentInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateTransferFulfilmentInstructionMutation, { data, loading, error }] = useDeactivateTransferFulfilmentInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateTransferFulfilmentInstructionMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateTransferFulfilmentInstructionMutation, DeactivateTransferFulfilmentInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateTransferFulfilmentInstructionMutation, DeactivateTransferFulfilmentInstructionMutationVariables>(DeactivateTransferFulfilmentInstructionDocument, options);
      }
export type DeactivateTransferFulfilmentInstructionMutationHookResult = ReturnType<typeof useDeactivateTransferFulfilmentInstructionMutation>;
export type DeactivateTransferFulfilmentInstructionMutationResult = Apollo.MutationResult<DeactivateTransferFulfilmentInstructionMutation>;
export type DeactivateTransferFulfilmentInstructionMutationOptions = Apollo.BaseMutationOptions<DeactivateTransferFulfilmentInstructionMutation, DeactivateTransferFulfilmentInstructionMutationVariables>;
export const GetManualFulfilmentLineItemsDocument = gql`
    query GetManualFulfilmentLineItems($filter: ManualFulfilmentResolverManualFulfilmentInput, $orderBy: [SearchkickOrderByInput!], $page: Int, $pageSize: Int) {
  manualFulfilmentLineItems(
    filter: $filter
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    currentPage
    pageSize
    totalCount
    totalPages
    nodes {
      id
      arriveAt
      currency
      supplierCurrency
      departAt
      customerDepositAmount
      customerRemainingBalanceAmount
      customerRemainingBalanceDueAt
      customerRemainingBalancePaidAmount
      fulfilmentState
      fulfilmentAgentId
      fulfilmentAgent {
        id
        firstName
        lastName
      }
      assignedAgent {
        id
        firstName
        lastName
      }
      sessionId
      itineraryFulfilmentState
      itineraryId
      itineraryPublicId
      normalizedFirstName
      normalizedLastName
      margin
      paidAt
      payableAmount
      propertyName
      resortName
      supplierDepositAmount
      supplierDepositDueAt
      supplierDepositPaid
      supplierConfirmationNumber
      supplierCreditIssued
      supplierCreditAmount
      supplierLodgingTotal
      supplierRefundIssued
      supplierRefundAmount
      supplierRemainingBalanceAmount
      supplierRemainingBalanceDueAt
      supplierRemainingBalancePaid
      supplierOrderId
      propertySupplierUrl
      itineraryState
      propertyOrderedAt
      propertyCrosscheck
    }
  }
}
    `;

/**
 * __useGetManualFulfilmentLineItemsQuery__
 *
 * To run a query within a React component, call `useGetManualFulfilmentLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManualFulfilmentLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManualFulfilmentLineItemsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetManualFulfilmentLineItemsQuery(baseOptions?: Apollo.QueryHookOptions<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>(GetManualFulfilmentLineItemsDocument, options);
      }
export function useGetManualFulfilmentLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>(GetManualFulfilmentLineItemsDocument, options);
        }
export function useGetManualFulfilmentLineItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>(GetManualFulfilmentLineItemsDocument, options);
        }
export type GetManualFulfilmentLineItemsQueryHookResult = ReturnType<typeof useGetManualFulfilmentLineItemsQuery>;
export type GetManualFulfilmentLineItemsLazyQueryHookResult = ReturnType<typeof useGetManualFulfilmentLineItemsLazyQuery>;
export type GetManualFulfilmentLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetManualFulfilmentLineItemsSuspenseQuery>;
export type GetManualFulfilmentLineItemsQueryResult = Apollo.QueryResult<GetManualFulfilmentLineItemsQuery, GetManualFulfilmentLineItemsQueryVariables>;
export const UpdateTransferFulfilmentInstructionDocument = gql`
    mutation updateTransferFulfilmentInstruction($input: MutationsTransferFulfilmentInstructionUpdateInput!) {
  transferFulfilmentInstruction {
    update(input: $input) {
      transferFulfilmentInstruction {
        active
        airport
        contactNumber
        createdAt
        direction
        instructionId: id
        instructions
        name
        order
        updatedAt
        audits(first: 1) {
          nodes {
            id
            createdAt
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateTransferFulfilmentInstructionMutationFn = Apollo.MutationFunction<UpdateTransferFulfilmentInstructionMutation, UpdateTransferFulfilmentInstructionMutationVariables>;

/**
 * __useUpdateTransferFulfilmentInstructionMutation__
 *
 * To run a mutation, you first call `useUpdateTransferFulfilmentInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransferFulfilmentInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransferFulfilmentInstructionMutation, { data, loading, error }] = useUpdateTransferFulfilmentInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransferFulfilmentInstructionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransferFulfilmentInstructionMutation, UpdateTransferFulfilmentInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransferFulfilmentInstructionMutation, UpdateTransferFulfilmentInstructionMutationVariables>(UpdateTransferFulfilmentInstructionDocument, options);
      }
export type UpdateTransferFulfilmentInstructionMutationHookResult = ReturnType<typeof useUpdateTransferFulfilmentInstructionMutation>;
export type UpdateTransferFulfilmentInstructionMutationResult = Apollo.MutationResult<UpdateTransferFulfilmentInstructionMutation>;
export type UpdateTransferFulfilmentInstructionMutationOptions = Apollo.BaseMutationOptions<UpdateTransferFulfilmentInstructionMutation, UpdateTransferFulfilmentInstructionMutationVariables>;
export const GetSupportCasesDocument = gql`
    query GetSupportCases($filter: SupportCaseResolverFilterInput, $orderBy: [SearchkickOrderByInput!], $page: Int, $pageSize: Int) {
  supportCases(
    filter: $filter
    orderBy: $orderBy
    page: $page
    pageSize: $pageSize
  ) {
    currentPage
    pageSize
    totalCount
    totalPages
    nodes {
      id
      itineraryPublicId
      normalizedFirstName
      normalizedLastName
      email
      phone
      propertyName
      resortName
      arriveAt
      departAt
      fulfilmentState
      createdAt
      category
      subcategory
      action
      caseType
      latestConfirmedItineraryPublicId
      assignedTo {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetSupportCasesQuery__
 *
 * To run a query within a React component, call `useGetSupportCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSupportCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSupportCasesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useGetSupportCasesQuery(baseOptions?: Apollo.QueryHookOptions<GetSupportCasesQuery, GetSupportCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSupportCasesQuery, GetSupportCasesQueryVariables>(GetSupportCasesDocument, options);
      }
export function useGetSupportCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSupportCasesQuery, GetSupportCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSupportCasesQuery, GetSupportCasesQueryVariables>(GetSupportCasesDocument, options);
        }
export function useGetSupportCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSupportCasesQuery, GetSupportCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSupportCasesQuery, GetSupportCasesQueryVariables>(GetSupportCasesDocument, options);
        }
export type GetSupportCasesQueryHookResult = ReturnType<typeof useGetSupportCasesQuery>;
export type GetSupportCasesLazyQueryHookResult = ReturnType<typeof useGetSupportCasesLazyQuery>;
export type GetSupportCasesSuspenseQueryHookResult = ReturnType<typeof useGetSupportCasesSuspenseQuery>;
export type GetSupportCasesQueryResult = Apollo.QueryResult<GetSupportCasesQuery, GetSupportCasesQueryVariables>;
export const AddRentalDocument = gql`
    mutation AddRental($itinerarySessionId: ID!, $sku: ID!, $startAt: Date!, $travelerIdx: Int, $helmetIncluded: Boolean) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      addProduct: addRental(
        sku: $sku
        startAt: $startAt
        travelerIdx: $travelerIdx
        helmetIncluded: $helmetIncluded
      ) {
        itinerary {
          id
          updatedAt
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type AddRentalMutationFn = Apollo.MutationFunction<AddRentalMutation, AddRentalMutationVariables>;

/**
 * __useAddRentalMutation__
 *
 * To run a mutation, you first call `useAddRentalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRentalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRentalMutation, { data, loading, error }] = useAddRentalMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      sku: // value for 'sku'
 *      startAt: // value for 'startAt'
 *      travelerIdx: // value for 'travelerIdx'
 *      helmetIncluded: // value for 'helmetIncluded'
 *   },
 * });
 */
export function useAddRentalMutation(baseOptions?: Apollo.MutationHookOptions<AddRentalMutation, AddRentalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRentalMutation, AddRentalMutationVariables>(AddRentalDocument, options);
      }
export type AddRentalMutationHookResult = ReturnType<typeof useAddRentalMutation>;
export type AddRentalMutationResult = Apollo.MutationResult<AddRentalMutation>;
export type AddRentalMutationOptions = Apollo.BaseMutationOptions<AddRentalMutation, AddRentalMutationVariables>;
export const FindItineraryDocument = gql`
    query FindItinerary($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      publicId
      duplicated {
        id
        publicId
        createdAt
        isConfirmed
      }
    }
  }
}
    `;

/**
 * __useFindItineraryQuery__
 *
 * To run a query within a React component, call `useFindItineraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindItineraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindItineraryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindItineraryQuery(baseOptions: Apollo.QueryHookOptions<FindItineraryQuery, FindItineraryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindItineraryQuery, FindItineraryQueryVariables>(FindItineraryDocument, options);
      }
export function useFindItineraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindItineraryQuery, FindItineraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindItineraryQuery, FindItineraryQueryVariables>(FindItineraryDocument, options);
        }
export function useFindItinerarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindItineraryQuery, FindItineraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindItineraryQuery, FindItineraryQueryVariables>(FindItineraryDocument, options);
        }
export type FindItineraryQueryHookResult = ReturnType<typeof useFindItineraryQuery>;
export type FindItineraryLazyQueryHookResult = ReturnType<typeof useFindItineraryLazyQuery>;
export type FindItinerarySuspenseQueryHookResult = ReturnType<typeof useFindItinerarySuspenseQuery>;
export type FindItineraryQueryResult = Apollo.QueryResult<FindItineraryQuery, FindItineraryQueryVariables>;
export const AddLessonDocument = gql`
    mutation AddLesson($itinerarySessionId: ID, $sku: ID!, $startAt: Date!, $travelerIdx: Int, $participants: [Int!]) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      addProduct: addLesson(
        sku: $sku
        startAt: $startAt
        travelerIdx: $travelerIdx
        participants: $participants
      ) {
        itinerary {
          id
          updatedAt
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type AddLessonMutationFn = Apollo.MutationFunction<AddLessonMutation, AddLessonMutationVariables>;

/**
 * __useAddLessonMutation__
 *
 * To run a mutation, you first call `useAddLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLessonMutation, { data, loading, error }] = useAddLessonMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      sku: // value for 'sku'
 *      startAt: // value for 'startAt'
 *      travelerIdx: // value for 'travelerIdx'
 *      participants: // value for 'participants'
 *   },
 * });
 */
export function useAddLessonMutation(baseOptions?: Apollo.MutationHookOptions<AddLessonMutation, AddLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLessonMutation, AddLessonMutationVariables>(AddLessonDocument, options);
      }
export type AddLessonMutationHookResult = ReturnType<typeof useAddLessonMutation>;
export type AddLessonMutationResult = Apollo.MutationResult<AddLessonMutation>;
export type AddLessonMutationOptions = Apollo.BaseMutationOptions<AddLessonMutation, AddLessonMutationVariables>;
export const AddLiftTicketDocument = gql`
    mutation AddLiftTicket($itinerarySessionId: ID, $sku: ID!, $startAt: Date!, $travelerIdx: Int) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      addProduct: addLiftTicket(
        sku: $sku
        startAt: $startAt
        travelerIdx: $travelerIdx
      ) {
        itinerary {
          id
          updatedAt
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type AddLiftTicketMutationFn = Apollo.MutationFunction<AddLiftTicketMutation, AddLiftTicketMutationVariables>;

/**
 * __useAddLiftTicketMutation__
 *
 * To run a mutation, you first call `useAddLiftTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLiftTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLiftTicketMutation, { data, loading, error }] = useAddLiftTicketMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      sku: // value for 'sku'
 *      startAt: // value for 'startAt'
 *      travelerIdx: // value for 'travelerIdx'
 *   },
 * });
 */
export function useAddLiftTicketMutation(baseOptions?: Apollo.MutationHookOptions<AddLiftTicketMutation, AddLiftTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddLiftTicketMutation, AddLiftTicketMutationVariables>(AddLiftTicketDocument, options);
      }
export type AddLiftTicketMutationHookResult = ReturnType<typeof useAddLiftTicketMutation>;
export type AddLiftTicketMutationResult = Apollo.MutationResult<AddLiftTicketMutation>;
export type AddLiftTicketMutationOptions = Apollo.BaseMutationOptions<AddLiftTicketMutation, AddLiftTicketMutationVariables>;
export const CreateTransferFulfilmentInstructionDocument = gql`
    mutation createTransferFulfilmentInstruction($input: MutationsTransferFulfilmentInstructionCreateInput!) {
  transferFulfilmentInstruction {
    create(input: $input) {
      transferFulfilmentInstruction {
        active
        airport
        contactNumber
        createdAt
        direction
        instructionId: id
        instructions
        name
        order
        updatedAt
        audits(first: 1) {
          nodes {
            id
            createdAt
            user {
              id
              fullName
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateTransferFulfilmentInstructionMutationFn = Apollo.MutationFunction<CreateTransferFulfilmentInstructionMutation, CreateTransferFulfilmentInstructionMutationVariables>;

/**
 * __useCreateTransferFulfilmentInstructionMutation__
 *
 * To run a mutation, you first call `useCreateTransferFulfilmentInstructionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferFulfilmentInstructionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferFulfilmentInstructionMutation, { data, loading, error }] = useCreateTransferFulfilmentInstructionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransferFulfilmentInstructionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransferFulfilmentInstructionMutation, CreateTransferFulfilmentInstructionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransferFulfilmentInstructionMutation, CreateTransferFulfilmentInstructionMutationVariables>(CreateTransferFulfilmentInstructionDocument, options);
      }
export type CreateTransferFulfilmentInstructionMutationHookResult = ReturnType<typeof useCreateTransferFulfilmentInstructionMutation>;
export type CreateTransferFulfilmentInstructionMutationResult = Apollo.MutationResult<CreateTransferFulfilmentInstructionMutation>;
export type CreateTransferFulfilmentInstructionMutationOptions = Apollo.BaseMutationOptions<CreateTransferFulfilmentInstructionMutation, CreateTransferFulfilmentInstructionMutationVariables>;
export const AddTransportationDocument = gql`
    mutation AddTransportation($itinerarySessionId: ID!, $sku: ID!, $startAt: Date!, $travelerIdx: Int) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      addProduct: addTransportation(
        sku: $sku
        startAt: $startAt
        travelerIdx: $travelerIdx
      ) {
        itinerary {
          id
          updatedAt
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type AddTransportationMutationFn = Apollo.MutationFunction<AddTransportationMutation, AddTransportationMutationVariables>;

/**
 * __useAddTransportationMutation__
 *
 * To run a mutation, you first call `useAddTransportationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTransportationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTransportationMutation, { data, loading, error }] = useAddTransportationMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      sku: // value for 'sku'
 *      startAt: // value for 'startAt'
 *      travelerIdx: // value for 'travelerIdx'
 *   },
 * });
 */
export function useAddTransportationMutation(baseOptions?: Apollo.MutationHookOptions<AddTransportationMutation, AddTransportationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTransportationMutation, AddTransportationMutationVariables>(AddTransportationDocument, options);
      }
export type AddTransportationMutationHookResult = ReturnType<typeof useAddTransportationMutation>;
export type AddTransportationMutationResult = Apollo.MutationResult<AddTransportationMutation>;
export type AddTransportationMutationOptions = Apollo.BaseMutationOptions<AddTransportationMutation, AddTransportationMutationVariables>;
export const GetItineraryUserCreditCardsDocument = gql`
    query GetItineraryUserCreditCards($id: ID!, $skip: Boolean!) {
  itinerary @skip(if: $skip) {
    itinerary(id: $id) {
      id
      currency
      state
      user {
        id
        ...UserCreditCardFormFields
        creditCards {
          nodes {
            id
            createdAt
            cardType
            defaultCard
            expiresAt
            last4
            paymentGateway
          }
        }
      }
    }
  }
}
    ${UserCreditCardFormFieldsFragmentDoc}`;

/**
 * __useGetItineraryUserCreditCardsQuery__
 *
 * To run a query within a React component, call `useGetItineraryUserCreditCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryUserCreditCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryUserCreditCardsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItineraryUserCreditCardsQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>(GetItineraryUserCreditCardsDocument, options);
      }
export function useGetItineraryUserCreditCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>(GetItineraryUserCreditCardsDocument, options);
        }
export function useGetItineraryUserCreditCardsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>(GetItineraryUserCreditCardsDocument, options);
        }
export type GetItineraryUserCreditCardsQueryHookResult = ReturnType<typeof useGetItineraryUserCreditCardsQuery>;
export type GetItineraryUserCreditCardsLazyQueryHookResult = ReturnType<typeof useGetItineraryUserCreditCardsLazyQuery>;
export type GetItineraryUserCreditCardsSuspenseQueryHookResult = ReturnType<typeof useGetItineraryUserCreditCardsSuspenseQuery>;
export type GetItineraryUserCreditCardsQueryResult = Apollo.QueryResult<GetItineraryUserCreditCardsQuery, GetItineraryUserCreditCardsQueryVariables>;
export const RemoveCreditCardDocument = gql`
    mutation RemoveCreditCard($input: MutationsCreditCardRemoveInput!) {
  creditCard {
    remove(input: $input) {
      creditCard {
        id
      }
    }
  }
}
    `;
export type RemoveCreditCardMutationFn = Apollo.MutationFunction<RemoveCreditCardMutation, RemoveCreditCardMutationVariables>;

/**
 * __useRemoveCreditCardMutation__
 *
 * To run a mutation, you first call `useRemoveCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreditCardMutation, { data, loading, error }] = useRemoveCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCreditCardMutation, RemoveCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCreditCardMutation, RemoveCreditCardMutationVariables>(RemoveCreditCardDocument, options);
      }
export type RemoveCreditCardMutationHookResult = ReturnType<typeof useRemoveCreditCardMutation>;
export type RemoveCreditCardMutationResult = Apollo.MutationResult<RemoveCreditCardMutation>;
export type RemoveCreditCardMutationOptions = Apollo.BaseMutationOptions<RemoveCreditCardMutation, RemoveCreditCardMutationVariables>;
export const AddUpsellDocument = gql`
    mutation addUpsell($itinerarySessionId: ID, $sku: ID!, $startAt: Date!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      addProduct: addUpsell(sku: $sku, startAt: $startAt) {
        itinerary {
          id
          updatedAt
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type AddUpsellMutationFn = Apollo.MutationFunction<AddUpsellMutation, AddUpsellMutationVariables>;

/**
 * __useAddUpsellMutation__
 *
 * To run a mutation, you first call `useAddUpsellMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUpsellMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUpsellMutation, { data, loading, error }] = useAddUpsellMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      sku: // value for 'sku'
 *      startAt: // value for 'startAt'
 *   },
 * });
 */
export function useAddUpsellMutation(baseOptions?: Apollo.MutationHookOptions<AddUpsellMutation, AddUpsellMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUpsellMutation, AddUpsellMutationVariables>(AddUpsellDocument, options);
      }
export type AddUpsellMutationHookResult = ReturnType<typeof useAddUpsellMutation>;
export type AddUpsellMutationResult = Apollo.MutationResult<AddUpsellMutation>;
export type AddUpsellMutationOptions = Apollo.BaseMutationOptions<AddUpsellMutation, AddUpsellMutationVariables>;
export const RemoveDuplicateDocument = gql`
    mutation RemoveDuplicate($itinerarySessionId: ID!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      removeDuplicate {
        itinerary {
          id
          publicId
          duplicated {
            id
          }
          main {
            id
            duplicated {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type RemoveDuplicateMutationFn = Apollo.MutationFunction<RemoveDuplicateMutation, RemoveDuplicateMutationVariables>;

/**
 * __useRemoveDuplicateMutation__
 *
 * To run a mutation, you first call `useRemoveDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDuplicateMutation, { data, loading, error }] = useRemoveDuplicateMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *   },
 * });
 */
export function useRemoveDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDuplicateMutation, RemoveDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDuplicateMutation, RemoveDuplicateMutationVariables>(RemoveDuplicateDocument, options);
      }
export type RemoveDuplicateMutationHookResult = ReturnType<typeof useRemoveDuplicateMutation>;
export type RemoveDuplicateMutationResult = Apollo.MutationResult<RemoveDuplicateMutation>;
export type RemoveDuplicateMutationOptions = Apollo.BaseMutationOptions<RemoveDuplicateMutation, RemoveDuplicateMutationVariables>;
export const SetDefaultCreditCardDocument = gql`
    mutation SetDefaultCreditCard($input: MutationsCreditCardSetDefaultCardInput!) {
  creditCard {
    setDefaultCard(input: $input) {
      creditCard {
        id
      }
    }
  }
}
    `;
export type SetDefaultCreditCardMutationFn = Apollo.MutationFunction<SetDefaultCreditCardMutation, SetDefaultCreditCardMutationVariables>;

/**
 * __useSetDefaultCreditCardMutation__
 *
 * To run a mutation, you first call `useSetDefaultCreditCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultCreditCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultCreditCardMutation, { data, loading, error }] = useSetDefaultCreditCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDefaultCreditCardMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultCreditCardMutation, SetDefaultCreditCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultCreditCardMutation, SetDefaultCreditCardMutationVariables>(SetDefaultCreditCardDocument, options);
      }
export type SetDefaultCreditCardMutationHookResult = ReturnType<typeof useSetDefaultCreditCardMutation>;
export type SetDefaultCreditCardMutationResult = Apollo.MutationResult<SetDefaultCreditCardMutation>;
export type SetDefaultCreditCardMutationOptions = Apollo.BaseMutationOptions<SetDefaultCreditCardMutation, SetDefaultCreditCardMutationVariables>;
export const GetItineraryStateDocument = gql`
    query GetItineraryState($id: ID!, $skip: Boolean!) {
  itinerary @skip(if: $skip) {
    itinerary(id: $id) {
      id
      publicId
      child {
        id
        publicId
        state
      }
      main {
        id
        publicId
        state
      }
      normalizedFirstName
      normalizedLastName
      totalAmount
      totalPayable
      couponDiscount
      currency
      state
      fulfilmentState
      isDuplicated
      isPaid
      isCancelled
      isConfirmed
      isModified
      preArrivalCompleted
      postBookingCallSuccessful
      postBookingCallUnsuccessful
      manualFollowupEmail4Required
      isInformationRequired
      isFlightsRequired
      refundableAmount
      propertyLineItem {
        id
        hasOverrideData
      }
      scheduledPayments(paymentType: [ALL], snowpakCollect: true) {
        nodes {
          id
          isModified
        }
      }
    }
  }
}
    `;

/**
 * __useGetItineraryStateQuery__
 *
 * To run a query within a React component, call `useGetItineraryStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItineraryStateQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryStateQuery, GetItineraryStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryStateQuery, GetItineraryStateQueryVariables>(GetItineraryStateDocument, options);
      }
export function useGetItineraryStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryStateQuery, GetItineraryStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryStateQuery, GetItineraryStateQueryVariables>(GetItineraryStateDocument, options);
        }
export function useGetItineraryStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryStateQuery, GetItineraryStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryStateQuery, GetItineraryStateQueryVariables>(GetItineraryStateDocument, options);
        }
export type GetItineraryStateQueryHookResult = ReturnType<typeof useGetItineraryStateQuery>;
export type GetItineraryStateLazyQueryHookResult = ReturnType<typeof useGetItineraryStateLazyQuery>;
export type GetItineraryStateSuspenseQueryHookResult = ReturnType<typeof useGetItineraryStateSuspenseQuery>;
export type GetItineraryStateQueryResult = Apollo.QueryResult<GetItineraryStateQuery, GetItineraryStateQueryVariables>;
export const ClearRefundableAmountDocument = gql`
    mutation ClearRefundableAmount($id: ID!, $input: ClearRefundableAmountInput!) {
  viewer {
    itinerary(id: $id) {
      clearRefundableAmount(input: $input) {
        itinerary {
          id
          refundableAmount
        }
      }
    }
  }
}
    `;
export type ClearRefundableAmountMutationFn = Apollo.MutationFunction<ClearRefundableAmountMutation, ClearRefundableAmountMutationVariables>;

/**
 * __useClearRefundableAmountMutation__
 *
 * To run a mutation, you first call `useClearRefundableAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRefundableAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRefundableAmountMutation, { data, loading, error }] = useClearRefundableAmountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearRefundableAmountMutation(baseOptions?: Apollo.MutationHookOptions<ClearRefundableAmountMutation, ClearRefundableAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearRefundableAmountMutation, ClearRefundableAmountMutationVariables>(ClearRefundableAmountDocument, options);
      }
export type ClearRefundableAmountMutationHookResult = ReturnType<typeof useClearRefundableAmountMutation>;
export type ClearRefundableAmountMutationResult = Apollo.MutationResult<ClearRefundableAmountMutation>;
export type ClearRefundableAmountMutationOptions = Apollo.BaseMutationOptions<ClearRefundableAmountMutation, ClearRefundableAmountMutationVariables>;
export const DuplicateItineraryDocument = gql`
    mutation DuplicateItinerary($id: ID!, $input: DuplicateItineraryInput!) {
  viewer {
    itinerary(id: $id) {
      duplicateItinerary(input: $input) {
        itinerary {
          id
          publicId
        }
      }
    }
  }
}
    `;
export type DuplicateItineraryMutationFn = Apollo.MutationFunction<DuplicateItineraryMutation, DuplicateItineraryMutationVariables>;

/**
 * __useDuplicateItineraryMutation__
 *
 * To run a mutation, you first call `useDuplicateItineraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateItineraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateItineraryMutation, { data, loading, error }] = useDuplicateItineraryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateItineraryMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateItineraryMutation, DuplicateItineraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateItineraryMutation, DuplicateItineraryMutationVariables>(DuplicateItineraryDocument, options);
      }
export type DuplicateItineraryMutationHookResult = ReturnType<typeof useDuplicateItineraryMutation>;
export type DuplicateItineraryMutationResult = Apollo.MutationResult<DuplicateItineraryMutation>;
export type DuplicateItineraryMutationOptions = Apollo.BaseMutationOptions<DuplicateItineraryMutation, DuplicateItineraryMutationVariables>;
export const UpdateItineraryStatesDocument = gql`
    mutation updateItineraryStates($id: ID!, $input: UpdateItineraryStatesInput!) {
  viewer {
    itinerary(id: $id) {
      updateItineraryStates: updateStates(input: $input) {
        itinerary {
          id
          publicId
          isFlightsRequired
        }
      }
    }
  }
}
    `;
export type UpdateItineraryStatesMutationFn = Apollo.MutationFunction<UpdateItineraryStatesMutation, UpdateItineraryStatesMutationVariables>;

/**
 * __useUpdateItineraryStatesMutation__
 *
 * To run a mutation, you first call `useUpdateItineraryStatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItineraryStatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItineraryStatesMutation, { data, loading, error }] = useUpdateItineraryStatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItineraryStatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItineraryStatesMutation, UpdateItineraryStatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItineraryStatesMutation, UpdateItineraryStatesMutationVariables>(UpdateItineraryStatesDocument, options);
      }
export type UpdateItineraryStatesMutationHookResult = ReturnType<typeof useUpdateItineraryStatesMutation>;
export type UpdateItineraryStatesMutationResult = Apollo.MutationResult<UpdateItineraryStatesMutation>;
export type UpdateItineraryStatesMutationOptions = Apollo.BaseMutationOptions<UpdateItineraryStatesMutation, UpdateItineraryStatesMutationVariables>;
export const UpdateItineraryDataDocument = gql`
    mutation updateItineraryData($itinerarySessionId: ID!, $input: UpdateItineraryDataInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateData(input: $input) {
        itinerary {
          id
          data
          liftTicketLineItems {
            nodes {
              id
              fulfillmentInstructions
            }
          }
          rentalLineItems {
            nodes {
              id
              fulfillmentInstructions
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateItineraryDataMutationFn = Apollo.MutationFunction<UpdateItineraryDataMutation, UpdateItineraryDataMutationVariables>;

/**
 * __useUpdateItineraryDataMutation__
 *
 * To run a mutation, you first call `useUpdateItineraryDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItineraryDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItineraryDataMutation, { data, loading, error }] = useUpdateItineraryDataMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItineraryDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItineraryDataMutation, UpdateItineraryDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItineraryDataMutation, UpdateItineraryDataMutationVariables>(UpdateItineraryDataDocument, options);
      }
export type UpdateItineraryDataMutationHookResult = ReturnType<typeof useUpdateItineraryDataMutation>;
export type UpdateItineraryDataMutationResult = Apollo.MutationResult<UpdateItineraryDataMutation>;
export type UpdateItineraryDataMutationOptions = Apollo.BaseMutationOptions<UpdateItineraryDataMutation, UpdateItineraryDataMutationVariables>;
export const AssignLineItemAgentDocument = gql`
    mutation AssignLineItemAgent($itinerarySessionId: ID, $input: AssignLineItemAgentInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      assignLineItemAgent(input: $input) {
        lineItem {
          id
          fulfilmentAgent {
            id
            ...UserCoreFields
          }
          assignedAgent {
            id
            ...UserCoreFields
          }
        }
      }
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type AssignLineItemAgentMutationFn = Apollo.MutationFunction<AssignLineItemAgentMutation, AssignLineItemAgentMutationVariables>;

/**
 * __useAssignLineItemAgentMutation__
 *
 * To run a mutation, you first call `useAssignLineItemAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignLineItemAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignLineItemAgentMutation, { data, loading, error }] = useAssignLineItemAgentMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignLineItemAgentMutation(baseOptions?: Apollo.MutationHookOptions<AssignLineItemAgentMutation, AssignLineItemAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignLineItemAgentMutation, AssignLineItemAgentMutationVariables>(AssignLineItemAgentDocument, options);
      }
export type AssignLineItemAgentMutationHookResult = ReturnType<typeof useAssignLineItemAgentMutation>;
export type AssignLineItemAgentMutationResult = Apollo.MutationResult<AssignLineItemAgentMutation>;
export type AssignLineItemAgentMutationOptions = Apollo.BaseMutationOptions<AssignLineItemAgentMutation, AssignLineItemAgentMutationVariables>;
export const UpdateItineraryFulfilmentStateDocument = gql`
    mutation UpdateItineraryFulfilmentState($itinerarySessionId: ID!, $input: UpdateItineraryFulfilmentStateInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateFulfilmentState(input: $input) {
        itinerary {
          id
          fulfilmentState
        }
      }
    }
  }
}
    `;
export type UpdateItineraryFulfilmentStateMutationFn = Apollo.MutationFunction<UpdateItineraryFulfilmentStateMutation, UpdateItineraryFulfilmentStateMutationVariables>;

/**
 * __useUpdateItineraryFulfilmentStateMutation__
 *
 * To run a mutation, you first call `useUpdateItineraryFulfilmentStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateItineraryFulfilmentStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateItineraryFulfilmentStateMutation, { data, loading, error }] = useUpdateItineraryFulfilmentStateMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateItineraryFulfilmentStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateItineraryFulfilmentStateMutation, UpdateItineraryFulfilmentStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateItineraryFulfilmentStateMutation, UpdateItineraryFulfilmentStateMutationVariables>(UpdateItineraryFulfilmentStateDocument, options);
      }
export type UpdateItineraryFulfilmentStateMutationHookResult = ReturnType<typeof useUpdateItineraryFulfilmentStateMutation>;
export type UpdateItineraryFulfilmentStateMutationResult = Apollo.MutationResult<UpdateItineraryFulfilmentStateMutation>;
export type UpdateItineraryFulfilmentStateMutationOptions = Apollo.BaseMutationOptions<UpdateItineraryFulfilmentStateMutation, UpdateItineraryFulfilmentStateMutationVariables>;
export const GetCustomerItinerariesDocument = gql`
    query GetCustomerItineraries($filter: ItinerarySearchResolverFilterInput, $order: [SearchkickOrderByInput!]) {
  itineraries(filter: $filter, orderBy: $order) {
    nodes {
      id
      state
      fulfilmentState
      arriveAt
      payableAmount(currency: "USD")
      mainId
      mainPublicId
      publicId
    }
  }
}
    `;

/**
 * __useGetCustomerItinerariesQuery__
 *
 * To run a query within a React component, call `useGetCustomerItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerItinerariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetCustomerItinerariesQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>(GetCustomerItinerariesDocument, options);
      }
export function useGetCustomerItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>(GetCustomerItinerariesDocument, options);
        }
export function useGetCustomerItinerariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>(GetCustomerItinerariesDocument, options);
        }
export type GetCustomerItinerariesQueryHookResult = ReturnType<typeof useGetCustomerItinerariesQuery>;
export type GetCustomerItinerariesLazyQueryHookResult = ReturnType<typeof useGetCustomerItinerariesLazyQuery>;
export type GetCustomerItinerariesSuspenseQueryHookResult = ReturnType<typeof useGetCustomerItinerariesSuspenseQuery>;
export type GetCustomerItinerariesQueryResult = Apollo.QueryResult<GetCustomerItinerariesQuery, GetCustomerItinerariesQueryVariables>;
export const UpdateLessonLineItemDocument = gql`
    mutation UpdateLessonLineItem($itinerarySessionId: ID, $lineItemId: ID!, $data: LessonLineItem!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateLesson(id: $lineItemId, data: $data) {
        lineItem {
          id
          firstName
          lastName
          dob
        }
      }
    }
  }
}
    `;
export type UpdateLessonLineItemMutationFn = Apollo.MutationFunction<UpdateLessonLineItemMutation, UpdateLessonLineItemMutationVariables>;

/**
 * __useUpdateLessonLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateLessonLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLessonLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLessonLineItemMutation, { data, loading, error }] = useUpdateLessonLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      lineItemId: // value for 'lineItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLessonLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLessonLineItemMutation, UpdateLessonLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLessonLineItemMutation, UpdateLessonLineItemMutationVariables>(UpdateLessonLineItemDocument, options);
      }
export type UpdateLessonLineItemMutationHookResult = ReturnType<typeof useUpdateLessonLineItemMutation>;
export type UpdateLessonLineItemMutationResult = Apollo.MutationResult<UpdateLessonLineItemMutation>;
export type UpdateLessonLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateLessonLineItemMutation, UpdateLessonLineItemMutationVariables>;
export const UpdateLiftTicketLineItemDocument = gql`
    mutation UpdateLiftTicketLineItem($itinerarySessionId: ID, $lineItemId: ID!, $data: LiftTicketLineItem!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateLiftTicket(id: $lineItemId, data: $data) {
        lineItem {
          id
          firstName
          lastName
          dob
        }
      }
    }
  }
}
    `;
export type UpdateLiftTicketLineItemMutationFn = Apollo.MutationFunction<UpdateLiftTicketLineItemMutation, UpdateLiftTicketLineItemMutationVariables>;

/**
 * __useUpdateLiftTicketLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateLiftTicketLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiftTicketLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiftTicketLineItemMutation, { data, loading, error }] = useUpdateLiftTicketLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      lineItemId: // value for 'lineItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLiftTicketLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLiftTicketLineItemMutation, UpdateLiftTicketLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLiftTicketLineItemMutation, UpdateLiftTicketLineItemMutationVariables>(UpdateLiftTicketLineItemDocument, options);
      }
export type UpdateLiftTicketLineItemMutationHookResult = ReturnType<typeof useUpdateLiftTicketLineItemMutation>;
export type UpdateLiftTicketLineItemMutationResult = Apollo.MutationResult<UpdateLiftTicketLineItemMutation>;
export type UpdateLiftTicketLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateLiftTicketLineItemMutation, UpdateLiftTicketLineItemMutationVariables>;
export const UpdateLineItemSupplierDataDocument = gql`
    mutation UpdateLineItemSupplierData($id: ID!, $input: UpdateLineItemInput!) {
  viewer {
    itinerary(id: $id) {
      updateLineItem(input: $input) {
        lineItem {
          id
          data
          costAmount
          supplierOrderId
          supplierConfirmationNumber
        }
      }
    }
  }
}
    `;
export type UpdateLineItemSupplierDataMutationFn = Apollo.MutationFunction<UpdateLineItemSupplierDataMutation, UpdateLineItemSupplierDataMutationVariables>;

/**
 * __useUpdateLineItemSupplierDataMutation__
 *
 * To run a mutation, you first call `useUpdateLineItemSupplierDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineItemSupplierDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineItemSupplierDataMutation, { data, loading, error }] = useUpdateLineItemSupplierDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineItemSupplierDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineItemSupplierDataMutation, UpdateLineItemSupplierDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineItemSupplierDataMutation, UpdateLineItemSupplierDataMutationVariables>(UpdateLineItemSupplierDataDocument, options);
      }
export type UpdateLineItemSupplierDataMutationHookResult = ReturnType<typeof useUpdateLineItemSupplierDataMutation>;
export type UpdateLineItemSupplierDataMutationResult = Apollo.MutationResult<UpdateLineItemSupplierDataMutation>;
export type UpdateLineItemSupplierDataMutationOptions = Apollo.BaseMutationOptions<UpdateLineItemSupplierDataMutation, UpdateLineItemSupplierDataMutationVariables>;
export const UpdateLineItemSupplierDocument = gql`
    mutation UpdateLineItemSupplier($itinerarySessionId: ID, $input: UpdateLineItemSupplierInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateLineItemSupplier(input: $input) {
        lineItem {
          id
          productSupplier {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type UpdateLineItemSupplierMutationFn = Apollo.MutationFunction<UpdateLineItemSupplierMutation, UpdateLineItemSupplierMutationVariables>;

/**
 * __useUpdateLineItemSupplierMutation__
 *
 * To run a mutation, you first call `useUpdateLineItemSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineItemSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineItemSupplierMutation, { data, loading, error }] = useUpdateLineItemSupplierMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineItemSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineItemSupplierMutation, UpdateLineItemSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineItemSupplierMutation, UpdateLineItemSupplierMutationVariables>(UpdateLineItemSupplierDocument, options);
      }
export type UpdateLineItemSupplierMutationHookResult = ReturnType<typeof useUpdateLineItemSupplierMutation>;
export type UpdateLineItemSupplierMutationResult = Apollo.MutationResult<UpdateLineItemSupplierMutation>;
export type UpdateLineItemSupplierMutationOptions = Apollo.BaseMutationOptions<UpdateLineItemSupplierMutation, UpdateLineItemSupplierMutationVariables>;
export const SendEmailDocument = gql`
    mutation SendEmail($itineraryId: ID!, $input: SendEmailInput!) {
  viewer {
    itinerary(id: $itineraryId) {
      sendEmail(input: $input) {
        itinerary {
          id
          fulfilmentState
        }
      }
    }
  }
}
    `;
export type SendEmailMutationFn = Apollo.MutationFunction<SendEmailMutation, SendEmailMutationVariables>;

/**
 * __useSendEmailMutation__
 *
 * To run a mutation, you first call `useSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailMutation, { data, loading, error }] = useSendEmailMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailMutation, SendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailMutation, SendEmailMutationVariables>(SendEmailDocument, options);
      }
export type SendEmailMutationHookResult = ReturnType<typeof useSendEmailMutation>;
export type SendEmailMutationResult = Apollo.MutationResult<SendEmailMutation>;
export type SendEmailMutationOptions = Apollo.BaseMutationOptions<SendEmailMutation, SendEmailMutationVariables>;
export const UpdateRentalLineItemDocument = gql`
    mutation UpdateRentalLineItem($itinerarySessionId: ID, $lineItemId: ID!, $data: RentalLineItem!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateRental(id: $lineItemId, data: $data) {
        lineItem {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export type UpdateRentalLineItemMutationFn = Apollo.MutationFunction<UpdateRentalLineItemMutation, UpdateRentalLineItemMutationVariables>;

/**
 * __useUpdateRentalLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateRentalLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRentalLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRentalLineItemMutation, { data, loading, error }] = useUpdateRentalLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      lineItemId: // value for 'lineItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRentalLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRentalLineItemMutation, UpdateRentalLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRentalLineItemMutation, UpdateRentalLineItemMutationVariables>(UpdateRentalLineItemDocument, options);
      }
export type UpdateRentalLineItemMutationHookResult = ReturnType<typeof useUpdateRentalLineItemMutation>;
export type UpdateRentalLineItemMutationResult = Apollo.MutationResult<UpdateRentalLineItemMutation>;
export type UpdateRentalLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateRentalLineItemMutation, UpdateRentalLineItemMutationVariables>;
export const UpdateUpsellLineItemDocument = gql`
    mutation UpdateUpsellLineItem($itinerarySessionId: ID, $lineItemId: ID!, $data: UpsellLineItem!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateUpsell(id: $lineItemId, data: $data) {
        lineItem {
          id
          amount
          firstName
          lastName
          dob
        }
      }
    }
  }
}
    `;
export type UpdateUpsellLineItemMutationFn = Apollo.MutationFunction<UpdateUpsellLineItemMutation, UpdateUpsellLineItemMutationVariables>;

/**
 * __useUpdateUpsellLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateUpsellLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUpsellLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUpsellLineItemMutation, { data, loading, error }] = useUpdateUpsellLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      lineItemId: // value for 'lineItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUpsellLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUpsellLineItemMutation, UpdateUpsellLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUpsellLineItemMutation, UpdateUpsellLineItemMutationVariables>(UpdateUpsellLineItemDocument, options);
      }
export type UpdateUpsellLineItemMutationHookResult = ReturnType<typeof useUpdateUpsellLineItemMutation>;
export type UpdateUpsellLineItemMutationResult = Apollo.MutationResult<UpdateUpsellLineItemMutation>;
export type UpdateUpsellLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateUpsellLineItemMutation, UpdateUpsellLineItemMutationVariables>;
export const UpdateLineItemFulfilmentStateDocument = gql`
    mutation UpdateLineItemFulfilmentState($id: ID!, $input: UpdateLineItemFulfilmentStateInput!) {
  viewer {
    itinerary(id: $id) {
      updateLineItemFulfilmentState(input: $input) {
        itinerary {
          id
          fulfilmentState
        }
        lineItem {
          id
          fulfilmentState
        }
      }
    }
  }
}
    `;
export type UpdateLineItemFulfilmentStateMutationFn = Apollo.MutationFunction<UpdateLineItemFulfilmentStateMutation, UpdateLineItemFulfilmentStateMutationVariables>;

/**
 * __useUpdateLineItemFulfilmentStateMutation__
 *
 * To run a mutation, you first call `useUpdateLineItemFulfilmentStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLineItemFulfilmentStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLineItemFulfilmentStateMutation, { data, loading, error }] = useUpdateLineItemFulfilmentStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLineItemFulfilmentStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLineItemFulfilmentStateMutation, UpdateLineItemFulfilmentStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLineItemFulfilmentStateMutation, UpdateLineItemFulfilmentStateMutationVariables>(UpdateLineItemFulfilmentStateDocument, options);
      }
export type UpdateLineItemFulfilmentStateMutationHookResult = ReturnType<typeof useUpdateLineItemFulfilmentStateMutation>;
export type UpdateLineItemFulfilmentStateMutationResult = Apollo.MutationResult<UpdateLineItemFulfilmentStateMutation>;
export type UpdateLineItemFulfilmentStateMutationOptions = Apollo.BaseMutationOptions<UpdateLineItemFulfilmentStateMutation, UpdateLineItemFulfilmentStateMutationVariables>;
export const GetLessonLineItemsDocument = gql`
    query GetLessonLineItems($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      arriveAt
      departAt
      isDraftDuplicate
      normalizedTravelerDetails {
        normalizedFirstName
        normalizedLastName
        dob
        travelerIdx
      }
      ...ItineraryPricingFields
      propertyLineItem {
        id
        resort {
          id
          slug
          name
        }
      }
      lineItems: lessonLineItems {
        nodes {
          id
          data
          travelerIdx
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          costAmount
          costAmountCurrency
          currency
          payableAmount
          fulfilmentState
          fulfilmentInstructionLocation
          travelerIdx
          hasPriceChanges
          product {
            id
            name
            sku
            age
            fulfillmentInstructions
            daysInAdvance
            size: lesson
            sport: gear
            skill
            participants
            duration
            checkinTime
            lessonTime
            resort {
              id
              name
              slug
              productSuppliers(productType: LESSON) {
                id
                name
                shortName
                url
                bookingPortalType
                mainSupplier
                cancellationPolicy
                currency
              }
            }
          }
          productSupplier {
            id
            name
            shortName
            url
            bookingPortalType
            cancellationPolicy
            currency
            vouchersRequired
          }
          fulfilmentState
          fulfilmentAgent {
            id
            firstName
            lastName
          }
          supplierOrderId
          supplierConfirmationNumber
          crosscheck
        }
      }
    }
  }
}
    ${ItineraryPricingFieldsFragmentDoc}`;

/**
 * __useGetLessonLineItemsQuery__
 *
 * To run a query within a React component, call `useGetLessonLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLessonLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLessonLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLessonLineItemsQuery(baseOptions: Apollo.QueryHookOptions<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>(GetLessonLineItemsDocument, options);
      }
export function useGetLessonLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>(GetLessonLineItemsDocument, options);
        }
export function useGetLessonLineItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>(GetLessonLineItemsDocument, options);
        }
export type GetLessonLineItemsQueryHookResult = ReturnType<typeof useGetLessonLineItemsQuery>;
export type GetLessonLineItemsLazyQueryHookResult = ReturnType<typeof useGetLessonLineItemsLazyQuery>;
export type GetLessonLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetLessonLineItemsSuspenseQuery>;
export type GetLessonLineItemsQueryResult = Apollo.QueryResult<GetLessonLineItemsQuery, GetLessonLineItemsQueryVariables>;
export const UpdateTransportationLineItemDocument = gql`
    mutation UpdateTransportationLineItem($itinerarySessionId: ID, $lineItemId: ID!, $data: TransportationLineItem!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateTransportation(id: $lineItemId, data: $data) {
        lineItem {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export type UpdateTransportationLineItemMutationFn = Apollo.MutationFunction<UpdateTransportationLineItemMutation, UpdateTransportationLineItemMutationVariables>;

/**
 * __useUpdateTransportationLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateTransportationLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransportationLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransportationLineItemMutation, { data, loading, error }] = useUpdateTransportationLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      lineItemId: // value for 'lineItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTransportationLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransportationLineItemMutation, UpdateTransportationLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransportationLineItemMutation, UpdateTransportationLineItemMutationVariables>(UpdateTransportationLineItemDocument, options);
      }
export type UpdateTransportationLineItemMutationHookResult = ReturnType<typeof useUpdateTransportationLineItemMutation>;
export type UpdateTransportationLineItemMutationResult = Apollo.MutationResult<UpdateTransportationLineItemMutation>;
export type UpdateTransportationLineItemMutationOptions = Apollo.BaseMutationOptions<UpdateTransportationLineItemMutation, UpdateTransportationLineItemMutationVariables>;
export const GetItineraryLodgingDocument = gql`
    query GetItineraryLodging($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      sessionId
      currency
      isDraftDuplicate
      isPaid
      parentId
      cancelPenalties
      state
      ...ItineraryPricingFields
      liftTicketLineItems(first: 1) {
        nodes {
          id
        }
      }
      rentalLineItems(first: 1) {
        nodes {
          id
        }
      }
      lessonLineItems(first: 1) {
        nodes {
          id
        }
      }
      transportationLineItems(first: 1) {
        nodes {
          id
        }
      }
      propertyLineItem {
        id
        isPaid
        inventoryType
        manualFulfilment
        arriveAt
        departAt
        nights
        amount
        taxAmount
        discountAmount
        costAmount
        costAmountCurrency
        payableAmount
        hasPriceChanges
        amountIncTax
        resortFeesAmount
        markedAsCancelled
        state
        data
        bedGroup {
          id
          description
          configuration
        }
        room {
          id
          name
        }
        rate {
          id
          bedGroups {
            configuration
            tokens
          }
          cancelPenalties
          refundable
        }
        product {
          id
          address
          checkin
          name
          phone
        }
        productSupplier {
          id
          name
          cancellationPolicy
          confirmationNumberInstruction
          paymentOptions
          url
          fulfilmentNotes
          currency
          shortName
          order
          username
          password
          spreadsheetUrl
          email
          fulfilmentNotes
          depositPolicy
          productType
          paymentBulkBill
          paymentMethod
          paymentFrequency
        }
        resort {
          productSuppliers(productType: MANUAL_FULFILMENT) {
            id
            order
            name
            shortName
          }
        }
        specialRequest
        specialRequestFulfilled
        confirmationNumbers
        messageCenterHref
        fulfilmentState
        fulfilmentAgent {
          id
          firstName
        }
        supplierOrderId
        supplierConfirmationNumber
        supplierDepositAmount
        supplierDepositDueAt
        supplierDepositPaid
        supplierRemainingBalanceAmount
        supplierRemainingBalanceDueAt
        supplierRemainingBalancePaid
        supplierRefundIssued
        supplierRefundAmount
        supplierCreditIssued
        supplierCreditAmount
        crosscheck
      }
    }
  }
}
    ${ItineraryPricingFieldsFragmentDoc}`;

/**
 * __useGetItineraryLodgingQuery__
 *
 * To run a query within a React component, call `useGetItineraryLodgingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryLodgingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryLodgingQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryLodgingQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>(GetItineraryLodgingDocument, options);
      }
export function useGetItineraryLodgingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>(GetItineraryLodgingDocument, options);
        }
export function useGetItineraryLodgingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>(GetItineraryLodgingDocument, options);
        }
export type GetItineraryLodgingQueryHookResult = ReturnType<typeof useGetItineraryLodgingQuery>;
export type GetItineraryLodgingLazyQueryHookResult = ReturnType<typeof useGetItineraryLodgingLazyQuery>;
export type GetItineraryLodgingSuspenseQueryHookResult = ReturnType<typeof useGetItineraryLodgingSuspenseQuery>;
export type GetItineraryLodgingQueryResult = Apollo.QueryResult<GetItineraryLodgingQuery, GetItineraryLodgingQueryVariables>;
export const PropertyCancelDocument = gql`
    mutation PropertyCancel($id: ID!, $input: CancelPropertyInput!) {
  viewer {
    itinerary(id: $id) {
      cancelProperty(input: $input) {
        itinerary {
          id
          propertyLineItem {
            id
            state
            fulfilmentState
            markedAsCancelled
          }
        }
      }
    }
  }
}
    `;
export type PropertyCancelMutationFn = Apollo.MutationFunction<PropertyCancelMutation, PropertyCancelMutationVariables>;

/**
 * __usePropertyCancelMutation__
 *
 * To run a mutation, you first call `usePropertyCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePropertyCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [propertyCancelMutation, { data, loading, error }] = usePropertyCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePropertyCancelMutation(baseOptions?: Apollo.MutationHookOptions<PropertyCancelMutation, PropertyCancelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PropertyCancelMutation, PropertyCancelMutationVariables>(PropertyCancelDocument, options);
      }
export type PropertyCancelMutationHookResult = ReturnType<typeof usePropertyCancelMutation>;
export type PropertyCancelMutationResult = Apollo.MutationResult<PropertyCancelMutation>;
export type PropertyCancelMutationOptions = Apollo.BaseMutationOptions<PropertyCancelMutation, PropertyCancelMutationVariables>;
export const GetItineraryIdsDocument = gql`
    query GetItineraryIds($id: ID!, $skip: Boolean!) {
  itinerary @skip(if: $skip) {
    itinerary(id: $id) {
      id
      publicId
      sessionId
      internalId
      lineItems {
        id
        firstName
        lastName
        product {
          ... on PropertyProduct {
            id
            name
          }
          ... on LiftTicketProduct {
            id
            name
          }
          ... on RentalProduct {
            id
            name
          }
          ... on LessonProduct {
            id
            name
          }
          ... on TransportationProduct {
            id
            name
          }
          ... on UpsellProduct {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetItineraryIdsQuery__
 *
 * To run a query within a React component, call `useGetItineraryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryIdsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItineraryIdsQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>(GetItineraryIdsDocument, options);
      }
export function useGetItineraryIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>(GetItineraryIdsDocument, options);
        }
export function useGetItineraryIdsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>(GetItineraryIdsDocument, options);
        }
export type GetItineraryIdsQueryHookResult = ReturnType<typeof useGetItineraryIdsQuery>;
export type GetItineraryIdsLazyQueryHookResult = ReturnType<typeof useGetItineraryIdsLazyQuery>;
export type GetItineraryIdsSuspenseQueryHookResult = ReturnType<typeof useGetItineraryIdsSuspenseQuery>;
export type GetItineraryIdsQueryResult = Apollo.QueryResult<GetItineraryIdsQuery, GetItineraryIdsQueryVariables>;
export const GetInsuranceLineItemsDocument = gql`
    query GetInsuranceLineItems($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      publicId
      arriveAt
      isDraftDuplicate
      lastScheduledPayment {
        id
        processAt
      }
      normalizedTravelerDetails {
        travelerIdx
      }
      lineItems: upsellLineItems {
        nodes {
          id
          costAmount
          costAmountCurrency
          currency
          payableAmount
          hasPriceChanges
          gender
          product {
            id
            name
          }
          fulfilmentState
          fulfilmentAgent {
            id
            firstName
            lastName
          }
          supplierOrderId
          supplierConfirmationNumber
          productSupplier {
            id
            currency
          }
          crosscheck
        }
      }
      paidAt
      propertyLineItem {
        id
        data
        arriveAt
        departAt
        resort {
          id
          country {
            id
            name
          }
          region {
            id
            name
            slug
          }
        }
      }
      state
      travelerDetails
      ...ItineraryPricingFields
    }
  }
}
    ${ItineraryPricingFieldsFragmentDoc}`;

/**
 * __useGetInsuranceLineItemsQuery__
 *
 * To run a query within a React component, call `useGetInsuranceLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInsuranceLineItemsQuery(baseOptions: Apollo.QueryHookOptions<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>(GetInsuranceLineItemsDocument, options);
      }
export function useGetInsuranceLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>(GetInsuranceLineItemsDocument, options);
        }
export function useGetInsuranceLineItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>(GetInsuranceLineItemsDocument, options);
        }
export type GetInsuranceLineItemsQueryHookResult = ReturnType<typeof useGetInsuranceLineItemsQuery>;
export type GetInsuranceLineItemsLazyQueryHookResult = ReturnType<typeof useGetInsuranceLineItemsLazyQuery>;
export type GetInsuranceLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceLineItemsSuspenseQuery>;
export type GetInsuranceLineItemsQueryResult = Apollo.QueryResult<GetInsuranceLineItemsQuery, GetInsuranceLineItemsQueryVariables>;
export const GetLiftTicketLineItemsDocument = gql`
    query GetLiftTicketLineItems($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      arriveAt
      departAt
      isDraftDuplicate
      normalizedTravelerDetails {
        normalizedFirstName
        normalizedLastName
        dob
        travelerIdx
      }
      ...ItineraryPricingFields
      propertyLineItem {
        id
        resort {
          id
          slug
          name
        }
      }
      lineItems: liftTicketLineItems {
        nodes {
          id
          data
          travelerIdx
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          costAmount
          costAmountCurrency
          currency
          payableAmount
          fulfillmentInstructions(editMode: true)
          fulfillmentInstructionsForSms: fulfillmentInstructions(forSms: true)
          travelerIdx
          hasPriceChanges
          product {
            id
            name
            sku
            age
            daysInAdvance
            description
            ticket
            resort {
              id
              name
              slug
              productSuppliers(productType: LIFT_TICKET) {
                id
                name
                url
                bookingPortalType
                cancellationPolicy
                confirmationNumberInstruction
                currency
                shortName
                order
                username
                password
                spreadsheetUrl
                email
                fulfilmentNotes
              }
            }
          }
          productSupplier {
            id
            name
            url
            bookingPortalType
            cancellationPolicy
            confirmationNumberInstruction
            currency
            vouchersRequired
            shortName
            order
            username
            password
            spreadsheetUrl
            email
            fulfilmentNotes
          }
          fulfilmentState
          fulfilmentAgent {
            id
            firstName
            lastName
          }
          supplierOrderId
          supplierConfirmationNumber
          crosscheck
        }
      }
    }
  }
}
    ${ItineraryPricingFieldsFragmentDoc}`;

/**
 * __useGetLiftTicketLineItemsQuery__
 *
 * To run a query within a React component, call `useGetLiftTicketLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLiftTicketLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLiftTicketLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLiftTicketLineItemsQuery(baseOptions: Apollo.QueryHookOptions<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>(GetLiftTicketLineItemsDocument, options);
      }
export function useGetLiftTicketLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>(GetLiftTicketLineItemsDocument, options);
        }
export function useGetLiftTicketLineItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>(GetLiftTicketLineItemsDocument, options);
        }
export type GetLiftTicketLineItemsQueryHookResult = ReturnType<typeof useGetLiftTicketLineItemsQuery>;
export type GetLiftTicketLineItemsLazyQueryHookResult = ReturnType<typeof useGetLiftTicketLineItemsLazyQuery>;
export type GetLiftTicketLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetLiftTicketLineItemsSuspenseQuery>;
export type GetLiftTicketLineItemsQueryResult = Apollo.QueryResult<GetLiftTicketLineItemsQuery, GetLiftTicketLineItemsQueryVariables>;
export const UpdateLodgingConfirmationNumberDocument = gql`
    mutation updateLodgingConfirmationNumber($id: ID!, $input: UpdateItineraryDataInput!) {
  viewer {
    itinerary(id: $id) {
      updateData(input: $input) {
        itinerary {
          id
          data
        }
      }
    }
  }
}
    `;
export type UpdateLodgingConfirmationNumberMutationFn = Apollo.MutationFunction<UpdateLodgingConfirmationNumberMutation, UpdateLodgingConfirmationNumberMutationVariables>;

/**
 * __useUpdateLodgingConfirmationNumberMutation__
 *
 * To run a mutation, you first call `useUpdateLodgingConfirmationNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLodgingConfirmationNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLodgingConfirmationNumberMutation, { data, loading, error }] = useUpdateLodgingConfirmationNumberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLodgingConfirmationNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLodgingConfirmationNumberMutation, UpdateLodgingConfirmationNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLodgingConfirmationNumberMutation, UpdateLodgingConfirmationNumberMutationVariables>(UpdateLodgingConfirmationNumberDocument, options);
      }
export type UpdateLodgingConfirmationNumberMutationHookResult = ReturnType<typeof useUpdateLodgingConfirmationNumberMutation>;
export type UpdateLodgingConfirmationNumberMutationResult = Apollo.MutationResult<UpdateLodgingConfirmationNumberMutation>;
export type UpdateLodgingConfirmationNumberMutationOptions = Apollo.BaseMutationOptions<UpdateLodgingConfirmationNumberMutation, UpdateLodgingConfirmationNumberMutationVariables>;
export const GetItineraryLogsDocument = gql`
    query GetItineraryLogs($id: ID!, $before: String, $last: Int) {
  itinerary {
    itinerary(id: $id) {
      id
      firstName
      audits(before: $before, last: $last) {
        pageInfo {
          startCursor
          hasPreviousPage
        }
        edges {
          node {
            id
            action
            auditableType
            auditable {
              ... on Itinerary {
                id
                publicId
              }
              ... on LineItem {
                id
                product {
                  ... on PropertyProduct {
                    id
                    name
                  }
                  ... on Product {
                    id
                    name
                  }
                }
              }
              ... on Payment {
                id
                amount
                trxnType
                parentPayment {
                  id
                }
              }
              ... on ItineraryEmailLog {
                id
                type
                state
                address
                sentBy {
                  fullName
                }
              }
              ... on SupportCase {
                id
              }
              ... on SupportNote {
                id
              }
            }
            user {
              id
              fullName
            }
            createdAt
            comment
            changes
            typedChanges {
              attribute
              from {
                ... on AuditedChangeRecordBoolean {
                  boolean
                }
                ... on AuditedChangeRecordDate {
                  date
                }
                ... on AuditedChangeRecordDateTime {
                  dateTime
                }
                ... on AuditedChangeRecordFloat {
                  float
                }
                ... on AuditedChangeRecordInteger {
                  integer
                }
                ... on AuditedChangeRecordString {
                  string
                }
                ... on User {
                  id
                  fullName
                }
                ... on UserCreditCard {
                  id
                  last4
                  createdAt
                }
                ... on Itinerary {
                  id
                  publicId
                  email
                }
                ... on LessonProduct {
                  id
                  name
                }
                ... on LiftTicketProduct {
                  id
                  name
                }
                ... on RentalProduct {
                  id
                  name
                }
                ... on TransportationProduct {
                  id
                  name
                }
                ... on UpsellProduct {
                  id
                  name
                }
                __typename
              }
              to {
                ... on AuditedChangeRecordBoolean {
                  boolean
                }
                ... on AuditedChangeRecordDate {
                  date
                }
                ... on AuditedChangeRecordDateTime {
                  dateTime
                }
                ... on AuditedChangeRecordFloat {
                  float
                }
                ... on AuditedChangeRecordInteger {
                  integer
                }
                ... on AuditedChangeRecordString {
                  string
                }
                ... on User {
                  id
                  fullName
                }
                ... on UserCreditCard {
                  id
                  last4
                  createdAt
                }
                ... on Itinerary {
                  id
                  publicId
                  email
                }
                ... on LessonProduct {
                  id
                  name
                }
                ... on LiftTicketProduct {
                  id
                  name
                }
                ... on RentalProduct {
                  id
                  name
                }
                ... on TransportationProduct {
                  id
                  name
                }
                ... on UpsellProduct {
                  id
                  name
                }
                __typename
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetItineraryLogsQuery__
 *
 * To run a query within a React component, call `useGetItineraryLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetItineraryLogsQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>(GetItineraryLogsDocument, options);
      }
export function useGetItineraryLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>(GetItineraryLogsDocument, options);
        }
export function useGetItineraryLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>(GetItineraryLogsDocument, options);
        }
export type GetItineraryLogsQueryHookResult = ReturnType<typeof useGetItineraryLogsQuery>;
export type GetItineraryLogsLazyQueryHookResult = ReturnType<typeof useGetItineraryLogsLazyQuery>;
export type GetItineraryLogsSuspenseQueryHookResult = ReturnType<typeof useGetItineraryLogsSuspenseQuery>;
export type GetItineraryLogsQueryResult = Apollo.QueryResult<GetItineraryLogsQuery, GetItineraryLogsQueryVariables>;
export const GetItineraryOverviewDocument = gql`
    query GetItineraryOverview($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      currency
      paidAt
      cancellationCutoffAt
      normalizedTravelerDetails {
        travelerIdx
        firstName
        lastName
        dob
      }
      data
      cancelPenalties
      propertyLineItem {
        id
        isCanceled
        arriveAt
        supplierConfirmationNumber
        departAt
        payableAmount
        amountIncTax
        fulfilmentState
        specialRequest
        specialRequestFulfilled
        room {
          id
          name
        }
        rate {
          id
          bedGroups {
            configuration
          }
          refundable
        }
        product {
          id
          address
          checkin
          curatedPropertyDatum {
            checkinSpecialInstructions
          }
          checkout
          name
          phone
          descriptions
        }
        resort {
          id
          ...CovidProtocolFields
        }
      }
      liftTicketLineItems {
        nodes {
          id
          travelerIdx
          isCanceled
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          payableAmount
          supplierConfirmationNumber
          fulfillmentInstructions(editMode: true)
          fulfilmentState
          productSupplier {
            id
            cancellationPolicy
          }
          product {
            id
            name
          }
        }
      }
      rentalLineItems {
        nodes {
          id
          travelerIdx
          isCanceled
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          payableAmount
          supplierConfirmationNumber
          fulfillmentInstructions(editMode: true)
          fulfilmentState
          helmetIncluded
          productSupplier {
            id
            cancellationPolicy
          }
          product {
            id
            name
            days
          }
        }
      }
      lessonLineItems {
        nodes {
          id
          data
          travelerIdx
          isCanceled
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          payableAmount
          supplierConfirmationNumber
          fulfilmentInstructionLocation
          fulfilmentState
          productSupplier {
            id
            cancellationPolicy
          }
          product {
            id
            sku
            name
            checkinTime
            lessonTime
          }
        }
      }
      transportationLineItems {
        nodes {
          id
          travelerIdx
          isCanceled
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          payableAmount
          supplierConfirmationNumber
          altSupplierConfirmationNumber
          fulfillmentInstructions
          fulfilmentState
          productSupplier {
            id
            cancellationPolicy
          }
          product {
            id
            name
          }
        }
      }
      upsellLineItems {
        nodes {
          id
          isCanceled
          payableAmount
          supplierConfirmationNumber
          fulfilmentState
        }
      }
    }
  }
}
    ${CovidProtocolFieldsFragmentDoc}`;

/**
 * __useGetItineraryOverviewQuery__
 *
 * To run a query within a React component, call `useGetItineraryOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>(GetItineraryOverviewDocument, options);
      }
export function useGetItineraryOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>(GetItineraryOverviewDocument, options);
        }
export function useGetItineraryOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>(GetItineraryOverviewDocument, options);
        }
export type GetItineraryOverviewQueryHookResult = ReturnType<typeof useGetItineraryOverviewQuery>;
export type GetItineraryOverviewLazyQueryHookResult = ReturnType<typeof useGetItineraryOverviewLazyQuery>;
export type GetItineraryOverviewSuspenseQueryHookResult = ReturnType<typeof useGetItineraryOverviewSuspenseQuery>;
export type GetItineraryOverviewQueryResult = Apollo.QueryResult<GetItineraryOverviewQuery, GetItineraryOverviewQueryVariables>;
export const ValidateItineraryDocument = gql`
    mutation validateItinerary($itinerarySessionId: ID!, $input: ValidateItineraryInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      validateItinerary(input: $input) {
        itinerary {
          id
        }
        invalidLineItems {
          id
        }
      }
    }
  }
}
    `;
export type ValidateItineraryMutationFn = Apollo.MutationFunction<ValidateItineraryMutation, ValidateItineraryMutationVariables>;

/**
 * __useValidateItineraryMutation__
 *
 * To run a mutation, you first call `useValidateItineraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateItineraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateItineraryMutation, { data, loading, error }] = useValidateItineraryMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateItineraryMutation(baseOptions?: Apollo.MutationHookOptions<ValidateItineraryMutation, ValidateItineraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateItineraryMutation, ValidateItineraryMutationVariables>(ValidateItineraryDocument, options);
      }
export type ValidateItineraryMutationHookResult = ReturnType<typeof useValidateItineraryMutation>;
export type ValidateItineraryMutationResult = Apollo.MutationResult<ValidateItineraryMutation>;
export type ValidateItineraryMutationOptions = Apollo.BaseMutationOptions<ValidateItineraryMutation, ValidateItineraryMutationVariables>;
export const GetItineraryOverviewCheckoutDocument = gql`
    query GetItineraryOverviewCheckout($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      hasLineItemsChanged
      parent {
        id
        ...ItineraryCheckoutOverviewFields
      }
      ...ItineraryCheckoutOverviewFields
      ...ItineraryDuplicateCheckoutFields
    }
  }
}
    ${ItineraryCheckoutOverviewFieldsFragmentDoc}
${ItineraryDuplicateCheckoutFieldsFragmentDoc}`;

/**
 * __useGetItineraryOverviewCheckoutQuery__
 *
 * To run a query within a React component, call `useGetItineraryOverviewCheckoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryOverviewCheckoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryOverviewCheckoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryOverviewCheckoutQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>(GetItineraryOverviewCheckoutDocument, options);
      }
export function useGetItineraryOverviewCheckoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>(GetItineraryOverviewCheckoutDocument, options);
        }
export function useGetItineraryOverviewCheckoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>(GetItineraryOverviewCheckoutDocument, options);
        }
export type GetItineraryOverviewCheckoutQueryHookResult = ReturnType<typeof useGetItineraryOverviewCheckoutQuery>;
export type GetItineraryOverviewCheckoutLazyQueryHookResult = ReturnType<typeof useGetItineraryOverviewCheckoutLazyQuery>;
export type GetItineraryOverviewCheckoutSuspenseQueryHookResult = ReturnType<typeof useGetItineraryOverviewCheckoutSuspenseQuery>;
export type GetItineraryOverviewCheckoutQueryResult = Apollo.QueryResult<GetItineraryOverviewCheckoutQuery, GetItineraryOverviewCheckoutQueryVariables>;
export const GetItineraryPaymentsDocument = gql`
    query GetItineraryPayments($id: ID!, $includeFailed: Boolean, $trxnType: [PaymentTrxnTypeEnum!], $skip: Boolean!) {
  itinerary @skip(if: $skip) {
    itinerary(id: $id) {
      id
      state
      userCreditCards {
        nodes {
          id
          ...UserCreditCardPaymentProcessFields
        }
      }
      propertyLineItem {
        id
        rate {
          id
          merchantOfRecord
        }
      }
      child {
        id
        publicId
        state
      }
      payments(includeFailed: $includeFailed, trxnType: $trxnType) {
        nodes {
          id
          ...PaymentTableFields
        }
      }
      snowpakScheduledPayments: scheduledPayments(
        paymentType: [SCHEDULED]
        snowpakCollect: true
      ) {
        nodes {
          id
          ...ScheduledPaymentTableFields
        }
      }
      expediaScheduledPayments: scheduledPayments(
        paymentType: [ALL]
        snowpakCollect: false
      ) {
        nodes {
          id
          ...ScheduledPaymentTableFields
        }
      }
      coupon {
        id
        code
        currency
        discountValue
        reason
      }
      relatedCoupons {
        id
        code
        currency
        discountValue
        reason
      }
      couponCode
      couponDiscount
      currency
      paidAt
    }
  }
}
    ${UserCreditCardPaymentProcessFieldsFragmentDoc}
${PaymentTableFieldsFragmentDoc}
${ScheduledPaymentTableFieldsFragmentDoc}`;

/**
 * __useGetItineraryPaymentsQuery__
 *
 * To run a query within a React component, call `useGetItineraryPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryPaymentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeFailed: // value for 'includeFailed'
 *      trxnType: // value for 'trxnType'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItineraryPaymentsQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>(GetItineraryPaymentsDocument, options);
      }
export function useGetItineraryPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>(GetItineraryPaymentsDocument, options);
        }
export function useGetItineraryPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>(GetItineraryPaymentsDocument, options);
        }
export type GetItineraryPaymentsQueryHookResult = ReturnType<typeof useGetItineraryPaymentsQuery>;
export type GetItineraryPaymentsLazyQueryHookResult = ReturnType<typeof useGetItineraryPaymentsLazyQuery>;
export type GetItineraryPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetItineraryPaymentsSuspenseQuery>;
export type GetItineraryPaymentsQueryResult = Apollo.QueryResult<GetItineraryPaymentsQuery, GetItineraryPaymentsQueryVariables>;
export const GetHelmetPriceDocument = gql`
    query GetHelmetPrice($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      propertyLineItem {
        id
        product {
          id
          rentalLocations {
            nodes {
              id
              helmetAvailable
              helmetPrice
              resort {
                id
                slug
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetHelmetPriceQuery__
 *
 * To run a query within a React component, call `useGetHelmetPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHelmetPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHelmetPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHelmetPriceQuery(baseOptions: Apollo.QueryHookOptions<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>(GetHelmetPriceDocument, options);
      }
export function useGetHelmetPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>(GetHelmetPriceDocument, options);
        }
export function useGetHelmetPriceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>(GetHelmetPriceDocument, options);
        }
export type GetHelmetPriceQueryHookResult = ReturnType<typeof useGetHelmetPriceQuery>;
export type GetHelmetPriceLazyQueryHookResult = ReturnType<typeof useGetHelmetPriceLazyQuery>;
export type GetHelmetPriceSuspenseQueryHookResult = ReturnType<typeof useGetHelmetPriceSuspenseQuery>;
export type GetHelmetPriceQueryResult = Apollo.QueryResult<GetHelmetPriceQuery, GetHelmetPriceQueryVariables>;
export const GetSnowPakLinksDocument = gql`
    query getSnowPakLinks($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      sessionId
      currency
      state
      isPaid
      propertyLineItem {
        id
        arriveAt
        departAt
        product {
          id
          name
        }
        data
      }
      skicomQuoteId
    }
  }
}
    `;

/**
 * __useGetSnowPakLinksQuery__
 *
 * To run a query within a React component, call `useGetSnowPakLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnowPakLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnowPakLinksQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSnowPakLinksQuery(baseOptions: Apollo.QueryHookOptions<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>(GetSnowPakLinksDocument, options);
      }
export function useGetSnowPakLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>(GetSnowPakLinksDocument, options);
        }
export function useGetSnowPakLinksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>(GetSnowPakLinksDocument, options);
        }
export type GetSnowPakLinksQueryHookResult = ReturnType<typeof useGetSnowPakLinksQuery>;
export type GetSnowPakLinksLazyQueryHookResult = ReturnType<typeof useGetSnowPakLinksLazyQuery>;
export type GetSnowPakLinksSuspenseQueryHookResult = ReturnType<typeof useGetSnowPakLinksSuspenseQuery>;
export type GetSnowPakLinksQueryResult = Apollo.QueryResult<GetSnowPakLinksQuery, GetSnowPakLinksQueryVariables>;
export const GetRentalLineItemsDocument = gql`
    query GetRentalLineItems($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      arriveAt
      departAt
      currency
      isDraftDuplicate
      publicId
      normalizedTravelerDetails {
        normalizedFirstName
        normalizedLastName
        dob
        gender
        travelerIdx
      }
      ...ItineraryPricingFields
      propertyLineItem {
        id
        product {
          id
          rentalLocations {
            nodes {
              id
              isPremium
              premium
              resort {
                id
                slug
              }
            }
          }
        }
        resort {
          id
          slug
          name
        }
      }
      lineItems: rentalLineItems {
        nodes {
          id
          data
          travelerIdx
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          costAmount
          costAmountCurrency
          currency
          payableAmount
          hasPriceChanges
          fulfillmentInstructions(editMode: true)
          height
          weight
          gender
          shoeSize
          deliverTo
          pickupAt
          dropoffAt
          helmetIncluded
          rentalLocation {
            id
            name
            storeName
            productSupplier {
              id
              name
              url
              bookingPortalType
              cancellationPolicy
              confirmationNumberInstruction
              currency
              shortName
              order
              username
              password
              spreadsheetUrl
              email
              fulfilmentNotes
            }
          }
          product {
            id
            sku
            days
            name
            payable
            daysInAdvance
            resort {
              id
              name
              slug
              productSuppliers(productType: RENTAL) {
                id
                name
                shortName
                currency
              }
            }
          }
          productSupplier {
            id
            name
            url
            bookingPortalType
            cancellationPolicy
            confirmationNumberInstruction
            currency
            vouchersRequired
            shortName
            order
            username
            password
            spreadsheetUrl
            email
            fulfilmentNotes
          }
          fulfilmentState
          fulfilmentAgent {
            id
            firstName
            lastName
          }
          supplierOrderId
          supplierConfirmationNumber
          zendeskTicket
          skillLevel
          crosscheck
        }
      }
    }
  }
}
    ${ItineraryPricingFieldsFragmentDoc}`;

/**
 * __useGetRentalLineItemsQuery__
 *
 * To run a query within a React component, call `useGetRentalLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRentalLineItemsQuery(baseOptions: Apollo.QueryHookOptions<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>(GetRentalLineItemsDocument, options);
      }
export function useGetRentalLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>(GetRentalLineItemsDocument, options);
        }
export function useGetRentalLineItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>(GetRentalLineItemsDocument, options);
        }
export type GetRentalLineItemsQueryHookResult = ReturnType<typeof useGetRentalLineItemsQuery>;
export type GetRentalLineItemsLazyQueryHookResult = ReturnType<typeof useGetRentalLineItemsLazyQuery>;
export type GetRentalLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetRentalLineItemsSuspenseQuery>;
export type GetRentalLineItemsQueryResult = Apollo.QueryResult<GetRentalLineItemsQuery, GetRentalLineItemsQueryVariables>;
export const SearchItinerariesDocument = gql`
    query SearchItineraries($filter: ItinerarySearchResolverFilterInput, $orderBy: [SearchkickOrderByInput!], $skip: Boolean!) {
  itineraries(filter: $filter, orderBy: $orderBy) @skip(if: $skip) {
    edges {
      node {
        id
        arriveAt
        email
        normalizedFirstName
        normalizedLastName
        state
        fulfilmentState
        propertyName
        publicId
        resortName
      }
    }
  }
}
    `;

/**
 * __useSearchItinerariesQuery__
 *
 * To run a query within a React component, call `useSearchItinerariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchItinerariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchItinerariesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchItinerariesQuery(baseOptions: Apollo.QueryHookOptions<SearchItinerariesQuery, SearchItinerariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchItinerariesQuery, SearchItinerariesQueryVariables>(SearchItinerariesDocument, options);
      }
export function useSearchItinerariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchItinerariesQuery, SearchItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchItinerariesQuery, SearchItinerariesQueryVariables>(SearchItinerariesDocument, options);
        }
export function useSearchItinerariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchItinerariesQuery, SearchItinerariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchItinerariesQuery, SearchItinerariesQueryVariables>(SearchItinerariesDocument, options);
        }
export type SearchItinerariesQueryHookResult = ReturnType<typeof useSearchItinerariesQuery>;
export type SearchItinerariesLazyQueryHookResult = ReturnType<typeof useSearchItinerariesLazyQuery>;
export type SearchItinerariesSuspenseQueryHookResult = ReturnType<typeof useSearchItinerariesSuspenseQuery>;
export type SearchItinerariesQueryResult = Apollo.QueryResult<SearchItinerariesQuery, SearchItinerariesQueryVariables>;
export const GetItineraryTreeDocument = gql`
    query GetItineraryTree($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      ...ItineraryDuplicationTreeFields
      main {
        ...ItineraryDuplicationTreeFields
      }
    }
  }
}
    ${ItineraryDuplicationTreeFieldsFragmentDoc}`;

/**
 * __useGetItineraryTreeQuery__
 *
 * To run a query within a React component, call `useGetItineraryTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryTreeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryTreeQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>(GetItineraryTreeDocument, options);
      }
export function useGetItineraryTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>(GetItineraryTreeDocument, options);
        }
export function useGetItineraryTreeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>(GetItineraryTreeDocument, options);
        }
export type GetItineraryTreeQueryHookResult = ReturnType<typeof useGetItineraryTreeQuery>;
export type GetItineraryTreeLazyQueryHookResult = ReturnType<typeof useGetItineraryTreeLazyQuery>;
export type GetItineraryTreeSuspenseQueryHookResult = ReturnType<typeof useGetItineraryTreeSuspenseQuery>;
export type GetItineraryTreeQueryResult = Apollo.QueryResult<GetItineraryTreeQuery, GetItineraryTreeQueryVariables>;
export const GetItinerarySupportCasesDocument = gql`
    query GetItinerarySupportCases($id: ID!, $skip: Boolean!) {
  itinerary {
    itinerary(id: $id) @skip(if: $skip) {
      id
      mainId
      main {
        id
        supportCases {
          id
          ...SupportCaseTableFields
        }
      }
    }
  }
}
    ${SupportCaseTableFieldsFragmentDoc}`;

/**
 * __useGetItinerarySupportCasesQuery__
 *
 * To run a query within a React component, call `useGetItinerarySupportCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItinerarySupportCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItinerarySupportCasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetItinerarySupportCasesQuery(baseOptions: Apollo.QueryHookOptions<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>(GetItinerarySupportCasesDocument, options);
      }
export function useGetItinerarySupportCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>(GetItinerarySupportCasesDocument, options);
        }
export function useGetItinerarySupportCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>(GetItinerarySupportCasesDocument, options);
        }
export type GetItinerarySupportCasesQueryHookResult = ReturnType<typeof useGetItinerarySupportCasesQuery>;
export type GetItinerarySupportCasesLazyQueryHookResult = ReturnType<typeof useGetItinerarySupportCasesLazyQuery>;
export type GetItinerarySupportCasesSuspenseQueryHookResult = ReturnType<typeof useGetItinerarySupportCasesSuspenseQuery>;
export type GetItinerarySupportCasesQueryResult = Apollo.QueryResult<GetItinerarySupportCasesQuery, GetItinerarySupportCasesQueryVariables>;
export const GetTransportationLineItemsDocument = gql`
    query GetTransportationLineItems($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      sessionId
      arriveAt
      departAt
      currency
      data
      isDraftDuplicate
      normalizedTravelerDetails {
        normalizedFirstName
        normalizedLastName
        dob
        travelerIdx
      }
      ...ItineraryPricingFields
      propertyLineItem {
        id
        isCanceled
        arriveAt
        departAt
        resort {
          id
          slug
          showForOutboundTransfer
          name
          airports {
            edges {
              node {
                id
                name
                iataCode
              }
            }
          }
        }
        product {
          id
          address
          name
        }
      }
      lineItems: transportationLineItems {
        nodes {
          id
          travelerIdx
          arriveAt
          firstName: normalizedFirstName
          lastName: normalizedLastName
          dob
          costAmount
          costAmountCurrency
          currency
          payableAmount
          hasPriceChanges
          fulfillmentInstructions
          flightArrival
          flightDeparture
          flightHash
          isCanceled
          product {
            id
            name
            daysInAdvance
            resort {
              id
              name
              slug
              productSuppliers(productType: TRANSPORTATION) {
                id
                name
                url
                mainSupplier
                bookingPortalType
                cancellationPolicy
                confirmationNumberInstruction
                currency
                shortName
                order
                username
                password
                spreadsheetUrl
                email
                fulfilmentNotes
                pickupTimeLocation
                productType
              }
            }
          }
          productSupplier {
            id
            name
            url
            bookingPortalType
            cancellationPolicy
            confirmationNumberInstruction
            currency
            vouchersRequired
            shortName
            order
            username
            password
            spreadsheetUrl
            email
            fulfilmentNotes
            pickupTimeLocation
            productType
          }
          altProductSupplier {
            id
            name
            url
            bookingPortalType
            cancellationPolicy
            confirmationNumberInstruction
            vouchersRequired
            shortName
            order
            username
            password
            spreadsheetUrl
            email
            fulfilmentNotes
            pickupTimeLocation
            productType
          }
          fulfilmentState
          fulfilmentAgent {
            id
            firstName
            lastName
          }
          supplierOrderId
          altSupplierOrderId
          supplierConfirmationNumber
          altSupplierConfirmationNumber
          crosscheck
          supplierPickupDate
          altSupplierPickupDate
          supplierPickupTime
          altSupplierPickupTime
        }
      }
    }
  }
}
    ${ItineraryPricingFieldsFragmentDoc}`;

/**
 * __useGetTransportationLineItemsQuery__
 *
 * To run a query within a React component, call `useGetTransportationLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransportationLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransportationLineItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransportationLineItemsQuery(baseOptions: Apollo.QueryHookOptions<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>(GetTransportationLineItemsDocument, options);
      }
export function useGetTransportationLineItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>(GetTransportationLineItemsDocument, options);
        }
export function useGetTransportationLineItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>(GetTransportationLineItemsDocument, options);
        }
export type GetTransportationLineItemsQueryHookResult = ReturnType<typeof useGetTransportationLineItemsQuery>;
export type GetTransportationLineItemsLazyQueryHookResult = ReturnType<typeof useGetTransportationLineItemsLazyQuery>;
export type GetTransportationLineItemsSuspenseQueryHookResult = ReturnType<typeof useGetTransportationLineItemsSuspenseQuery>;
export type GetTransportationLineItemsQueryResult = Apollo.QueryResult<GetTransportationLineItemsQuery, GetTransportationLineItemsQueryVariables>;
export const GetTravelerDetailsDocument = gql`
    query GetTravelerDetails($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      sessionId
      arriveAt
      isDuplicated
      normalizedTravelerDetails {
        travelerIdx
        normalizedFirstName
        normalizedLastName
        dob
        gender
        height
        weight
        shoeSize
        skillLevel
        pickupAt
        zendeskTicket
      }
    }
  }
}
    `;

/**
 * __useGetTravelerDetailsQuery__
 *
 * To run a query within a React component, call `useGetTravelerDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTravelerDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTravelerDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTravelerDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>(GetTravelerDetailsDocument, options);
      }
export function useGetTravelerDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>(GetTravelerDetailsDocument, options);
        }
export function useGetTravelerDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>(GetTravelerDetailsDocument, options);
        }
export type GetTravelerDetailsQueryHookResult = ReturnType<typeof useGetTravelerDetailsQuery>;
export type GetTravelerDetailsLazyQueryHookResult = ReturnType<typeof useGetTravelerDetailsLazyQuery>;
export type GetTravelerDetailsSuspenseQueryHookResult = ReturnType<typeof useGetTravelerDetailsSuspenseQuery>;
export type GetTravelerDetailsQueryResult = Apollo.QueryResult<GetTravelerDetailsQuery, GetTravelerDetailsQueryVariables>;
export const AssignItineraryAgentDocument = gql`
    mutation AssignItineraryAgent($itinerarySessionId: ID, $input: AssignAgentInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      assignAgent(input: $input) {
        itinerary {
          id
          internalId
          fulfilmentAgent {
            ...UserCoreFields
          }
          customerAgent {
            ...UserCoreFields
          }
          liftTicketAgent {
            ...UserCoreFields
          }
          rentalAgent {
            ...UserCoreFields
          }
          lessonAgent {
            ...UserCoreFields
          }
          transportationAgent {
            ...UserCoreFields
          }
          f4Agent {
            ...UserCoreFields
          }
          requestedAgent {
            ...UserCoreFields
          }
          inProgressAgent {
            ...UserCoreFields
          }
          flightInfoAgent {
            ...UserCoreFields
          }
          postBookingAgent {
            ...UserCoreFields
          }
        }
      }
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type AssignItineraryAgentMutationFn = Apollo.MutationFunction<AssignItineraryAgentMutation, AssignItineraryAgentMutationVariables>;

/**
 * __useAssignItineraryAgentMutation__
 *
 * To run a mutation, you first call `useAssignItineraryAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignItineraryAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignItineraryAgentMutation, { data, loading, error }] = useAssignItineraryAgentMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignItineraryAgentMutation(baseOptions?: Apollo.MutationHookOptions<AssignItineraryAgentMutation, AssignItineraryAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignItineraryAgentMutation, AssignItineraryAgentMutationVariables>(AssignItineraryAgentDocument, options);
      }
export type AssignItineraryAgentMutationHookResult = ReturnType<typeof useAssignItineraryAgentMutation>;
export type AssignItineraryAgentMutationResult = Apollo.MutationResult<AssignItineraryAgentMutation>;
export type AssignItineraryAgentMutationOptions = Apollo.BaseMutationOptions<AssignItineraryAgentMutation, AssignItineraryAgentMutationVariables>;
export const UpdateTableNotesDocument = gql`
    mutation updateTableNotes($itinerarySessionId: ID, $input: UpdateTableNotesInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateTableNotes(input: $input) {
        itinerary {
          id
          data
        }
      }
    }
  }
}
    `;
export type UpdateTableNotesMutationFn = Apollo.MutationFunction<UpdateTableNotesMutation, UpdateTableNotesMutationVariables>;

/**
 * __useUpdateTableNotesMutation__
 *
 * To run a mutation, you first call `useUpdateTableNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTableNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTableNotesMutation, { data, loading, error }] = useUpdateTableNotesMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTableNotesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTableNotesMutation, UpdateTableNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTableNotesMutation, UpdateTableNotesMutationVariables>(UpdateTableNotesDocument, options);
      }
export type UpdateTableNotesMutationHookResult = ReturnType<typeof useUpdateTableNotesMutation>;
export type UpdateTableNotesMutationResult = Apollo.MutationResult<UpdateTableNotesMutation>;
export type UpdateTableNotesMutationOptions = Apollo.BaseMutationOptions<UpdateTableNotesMutation, UpdateTableNotesMutationVariables>;
export const UpdateSupportCaseAgentDocument = gql`
    mutation UpdateSupportCaseAgent($input: MutationsSupportCaseUpdateInput!) {
  supportCase {
    update(input: $input) {
      supportCase {
        id
        assignedTo {
          id
          ...UserCoreFields
        }
      }
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type UpdateSupportCaseAgentMutationFn = Apollo.MutationFunction<UpdateSupportCaseAgentMutation, UpdateSupportCaseAgentMutationVariables>;

/**
 * __useUpdateSupportCaseAgentMutation__
 *
 * To run a mutation, you first call `useUpdateSupportCaseAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupportCaseAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupportCaseAgentMutation, { data, loading, error }] = useUpdateSupportCaseAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSupportCaseAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSupportCaseAgentMutation, UpdateSupportCaseAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSupportCaseAgentMutation, UpdateSupportCaseAgentMutationVariables>(UpdateSupportCaseAgentDocument, options);
      }
export type UpdateSupportCaseAgentMutationHookResult = ReturnType<typeof useUpdateSupportCaseAgentMutation>;
export type UpdateSupportCaseAgentMutationResult = Apollo.MutationResult<UpdateSupportCaseAgentMutation>;
export type UpdateSupportCaseAgentMutationOptions = Apollo.BaseMutationOptions<UpdateSupportCaseAgentMutation, UpdateSupportCaseAgentMutationVariables>;
export const GetUsersDocument = gql`
    query GetUsers($isAdmin: Boolean!) {
  users(admin: $isAdmin) {
    nodes {
      ...UserCoreFields
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      isAdmin: // value for 'isAdmin'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetRegionsDocument = gql`
    query getRegions {
  regions {
    nodes {
      id
      name
    }
  }
  apexReady
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export function useGetRegionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsSuspenseQueryHookResult = ReturnType<typeof useGetRegionsSuspenseQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetPropertyDocument = gql`
    query getProperty($propertyId: ID!) {
  product {
    propertyNew(id: $propertyId) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetPropertyQuery__
 *
 * To run a query within a React component, call `useGetPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *   },
 * });
 */
export function useGetPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
      }
export function useGetPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export function useGetPropertySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export type GetPropertyQueryHookResult = ReturnType<typeof useGetPropertyQuery>;
export type GetPropertyLazyQueryHookResult = ReturnType<typeof useGetPropertyLazyQuery>;
export type GetPropertySuspenseQueryHookResult = ReturnType<typeof useGetPropertySuspenseQuery>;
export type GetPropertyQueryResult = Apollo.QueryResult<GetPropertyQuery, GetPropertyQueryVariables>;
export const CreateProductSupplierDocument = gql`
    mutation createProductSupplier($input: MutationsProductSupplierCreateInput!) {
  productSupplier {
    create(input: $input) {
      productSupplier {
        id
      }
    }
  }
}
    `;
export type CreateProductSupplierMutationFn = Apollo.MutationFunction<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>;

/**
 * __useCreateProductSupplierMutation__
 *
 * To run a mutation, you first call `useCreateProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductSupplierMutation, { data, loading, error }] = useCreateProductSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>(CreateProductSupplierDocument, options);
      }
export type CreateProductSupplierMutationHookResult = ReturnType<typeof useCreateProductSupplierMutation>;
export type CreateProductSupplierMutationResult = Apollo.MutationResult<CreateProductSupplierMutation>;
export type CreateProductSupplierMutationOptions = Apollo.BaseMutationOptions<CreateProductSupplierMutation, CreateProductSupplierMutationVariables>;
export const GetResortsDocument = gql`
    query getResorts {
  resorts {
    nodes {
      id
      name
      skicomId
      availableLiftTicketsCount: productsCount(productType: LiftTicket)
    }
  }
  apexReady
}
    `;

/**
 * __useGetResortsQuery__
 *
 * To run a query within a React component, call `useGetResortsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResortsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResortsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetResortsQuery(baseOptions?: Apollo.QueryHookOptions<GetResortsQuery, GetResortsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetResortsQuery, GetResortsQueryVariables>(GetResortsDocument, options);
      }
export function useGetResortsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResortsQuery, GetResortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetResortsQuery, GetResortsQueryVariables>(GetResortsDocument, options);
        }
export function useGetResortsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetResortsQuery, GetResortsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetResortsQuery, GetResortsQueryVariables>(GetResortsDocument, options);
        }
export type GetResortsQueryHookResult = ReturnType<typeof useGetResortsQuery>;
export type GetResortsLazyQueryHookResult = ReturnType<typeof useGetResortsLazyQuery>;
export type GetResortsSuspenseQueryHookResult = ReturnType<typeof useGetResortsSuspenseQuery>;
export type GetResortsQueryResult = Apollo.QueryResult<GetResortsQuery, GetResortsQueryVariables>;
export const GetProductSupplierLockStateDocument = gql`
    query GetProductSupplierLockState($id: ID!) {
  productSupplier(id: $id) {
    id
    lock {
      lockedAt
      lockedBy {
        id
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetProductSupplierLockStateQuery__
 *
 * To run a query within a React component, call `useGetProductSupplierLockStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSupplierLockStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSupplierLockStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductSupplierLockStateQuery(baseOptions: Apollo.QueryHookOptions<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>(GetProductSupplierLockStateDocument, options);
      }
export function useGetProductSupplierLockStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>(GetProductSupplierLockStateDocument, options);
        }
export function useGetProductSupplierLockStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>(GetProductSupplierLockStateDocument, options);
        }
export type GetProductSupplierLockStateQueryHookResult = ReturnType<typeof useGetProductSupplierLockStateQuery>;
export type GetProductSupplierLockStateLazyQueryHookResult = ReturnType<typeof useGetProductSupplierLockStateLazyQuery>;
export type GetProductSupplierLockStateSuspenseQueryHookResult = ReturnType<typeof useGetProductSupplierLockStateSuspenseQuery>;
export type GetProductSupplierLockStateQueryResult = Apollo.QueryResult<GetProductSupplierLockStateQuery, GetProductSupplierLockStateQueryVariables>;
export const LockProductSupplierDocument = gql`
    mutation LockProductSupplier($input: MutationsProductSupplierLockInput!) {
  productSupplier {
    lock(input: $input) {
      productSupplier {
        id
        lock {
          lockedAt
          lockedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;
export type LockProductSupplierMutationFn = Apollo.MutationFunction<LockProductSupplierMutation, LockProductSupplierMutationVariables>;

/**
 * __useLockProductSupplierMutation__
 *
 * To run a mutation, you first call `useLockProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockProductSupplierMutation, { data, loading, error }] = useLockProductSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLockProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<LockProductSupplierMutation, LockProductSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockProductSupplierMutation, LockProductSupplierMutationVariables>(LockProductSupplierDocument, options);
      }
export type LockProductSupplierMutationHookResult = ReturnType<typeof useLockProductSupplierMutation>;
export type LockProductSupplierMutationResult = Apollo.MutationResult<LockProductSupplierMutation>;
export type LockProductSupplierMutationOptions = Apollo.BaseMutationOptions<LockProductSupplierMutation, LockProductSupplierMutationVariables>;
export const ActivateProductSupplierDocument = gql`
    mutation activateProductSupplier($input: MutationsProductSupplierActivateInput!) {
  productSupplier {
    activate(input: $input) {
      productSupplier {
        id
      }
    }
  }
}
    `;
export type ActivateProductSupplierMutationFn = Apollo.MutationFunction<ActivateProductSupplierMutation, ActivateProductSupplierMutationVariables>;

/**
 * __useActivateProductSupplierMutation__
 *
 * To run a mutation, you first call `useActivateProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateProductSupplierMutation, { data, loading, error }] = useActivateProductSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<ActivateProductSupplierMutation, ActivateProductSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateProductSupplierMutation, ActivateProductSupplierMutationVariables>(ActivateProductSupplierDocument, options);
      }
export type ActivateProductSupplierMutationHookResult = ReturnType<typeof useActivateProductSupplierMutation>;
export type ActivateProductSupplierMutationResult = Apollo.MutationResult<ActivateProductSupplierMutation>;
export type ActivateProductSupplierMutationOptions = Apollo.BaseMutationOptions<ActivateProductSupplierMutation, ActivateProductSupplierMutationVariables>;
export const UnlockProductSupplierDocument = gql`
    mutation UnlockProductSupplier($input: MutationsProductSupplierUnlockInput!) {
  productSupplier {
    unlock(input: $input) {
      productSupplier {
        id
        lock {
          lockedAt
          lockedBy {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;
export type UnlockProductSupplierMutationFn = Apollo.MutationFunction<UnlockProductSupplierMutation, UnlockProductSupplierMutationVariables>;

/**
 * __useUnlockProductSupplierMutation__
 *
 * To run a mutation, you first call `useUnlockProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockProductSupplierMutation, { data, loading, error }] = useUnlockProductSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<UnlockProductSupplierMutation, UnlockProductSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockProductSupplierMutation, UnlockProductSupplierMutationVariables>(UnlockProductSupplierDocument, options);
      }
export type UnlockProductSupplierMutationHookResult = ReturnType<typeof useUnlockProductSupplierMutation>;
export type UnlockProductSupplierMutationResult = Apollo.MutationResult<UnlockProductSupplierMutation>;
export type UnlockProductSupplierMutationOptions = Apollo.BaseMutationOptions<UnlockProductSupplierMutation, UnlockProductSupplierMutationVariables>;
export const GetProductSupplierFulfilmentAttachmentsDocument = gql`
    query GetProductSupplierFulfilmentAttachments($id: ID!) {
  productSupplier(id: $id) {
    id
    fulfilmentAttachments {
      nodes {
        id
        filename
        url
        createdAt
      }
    }
  }
}
    `;

/**
 * __useGetProductSupplierFulfilmentAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetProductSupplierFulfilmentAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSupplierFulfilmentAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSupplierFulfilmentAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductSupplierFulfilmentAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>(GetProductSupplierFulfilmentAttachmentsDocument, options);
      }
export function useGetProductSupplierFulfilmentAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>(GetProductSupplierFulfilmentAttachmentsDocument, options);
        }
export function useGetProductSupplierFulfilmentAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>(GetProductSupplierFulfilmentAttachmentsDocument, options);
        }
export type GetProductSupplierFulfilmentAttachmentsQueryHookResult = ReturnType<typeof useGetProductSupplierFulfilmentAttachmentsQuery>;
export type GetProductSupplierFulfilmentAttachmentsLazyQueryHookResult = ReturnType<typeof useGetProductSupplierFulfilmentAttachmentsLazyQuery>;
export type GetProductSupplierFulfilmentAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetProductSupplierFulfilmentAttachmentsSuspenseQuery>;
export type GetProductSupplierFulfilmentAttachmentsQueryResult = Apollo.QueryResult<GetProductSupplierFulfilmentAttachmentsQuery, GetProductSupplierFulfilmentAttachmentsQueryVariables>;
export const ProductSupplierCreateAttachmentDocument = gql`
    mutation ProductSupplierCreateAttachment($input: MutationsProductSupplierCreateAttachmentInput!) {
  productSupplier {
    createAttachment(input: $input) {
      productSupplier {
        id
      }
    }
  }
}
    `;
export type ProductSupplierCreateAttachmentMutationFn = Apollo.MutationFunction<ProductSupplierCreateAttachmentMutation, ProductSupplierCreateAttachmentMutationVariables>;

/**
 * __useProductSupplierCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useProductSupplierCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductSupplierCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productSupplierCreateAttachmentMutation, { data, loading, error }] = useProductSupplierCreateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductSupplierCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ProductSupplierCreateAttachmentMutation, ProductSupplierCreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductSupplierCreateAttachmentMutation, ProductSupplierCreateAttachmentMutationVariables>(ProductSupplierCreateAttachmentDocument, options);
      }
export type ProductSupplierCreateAttachmentMutationHookResult = ReturnType<typeof useProductSupplierCreateAttachmentMutation>;
export type ProductSupplierCreateAttachmentMutationResult = Apollo.MutationResult<ProductSupplierCreateAttachmentMutation>;
export type ProductSupplierCreateAttachmentMutationOptions = Apollo.BaseMutationOptions<ProductSupplierCreateAttachmentMutation, ProductSupplierCreateAttachmentMutationVariables>;
export const GetProductSupplierShortNamesDocument = gql`
    query GetProductSupplierShortNames {
  productSupplierShortNames
}
    `;

/**
 * __useGetProductSupplierShortNamesQuery__
 *
 * To run a query within a React component, call `useGetProductSupplierShortNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSupplierShortNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSupplierShortNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductSupplierShortNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>(GetProductSupplierShortNamesDocument, options);
      }
export function useGetProductSupplierShortNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>(GetProductSupplierShortNamesDocument, options);
        }
export function useGetProductSupplierShortNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>(GetProductSupplierShortNamesDocument, options);
        }
export type GetProductSupplierShortNamesQueryHookResult = ReturnType<typeof useGetProductSupplierShortNamesQuery>;
export type GetProductSupplierShortNamesLazyQueryHookResult = ReturnType<typeof useGetProductSupplierShortNamesLazyQuery>;
export type GetProductSupplierShortNamesSuspenseQueryHookResult = ReturnType<typeof useGetProductSupplierShortNamesSuspenseQuery>;
export type GetProductSupplierShortNamesQueryResult = Apollo.QueryResult<GetProductSupplierShortNamesQuery, GetProductSupplierShortNamesQueryVariables>;
export const GetItineraryFulfilmentAttachmentsDocument = gql`
    query GetItineraryFulfilmentAttachments($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      fulfilmentAttachments {
        nodes {
          id
          filename
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetItineraryFulfilmentAttachmentsQuery__
 *
 * To run a query within a React component, call `useGetItineraryFulfilmentAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryFulfilmentAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryFulfilmentAttachmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryFulfilmentAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>(GetItineraryFulfilmentAttachmentsDocument, options);
      }
export function useGetItineraryFulfilmentAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>(GetItineraryFulfilmentAttachmentsDocument, options);
        }
export function useGetItineraryFulfilmentAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>(GetItineraryFulfilmentAttachmentsDocument, options);
        }
export type GetItineraryFulfilmentAttachmentsQueryHookResult = ReturnType<typeof useGetItineraryFulfilmentAttachmentsQuery>;
export type GetItineraryFulfilmentAttachmentsLazyQueryHookResult = ReturnType<typeof useGetItineraryFulfilmentAttachmentsLazyQuery>;
export type GetItineraryFulfilmentAttachmentsSuspenseQueryHookResult = ReturnType<typeof useGetItineraryFulfilmentAttachmentsSuspenseQuery>;
export type GetItineraryFulfilmentAttachmentsQueryResult = Apollo.QueryResult<GetItineraryFulfilmentAttachmentsQuery, GetItineraryFulfilmentAttachmentsQueryVariables>;
export const DeactivateProductSupplierDocument = gql`
    mutation deactivateProductSupplier($input: MutationsProductSupplierDeactivateInput!) {
  productSupplier {
    deactivate(input: $input) {
      productSupplier {
        id
      }
    }
  }
}
    `;
export type DeactivateProductSupplierMutationFn = Apollo.MutationFunction<DeactivateProductSupplierMutation, DeactivateProductSupplierMutationVariables>;

/**
 * __useDeactivateProductSupplierMutation__
 *
 * To run a mutation, you first call `useDeactivateProductSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProductSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProductSupplierMutation, { data, loading, error }] = useDeactivateProductSupplierMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateProductSupplierMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateProductSupplierMutation, DeactivateProductSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateProductSupplierMutation, DeactivateProductSupplierMutationVariables>(DeactivateProductSupplierDocument, options);
      }
export type DeactivateProductSupplierMutationHookResult = ReturnType<typeof useDeactivateProductSupplierMutation>;
export type DeactivateProductSupplierMutationResult = Apollo.MutationResult<DeactivateProductSupplierMutation>;
export type DeactivateProductSupplierMutationOptions = Apollo.BaseMutationOptions<DeactivateProductSupplierMutation, DeactivateProductSupplierMutationVariables>;
export const CreateDirectUploadDocument = gql`
    mutation CreateDirectUpload($input: CreateDirectUploadInput!) {
  createDirectUpload(input: $input) {
    directUpload {
      id
      url
      headers
      blobId
      signedBlobId
    }
  }
}
    `;
export type CreateDirectUploadMutationFn = Apollo.MutationFunction<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>;

/**
 * __useCreateDirectUploadMutation__
 *
 * To run a mutation, you first call `useCreateDirectUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectUploadMutation, { data, loading, error }] = useCreateDirectUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDirectUploadMutation(baseOptions?: Apollo.MutationHookOptions<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>(CreateDirectUploadDocument, options);
      }
export type CreateDirectUploadMutationHookResult = ReturnType<typeof useCreateDirectUploadMutation>;
export type CreateDirectUploadMutationResult = Apollo.MutationResult<CreateDirectUploadMutation>;
export type CreateDirectUploadMutationOptions = Apollo.BaseMutationOptions<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>;
export const CreditCardCreateDocument = gql`
    mutation CreditCardCreate($input: MutationsCreditCardCreateInput!) {
  creditCard {
    create(input: $input) {
      creditCard {
        id
      }
    }
  }
}
    `;
export type CreditCardCreateMutationFn = Apollo.MutationFunction<CreditCardCreateMutation, CreditCardCreateMutationVariables>;

/**
 * __useCreditCardCreateMutation__
 *
 * To run a mutation, you first call `useCreditCardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreditCardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [creditCardCreateMutation, { data, loading, error }] = useCreditCardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreditCardCreateMutation(baseOptions?: Apollo.MutationHookOptions<CreditCardCreateMutation, CreditCardCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreditCardCreateMutation, CreditCardCreateMutationVariables>(CreditCardCreateDocument, options);
      }
export type CreditCardCreateMutationHookResult = ReturnType<typeof useCreditCardCreateMutation>;
export type CreditCardCreateMutationResult = Apollo.MutationResult<CreditCardCreateMutation>;
export type CreditCardCreateMutationOptions = Apollo.BaseMutationOptions<CreditCardCreateMutation, CreditCardCreateMutationVariables>;
export const GetProductSupplierProductsDocument = gql`
    query GetProductSupplierProducts {
  productSupplierProducts
}
    `;

/**
 * __useGetProductSupplierProductsQuery__
 *
 * To run a query within a React component, call `useGetProductSupplierProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductSupplierProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductSupplierProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProductSupplierProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>(GetProductSupplierProductsDocument, options);
      }
export function useGetProductSupplierProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>(GetProductSupplierProductsDocument, options);
        }
export function useGetProductSupplierProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>(GetProductSupplierProductsDocument, options);
        }
export type GetProductSupplierProductsQueryHookResult = ReturnType<typeof useGetProductSupplierProductsQuery>;
export type GetProductSupplierProductsLazyQueryHookResult = ReturnType<typeof useGetProductSupplierProductsLazyQuery>;
export type GetProductSupplierProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductSupplierProductsSuspenseQuery>;
export type GetProductSupplierProductsQueryResult = Apollo.QueryResult<GetProductSupplierProductsQuery, GetProductSupplierProductsQueryVariables>;
export const ItineraryCreateAttachmentDocument = gql`
    mutation ItineraryCreateAttachment($sessionId: ID!, $input: CreateAttachmentInput!) {
  viewer {
    itinerary(id: $sessionId) {
      createAttachment(input: $input) {
        itinerary {
          id
        }
      }
    }
  }
}
    `;
export type ItineraryCreateAttachmentMutationFn = Apollo.MutationFunction<ItineraryCreateAttachmentMutation, ItineraryCreateAttachmentMutationVariables>;

/**
 * __useItineraryCreateAttachmentMutation__
 *
 * To run a mutation, you first call `useItineraryCreateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItineraryCreateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itineraryCreateAttachmentMutation, { data, loading, error }] = useItineraryCreateAttachmentMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useItineraryCreateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ItineraryCreateAttachmentMutation, ItineraryCreateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItineraryCreateAttachmentMutation, ItineraryCreateAttachmentMutationVariables>(ItineraryCreateAttachmentDocument, options);
      }
export type ItineraryCreateAttachmentMutationHookResult = ReturnType<typeof useItineraryCreateAttachmentMutation>;
export type ItineraryCreateAttachmentMutationResult = Apollo.MutationResult<ItineraryCreateAttachmentMutation>;
export type ItineraryCreateAttachmentMutationOptions = Apollo.BaseMutationOptions<ItineraryCreateAttachmentMutation, ItineraryCreateAttachmentMutationVariables>;
export const GetItineraryLockStateDocument = gql`
    query GetItineraryLockState($id: ID!) {
  itinerary {
    itinerary(id: $id) {
      id
      state
      firstName
      ...ItineraryLockFields
    }
  }
}
    ${ItineraryLockFieldsFragmentDoc}`;

/**
 * __useGetItineraryLockStateQuery__
 *
 * To run a query within a React component, call `useGetItineraryLockStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetItineraryLockStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetItineraryLockStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetItineraryLockStateQuery(baseOptions: Apollo.QueryHookOptions<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>(GetItineraryLockStateDocument, options);
      }
export function useGetItineraryLockStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>(GetItineraryLockStateDocument, options);
        }
export function useGetItineraryLockStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>(GetItineraryLockStateDocument, options);
        }
export type GetItineraryLockStateQueryHookResult = ReturnType<typeof useGetItineraryLockStateQuery>;
export type GetItineraryLockStateLazyQueryHookResult = ReturnType<typeof useGetItineraryLockStateLazyQuery>;
export type GetItineraryLockStateSuspenseQueryHookResult = ReturnType<typeof useGetItineraryLockStateSuspenseQuery>;
export type GetItineraryLockStateQueryResult = Apollo.QueryResult<GetItineraryLockStateQuery, GetItineraryLockStateQueryVariables>;
export const LockItineraryDocument = gql`
    mutation LockItinerary($sessionId: ID!, $input: TypesItineraryMutationsLockInput!) {
  viewer {
    itinerary(id: $sessionId) {
      lock(input: $input) {
        itinerary {
          id
          ...ItineraryLockFields
        }
      }
    }
  }
}
    ${ItineraryLockFieldsFragmentDoc}`;
export type LockItineraryMutationFn = Apollo.MutationFunction<LockItineraryMutation, LockItineraryMutationVariables>;

/**
 * __useLockItineraryMutation__
 *
 * To run a mutation, you first call `useLockItineraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockItineraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockItineraryMutation, { data, loading, error }] = useLockItineraryMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLockItineraryMutation(baseOptions?: Apollo.MutationHookOptions<LockItineraryMutation, LockItineraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockItineraryMutation, LockItineraryMutationVariables>(LockItineraryDocument, options);
      }
export type LockItineraryMutationHookResult = ReturnType<typeof useLockItineraryMutation>;
export type LockItineraryMutationResult = Apollo.MutationResult<LockItineraryMutation>;
export type LockItineraryMutationOptions = Apollo.BaseMutationOptions<LockItineraryMutation, LockItineraryMutationVariables>;
export const UpdateCustomerInfoDocument = gql`
    mutation UpdateCustomerInfo($itinerarySessionId: ID!, $input: ItineraryInput) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      update(input: $input) {
        id
        publicId
      }
    }
  }
}
    `;
export type UpdateCustomerInfoMutationFn = Apollo.MutationFunction<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>;

/**
 * __useUpdateCustomerInfoMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerInfoMutation, { data, loading, error }] = useUpdateCustomerInfoMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomerInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>(UpdateCustomerInfoDocument, options);
      }
export type UpdateCustomerInfoMutationHookResult = ReturnType<typeof useUpdateCustomerInfoMutation>;
export type UpdateCustomerInfoMutationResult = Apollo.MutationResult<UpdateCustomerInfoMutation>;
export type UpdateCustomerInfoMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerInfoMutation, UpdateCustomerInfoMutationVariables>;
export const UnlockItineraryDocument = gql`
    mutation UnlockItinerary($sessionId: ID!, $input: TypesItineraryMutationsUnlockInput!) {
  viewer {
    itinerary(id: $sessionId) {
      unlock(input: $input) {
        itinerary {
          id
          ...ItineraryLockFields
        }
      }
    }
  }
}
    ${ItineraryLockFieldsFragmentDoc}`;
export type UnlockItineraryMutationFn = Apollo.MutationFunction<UnlockItineraryMutation, UnlockItineraryMutationVariables>;

/**
 * __useUnlockItineraryMutation__
 *
 * To run a mutation, you first call `useUnlockItineraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockItineraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockItineraryMutation, { data, loading, error }] = useUnlockItineraryMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlockItineraryMutation(baseOptions?: Apollo.MutationHookOptions<UnlockItineraryMutation, UnlockItineraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockItineraryMutation, UnlockItineraryMutationVariables>(UnlockItineraryDocument, options);
      }
export type UnlockItineraryMutationHookResult = ReturnType<typeof useUnlockItineraryMutation>;
export type UnlockItineraryMutationResult = Apollo.MutationResult<UnlockItineraryMutation>;
export type UnlockItineraryMutationOptions = Apollo.BaseMutationOptions<UnlockItineraryMutation, UnlockItineraryMutationVariables>;
export const UpdateTravelerDetailsDocument = gql`
    mutation UpdateTravelerDetails($itinerarySessionId: ID!, $travelerDetails: [TravelerDetailInput]) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updateTravelerDetails(travelerDetails: $travelerDetails) {
        id
        normalizedTravelerDetails {
          travelerIdx
          normalizedFirstName
          normalizedLastName
          dob
          gender
          height
          weight
          shoeSize
          skillLevel
          pickupAt
          zendeskTicket
        }
      }
    }
  }
}
    `;
export type UpdateTravelerDetailsMutationFn = Apollo.MutationFunction<UpdateTravelerDetailsMutation, UpdateTravelerDetailsMutationVariables>;

/**
 * __useUpdateTravelerDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateTravelerDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTravelerDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTravelerDetailsMutation, { data, loading, error }] = useUpdateTravelerDetailsMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      travelerDetails: // value for 'travelerDetails'
 *   },
 * });
 */
export function useUpdateTravelerDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTravelerDetailsMutation, UpdateTravelerDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTravelerDetailsMutation, UpdateTravelerDetailsMutationVariables>(UpdateTravelerDetailsDocument, options);
      }
export type UpdateTravelerDetailsMutationHookResult = ReturnType<typeof useUpdateTravelerDetailsMutation>;
export type UpdateTravelerDetailsMutationResult = Apollo.MutationResult<UpdateTravelerDetailsMutation>;
export type UpdateTravelerDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateTravelerDetailsMutation, UpdateTravelerDetailsMutationVariables>;
export const UpdatePropertyLineItemDocument = gql`
    mutation UpdatePropertyLineItem($itinerarySessionId: ID, $input: UpdatePropertyLineItemInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      updatePropertyLineItem(input: $input) {
        itinerary {
          id
          propertyLineItem {
            id
            hasOverrideData
            specialRequestFulfilled
          }
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type UpdatePropertyLineItemMutationFn = Apollo.MutationFunction<UpdatePropertyLineItemMutation, UpdatePropertyLineItemMutationVariables>;

/**
 * __useUpdatePropertyLineItemMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyLineItemMutation, { data, loading, error }] = useUpdatePropertyLineItemMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePropertyLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyLineItemMutation, UpdatePropertyLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyLineItemMutation, UpdatePropertyLineItemMutationVariables>(UpdatePropertyLineItemDocument, options);
      }
export type UpdatePropertyLineItemMutationHookResult = ReturnType<typeof useUpdatePropertyLineItemMutation>;
export type UpdatePropertyLineItemMutationResult = Apollo.MutationResult<UpdatePropertyLineItemMutation>;
export type UpdatePropertyLineItemMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyLineItemMutation, UpdatePropertyLineItemMutationVariables>;
export const AddPropertyDocument = gql`
    mutation addProperty($itineraryId: ID, $lineItemId: ID, $startAt: Date!, $endAt: Date!, $occupancy: [ExpediaPropertyRoomOccupancy!]!, $priceCheckingToken: String!, $paymentOptionsToken: String!, $rateId: ID!, $roomId: ID!, $sku: ID!, $cancelPenalties: [JSON], $resort: JSON!, $refundable: Boolean!, $merchantOfRecord: String!, $depositPolicies: [JSON], $rate: JSON!) {
  viewer {
    itinerary(id: $itineraryId) {
      addProperty(
        lineItemId: $lineItemId
        startAt: $startAt
        endAt: $endAt
        occupancy: $occupancy
        priceCheckingToken: $priceCheckingToken
        paymentOptionsToken: $paymentOptionsToken
        rateId: $rateId
        roomId: $roomId
        sku: $sku
        cancelPenalties: $cancelPenalties
        resort: $resort
        refundable: $refundable
        merchantOfRecord: $merchantOfRecord
        depositPolicies: $depositPolicies
        rates: $rate
        newPackage: false
      ) {
        itinerary {
          id
          publicId
        }
        lineItem {
          id
        }
      }
    }
  }
}
    `;
export type AddPropertyMutationFn = Apollo.MutationFunction<AddPropertyMutation, AddPropertyMutationVariables>;

/**
 * __useAddPropertyMutation__
 *
 * To run a mutation, you first call `useAddPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyMutation, { data, loading, error }] = useAddPropertyMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      lineItemId: // value for 'lineItemId'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      occupancy: // value for 'occupancy'
 *      priceCheckingToken: // value for 'priceCheckingToken'
 *      paymentOptionsToken: // value for 'paymentOptionsToken'
 *      rateId: // value for 'rateId'
 *      roomId: // value for 'roomId'
 *      sku: // value for 'sku'
 *      cancelPenalties: // value for 'cancelPenalties'
 *      resort: // value for 'resort'
 *      refundable: // value for 'refundable'
 *      merchantOfRecord: // value for 'merchantOfRecord'
 *      depositPolicies: // value for 'depositPolicies'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useAddPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyMutation, AddPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyMutation, AddPropertyMutationVariables>(AddPropertyDocument, options);
      }
export type AddPropertyMutationHookResult = ReturnType<typeof useAddPropertyMutation>;
export type AddPropertyMutationResult = Apollo.MutationResult<AddPropertyMutation>;
export type AddPropertyMutationOptions = Apollo.BaseMutationOptions<AddPropertyMutation, AddPropertyMutationVariables>;
export const GetPropertyAvailabilityDocument = gql`
    query getPropertyAvailability($propertyId: ID!, $arrival: Date!, $departure: Date!, $occupancy: [ExpediaPropertyRoomOccupancy!]!, $isPackage: Boolean!) {
  product {
    propertyNew(id: $propertyId) {
      id
      name
      resortsOld {
        id
        name
        region {
          id
          slug
        }
        slug
      }
      rooms {
        id
        name
        rates(
          arrival: $arrival
          departure: $departure
          occupancy: $occupancy
          isPackage: $isPackage
        ) {
          id
          ...RateRowFields
        }
      }
    }
  }
}
    ${RateRowFieldsFragmentDoc}`;

/**
 * __useGetPropertyAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetPropertyAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyAvailabilityQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      arrival: // value for 'arrival'
 *      departure: // value for 'departure'
 *      occupancy: // value for 'occupancy'
 *      isPackage: // value for 'isPackage'
 *   },
 * });
 */
export function useGetPropertyAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>(GetPropertyAvailabilityDocument, options);
      }
export function useGetPropertyAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>(GetPropertyAvailabilityDocument, options);
        }
export function useGetPropertyAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>(GetPropertyAvailabilityDocument, options);
        }
export type GetPropertyAvailabilityQueryHookResult = ReturnType<typeof useGetPropertyAvailabilityQuery>;
export type GetPropertyAvailabilityLazyQueryHookResult = ReturnType<typeof useGetPropertyAvailabilityLazyQuery>;
export type GetPropertyAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetPropertyAvailabilitySuspenseQuery>;
export type GetPropertyAvailabilityQueryResult = Apollo.QueryResult<GetPropertyAvailabilityQuery, GetPropertyAvailabilityQueryVariables>;
export const ApplyCouponDocument = gql`
    mutation applyCoupon($itineraryId: ID, $code: String!, $force: Boolean!) {
  viewer {
    itinerary(id: $itineraryId) {
      applyCoupon(code: $code, force: $force) {
        couponDiscount
        coupon {
          id
          remainingAmount
        }
      }
    }
  }
}
    `;
export type ApplyCouponMutationFn = Apollo.MutationFunction<ApplyCouponMutation, ApplyCouponMutationVariables>;

/**
 * __useApplyCouponMutation__
 *
 * To run a mutation, you first call `useApplyCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyCouponMutation, { data, loading, error }] = useApplyCouponMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      code: // value for 'code'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useApplyCouponMutation(baseOptions?: Apollo.MutationHookOptions<ApplyCouponMutation, ApplyCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyCouponMutation, ApplyCouponMutationVariables>(ApplyCouponDocument, options);
      }
export type ApplyCouponMutationHookResult = ReturnType<typeof useApplyCouponMutation>;
export type ApplyCouponMutationResult = Apollo.MutationResult<ApplyCouponMutation>;
export type ApplyCouponMutationOptions = Apollo.BaseMutationOptions<ApplyCouponMutation, ApplyCouponMutationVariables>;
export const UpdateContactDetailDocument = gql`
    mutation updateContactDetail($itineraryId: ID, $lineItemId: ID!, $data: PropertyLineItem!) {
  viewer {
    itinerary(id: $itineraryId) {
      updateProperty(id: $lineItemId, data: $data) {
        itinerary {
          id
          publicId
        }
      }
    }
  }
}
    `;
export type UpdateContactDetailMutationFn = Apollo.MutationFunction<UpdateContactDetailMutation, UpdateContactDetailMutationVariables>;

/**
 * __useUpdateContactDetailMutation__
 *
 * To run a mutation, you first call `useUpdateContactDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactDetailMutation, { data, loading, error }] = useUpdateContactDetailMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      lineItemId: // value for 'lineItemId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactDetailMutation, UpdateContactDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactDetailMutation, UpdateContactDetailMutationVariables>(UpdateContactDetailDocument, options);
      }
export type UpdateContactDetailMutationHookResult = ReturnType<typeof useUpdateContactDetailMutation>;
export type UpdateContactDetailMutationResult = Apollo.MutationResult<UpdateContactDetailMutation>;
export type UpdateContactDetailMutationOptions = Apollo.BaseMutationOptions<UpdateContactDetailMutation, UpdateContactDetailMutationVariables>;
export const FinalizeDuplicateDocument = gql`
    mutation FinalizeDuplicate($itinerarySessionId: ID, $input: FinalizeDuplicateInput!) {
  viewer {
    itinerary(id: $itinerarySessionId) {
      finalizeDuplicate(input: $input) {
        itinerary {
          id
        }
      }
    }
  }
}
    `;
export type FinalizeDuplicateMutationFn = Apollo.MutationFunction<FinalizeDuplicateMutation, FinalizeDuplicateMutationVariables>;

/**
 * __useFinalizeDuplicateMutation__
 *
 * To run a mutation, you first call `useFinalizeDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinalizeDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finalizeDuplicateMutation, { data, loading, error }] = useFinalizeDuplicateMutation({
 *   variables: {
 *      itinerarySessionId: // value for 'itinerarySessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinalizeDuplicateMutation(baseOptions?: Apollo.MutationHookOptions<FinalizeDuplicateMutation, FinalizeDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinalizeDuplicateMutation, FinalizeDuplicateMutationVariables>(FinalizeDuplicateDocument, options);
      }
export type FinalizeDuplicateMutationHookResult = ReturnType<typeof useFinalizeDuplicateMutation>;
export type FinalizeDuplicateMutationResult = Apollo.MutationResult<FinalizeDuplicateMutation>;
export type FinalizeDuplicateMutationOptions = Apollo.BaseMutationOptions<FinalizeDuplicateMutation, FinalizeDuplicateMutationVariables>;
export const GetPropertyRoomsDocument = gql`
    query getPropertyRooms($id: ID!) {
  product {
    property(id: $id) {
      id
      rooms {
        id
        name
        bedGroups {
          id
          description
          configuration
        }
      }
    }
  }
}
    `;

/**
 * __useGetPropertyRoomsQuery__
 *
 * To run a query within a React component, call `useGetPropertyRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyRoomsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPropertyRoomsQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>(GetPropertyRoomsDocument, options);
      }
export function useGetPropertyRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>(GetPropertyRoomsDocument, options);
        }
export function useGetPropertyRoomsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>(GetPropertyRoomsDocument, options);
        }
export type GetPropertyRoomsQueryHookResult = ReturnType<typeof useGetPropertyRoomsQuery>;
export type GetPropertyRoomsLazyQueryHookResult = ReturnType<typeof useGetPropertyRoomsLazyQuery>;
export type GetPropertyRoomsSuspenseQueryHookResult = ReturnType<typeof useGetPropertyRoomsSuspenseQuery>;
export type GetPropertyRoomsQueryResult = Apollo.QueryResult<GetPropertyRoomsQuery, GetPropertyRoomsQueryVariables>;
export const AddScheduledPaymentDocument = gql`
    mutation addScheduledPayment($itineraryId: ID!, $input: AddScheduledPaymentInput!) {
  viewer {
    itinerary(id: $itineraryId) {
      addScheduledPayment(input: $input) {
        itinerary {
          id
          scheduledPayments(paymentType: [SCHEDULED]) {
            nodes {
              id
              amount
              processAt
            }
          }
        }
      }
    }
  }
}
    `;
export type AddScheduledPaymentMutationFn = Apollo.MutationFunction<AddScheduledPaymentMutation, AddScheduledPaymentMutationVariables>;

/**
 * __useAddScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useAddScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addScheduledPaymentMutation, { data, loading, error }] = useAddScheduledPaymentMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddScheduledPaymentMutation(baseOptions?: Apollo.MutationHookOptions<AddScheduledPaymentMutation, AddScheduledPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddScheduledPaymentMutation, AddScheduledPaymentMutationVariables>(AddScheduledPaymentDocument, options);
      }
export type AddScheduledPaymentMutationHookResult = ReturnType<typeof useAddScheduledPaymentMutation>;
export type AddScheduledPaymentMutationResult = Apollo.MutationResult<AddScheduledPaymentMutation>;
export type AddScheduledPaymentMutationOptions = Apollo.BaseMutationOptions<AddScheduledPaymentMutation, AddScheduledPaymentMutationVariables>;
export const PaymentProcessChargeDocument = gql`
    mutation PaymentProcessCharge($input: MutationsPaymentProcessChargeInput!) {
  payment {
    processCharge(input: $input) {
      payment {
        id
        amount
        trxnNumber
        trxnType
      }
      itinerary {
        id
        payments {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export type PaymentProcessChargeMutationFn = Apollo.MutationFunction<PaymentProcessChargeMutation, PaymentProcessChargeMutationVariables>;

/**
 * __usePaymentProcessChargeMutation__
 *
 * To run a mutation, you first call `usePaymentProcessChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentProcessChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentProcessChargeMutation, { data, loading, error }] = usePaymentProcessChargeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentProcessChargeMutation(baseOptions?: Apollo.MutationHookOptions<PaymentProcessChargeMutation, PaymentProcessChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentProcessChargeMutation, PaymentProcessChargeMutationVariables>(PaymentProcessChargeDocument, options);
      }
export type PaymentProcessChargeMutationHookResult = ReturnType<typeof usePaymentProcessChargeMutation>;
export type PaymentProcessChargeMutationResult = Apollo.MutationResult<PaymentProcessChargeMutation>;
export type PaymentProcessChargeMutationOptions = Apollo.BaseMutationOptions<PaymentProcessChargeMutation, PaymentProcessChargeMutationVariables>;
export const ScheduledPaymentMarkAsPaidDocument = gql`
    mutation ScheduledPaymentMarkAsPaid($input: MutationsScheduledPaymentMarkAsPaidInput!) {
  scheduledPayment {
    markAsPaid(input: $input) {
      itinerary {
        id
      }
    }
  }
}
    `;
export type ScheduledPaymentMarkAsPaidMutationFn = Apollo.MutationFunction<ScheduledPaymentMarkAsPaidMutation, ScheduledPaymentMarkAsPaidMutationVariables>;

/**
 * __useScheduledPaymentMarkAsPaidMutation__
 *
 * To run a mutation, you first call `useScheduledPaymentMarkAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentMarkAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduledPaymentMarkAsPaidMutation, { data, loading, error }] = useScheduledPaymentMarkAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduledPaymentMarkAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<ScheduledPaymentMarkAsPaidMutation, ScheduledPaymentMarkAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduledPaymentMarkAsPaidMutation, ScheduledPaymentMarkAsPaidMutationVariables>(ScheduledPaymentMarkAsPaidDocument, options);
      }
export type ScheduledPaymentMarkAsPaidMutationHookResult = ReturnType<typeof useScheduledPaymentMarkAsPaidMutation>;
export type ScheduledPaymentMarkAsPaidMutationResult = Apollo.MutationResult<ScheduledPaymentMarkAsPaidMutation>;
export type ScheduledPaymentMarkAsPaidMutationOptions = Apollo.BaseMutationOptions<ScheduledPaymentMarkAsPaidMutation, ScheduledPaymentMarkAsPaidMutationVariables>;
export const ScheduledPaymentProcessChargeDocument = gql`
    mutation ScheduledPaymentProcessCharge($input: MutationsScheduledPaymentProcessChargeInput!) {
  scheduledPayment {
    processCharge(input: $input) {
      itinerary {
        id
      }
    }
  }
}
    `;
export type ScheduledPaymentProcessChargeMutationFn = Apollo.MutationFunction<ScheduledPaymentProcessChargeMutation, ScheduledPaymentProcessChargeMutationVariables>;

/**
 * __useScheduledPaymentProcessChargeMutation__
 *
 * To run a mutation, you first call `useScheduledPaymentProcessChargeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduledPaymentProcessChargeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduledPaymentProcessChargeMutation, { data, loading, error }] = useScheduledPaymentProcessChargeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduledPaymentProcessChargeMutation(baseOptions?: Apollo.MutationHookOptions<ScheduledPaymentProcessChargeMutation, ScheduledPaymentProcessChargeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduledPaymentProcessChargeMutation, ScheduledPaymentProcessChargeMutationVariables>(ScheduledPaymentProcessChargeDocument, options);
      }
export type ScheduledPaymentProcessChargeMutationHookResult = ReturnType<typeof useScheduledPaymentProcessChargeMutation>;
export type ScheduledPaymentProcessChargeMutationResult = Apollo.MutationResult<ScheduledPaymentProcessChargeMutation>;
export type ScheduledPaymentProcessChargeMutationOptions = Apollo.BaseMutationOptions<ScheduledPaymentProcessChargeMutation, ScheduledPaymentProcessChargeMutationVariables>;
export const PaymentProcessRefundDocument = gql`
    mutation PaymentProcessRefund($input: MutationsPaymentProcessRefundInput!) {
  payment {
    processRefund(input: $input) {
      payment {
        id
      }
      refund {
        id
      }
    }
  }
}
    `;
export type PaymentProcessRefundMutationFn = Apollo.MutationFunction<PaymentProcessRefundMutation, PaymentProcessRefundMutationVariables>;

/**
 * __usePaymentProcessRefundMutation__
 *
 * To run a mutation, you first call `usePaymentProcessRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentProcessRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentProcessRefundMutation, { data, loading, error }] = usePaymentProcessRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentProcessRefundMutation(baseOptions?: Apollo.MutationHookOptions<PaymentProcessRefundMutation, PaymentProcessRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PaymentProcessRefundMutation, PaymentProcessRefundMutationVariables>(PaymentProcessRefundDocument, options);
      }
export type PaymentProcessRefundMutationHookResult = ReturnType<typeof usePaymentProcessRefundMutation>;
export type PaymentProcessRefundMutationResult = Apollo.MutationResult<PaymentProcessRefundMutation>;
export type PaymentProcessRefundMutationOptions = Apollo.BaseMutationOptions<PaymentProcessRefundMutation, PaymentProcessRefundMutationVariables>;
export const UpdateScheduledPaymentDocument = gql`
    mutation updateScheduledPayment($itineraryId: ID!, $input: UpdateScheduledPaymentInput!) {
  viewer {
    itinerary(id: $itineraryId) {
      updateScheduledPayment(input: $input) {
        itinerary {
          id
          scheduledPayments(paymentType: [SCHEDULED]) {
            nodes {
              id
              amount
              processAt
              isModified
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateScheduledPaymentMutationFn = Apollo.MutationFunction<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>;

/**
 * __useUpdateScheduledPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledPaymentMutation, { data, loading, error }] = useUpdateScheduledPaymentMutation({
 *   variables: {
 *      itineraryId: // value for 'itineraryId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>(UpdateScheduledPaymentDocument, options);
      }
export type UpdateScheduledPaymentMutationHookResult = ReturnType<typeof useUpdateScheduledPaymentMutation>;
export type UpdateScheduledPaymentMutationResult = Apollo.MutationResult<UpdateScheduledPaymentMutation>;
export type UpdateScheduledPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledPaymentMutation, UpdateScheduledPaymentMutationVariables>;
export const PostBookingCallCreateDocument = gql`
    mutation postBookingCallCreate($input: MutationsPostBookingCallCreateInput!) {
  postBookingCall {
    create(input: $input) {
      itinerary {
        id
        postBookingCalls {
          nodes {
            id
            comments
            createdAt
            outcome
            zendeskTicket
            user {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;
export type PostBookingCallCreateMutationFn = Apollo.MutationFunction<PostBookingCallCreateMutation, PostBookingCallCreateMutationVariables>;

/**
 * __usePostBookingCallCreateMutation__
 *
 * To run a mutation, you first call `usePostBookingCallCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostBookingCallCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postBookingCallCreateMutation, { data, loading, error }] = usePostBookingCallCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostBookingCallCreateMutation(baseOptions?: Apollo.MutationHookOptions<PostBookingCallCreateMutation, PostBookingCallCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostBookingCallCreateMutation, PostBookingCallCreateMutationVariables>(PostBookingCallCreateDocument, options);
      }
export type PostBookingCallCreateMutationHookResult = ReturnType<typeof usePostBookingCallCreateMutation>;
export type PostBookingCallCreateMutationResult = Apollo.MutationResult<PostBookingCallCreateMutation>;
export type PostBookingCallCreateMutationOptions = Apollo.BaseMutationOptions<PostBookingCallCreateMutation, PostBookingCallCreateMutationVariables>;
export const PostBookingCallUpdateDocument = gql`
    mutation PostBookingCallUpdate($input: MutationsPostBookingCallUpdateInput!) {
  postBookingCall {
    update(input: $input) {
      postBookingCall {
        id
        comments
        createdAt
        outcome
        zendeskTicket
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export type PostBookingCallUpdateMutationFn = Apollo.MutationFunction<PostBookingCallUpdateMutation, PostBookingCallUpdateMutationVariables>;

/**
 * __usePostBookingCallUpdateMutation__
 *
 * To run a mutation, you first call `usePostBookingCallUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostBookingCallUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postBookingCallUpdateMutation, { data, loading, error }] = usePostBookingCallUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostBookingCallUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PostBookingCallUpdateMutation, PostBookingCallUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostBookingCallUpdateMutation, PostBookingCallUpdateMutationVariables>(PostBookingCallUpdateDocument, options);
      }
export type PostBookingCallUpdateMutationHookResult = ReturnType<typeof usePostBookingCallUpdateMutation>;
export type PostBookingCallUpdateMutationResult = Apollo.MutationResult<PostBookingCallUpdateMutation>;
export type PostBookingCallUpdateMutationOptions = Apollo.BaseMutationOptions<PostBookingCallUpdateMutation, PostBookingCallUpdateMutationVariables>;
export const PreArrivalCallUpdateDocument = gql`
    mutation PreArrivalCallUpdate($input: MutationsPreArrivalCallUpdateInput!) {
  preArrivalCall {
    update(input: $input) {
      preArrivalCall {
        id
        comments
        createdAt
        outcome
        zendeskTicket
        user {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export type PreArrivalCallUpdateMutationFn = Apollo.MutationFunction<PreArrivalCallUpdateMutation, PreArrivalCallUpdateMutationVariables>;

/**
 * __usePreArrivalCallUpdateMutation__
 *
 * To run a mutation, you first call `usePreArrivalCallUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreArrivalCallUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preArrivalCallUpdateMutation, { data, loading, error }] = usePreArrivalCallUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreArrivalCallUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PreArrivalCallUpdateMutation, PreArrivalCallUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreArrivalCallUpdateMutation, PreArrivalCallUpdateMutationVariables>(PreArrivalCallUpdateDocument, options);
      }
export type PreArrivalCallUpdateMutationHookResult = ReturnType<typeof usePreArrivalCallUpdateMutation>;
export type PreArrivalCallUpdateMutationResult = Apollo.MutationResult<PreArrivalCallUpdateMutation>;
export type PreArrivalCallUpdateMutationOptions = Apollo.BaseMutationOptions<PreArrivalCallUpdateMutation, PreArrivalCallUpdateMutationVariables>;
export const PreArrivalCallCreateDocument = gql`
    mutation PreArrivalCallCreate($input: MutationsPreArrivalCallCreateInput!) {
  preArrivalCall {
    create(input: $input) {
      itinerary {
        id
        preArrivalCalls {
          nodes {
            id
            comments
            createdAt
            outcome
            zendeskTicket
            user {
              id
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `;
export type PreArrivalCallCreateMutationFn = Apollo.MutationFunction<PreArrivalCallCreateMutation, PreArrivalCallCreateMutationVariables>;

/**
 * __usePreArrivalCallCreateMutation__
 *
 * To run a mutation, you first call `usePreArrivalCallCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreArrivalCallCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [preArrivalCallCreateMutation, { data, loading, error }] = usePreArrivalCallCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreArrivalCallCreateMutation(baseOptions?: Apollo.MutationHookOptions<PreArrivalCallCreateMutation, PreArrivalCallCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreArrivalCallCreateMutation, PreArrivalCallCreateMutationVariables>(PreArrivalCallCreateDocument, options);
      }
export type PreArrivalCallCreateMutationHookResult = ReturnType<typeof usePreArrivalCallCreateMutation>;
export type PreArrivalCallCreateMutationResult = Apollo.MutationResult<PreArrivalCallCreateMutation>;
export type PreArrivalCallCreateMutationOptions = Apollo.BaseMutationOptions<PreArrivalCallCreateMutation, PreArrivalCallCreateMutationVariables>;
export const SupportCaseCreateDocument = gql`
    mutation SupportCaseCreate($input: MutationsSupportCaseCreateInput!) {
  supportCase {
    create(input: $input) {
      itinerary {
        id
        mainId
        main {
          id
          supportCases {
            id
            ...SupportCaseTableFields
          }
        }
      }
    }
  }
}
    ${SupportCaseTableFieldsFragmentDoc}`;
export type SupportCaseCreateMutationFn = Apollo.MutationFunction<SupportCaseCreateMutation, SupportCaseCreateMutationVariables>;

/**
 * __useSupportCaseCreateMutation__
 *
 * To run a mutation, you first call `useSupportCaseCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportCaseCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportCaseCreateMutation, { data, loading, error }] = useSupportCaseCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupportCaseCreateMutation(baseOptions?: Apollo.MutationHookOptions<SupportCaseCreateMutation, SupportCaseCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportCaseCreateMutation, SupportCaseCreateMutationVariables>(SupportCaseCreateDocument, options);
      }
export type SupportCaseCreateMutationHookResult = ReturnType<typeof useSupportCaseCreateMutation>;
export type SupportCaseCreateMutationResult = Apollo.MutationResult<SupportCaseCreateMutation>;
export type SupportCaseCreateMutationOptions = Apollo.BaseMutationOptions<SupportCaseCreateMutation, SupportCaseCreateMutationVariables>;
export const SupportCaseUpdateDocument = gql`
    mutation SupportCaseUpdate($input: MutationsSupportCaseUpdateInput!) {
  supportCase {
    update(input: $input) {
      supportCase {
        id
        ...SupportCaseTableFields
      }
    }
  }
}
    ${SupportCaseTableFieldsFragmentDoc}`;
export type SupportCaseUpdateMutationFn = Apollo.MutationFunction<SupportCaseUpdateMutation, SupportCaseUpdateMutationVariables>;

/**
 * __useSupportCaseUpdateMutation__
 *
 * To run a mutation, you first call `useSupportCaseUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportCaseUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportCaseUpdateMutation, { data, loading, error }] = useSupportCaseUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupportCaseUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SupportCaseUpdateMutation, SupportCaseUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportCaseUpdateMutation, SupportCaseUpdateMutationVariables>(SupportCaseUpdateDocument, options);
      }
export type SupportCaseUpdateMutationHookResult = ReturnType<typeof useSupportCaseUpdateMutation>;
export type SupportCaseUpdateMutationResult = Apollo.MutationResult<SupportCaseUpdateMutation>;
export type SupportCaseUpdateMutationOptions = Apollo.BaseMutationOptions<SupportCaseUpdateMutation, SupportCaseUpdateMutationVariables>;
export const SupportNoteCreateDocument = gql`
    mutation SupportNoteCreate($input: MutationsSupportNoteCreateInput!) {
  supportNote {
    create(input: $input) {
      supportCase {
        id
        supportNotes {
          id
          content
          createdAt
          createdBy {
            ...UserCoreFields
          }
          zendeskTicket
        }
      }
    }
  }
}
    ${UserCoreFieldsFragmentDoc}`;
export type SupportNoteCreateMutationFn = Apollo.MutationFunction<SupportNoteCreateMutation, SupportNoteCreateMutationVariables>;

/**
 * __useSupportNoteCreateMutation__
 *
 * To run a mutation, you first call `useSupportNoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSupportNoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [supportNoteCreateMutation, { data, loading, error }] = useSupportNoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSupportNoteCreateMutation(baseOptions?: Apollo.MutationHookOptions<SupportNoteCreateMutation, SupportNoteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SupportNoteCreateMutation, SupportNoteCreateMutationVariables>(SupportNoteCreateDocument, options);
      }
export type SupportNoteCreateMutationHookResult = ReturnType<typeof useSupportNoteCreateMutation>;
export type SupportNoteCreateMutationResult = Apollo.MutationResult<SupportNoteCreateMutation>;
export type SupportNoteCreateMutationOptions = Apollo.BaseMutationOptions<SupportNoteCreateMutation, SupportNoteCreateMutationVariables>;
export const ProductSupplierRemoveAttachmentDocument = gql`
    mutation ProductSupplierRemoveAttachment($input: MutationsProductSupplierRemoveAttachmentInput!) {
  productSupplier {
    removeAttachment(input: $input) {
      productSupplier {
        id
      }
    }
  }
}
    `;
export type ProductSupplierRemoveAttachmentMutationFn = Apollo.MutationFunction<ProductSupplierRemoveAttachmentMutation, ProductSupplierRemoveAttachmentMutationVariables>;

/**
 * __useProductSupplierRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useProductSupplierRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductSupplierRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productSupplierRemoveAttachmentMutation, { data, loading, error }] = useProductSupplierRemoveAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductSupplierRemoveAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ProductSupplierRemoveAttachmentMutation, ProductSupplierRemoveAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductSupplierRemoveAttachmentMutation, ProductSupplierRemoveAttachmentMutationVariables>(ProductSupplierRemoveAttachmentDocument, options);
      }
export type ProductSupplierRemoveAttachmentMutationHookResult = ReturnType<typeof useProductSupplierRemoveAttachmentMutation>;
export type ProductSupplierRemoveAttachmentMutationResult = Apollo.MutationResult<ProductSupplierRemoveAttachmentMutation>;
export type ProductSupplierRemoveAttachmentMutationOptions = Apollo.BaseMutationOptions<ProductSupplierRemoveAttachmentMutation, ProductSupplierRemoveAttachmentMutationVariables>;
export const ItineraryRemoveAttachmentDocument = gql`
    mutation ItineraryRemoveAttachment($sessionId: ID!, $input: RemoveAttachmentInput!) {
  viewer {
    itinerary(id: $sessionId) {
      removeAttachment(input: $input) {
        itinerary {
          id
        }
      }
    }
  }
}
    `;
export type ItineraryRemoveAttachmentMutationFn = Apollo.MutationFunction<ItineraryRemoveAttachmentMutation, ItineraryRemoveAttachmentMutationVariables>;

/**
 * __useItineraryRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useItineraryRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useItineraryRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [itineraryRemoveAttachmentMutation, { data, loading, error }] = useItineraryRemoveAttachmentMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useItineraryRemoveAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<ItineraryRemoveAttachmentMutation, ItineraryRemoveAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ItineraryRemoveAttachmentMutation, ItineraryRemoveAttachmentMutationVariables>(ItineraryRemoveAttachmentDocument, options);
      }
export type ItineraryRemoveAttachmentMutationHookResult = ReturnType<typeof useItineraryRemoveAttachmentMutation>;
export type ItineraryRemoveAttachmentMutationResult = Apollo.MutationResult<ItineraryRemoveAttachmentMutation>;
export type ItineraryRemoveAttachmentMutationOptions = Apollo.BaseMutationOptions<ItineraryRemoveAttachmentMutation, ItineraryRemoveAttachmentMutationVariables>;
export const UpdateTransportDetailsDocument = gql`
    mutation UpdateTransportDetails($sessionId: ID!, $input: UpdateTransportDetailsInput!) {
  viewer {
    itinerary(id: $sessionId) {
      updateTransportDetails(input: $input) {
        itinerary {
          id
          data
          propertyLineItem {
            id
            resort {
              id
              showForOutboundTransfer
            }
            product {
              name
            }
          }
          lineItems: transportationLineItems {
            nodes {
              id
              isCanceled
              travelerIdx
              firstName: normalizedFirstName
              supplierConfirmationNumber
              altSupplierConfirmationNumber
              supplierPickupTime
              altSupplierPickupTime
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateTransportDetailsMutationFn = Apollo.MutationFunction<UpdateTransportDetailsMutation, UpdateTransportDetailsMutationVariables>;

/**
 * __useUpdateTransportDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateTransportDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransportDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransportDetailsMutation, { data, loading, error }] = useUpdateTransportDetailsMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransportDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransportDetailsMutation, UpdateTransportDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransportDetailsMutation, UpdateTransportDetailsMutationVariables>(UpdateTransportDetailsDocument, options);
      }
export type UpdateTransportDetailsMutationHookResult = ReturnType<typeof useUpdateTransportDetailsMutation>;
export type UpdateTransportDetailsMutationResult = Apollo.MutationResult<UpdateTransportDetailsMutation>;
export type UpdateTransportDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateTransportDetailsMutation, UpdateTransportDetailsMutationVariables>;
export const GetProductsDocument = gql`
    query GetProducts($resortSlug: String!, $startAt: Date!) {
  product {
    liftTickets(resortSlug: $resortSlug, startAt: $startAt) {
      nodes {
        ...ProductOptionFields
        age
        days
      }
    }
    rentals(resortSlug: $resortSlug, startAt: $startAt) {
      nodes {
        ...ProductOptionFields
        age
        days
        gear
        gearLevel
      }
    }
    lessons(resortSlug: $resortSlug, startAt: $startAt) {
      nodes {
        ...ProductOptionFields
        age
        gear
        size: lesson
      }
    }
    transportations(resortSlug: $resortSlug, startAt: $startAt) {
      nodes {
        ...ProductOptionFields
        minAge
      }
    }
  }
}
    ${ProductOptionFieldsFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      resortSlug: // value for 'resortSlug'
 *      startAt: // value for 'startAt'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export function useGetProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsSuspenseQueryHookResult = ReturnType<typeof useGetProductsSuspenseQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;